import { DatePipe } from "@angular/common";
import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  QueryList,
  ViewChildren,
} from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { MatTableDataSource } from "@angular/material/table";
import { AuthService } from "app/auth/auth.service";
import { DashboardService } from "app/dashboard/dashboard.service";
import { OpdVisitService } from "app/opdvisits/Services/OpdVisit.service";
import { Observable, Subject, forkJoin, fromEvent, interval, of } from "rxjs";
import {
  ByIPDWorkup,
  GetIPDLocation,
  IPDDashbordModel,
  UserMaster,
  sschecklist,
  PostOpchecklist,
  RoutineExam,
  NursingCharges,
  StoresConsumeMasterModel,
} from "../models/ipdDashboardModel";
import { IPDService } from "../Services/ipdServices.service";
import { startWith } from "rxjs/operators/startWith";
import { map } from "rxjs/operators/map";
import { PatientDocumentComponent } from "../patient-document/patient-document.component";
import { MatDialog } from "@angular/material/dialog";
import { PatientTrackingComponent } from "./patient-tracking/patient-tracking.component";
import { PreopWorkupComponent } from "./preop-workup/preop-workup.component";
import { PatientLabComponent } from "./patient-lab/patient-lab.component";
import { PatientBedTransferComponent } from "./patient-bed-transfer/patient-bed-transfer.component";
import { MatDrawer, MatSidenav } from "@angular/material/sidenav";
import * as moment from "moment";
import { PainScalemodel } from "../models/painScaleModels";
import { BillingserviceService } from "app/billing/billingService.service";
import { DynamicHelpListComponent } from "app/EMR/Doctor/doctor-other-info/dynamic-help-list/dynamic-help-list.component";
import {
  exhaustMap,
  switchMap,
  take,
  tap,
  takeUntil,
} from "rxjs/operators";
import {
  InstructionMaster,
  InstructionSavemodel,
} from "../models/InstructionMasterModel";
import {
  DIschargeExaminationModel,
  DischargeMedicineModel,
  DischargeSUmmeryModel,
} from "../models/dischargeSummery.Model";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { MedicineTemplateComponent } from "app/EMR/template_help/medicine-template/medicine-template.component";
import { Template_helpComponent } from "app/EMR/template_help/template_help.component";
import { EMRService } from "app/EMR/EMR.service";
import { ExaminationHelpComponent } from "app/EMR/ExaminationHelp/ExaminationHelp.component";
import { DiagnosisComponent } from "app/EMR/Diagnosis/Diagnosis.component";
import { InvestigationServicesComponent } from "app/EMR/Doctor/investigation-services/investigation-services.component";
import {
  GetCounselorPreOpMedicineModel,
  GetNursingChartModel,
  GetNursingMedicineModel,
  IpdvisitDiagnosisModel,
  IpdvisitExamModel,
  IpdvisitInvestModel,
  IpdvisitPrescModel,
  NursingInstructionsModel,
  getIPDExamList,
} from "../models/nursingWorkup.Model";
import { FindingGroupdataModel } from "app/EMR/DoctorModels/findingsubcategorydata.model";
import { FindingResultModel } from "app/EMR/DoctorModels/findingResult.model";
import { BranchMatserService } from "app/masters/branch-matser.service";
import { EyecheckComponent } from "app/EMR/eyecheck/eyecheck.component";
import { HelpListPopupComponent } from "app/EMR/Doctor/doctor-other-info/help-list-popup/help-list-popup.component";
import { MatSlideToggleChange } from "@angular/material/slide-toggle";
import {
  IPDsurgicalRecordModel,
  OTRegisterIdModel,
  OtRecordSurgeryModel,
  OtcaseSheetModel,
} from "../models/surgicalRecordModel";
import { CounselorService } from "app/EMR/Counselor/counselor.service";
import { CommanSurgeryPopupComponent } from "app/EMR/NewSurgery/comman-surgery-popup/comman-surgery-popup.component";
import { AddServiceComponent } from "app/billing/add-service/add-service.component";
import { TemplateFindingsComponent } from "app/EMR/TemplateFindings/TemplateFindings.component";
import {
  GetPreOpTemplateMaster,
  GetMedicianTemplateMaster,
  GetInvestigationTemplateMaster,
  GetInstructionTemplateMaster,
  GetCounselorCheckList,
  CounselorPreOpInvestigation,
  CounselorPreOpMedicineDetail,
  CounselorPreOpInstructionDetail,
} from "../models/get-pre-op-template-master";
import {
  AnestheticRecordModel,
  AnestheticVisitDetailModel,
  GetPreOpAssesmentDetailHistroy,
  PreopAssesmentRecordModel,
  RecoveryScoreMaster,
} from "../models/PreOpAssesmentDetail.Model";
import { ExportService } from "app/reports/services/export.service";
import { Image_workupComponent } from "app/EMR/Image_workup/Image_workup.component";
import { IpdIolModel } from "../models/ipdIOL.model";
import { OtNotesModel } from "../models/OtNotes.model";
import { OtNotesMasterModel } from "../models/OtNotesMaster.model";
import { transferDataobjModel } from "../models/transferinsertobjModel";
import { BulkConsumptionComponent } from "./bulk-consumption/bulk-consumption.component";
import { imageworkupService } from "app/EMR/Image_workup/Services/Imageworkup.services";
import { VoiceRecognitionService } from 'app/masters/service/voice-recognition.service';
import { WebSocketService } from "app/EMR/webSocket.Service";
@Component({
  selector: "app-ipd-dashboard",
  templateUrl: "./ipd-dashboard.component.html",
  styleUrls: ["./ipd-dashboard.component.scss"],
})
export class IpdDashboardComponent implements OnInit {
  destroyipd$: Subject<boolean> = new Subject<boolean>();
  private selectedTabIndex: number = 0;
  private searchselecttype: any;
  private invalidInput = false;
  private clinicalComment;
  private FinancialComment;
  private q: any;
  private getdischageExamintion: DIschargeExaminationModel[] = [];
  private getdeletedischageExamintion: DIschargeExaminationModel[] = [];
  private getdischargeMedicine: DischargeMedicineModel[] = [];
  private getdeletedischargeMedicine: DischargeMedicineModel[] = [];
  private getipdLocation: GetIPDLocation[] = [];
  private ipdDahboarddata: IPDDashbordModel[] = [];
  private ipdDahboardobjdata: IPDDashbordModel = {};
  private painSacledata: PainScalemodel = {};
  private saveinstructionMaster: InstructionMaster[] = [];
  private instructionMasterobj: InstructionMaster = {};
  private surgicalRecordobj: IPDsurgicalRecordModel = {};
  private dischargeDatamodel: DischargeSUmmeryModel = {};
  private getInstructionmodel: InstructionSavemodel[] = [];
  private changeSaveInstructionmodel: InstructionSavemodel[] = [];
  private getOTArray: any = [];
  private getOPTypeArray: any = [];
  private getOtTheatreArray: any = [];
  private getpospondArray: any = [];
  private admissionFrom: any;
  private admissionTo: any;
  private dischargeFrom: any;
  private dischargeTo: any;
  private admssionById: any;
  private showspinner: boolean = false;
  private serachUhid: any = null;
  private consultantId: any = 0;
  private ShowDoctorName: any;
  private ShowDepName: any;

  private salesTypeControl: FormControl;
  private locationControl: FormControl;
  private gstCtrl: FormControl;
  private remarkCtrl: FormControl
  private payorControl: FormControl;
  private departmentControl: FormControl;

  private DoctorCtrl: FormControl;
  private DoctorCtrl1: FormControl;
  private DoctorCtrl2: FormControl;
  private DoctorCtrl3: FormControl;
  private DoctorCtrl4: FormControl;
  private DoctorCtrl5: FormControl;
  private DoctorCtrl6: FormControl;
  private DoctorCtrl7: FormControl;
  private DoctorCtrl8: FormControl;
  private InstructionsCtrl: FormControl;
  private filteredDoctorArray: Observable<any[]>;
  private filteredDoctorArray1: Observable<any[]>;
  private filteredDoctorArray2: Observable<any[]>;
  private filteredInstructionsArray: Observable<any[]>;
  private doctorholdData: Observable<any[]>;
  private InstructionsData: Observable<any[]>;
  private otGroupName: any;
  private OtgroupCtrl: FormControl;
  private filteredOtGroupArray: Observable<any[]>;
  private otgroupId: any = 0;
  private fkroomcategoryid: any = 0;
  private opTypeName: any;
  private OpTypeCtrl: FormControl;
  private OpTypeCtrl1: FormControl;
  private filteredOpTypeArray: Observable<any[]>;
  private opTypeId: any = 0;
  private OTTheatreName: any;
  private OTTheatreCtrl: FormControl;
  private OTTheatreCtrl1: FormControl;
  private filteredOTTheatreArray: Observable<any[]>;
  private OTTheatreId: any = 0;
  private PostpondName: any = null;
  private OperenedCtrl: FormControl;
  private filteredOperenedArray: Observable<any[]>;
  private examTypeCtrledit: FormControl;
  private filteredexamTypeArrayedit: Observable<any[]>;
  private postpondId: any = 0;
  private rowClicked: any;
  private indexClicked: any;
  private rowClickedipdDoctor: any;
  private checkipdid: any = 0;
  private checklocid: any = 0;
  private Totalcurrent: any = 0;
  private filtermasterdata: any;
  private TotalNotyetReported: any = 0;
  private RegId: any = 0;
  private headerChecked: boolean = true;
  private isDepartmentSelected: boolean = true;
  private pageheadType: any;
  private nav_position: string = "end";
  private dataSource = new MatTableDataSource<UserMaster>();
  private dataSourceWorkup = new MatTableDataSource<ByIPDWorkup>();
  private storeData: any[] = [];
  private getstoretemData: any[] = [];
  private viewconsmtiondata: any[] = [];
  private getstoreConsume: any[] = [];
  private getbatchnoData: any[] = [];
  private locationgetData: any[] = []
  private payorNames: any[] = [];
  private getdeparment: any[] = [];
  private filteredStoreData: any[] = [];
  private filterText: string = '';
  private displayedColumns: string[] = [
    "headName",
    "isHeader",
    "defaultValues",
    "action"
  ];
  private displayedColumnsIpd: string[] = [
    "headName",
    "Options",
    "actualValue",
  ];
  private getinvestigationlab: any = [];
  private getinvestigationDellab: any = [];
  // private Headname: string;
  payLoad: {
    AnesthesiaQuestionsDto: {
      PK_TranId: any;
      HeadName: any;
      DefaultValues: any;
      IsHeader: any;
      IsActive: any;
      IsEdit: any;
      IsHidden: any;
    }[];
  };
  payLoads: {
    PreOpCheckList: {
      PK_TranId: any;
      HeadName: any;
      ActualValue: any;
      IsHeader: any;
      IsActive: any;
      IsEdit: any;
      IsHidden: any;
      FK_IPDID: any;
    }[];
  };
  private selectedrow: any;
  private modifyList: any = {};
  @ViewChild(MatSidenav, { static: false }) sidenav: MatSidenav;
  private selectIpdId: any;
  private selectCouncelorId: number;
  private labelName: any;
  private patIpdlist: any = {};
  private findinggroupdata: FindingGroupdataModel[] = [];
  private masterData: any;
  private masterDataList: any[];
  private prerecordlength: any;
  private masterListData: any;
  private myControl = new FormControl();
  private PreOpListArray: Observable<any[]>;
  private ShowCheckListName: any;
  private TransId: any = 0;
  private masterListDataByName: any = [];
  private selectpreOpList: any;
  private sitelist: any = [];
  private Checklistname: any;
  private masterdataGA: any;
  private selectGA: any;
  private GAIpdlist: any = {};
  private GAmasterListData: any = [];
  private timeFormatcheck: any;
  private selectipdData: any;
  private getipddischargeData: any = [];
  private dischargeData: any;
  private ChangetimeName: any;
  private maxDate;
  private minDate;
  private doctype: string;
  private Otconsentdata: any = [];
  private consId: number;
  private PageHeader: any = {};
  private QrCode: any;
  private reporturl: any;
  private selectconsentdata: IPDDashbordModel[];
  private rightTypeCtrledit: FormControl;
  private filteredrightTypeArrayedit: Observable<any[]>;
  private result_dss: FindingResultModel[] = [];
  private leftTypeCtrledit: FormControl;
  private filteredleftTypeArrayedit: Observable<any[]>;
  private newdoctorenablebtn: boolean = false;
  private showspinner1: boolean = false;
  private partymaster_name: any;
  private refferedby_name: string;
  private counselorForm: boolean = false;
  private corporateFrom: boolean = false;
  private corporateData: any;
  private checklistname: any;
  private sschecklistModel: sschecklist[] = [];
  private PostOpchecklistModel: PostOpchecklist[] = [];
  private PostOPchecklistnameData: any;
  private PostOPchecklistname: any;
  private options: string[] = ["YES", "NO", "NONE"];
  private RoutineExamModel: RoutineExam[] = [];
  private selectedRoutineExam: RoutineExam = {};
  private RoutinegetData: any = [];
  private selectedDate: string;
  private rowcolor: any;
  private selecttime: string;
  private titlebpSys: any;
  private titlebpdy: string;
  private titlebmi: string;
  private titletemp: string;
  private titlerbs: string;
  private titlerespiration: string;
  private titlespO2: string;
  private enableroutine: boolean = false;
  private IOLgetData: any;
  private getotRegdata: any;
  private OtcaseSheetobj: OtcaseSheetModel = {};
  private OtcaseSheetArray: OtcaseSheetModel[] = [];
  private currentIndex = 0;
  private IOLBookingData: any;
  private ipdAmount: any;
  private routinecolorcode: string;
  private getChargeType: any;
  private ChargeTypeMasterName: any;
  private RateTpyeName: any;
  private RateTypeId: any;
  private NursingChargesModel: NursingCharges[] = [];

  private storesConsumeMasterArray: StoresConsumeMasterModel = {};

  private chargeTypeId: any;
  private OTpackageName: any;
  private templateMaster: GetPreOpTemplateMaster[] = [];
  private MediciantemplateMaster: GetMedicianTemplateMaster[] = [];
  private InvestigationtemplateMaster: GetInvestigationTemplateMaster[] = [];
  private InstructiontemplateMaster: GetInstructionTemplateMaster[] = [];
  private MediciantemplateDeleteArray: GetMedicianTemplateMaster[] = [];
  private InvestigationtemplateDeleteArray: GetInvestigationTemplateMaster[] =
    [];
  private InstructiontemplateDeleteArray: GetInstructionTemplateMaster[] = [];
  private CounselorCheckList: GetCounselorCheckList[] = [];
  private CounselorInvestigation: CounselorPreOpInvestigation[] = [];
  private CounselorMedicineDetail: CounselorPreOpMedicineDetail[] = [];
  private CounselorInstructionDetail: CounselorPreOpInstructionDetail[] = [];
  private CounselorCheckDeleteArray: GetCounselorCheckList[] = [];
  private CounselorInvestigationDeleteArray: CounselorPreOpInvestigation[] = [];
  private CounselorMedicineDetailDeleteArray: CounselorPreOpMedicineDetail[] =
    [];
  private CounselorInstructionDetailDeleteArray: CounselorPreOpInstructionDetail[] =
    [];
  private filterTemp: string;
  private selectedTemprow: any;
  private masterTemplateId: any;
  private tempobj: any = {};
  private templateMasterDisable: boolean = true;
  private rowClickedTemplate: any;
  private CounspreopDisable: boolean = true;
  private SelectListRecord: any;
  private indexdataCons: any;
  private filterIns: any;
  private ratetypeIPD: any;
  private GAcheckedyes: boolean = false;
  private GAcheckedno: boolean = false;
  private GAcheckednone: boolean = false;
  private Precheckedyes: boolean = false;
  private Precheckedno: boolean = false;
  private Precheckednone: boolean = false;
  private PDcheckedyes: boolean = false;
  private PDcheckedno: boolean = false;
  private PDcheckednone: boolean = false;
  private AQcheckedyes: boolean = false;
  private AQcheckedno: boolean = false;
  private AQcheckednone: boolean = false;
  private SScheckedyes: boolean = false;
  private SScheckedno: boolean = false;
  private SScheckednone: boolean = false;
  private Prequesdisable: boolean = true;
  private RoomCategory: FormControl;
  private filteredRoomArray: Observable<any[]>;
  private roomcategoryName: string = "";
  private isDropup = true;
  private registerTypeArray: any = [];
  private registerNameArray: any = [];
  private OTRegisterIdArray: OTRegisterIdModel[] = [];
  private otNotesArray: OtNotesModel = {};
  private OtNotesMasterArray: OtNotesMasterModel[] = [];
  private OtNotesMasterobj: OtNotesMasterModel = {};
  private salesTypes: any[] = [];
  private filteredSalesTypes: Observable<any[]>;
  private filteredSLocation: Observable<any[]>;
  private filterpayor: Observable<any[]>;
  private filterdeparment: Observable<any[]>;
  isActive: boolean = true;

  editCache: any = {};
  totalAmount: number = 0;
  totalNetAmount: number = 0;
  roundedOffAmount: number = 0;
  roundoff: any = '1.2-2'
  roundoffLimit: any = '1.2-2'
  con_dynamiclabel: any
  con_saleQty: any
  con_BillNoGeneration: any
  con_autoBatch: any

  addedItems = [];
  selectedItem: any[] = [];
  storesConsumeItemDetailsdata: any = [];


  searchQuery: string = '';
  searchbarcodeQuery: string = '';
  searchbatchnoQuery: string = '';
  barcodeQuery: string = '';

  filteredItemList: any[] = [];
  filteredbarcodeList: any[] = [];
  filterbatchcodeList: any[] = [];

  // Input field variables
  batchNo: any;
  expDate: any;
  rate: any;
  brate: any
  mrp: any;
  batchid: any

  saleQuantity: number;
  discountPercentage: any;
  discountAmount: any;
  gstAmount: number = 0;
  decimalAmount: any;
  rateAmount: any;


  searchItemlist: any;
  searchbarcodelist: any
  selectedStockQty: any;
  isVoiceEnabled: boolean = false;
  fieldRefs: { [key: string]: any } = {};
  fieldSequence: string[] = [
    'Complaints',
    'Procedures',
    'diagnosis',
    'disease',
    'cDischarge',
    'Remarks',
    'adviceonDischarge',
    'prognosis',
    'Prepared',
    'benificiaryName',
    'finding',
    'benificiaryRemarks'
  ];

  currentFieldIndex: number = -1;

  // @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  // dataSource = new MatTableDataSource<IPDDashbordModel>();
  // displayedColumns: string[] = ['IPNo', 'Admissiondate', 'Admissiontime', 'Surgerytime',
  // 'MRNo','PatientName','Ward','doctor','Payorname','Surgeryname','Anes','ot','site','package','packagetype','Amount','BL','CA','FA','DB','AST','HT','CD','AL','RN'];
  isLeftArrow = false;
  constructor(
    private authService: AuthService,
    private elRef: ElementRef,
    private datePipe: DatePipe,
    private dialog: MatDialog,
    private billingservice: BillingserviceService,
    private ipdService: IPDService,
    private dashboardService: DashboardService,
    private opdvisitService: OpdVisitService,
    private emrservice: EMRService,
    private branchMatserService: BranchMatserService,
    private counselorService: CounselorService,
    private exportdata: ExportService,
    private imageWorkupService: imageworkupService,
    private voiceService: VoiceRecognitionService,
    private webSocketService: WebSocketService
  ) {
    this.updateEditCache();
    this.getdeparment = [];
  }
  @ViewChildren("defaultauto") defaultautoRef: QueryList<ElementRef>;
  @ViewChildren("defaultTemp") defaulttemplate: QueryList<ElementRef>;
  @ViewChildren("defaultIns") defaultInstruction: QueryList<ElementRef>;
  @ViewChildren("defaultInsCons") defaultConsInstruction: QueryList<ElementRef>;
  @ViewChildren("Postauto") defaultPostauto: QueryList<ElementRef>;

  ngAfterViewInit(): void {
    fromEvent(this.button.nativeElement, "click")
      .pipe(
        tap((x) => (this.showspinner1 = true)),
        exhaustMap((ev) => {
          return this.createUser();
        })
      )
      .subscribe(this.handleResponse());

    fromEvent(this.button1.nativeElement, "click")
      .pipe(
        tap((x) => (this.showspinner1 = true)),
        exhaustMap((ev) => {
          return this.createUser();
        })
      )
      .subscribe(this.handleResponse1());

    fromEvent(this.button2.nativeElement, "click")
      .pipe(
        tap((x) => (this.showspinner1 = true)),
        exhaustMap((ev) => {
          return this.createUser();
        })
      )
      .subscribe(this.handleResponse2());

    // fromEvent(this.button3.nativeElement, 'click')
    // .pipe(
    //   tap((x) => this.showspinner1 = true),
    //   exhaustMap((ev) => {
    //     return this.createUser();
    //   })
    // )
    // .subscribe(this.handleResponse3());
  }
  @ViewChild("sertDrExaminationbtn", { static: true }) button;
  @ViewChild("sertDrdrugExaminationbtn", { static: true }) button1;
  @ViewChild("inertSurgerybtn", { static: true }) button2;
  @ViewChild("TemplateSave", { static: true }) button3;

  @ViewChild("widgetsContent", { read: ElementRef })
  widgetsContent: ElementRef<any>;
  scrollLeft(): void {
    this.widgetsContent.nativeElement.scrollTo({
      left: this.widgetsContent.nativeElement.scrollLeft - 150,
      behavior: "smooth",
    });
  }
  scrollRight(): void {
    this.widgetsContent.nativeElement.scrollTo({
      left: this.widgetsContent.nativeElement.scrollLeft + 70,
      behavior: "smooth",
    });
  }
  onScrolled() {
    const listEle = this.elRef.nativeElement.querySelector(
      ".bottom-menu-section"
    );
    if ((this.isLeftArrow = listEle.scrollLeft === 0)) {
      this.isLeftArrow = false;
    } else {
      this.isLeftArrow = true;
    }
  }
  clicks$: Observable<any>;
  createUser(): Observable<any> {
    return interval(500).pipe(take(1));
  }
  handleResponse(): any {
    return {
      next: (res) => {
        this.InsertDrExamination();
      },
      error: (err) => { },
    };
  }
  handleResponse1(): any {
    return {
      next: (res) => {
        this.saveNursingData();
      },
      error: (err) => { },
    };
  }
  handleResponse2(): any {
    return {
      next: (res) => {
        this.InsertOtRegisterdata();
      },
      error: (err) => { },
    };
  }
  // handleResponse3(): any {
  //   return {
  //     next: (res) => {
  //       this.SavePreOpTemplateMaster(0)
  //     },
  //     error: (err) => {

  //     },

  //   };

  // }
  ngOnInit(): void {



    // this.authService.Loggeduser.usertypeid
    this.searchselecttype = "UHID";
    this.selectedTabIndex = 0;
    this.otNotesArray = {};
    this.inserttrackingdata = {};
    this.OtNotesMasterArray = [];
    this.OtNotesMasterobj = {};
    this.OTRegisterdeleteArray = [];
    this.registerTypeArray = [];
    this.OTRegisterIdArray = [];
    this.registerNameArray = [];
    this.getinvestigationlab = [];
    this.getinvestigationDellab = [];
    this.opdvisitService.doctors = [];
    this.opdvisitService.patientdetails = {};
    this.opdvisitService.callsepecificApi = "ALL";
    this.pageheadType = "N";
    this.timeFormatcheck = "AM";
    this.DoctorCtrl1 = new FormControl();
    this.DoctorCtrl2 = new FormControl();
    this.DoctorCtrl3 = new FormControl();
    this.DoctorCtrl4 = new FormControl();
    this.DoctorCtrl5 = new FormControl();
    this.DoctorCtrl6 = new FormControl();
    this.DoctorCtrl7 = new FormControl();
    this.DoctorCtrl8 = new FormControl();
    this.InstructionsCtrl = new FormControl();
    this.OpTypeCtrl1 = new FormControl();
    this.OTTheatreCtrl1 = new FormControl();
    this.locationControl = new FormControl();
    this.salesTypeControl = new FormControl();
    this.payorControl = new FormControl();
    this.gstCtrl = new FormControl();
    this.remarkCtrl = new FormControl();
    this.departmentControl = new FormControl();
    this.GetLocationData();
    this.GetotData();
    this.GetotTypeData();
    this.GetOtTheatreData();
    this.GetPostponedData();
    this.GetNotYetReported();
    this.getRoomCategoryMaster();
    // this.showAllSaletype();
    // this.admissionFrom = this.datePipe.transform(
    //   this.authService.getServerDate,
    //   "yyyy-MM-dd"
    // );
    // this.admissionTo = this.datePipe.transform(
    //   this.authService.getServerDate,
    //   "yyyy-MM-dd"
    // );
    this.dischargeFrom = "";
    this.dischargeTo = "";
    let admissionid = "Y";
    this.GetIpdData(
      admissionid,
      this.admissionFrom,
      this.admissionTo,
      this.dischargeFrom,
      this.dischargeTo,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      this.fkroomcategoryid
    );
    this.CurrentPatient(0);
    this.getDoctorBrach();
    this.doctorControll();
    this.OtGroupControll();
    this.OpTypeControll();
    this.OTThreateControll();
    this.PosponedControll();
    this.headerChecked = true;
    this.getAnesthesiaMasterList();
    this.PreOpListControll();
    this.getSite();
    this.getproductmasterconfig();
    this.GetFindingGroupdata(0, 0, 0);
    this.ExamTypeControlledit();
    this.GetFindingGroupResult(0, 0);
    this.rightTypeControlledit();
    this.leftTypeControlledit();
    this.getBranchDetail(this.authService.Loggeduser.branchid);
    this.GetRateType();
  }

  formattimechange(appttime: string) {
    if (appttime == null) {
    } else {
      var hr_min_sec = appttime.split(".", 2);
      var hr_min = hr_min_sec[0].split(":", 3);
      return hr_min[0] + ":" + hr_min[1];
    }
  }
  ngOnDestroy(): void {
    this.destroyipd$.next(true);
    this.destroyipd$.unsubscribe();
    this.isVoiceEnabled = false;
    this.otNotesArray = null;
    this.inserttrackingdata = null;
    this.OtNotesMasterobj = null;
    this.OtNotesMasterArray = null;
    this.OTRegisterdeleteArray = null;
    this.registerTypeArray = null;
    this.OTRegisterIdArray = null;
    this.registerNameArray = null;
    this.clinicalComment = null;
    this.FinancialComment = null;
    this.q = null;
    this.getdischageExamintion = null;
    this.getdeletedischageExamintion = null;
    this.getdischargeMedicine = null;
    this.getdeletedischargeMedicine = null;
    this.getipdLocation = null;
    this.ipdDahboarddata = null;
    this.ipdDahboardobjdata = null;
    this.painSacledata = null;
    this.saveinstructionMaster = null;
    this.instructionMasterobj = null;
    this.surgicalRecordobj = null;
    this.dischargeDatamodel = null;
    this.getInstructionmodel = null;
    this.changeSaveInstructionmodel = null;
    this.getOTArray = null;
    this.getOPTypeArray = null;
    this.getOtTheatreArray = null;
    this.getpospondArray = null;
    this.admissionFrom = null;
    this.admissionTo = null;
    this.dischargeTo = null;
    this.admssionById = null;
    this.searchselecttype = null;
    this.showspinner = null;
    this.consultantId = null;
    this.serachUhid = null;
    this.DoctorCtrl = null;
    this.DoctorCtrl1 = null;
    this.DoctorCtrl2 = null;
    this.DoctorCtrl3 = null;
    this.DoctorCtrl4 = null;
    this.DoctorCtrl5 = null;
    this.DoctorCtrl6 = null;
    this.DoctorCtrl7 = null;
    this.DoctorCtrl8 = null;
    this.InstructionsCtrl = null;
    this.filteredDoctorArray = null;
    this.filteredDoctorArray1 = null;
    this.filteredDoctorArray2 = null;
    this.filteredInstructionsArray = null;
    this.doctorholdData = null;
    this.InstructionsData = null;
    this.otGroupName = null;
    this.OtgroupCtrl = null;
    this.filteredOtGroupArray = null;
    this.otgroupId = null;
    this.fkroomcategoryid = null;
    this.opTypeName = null;
    this.OpTypeCtrl = null;
    this.OpTypeCtrl1 = null;
    this.filteredOpTypeArray = null;
    this.opTypeId = null;
    this.OTTheatreName = null;
    this.OTTheatreCtrl = null;
    this.OTTheatreCtrl1 = null;
    this.filteredOTTheatreArray = null;
    this.OTTheatreId = null;
    this.PostpondName = null;
    this.OperenedCtrl = null;
    this.filteredOperenedArray = null;
    this.examTypeCtrledit = null;
    this.filteredexamTypeArrayedit = null;
    this.postpondId = null;
    this.rowClicked = null;
    this.rowClickedipdDoctor = null;
    this.checkipdid = null;
    this.checklocid = null;
    this.Totalcurrent = null;
    this.filtermasterdata = null;
    this.TotalNotyetReported = null;
    this.RegId = null;
    this.headerChecked = null;
    this.pageheadType = null;
    this.nav_position = null;
    this.dataSource = null;
    this.dataSourceWorkup = null;
    this.displayedColumns = null;
    this.displayedColumnsIpd = null;
    this.selectIpdId = null;
    this.selectCouncelorId = null;
    this.labelName = null;
    this.patIpdlist = null;
    this.findinggroupdata = null;
    this.masterData = null;
    this.masterDataList = null;
    this.prerecordlength = null;
    this.masterListData = null;
    this.myControl = null;
    this.PreOpListArray = null;
    this.ShowCheckListName = null;
    this.TransId = null;
    this.masterListDataByName = null;
    this.selectpreOpList = null;
    this.sitelist = null;
    this.Checklistname = null;
    this.masterdataGA = null;
    this.selectGA = null;
    this.GAIpdlist = null;
    this.GAmasterListData = null;
    this.timeFormatcheck = null;
    this.selectipdData = null;
    this.getipddischargeData = null;
    this.dischargeData = null;
    this.ChangetimeName = null;
    this.maxDate = null;
    this.minDate = null;
    this.doctype = null;
    this.Otconsentdata = null;
    this.consId = null;
    this.PageHeader = null;
    this.QrCode = null;
    this.reporturl = null;
    this.selectconsentdata = null;
    this.rightTypeCtrledit = null;
    this.filteredrightTypeArrayedit = null;
    this.result_dss = null;
    this.leftTypeCtrledit = null;
    this.filteredleftTypeArrayedit = null;
    this.newdoctorenablebtn = null;
    this.showspinner1 = null;
    this.partymaster_name = null;
    this.refferedby_name = null;
    this.counselorForm = null;
    this.corporateFrom = null;
    this.corporateData = null;
    this.checklistname = null;
    this.sschecklistModel = null;
    this.PostOpchecklistModel = null;
    this.PostOPchecklistnameData = null;
    this.PostOPchecklistname = null;
    this.options = null;
    this.RoutineExamModel = null;
    this.selectedRoutineExam = null;
    this.RoutinegetData = null;
    this.selectedDate = null;
    this.rowcolor = null;
    this.selecttime = null;
    this.titlebpSys = null;
    this.titlebpdy = null;
    this.titlebmi = null;
    this.titletemp = null;
    this.titlerbs = null;
    this.titlerespiration = null;
    this.titlespO2 = null;
    this.enableroutine = null;
    this.IOLgetData = null;
    this.getotRegdata = null;
    this.OtcaseSheetobj = null;
    this.OtcaseSheetArray = null;
    this.currentIndex = null;
    this.IOLBookingData = null;
    this.ipdAmount = null;
    this.routinecolorcode = null;
    this.getChargeType = null;
    this.ChargeTypeMasterName = null;
    this.RateTpyeName = null;
    this.RateTypeId = null;
    this.NursingChargesModel = null;
    this.chargeTypeId = null;
    this.OTpackageName = null;
    this.templateMaster = null;
    this.MediciantemplateMaster = null;
    this.InvestigationtemplateMaster = null;
    this.InstructiontemplateMaster = null;
    this.MediciantemplateDeleteArray = null;
    this.InvestigationtemplateDeleteArray = null;
    this.InstructiontemplateDeleteArray = null;
    this.CounselorCheckList = null;
    this.CounselorInvestigation = null;
    this.CounselorMedicineDetail = null;
    this.CounselorInstructionDetail = null;
    this.CounselorCheckDeleteArray = null;
    this.CounselorInvestigationDeleteArray = null;
    this.CounselorMedicineDetailDeleteArray = null;
    this.CounselorInstructionDetailDeleteArray = null;
    this.filterTemp = null;
    this.selectedTemprow = null;
    this.masterTemplateId = null;
    this.tempobj = null;
    this.templateMasterDisable = null;
    this.rowClickedTemplate = null;
    this.CounspreopDisable = null;
    this.SelectListRecord = null;
    this.indexdataCons = null;
    this.filterIns = null;
    this.ratetypeIPD = null;
    this.GAcheckedyes = null;
    this.GAcheckedno = null;
    this.GAcheckednone = null;
    this.Precheckedyes = null;
    this.Precheckedno = null;
    this.Precheckednone = null;
    this.PDcheckedyes = null;
    this.PDcheckedno = null;
    this.PDcheckednone = null;
    this.AQcheckedyes = null;
    this.AQcheckedno = null;
    this.AQcheckednone = null;
    this.SScheckedyes = null;
    this.SScheckedno = null;
    this.SScheckednone = null;
    this.Prequesdisable = null;
    this.RoomCategory = null;
    this.filteredRoomArray = null;
    this.roomcategoryName = null;
    this.isDropup = null;
    this.getinvestigationlab = null;

    this.viewconsmtiondata = null;
    this.getbatchnoData = null;
    this.locationgetData = null;
    this.payorNames = null;
    this.getdeparment = null;
    this.filteredStoreData = null;
    this.storeData = null;
    this.getstoretemData = null;
    this.totalAmount = null;
    this.totalNetAmount = null;
    this.roundedOffAmount = null;
    this.roundoff = null;
    this.addedItems = null;
    this.selectedItem = null;
    this.storesConsumeItemDetailsdata = null;
    this.searchQuery = null;
    this.searchbarcodeQuery = null;
    this.searchbatchnoQuery = null;
    this.barcodeQuery = null;
    this.filteredItemList = null;
    this.filteredbarcodeList = null;
    this.filterbatchcodeList = null;
    this.batchNo = null;
    this.expDate = null;
    this.rate = null;
    this.brate = null;
    this.mrp = null;
    this.batchid = null;
    this.saleQuantity = null;
    this.discountPercentage = null;
    this.discountAmount = null;
    this.gstAmount = null;
    this.decimalAmount = null;
    this.rateAmount = null;
    this.searchItemlist = null;
    this.searchbarcodelist = null;
    this.selectedStockQty = null;
    this.filteredSalesTypes = null;
    this.filteredSLocation = null;
    this.filterpayor = null;
    this.filterdeparment = null;
  }
  GetLocationData() {
    this.getipdLocation = [];
    try {
      this.ipdService
        .getIpdLocation(0)
        .pipe(takeUntil(this.destroyipd$))
        .subscribe(
          (item) => {
            this.getipdLocation = item;
          },
          (err) => {
            if (err.status == 403) {
              this.dashboardService.openSnackBar(
                "You Don't have Permission",
                "OK"
              );
            } else {
              this.dashboardService.openSnackBar("API Failed", "OK");
            }
          }
        );
    } catch (e) { }
  }
  GetotData() {
    this.getOTArray = [];
    let BranchId = this.authService.Loggeduser.branchid;
    try {
      this.ipdService
        .GetOTData(BranchId)
        .pipe(takeUntil(this.destroyipd$))
        .subscribe(
          (item) => {
            this.getOTArray = item.filter((x) => x.isActive == true);
            this.OtGroupControll();
          },
          (err) => {
            if (err.status == 403) {
              this.dashboardService.openSnackBar(
                "You Don't have Permission",
                "OK"
              );
            } else {
              this.dashboardService.openSnackBar("API Failed", "OK");
            }
          }
        );
    } catch (e) { }
  }
  //room category
  categoryRoomArray: any = [];
  getRoomCategoryMaster() {
    this.ipdService
      .getRoomCategoryMaster(this.authService.Loggeduser.specialityId)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (x: any) => {
          this.categoryRoomArray = [];
          this.categoryRoomArray = x.filter((item) => item.isActive == true);
          this.roomCategoryController();
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar(
              "You Don't have Permission",
              "OK"
            );
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }
  roomCategoryController() {
    this.RoomCategory = new FormControl();
    this.filteredRoomArray = this.RoomCategory.valueChanges.pipe(
      startWith(""),
      map((cat) =>
        cat ? this.filterroomfunction(cat) : this.categoryRoomArray.slice()
      )
    );
  }

  getroomobj2(e: any) {
    let roomID2 = e.option.id;
    this.fkroomcategoryid = roomID2;
    this.GetRecord();
  }
  checkValueroom(event: any) {
    var checkdata = event.target.value;
    if (checkdata == "") {
      // this.roomCategoryController();
      this.fkroomcategoryid = 0;
      this.GetRecord();
    }
  }
  filterroomfunction(name: string) {
    return this.categoryRoomArray.filter(
      (country) =>
        country.roomCategory.toLowerCase().indexOf(name.toLowerCase()) === 0
    );
  }
  //OT Diagram Modal
  OTDiagramModalDialog() {
    document.getElementById("OTDiagramModal").style.display = "block";
  }
  closeOTDiagramModalDialog() {
    document.getElementById("OTDiagramModal").style.display = "none";
  }

  //Status Modal
  StatusModalDialog() {
    document.getElementById("statusContainer").style.display = "block";
  }
  closeStatusModalDialog() {
    document.getElementById("statusContainer").style.display = "none";
  }

  //Operation Type Modal
  operationTypeModalDialog() {
    document.getElementById("operationType").style.display = "block";
  }
  closeoperationTypeModalDialog() {
    document.getElementById("operationType").style.display = "none";
  }

  //Case Type Modal
  caseTypeModalDialog() {
    document.getElementById("caseType").style.display = "block";
  }
  closecaseTypeModalDialog() {
    document.getElementById("caseType").style.display = "none";
  }

  //Anaesthetist Modal
  anaesthetistModalDialog() {
    document.getElementById("anaesthetistModal").style.display = "block";
  }
  closeanaesthetistModalDialog() {
    document.getElementById("anaesthetistModal").style.display = "none";
  }

  //OT Complications Modal
  otcomplicationsModalDialog() {
    document.getElementById("otcomplicationsModal").style.display = "block";
  }
  closeotcomplicationsModalDialog() {
    document.getElementById("otcomplicationsModal").style.display = "none";
  }

  //Scrub Nurse Modal
  scrubnurseModalDialog() {
    document.getElementById("scrubnurseModal").style.display = "block";
  }
  closescrubnurseModalDialog() {
    document.getElementById("scrubnurseModal").style.display = "none";
  }

  //GA Nurse Modal
  ganurseModalDialog() {
    document.getElementById("ganurseModal").style.display = "block";
  }
  closeganurseModalDialog() {
    document.getElementById("ganurseModal").style.display = "none";
  }

  //Surgeon Modal
  surgeonModalDialog() {
    document.getElementById("surgeonModal").style.display = "block";
  }
  closesurgeonModalDialog() {
    document.getElementById("surgeonModal").style.display = "none";
  }

  //Co Surgeon Modal
  cosurgeonModalDialog() {
    document.getElementById("cosurgeonModal").style.display = "block";
  }
  closecosurgeonModalDialog() {
    document.getElementById("cosurgeonModal").style.display = "none";
  }

  //Anaesthetist Type Modal
  anaesthetistTypeModalDialog() {
    document.getElementById("anaesthetistTypeModal").style.display = "block";
  }
  closeanaesthetistTypeModalDialog() {
    document.getElementById("anaesthetistTypeModal").style.display = "none";
  }

  //Theatre Modal
  theatreModalDialog() {
    document.getElementById("theatreModal").style.display = "block";
  }
  closetheatreModalDialog() {
    document.getElementById("theatreModal").style.display = "none";
  }

  //Assistant Doctor Modal
  assistantDoctorModalDialog() {
    document.getElementById("assistantDoctorModal").style.display = "block";
  }
  closeassistantDoctorModalDialog() {
    document.getElementById("assistantDoctorModal").style.display = "none";
  }

  //Circulating Nurse Modal
  circulatingNurseModalDialog() {
    document.getElementById("circulatingNurseModal").style.display = "block";
  }
  closecirculatingNurseModalDialog() {
    document.getElementById("circulatingNurseModal").style.display = "none";
  }

  //Duration Time Modal
  DurationModalDialog() {
    document.getElementById("DurationTime").style.display = "block";
  }
  closeDurationModalDialog() {
    document.getElementById("DurationTime").style.display = "none";
  }

  //OT Diagram Modal
  OTCaseSheetModal() {
    document.getElementById("OTCaseSheetModal").style.display = "block";
  }

  closeOTCaseSheetModal() {
    document.getElementById("OTCaseSheetModal").style.display = "none";
  }
  //OT register detail Modal
  OTregisterdetailModal() {
    document.getElementById("registerDetailModal").style.display = "block";
  }
  closeregisterDetailModal() {
    document.getElementById("registerDetailModal").style.display = "none";
  }
  //OT Diagram Modal
  generalSurgicalNotes() {
    if (this.surgicalRecordobj.pK_OTId > 0) {
      document.getElementById("generalSurgicalNotesModal").style.display =
        "block";
      this.getotnotedata(this.surgicalRecordobj.pK_OTId);
    }
  }
  closeGeneralSurgicalNotesModal() {
    this.otNotesArray = {};
    document.getElementById("generalSurgicalNotesModal").style.display = "none";
  }
  getotnotedata(otid) {
    this.ipdService.GetOtNotesByOTId(otid).subscribe(
      (item: any) => {
        this.otNotesArray = {};
        if (item.length > 0) {
          this.otNotesArray = item[0];
          this.otNotesArray.isActive = true;
          this.otNotesArray.isEdit = true;
          this.otNotesArray.fk_ModifiedByID =
            this.authService.Loggeduser.userid;
        } else {
          this.otNotesArray.pK_TranID = 0;
          this.otNotesArray.fK_OTID = this.surgicalRecordobj.pK_OTId;
          this.otNotesArray.fk_CreatedByID = this.authService.Loggeduser.userid;
          this.otNotesArray.fk_ModifiedByID = null;
          this.otNotesArray.isActive = true;
          this.otNotesArray.isEdit = false;
        }
      },
      (err) => {
        this.dashboardService.openSnackBar("API Failed", "ok");
      }
    );
  }
  InsertOtNotesrecord() {
    let payload = {
      OtNotes: this.otNotesArray,
    };
    this.ipdService.InsertOtNotes(payload).subscribe(
      (item: any) => {
        if (item.statusCode == 1) {
          if (this.otNotesArray.pK_TranID > 0) {
            this.dashboardService.openSnackBar(
              "Record Updated Successfully",
              "OK"
            );
          } else {
            this.dashboardService.openSnackBar(
              "Record Saved Successfully",
              "OK"
            );
          }

          this.getotnotedata(this.surgicalRecordobj.pK_OTId);
        }
      },
      (err) => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        }
        else if (err.error.statusCode == 422) {
          this.dashboardService.openSnackBar(err.error.message, "OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      }
    );
  }
  //Discharge Instruction Master Modal
  searchtemplate: any;
  helplistotnotesModal() {
    this.getotnoteMastyerdata("OT");
    document.getElementById("HelplistOTNotesModal").style.display = "block";
  }
  closehelplistotnotesModal() {
    this.OtNotesMasterArray = [];
    this.searchtemplate = null;
    this.OtNotesMasterobj = {};
    this.templateindex = -1;
    document.getElementById("HelplistOTNotesModal").style.display = "none";
  }
  templateindex = -1;
  changetemplate(data, index) {
    if (index == this.templateindex) {
      this.templateindex = -1;
      this.OtNotesMasterobj = {};
    } else {
      this.templateindex = index;
      this.OtNotesMasterobj = data;
    }
  }
  transfertemplatedata() {
    this.otNotesArray.operativeNotes = this.OtNotesMasterobj.otNotes;
    this.closehelplistotnotesModal();
  }
  AddNewtemplate() {
    this.templateindex = -1;
    this.OtNotesMasterobj = {};
    this.OtNotesMasterobj.pK_TranID = 0;
    this.OtNotesMasterobj.isDelete = false;
    this.OtNotesMasterobj.isEdit = false;
    this.OtNotesMasterobj.groupName = "OT";
    this.OtNotesMasterobj.isActive = true;
    this.OtNotesMasterobj.notesType = null;
    this.OtNotesMasterobj.otNotes = null;
  }
  InsertOtNotesMasterrecord(type) {
    if (type == 1) {
      this.OtNotesMasterobj.pK_TranID = this.OtNotesMasterobj.pK_TranID
        ? this.OtNotesMasterobj.pK_TranID
        : 0;
      this.OtNotesMasterobj.isEdit =
        this.OtNotesMasterobj.pK_TranID > 0 ? true : false;
      this.OtNotesMasterobj.groupName = "OT";
      this.OtNotesMasterobj.isActive = true;
      this.OtNotesMasterobj.isDelete = false;
    } else {
      this.OtNotesMasterobj.isEdit = true;
      this.OtNotesMasterobj.isActive = true;
      this.OtNotesMasterobj.isDelete = true;
    }
    if (this.OtNotesMasterArray.length > 0 && type == 1) {
      const checkdublicte = this.OtNotesMasterArray.filter(
        (item) =>
          item.notesType.toLowerCase() ==
          this.OtNotesMasterobj.notesType.toLowerCase()
      );
      if (checkdublicte.length > 0 && this.OtNotesMasterobj.pK_TranID == 0) {
        return this.dashboardService.openSnackBar(
          "Duplicate template name not Allowed",
          "OK"
        );
      }
    }

    let payload = {
      OtNotesMasterDto: this.OtNotesMasterobj,
    };
    this.ipdService.InsertOtNotesMaster(payload).subscribe(
      (item: any) => {
        if (item.statusCode == 1) {
          if (this.OtNotesMasterobj.pK_TranID > 0) {
            this.dashboardService.openSnackBar(
              "Record Updated Successfully",
              "OK"
            );
          } else {
            this.dashboardService.openSnackBar(
              "Record Saved Successfully",
              "OK"
            );
          }

          this.getotnoteMastyerdata("OT");
          this.OtNotesMasterobj = {};
          this.templateindex = -1;
        }
      },
      (err) => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        }
        else if (err.error.statusCode == 422) {
          this.dashboardService.openSnackBar(err.error.message, "OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      }
    );
  }
  getotnoteMastyerdata(ottype) {
    this.ipdService.GetOtNotesMasterByGroupName(ottype).subscribe(
      (item: any) => {
        this.OtNotesMasterArray = [];
        this.OtNotesMasterArray = item;
      },
      (err) => {
        this.dashboardService.openSnackBar("API Failed", "ok");
      }
    );
  }
  dischargeInstructionMasterModal() {
    document.getElementById("dischargeInstructionMasterModal").style.display =
      "block";
  }
  closeDischargeInstructionMasterModal() {
    this.savemasterArray = [];
    this.saveinstructionMaster = [];
    document.getElementById("dischargeInstructionMasterModal").style.display =
      "none";
  }

  //Post-Operative Checklist Modal
  postOperativeChecklistModal() {
    document.getElementById("postOperativeChecklistModal").style.display =
      "block";
  }
  closePostOperativeChecklistModal() {
    document.getElementById("postOperativeChecklistModal").style.display =
      "none";
  }
  //searchInstructionMasterModal
  InstructionMasterlistModal() {
    document.getElementById("searchInstructionMasterModal").style.display =
      "block";
  }
  closeInstructionMasterlistModal() {
    document.getElementById("searchInstructionMasterModal").style.display =
      "none";
  }

  //Add Consumable Items Modal
  addConsumableItemsModal() {
    if (this.deptId) {
      document.getElementById("AddConsumableItemsModal").style.display = "block";
    } else {
      this.dashboardService.openSnackBar("Please Select Department First", "ok");
    }
  }
  closeAddConsumableItemsModal() {
    document.getElementById("AddConsumableItemsModal").style.display = "none";
    this.addedItems = [];
    this.getbatchnoData = [];
    this.searchItemlist = [];
    this.selectedStockQty = 0;
    this.selecteditemStockQty = 0;
    this.barcodeQuery = "";

  }

  //Template Modal
  templateModal() {
    document.getElementById("templateModal").style.display = "block";
  }
  closeTemplateModal() {
    this.filterText = '';
    document.getElementById("templateModal").style.display = "none";
  }
  //OT Diagram Modal
  // iolModal() {

  //   document.getElementById("iolModal").style.display = "block";
  // }
  saveOtiolArray: IpdIolModel = {};
  iolModal(type) {
    this.ipdService
      .getOtiolsaveData(this.selectIpdId)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (x: any) => {
          if (type == 0) {
            document.getElementById("iolModal").style.display = "block";
          }
          if (x.length > 0) {
            this.saveOtiolArray = {};
            this.saveOtiolArray = x[0];
            this.saveOtiolArray.isEdit = true;
            this.saveOtiolArray.site =
              this.surgicalRecordobj?.site == null
                ? this.surgicalRecordobj?.site
                : this.surgicalRecordobj?.site;
            this.getIolDetail();
          } else {
            this.setdata();
          }
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar(
              "You Don't have Permission",
              "OK"
            );
          } else {
            this.dashboardService.openSnackBar("API Failed", "ok");
          }
        }
      );
  }

  setdata() {
    this.saveOtiolArray.isEdit = false;
    this.saveOtiolArray.pK_IOLId = 0;
    this.saveOtiolArray.fK_IPDId = Number(this.selectIpdId);
    this.saveOtiolArray.isAcitve = true;
    this.saveOtiolArray.site = this.surgicalRecordobj?.site
      ? this.surgicalRecordobj?.site
      : null;
    this.saveOtiolArray.k1R = null;
    this.saveOtiolArray.k2R = null;
    this.saveOtiolArray.axis = null;
    this.saveOtiolArray.k2Axis = null;
    this.saveOtiolArray.alx = null;
    this.saveOtiolArray.aConstant = null;
    this.saveOtiolArray.power = null;
    this.saveOtiolArray.aConstant2 = null;
    this.saveOtiolArray.power2 = null;
    this.saveOtiolArray.acpc = null;
    this.saveOtiolArray.typeofIOL = null;
    this.saveOtiolArray.modelCompany = null;
    this.saveOtiolArray.finalPower = null;
    this.saveOtiolArray.opSize = null;
    this.saveOtiolArray.plano = null;
    this.saveOtiolArray.needtoDiscuss = false;
    this.saveOtiolArray.iolRemarks = null;
    this.saveOtiolArray.machineName = null;
    this.saveOtiolArray.oldipdId = null;
    this.saveOtiolArray.lensThickness = null;
    this.saveOtiolArray.acd = null;
    this.saveOtiolArray.specularMicroscopy = null;
    this.saveOtiolArray.hexagonality = null;
    this.saveOtiolArray.cellDensity = null;
    this.saveOtiolArray.cellCount = null;
    this.getIolDetail();
  }
  detailiolArray: any = [];
  getIolDetail() {
    this.detailiolArray = [];
    this.detailiolArray = [
      {
        srno: 1,
        name: "K1 Reading",
        righteye: this.saveOtiolArray.k1R,
        enable: true,
      },
      {
        srno: 2,
        name: "K2 Reading",
        righteye: this.saveOtiolArray.k2R,
        enable: true,
      },
      {
        srno: 3,
        name: "K1-Axis",
        righteye: this.saveOtiolArray.axis,
        enable: true,
      },
      {
        srno: 4,
        name: "K2-Axis",
        righteye: this.saveOtiolArray.k2Axis,
        enable: true,
      },
      {
        srno: 5,
        name: "Axial Length",
        righteye: this.saveOtiolArray.alx,
        enable: true,
      },
      {
        srno: 6,
        name: "A-Constant",
        righteye: this.saveOtiolArray.aConstant,
        enable: true,
      },
      {
        srno: 7,
        name: "Power",
        righteye: this.saveOtiolArray.power,
        enable: true,
      },
      {
        srno: 8,
        name: "A-Constant",
        righteye: this.saveOtiolArray.aConstant2,
        enable: true,
      },
      {
        srno: 9,
        name: "Power",
        righteye: this.saveOtiolArray.power2,
        enable: true,
      },
      {
        srno: 10,
        name: "AC/PC",
        righteye: this.saveOtiolArray.acpc,
        enable: true,
      },
      {
        srno: 11,
        name: "Type of IOL",
        righteye: this.saveOtiolArray.typeofIOL,
        enable: true,
      },
      {
        srno: 12,
        name: "Company of IOL",
        righteye: this.saveOtiolArray.modelCompany,
        enable: true,
      },
      {
        srno: 13,
        name: "Final Power",
        righteye: this.saveOtiolArray.finalPower,
        enable: true,
      },
      {
        srno: 14,
        name: "Optic Dioptor",
        righteye: this.saveOtiolArray.opSize,
        enable: true,
      },
      {
        srno: 15,
        name: "Plano/Bio",
        righteye: this.saveOtiolArray.plano,
        enable: true,
      },
      {
        srno: 16,
        name: "MachineName",
        righteye: this.saveOtiolArray.machineName,
        enable: true,
      },
      {
        srno: 17,
        name: "LensThickNess",
        righteye: this.saveOtiolArray.lensThickness,
        enable: true,
      },
      {
        srno: 18,
        name: "ACD",
        righteye: this.saveOtiolArray.acd,
        enable: true,
      },
      {
        srno: 19,
        name: "SpecularMicroscopy",
        righteye: this.saveOtiolArray.specularMicroscopy,
        enable: true,
      },
      {
        srno: 20,
        name: "Hexagonality",
        righteye: this.saveOtiolArray.hexagonality,
        enable: true,
      },
      {
        srno: 21,
        name: "CellDensity",
        righteye: this.saveOtiolArray.cellDensity,
        enable: true,
      },
      {
        srno: 22,
        name: "CellCount",
        righteye: this.saveOtiolArray.cellCount,
        enable: true,
      },
    ];
  }

  Editioldata(i) {
    this.detailiolArray[i].enable = false;
  }
  closeiolEdit(i) {
    this.detailiolArray[i].enable = true;
  }
  closeIOLModal() {
    document.getElementById("iolModal").style.display = "none";
  }
  changedata(name: any, srno, i) {
    if (srno == 1) {
      this.detailiolArray[i].k1R = name;
      this.saveOtiolArray.k1R = name;
    } else if (srno == 2) {
      this.detailiolArray[i].k2R = name;
      this.saveOtiolArray.k2R = name;
    } else if (srno == 3) {
      this.detailiolArray[i].axis = name;
      this.saveOtiolArray.axis = name;
    } else if (srno == 4) {
      this.detailiolArray[i].k2Axis = name;
      this.saveOtiolArray.k2Axis = name;
    } else if (srno == 5) {
      this.detailiolArray[i].alx = name;
      this.saveOtiolArray.alx = name;
    } else if (srno == 6) {
      this.detailiolArray[i].aConstant = name;
      this.saveOtiolArray.aConstant = name;
    } else if (srno == 7) {
      this.detailiolArray[i].power = name;
      this.saveOtiolArray.power = name;
    } else if (srno == 8) {
      this.detailiolArray[i].aConstant2 = name;
      this.saveOtiolArray.aConstant2 = name;
    } else if (srno == 9) {
      this.detailiolArray[i].power2 = name;
      this.saveOtiolArray.power2 = name;
    } else if (srno == 10) {
      this.detailiolArray[i].acpc = name;
      this.saveOtiolArray.acpc = name;
    } else if (srno == 11) {
      this.detailiolArray[i].typeofIOL = name;
      this.saveOtiolArray.typeofIOL = name;
    } else if (srno == 12) {
      this.detailiolArray[i].modelCompany = name;
      this.saveOtiolArray.modelCompany = name;
    } else if (srno == 13) {
      this.detailiolArray[i].finalPower = name;
      this.saveOtiolArray.finalPower = name;
    } else if (srno == 14) {
      this.detailiolArray[i].opSize = name;
      this.saveOtiolArray.opSize = name;
    } else if (srno == 15) {
      this.detailiolArray[i].plano = name;
      this.saveOtiolArray.plano = name;
    } else if (srno == 16) {
      this.detailiolArray[i].machineName = name;
      this.saveOtiolArray.machineName = name;
    } else if (srno == 17) {
      this.detailiolArray[i].lensThickness = name;
      this.saveOtiolArray.lensThickness = name;
    } else if (srno == 18) {
      this.detailiolArray[i].acd = name;
      this.saveOtiolArray.acd = name;
    } else if (srno == 19) {
      this.detailiolArray[i].specularMicroscopy = name;
      this.saveOtiolArray.specularMicroscopy = name;
    } else if (srno == 20) {
      this.detailiolArray[i].hexagonality = name;
      this.saveOtiolArray.hexagonality = name;
    } else if (srno == 21) {
      this.detailiolArray[i].cellDensity = name;
      this.saveOtiolArray.cellDensity = name;
    } else if (srno == 22) {
      this.detailiolArray[i].cellCount = name;
      this.saveOtiolArray.cellCount = name;
    }
  }

  saveIoLData() {
    if (this.saveOtiolArray) {
      this.saveOtiolArray.site = this.saveOtiolArray.site.slice(0, 1);
    }
    let payload = {
      OtIolPowerDetail: this.saveOtiolArray,
    };
    this.ipdService
      .insertOtiolData(payload)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (x: any) => {
          this.dashboardService.openSnackBar(
            this.saveOtiolArray.pK_IOLId == 0
              ? "Record Saved Successfully"
              : "Record Updated Successfully",
            "ok"
          );
          this.iolModal(1);
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          }
          else if (err.error.statusCode == 422) {
            this.dashboardService.openSnackBar(err.error.message, "OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }
  //Get Opertation Type
  GetotTypeData() {
    this.getOPTypeArray = [];
    try {
      this.ipdService
        .GetOPType()
        .pipe(takeUntil(this.destroyipd$))
        .subscribe(
          (item) => {
            this.getOPTypeArray = item;
            this.OpTypeControll();
          },
          (err) => {
            if (err.status == 403) {
              this.dashboardService.openSnackBar(
                "You Don't have Permission",
                "OK"
              );
            } else {
              this.dashboardService.openSnackBar("API Failed", "OK");
            }
          }
        );
    } catch (e) { }
  }
  // Get Ot Theatre

  GetOtTheatreData() {
    this.getOtTheatreArray = [];
    let BranchId = this.authService.Loggeduser.branchid;
    try {
      this.ipdService
        .GetOtTheatre(BranchId)
        .pipe(takeUntil(this.destroyipd$))
        .subscribe(
          (item) => {
            this.getOtTheatreArray = item.filter((x) => x.isActive == true);
            this.OTThreateControll();
          },
          (err) => {
            if (err.status == 403) {
              this.dashboardService.openSnackBar(
                "You Don't have Permission",
                "OK"
              );
            } else {
              this.dashboardService.openSnackBar("API Failed", "OK");
            }
          }
        );
    } catch (e) { }
  }
  //get Postponed

  GetPostponedData() {
    this.getpospondArray = [];
    try {
      this.ipdService
        .GetPostponed()
        .pipe(takeUntil(this.destroyipd$))
        .subscribe(
          (item) => {
            this.getpospondArray = item;
            this.PosponedControll();
          },
          (err) => {
            if (err.status == 403) {
              this.dashboardService.openSnackBar(
                "You Don't have Permission",
                "OK"
              );
            } else {
              this.dashboardService.openSnackBar("API Failed", "OK");
            }
          }
        );
    } catch (e) { }
  }

  //get not yet reported

  GetNotYetReported() {
    this.TotalNotyetReported = 0;
    let BranchId = this.authService.Loggeduser.branchid;
    try {
      this.ipdService
        .NotyetReported(BranchId)
        .pipe(takeUntil(this.destroyipd$))
        .subscribe(
          (item) => {
            this.TotalNotyetReported = item;
          },
          (err) => {
            if (err.status == 403) {
              this.dashboardService.openSnackBar(
                "You Don't have Permission",
                "OK"
              );
            } else {
              this.dashboardService.openSnackBar("API Failed", "OK");
            }
          }
        );
    } catch (e) { }
  }
  //get schedule type
  getDoctorBrach() {
    this.dashboardService
      .getall_doctors()
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (data) => this.success_doctors(data),
        (err) => this.failed_doctors(err)
      );
  }

  success_doctors(data) {
    if (this.authService.masterdata.isExternal === true) {
      this.opdvisitService.doctors = data.filter(
        (item) => item.isExternal == false
      );
      this.doctorControll();
    } else {
      this.opdvisitService.doctors = data;
      this.doctorControll();
    }
  }
  failed_doctors(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }

  //autocomplet
  doctorControll() {
    this.DoctorCtrl = new FormControl();
    this.filteredDoctorArray = this.DoctorCtrl.valueChanges.pipe(
      startWith(""),
      map((cat) =>
        cat
          ? this.filterdoctorfunction(cat)
          : this.opdvisitService.doctors.slice()
      )
    );
  }
  doctorControll1() {
    this.doctorholdData = of(this.opdvisitService.doctors);
    this.DoctorCtrl1 = new FormControl();
    this.filteredDoctorArray1 = this.DoctorCtrl1.valueChanges.pipe(
      startWith(""),
      switchMap((value) => this._filter(value))
    );
  }
  private _filter(value: string): Observable<string[]> {
    const searchvalue = value?.toString().toLowerCase();
    return this.doctorholdData.pipe(
      map((options) =>
        options.filter((option) =>
          option.userName.toLowerCase().includes(searchvalue)
        )
      )
    );
  }
  doctorControll2() {
    this.doctorholdData = of(this.opdvisitService.doctors);
    this.DoctorCtrl2 = new FormControl();
    this.filteredDoctorArray2 = this.DoctorCtrl2.valueChanges.pipe(
      startWith(""),
      switchMap((value) => this._filter2(value))
    );
  }
  private _filter2(value: string): Observable<string[]> {
    const searchvalue = value?.toString().toLowerCase();
    return this.doctorholdData.pipe(
      map((options) =>
        options.filter((option) =>
          option.userName.toLowerCase().includes(searchvalue)
        )
      )
    );
  }
  filterdoctorfunction(name: string) {
    const len = Object.keys(name).length;
    if (len > 9) {
      return this.opdvisitService.doctors.filter(
        (country) => country.userName?.toLowerCase().indexOf(name) === 0
      );
    } else {
      return this.opdvisitService.doctors.filter(
        (country) =>
          country.userName?.toLowerCase().indexOf(name?.toLowerCase()) === 0
      );
    }
  }

  getdoctorobj(e: any) {
    var val = e.option.value;
    this.ShowDoctorName = val.userName;
    this.consultantId = val.userId;
  }
  newipddoctorId: number = 0;
  newipdrName: string = null;
  getdoctorobj2(e: any) {
    var val = e.option.value;
    this.newipdrName = val.userName;
    this.newipddoctorId = val.userId;
  }
  getdoctorobj1(e: any) {
    var val = e.option.value;
    this.dischargeDatamodel.drName = val.userName;
    this.dischargeDatamodel.fK_DoctorId = val.userId;
  }
  checkdocid(event: any) {
    if (event.target.value == "") {
      this.dischargeDatamodel.fK_DoctorId = null;
    }
  }
  CheckinputDoctor(event: any) {
    var checkdata = event.target.value;
    if (checkdata == "") {
      this.doctorControll();
      this.consultantId = 0;
      // this.ShowDoctorName = null;
    }
  }

  CheckinputDoctor2(event: any) {
    if (event.target.value == "") {
      // this.getipdExamlistObj.fK_DoctorID = null;
      // this.getipdExamlistObj.drName = null;
      this.newipdrName = null;
      this.newipddoctorId = 0;
      this.doctorControll2();
    }
  }
  //autocomplete OtGroup
  OtGroupControll() {
    this.OtgroupCtrl = new FormControl();
    this.filteredOtGroupArray = this.OtgroupCtrl.valueChanges.pipe(
      startWith(""),
      map((cat) => (cat ? this.filterOtfunction(cat) : this.getOTArray.slice()))
    );
  }

  filterOtfunction(name: string) {
    const len = Object.keys(name).length;
    if (len > 9) {
      return this.getOTArray.filter(
        (country) => country.groupName?.toLowerCase().indexOf(name) === 0
      );
    } else {
      return this.getOTArray.filter(
        (country) =>
          country.groupName?.toLowerCase().indexOf(name?.toLowerCase()) === 0
      );
    }
  }

  getOtGroupobj(e: any) {
    var val = e.option.value;
    this.otGroupName = val.groupName;
    this.otgroupId = val.id;
  }

  CheckinputOtgroup(event: any) {
    var checkdata = event.target.value;
    if (checkdata == "") {
      this.OtGroupControll();
      this.otgroupId = 0;
    }
  }

  //Autocomplete Op type

  OpTypeControll() {
    this.OpTypeCtrl = new FormControl();
    this.filteredOpTypeArray = this.OpTypeCtrl.valueChanges.pipe(
      startWith(""),
      map((cat) =>
        cat ? this.filterOpfunction(cat) : this.getOPTypeArray.slice()
      )
    );
  }

  filterOpfunction(name: string) {
    const len = Object.keys(name).length;
    if (len > 9) {
      return this.getOPTypeArray.filter(
        (country) =>
          country.operationTypeName?.toLowerCase().indexOf(name) === 0
      );
    } else {
      return this.getOPTypeArray.filter(
        (country) =>
          country.operationTypeName
            ?.toLowerCase()
            .indexOf(name?.toLowerCase()) === 0
      );
    }
  }

  getOpTypeobj(e: any) {
    var val = e.option.value;

    this.opTypeName = val.operationTypeName;
    this.opTypeId = val.pK_OperationTypeId;
  }

  CheckinputOpType(event: any) {
    var checkdata = event.target.value;
    if (checkdata == "") {
      this.OpTypeControll();
      this.opTypeId = 0;
    }
  }

  //Auto Ot Threate
  OTThreateControll() {
    this.OTTheatreCtrl = new FormControl();
    this.filteredOTTheatreArray = this.OTTheatreCtrl.valueChanges.pipe(
      startWith(""),
      map((cat) =>
        cat ? this.filterOTfunction(cat) : this.getOtTheatreArray.slice()
      )
    );
  }

  filterOTfunction(name: string) {
    const len = Object.keys(name).length;
    if (len > 9) {
      return this.getOtTheatreArray.filter(
        (country) => country.theatreName?.toLowerCase().indexOf(name) === 0
      );
    } else {
      return this.getOtTheatreArray.filter(
        (country) =>
          country.theatreName?.toLowerCase().indexOf(name?.toLowerCase()) === 0
      );
    }
  }

  getOTTheatreobj(e: any) {
    var val = e.option.value;
    this.OTTheatreName = val.theatreName;
    this.OTTheatreId = val.pK_OTTheatreId;
  }

  CheckinputOTTheatre(event: any) {
    var checkdata = event.target.value;
    if (checkdata == "") {
      this.OTThreateControll();
      this.OTTheatreId = 0;
    }
  }

  //auto complete postpond

  PosponedControll() {
    this.OperenedCtrl = new FormControl();
    this.filteredOperenedArray = this.OperenedCtrl.valueChanges.pipe(
      startWith(""),
      map((cat) =>
        cat ? this.filterpoponedfunction(cat) : this.getpospondArray.slice()
      )
    );
  }

  filterpoponedfunction(name: string) {
    const len = Object.keys(name).length;
    if (len > 9) {
      return this.getpospondArray.filter(
        (country) => country.status?.toLowerCase().indexOf(name) === 0
      );
    } else {
      return this.getpospondArray.filter(
        (country) =>
          country.status?.toLowerCase().indexOf(name?.toLowerCase()) === 0
      );
    }
  }

  getOperenedobj(e: any) {
    var val = e.option.value;
    this.PostpondName = val.status;
    this.postpondId = val.id;
  }

  CheckinputOperened(event: any) {
    var checkdata = event.target.value;
    if (checkdata == "") {
      this.PosponedControll();
      this.postpondId = 0;
    }
  }
  GetColor(color: any) {
    var colorcode = Number(color).toString(16);
    if (colorcode == "ff") {
      colorcode = "ff0000";
    } else if (colorcode == "ff00") {
      colorcode = "00ff00";
    } else if (colorcode == "ffff") {
      colorcode = "ffff00";
    }

    return "#" + colorcode + "!important";
    // const hexcode ='#00' + parseInt(colorcode).toString(16).toUpperCase();
    // return hexcode;
  }
  locationColor(locationid) {
    if (locationid != null) {
      const colorcode = this.getipdLocation.filter(
        (item) => item.pK_TranId == locationid
      );
      if (colorcode.length > 0) {
        var hexcolorcode = Number(colorcode[0]?.locationColorCode).toString(16);
        if (hexcolorcode == "ff") {
          hexcolorcode = "ff0000";
        } else if (hexcolorcode == "ff00") {
          hexcolorcode = "00ff00";
        } else if (hexcolorcode == "ffff") {
          hexcolorcode = "ffff00";
        }

        return "#" + hexcolorcode;
      }
    }
  }

  CurrentPatient(val) {
    if (val == 0) {
      this.admssionById = "Y";
    } else {
      this.admssionById = "A";
    }
  }
  selectType(event: any) {
    this.searchselecttype = event;
  }
  GetRecord() {
    var patientid = 0;
    var pName = 0;
    var IpdIdby = 0;
    if (
      this.searchselecttype == "UHID" &&
      this.serachUhid != null &&
      this.serachUhid != ""
    ) {
      patientid = this.serachUhid;
    } else {
      patientid = 0;
    }
    if (
      this.searchselecttype == "PName" &&
      this.serachUhid != null &&
      this.serachUhid != ""
    ) {
      pName = this.serachUhid;
    } else {
      pName = 0;
    }
    if (
      this.searchselecttype == "IPDId" &&
      this.serachUhid != null &&
      this.serachUhid != ""
    ) {
      IpdIdby = this.serachUhid;
    } else {
      IpdIdby = 0;
    }

    if (this.postpondId == 2) {
      this.ipdDahboarddata = this.ipdDahboarddata.filter(
        (item) => item.isPostponed == true
      );
    } else if (this.postpondId == 3) {
      this.ipdDahboarddata = this.ipdDahboarddata.filter(
        (item) => item.isPostponed == false
      );
    } else {
      this.GetIpdData(
        this.admssionById,
        this.admissionFrom,
        this.admissionTo,
        this.dischargeFrom,
        this.dischargeTo,
        0,
        this.consultantId,
        patientid,
        IpdIdby,
        this.opTypeId,
        this.OTTheatreId,
        pName,
        this.otgroupId,
        this.fkroomcategoryid
      );
    }
    document.getElementById("advanceSearchFilterModal").style.display = "none";
  }
  // get ipd data
  GetIpdData(
    admissionid,
    admissionFromdate,
    admissionTodte,
    dischargeFromdate,
    dischargeTodte,
    RoomCategoryId,
    ConsultantId,
    PatientID,
    IPDID,
    OperationTypeId,
    TheatreId,
    PatientName,
    OTGroupid,
    fk_roomcategoryid
  ) {
    let BranchId = this.authService.Loggeduser.branchid;
    let admissionFrom = this.datePipe.transform(
      admissionFromdate,
      "yyyy-MM-dd"
    );
    let admissionTo = this.datePipe.transform(admissionTodte, "yyyy-MM-dd");
    let dischargeFrom = this.datePipe.transform(
      dischargeFromdate,
      "yyyy-MM-dd"
    );
    let dischargeTo = this.datePipe.transform(dischargeTodte, "yyyy-MM-dd");
    try {
      this.showspinner = true;
      this.ipdService
        .GetALlIpdData(
          BranchId,
          admissionid,
          admissionFrom,
          admissionTo,
          dischargeFrom,
          dischargeTo,
          RoomCategoryId,
          ConsultantId,
          PatientID,
          IPDID,
          OperationTypeId,
          TheatreId,
          PatientName,
          OTGroupid,
          fk_roomcategoryid
        )
        .pipe(takeUntil(this.destroyipd$))
        .subscribe((data) => {
          this.ipdDahboarddata = [];
          if (data.length > 0) {
            this.ipdDahboarddata = data;
            this.Totalcurrent = data.length;
          }
          this.showspinner = false;
        });
    } catch (e) {
      this.showspinner = false;
    }
  }

  Amountcolor(amountColor) {
    if (amountColor == "Y") {
      return "Green";
    } else {
      return "";
    }
  }

  PatientMoveOtherLocation(ipdid, locationid) {
    this.ipdService
      .MoveOtherLocation(ipdid, locationid)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (data) => this.successMove(data),
        (err) => this.failedMove(err)
      );
  }
  successMove(data) {
    this.rowClicked = -1;
    this.checklocid = 0;
    this.checkipdid = 0;
    this.dashboardService.openSnackBar("Successfully Move Patient", "OK");
    document.getElementById("moveotherLocation").style.display = "none";
    this.dischargeFrom = "";
    this.dischargeTo = "";
    let admissionid = "Y";
    this.GetIpdData(
      admissionid,
      this.admissionFrom,
      this.admissionTo,
      this.dischargeFrom,
      this.dischargeTo,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      this.fkroomcategoryid
    );
    this.closePatientLocationSelectionModal()
  }
  failedMove(err) {
    document.getElementById("moveotherLocation").style.display = "none";
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }
  drugalerystring: string = "";
  // drupaleergyArray: any = [];
  changeTableRowColor(element: any, idx: any) {
    this.ratetypeIPD = element.rateType;
    this.corporateData = element;
    this.partymaster_name = element.shortName;
    this.selectIpdId = element.pK_IPDId;
    this.selectCouncelorId = element.fK_ConsId;
    if (this.rowClicked === idx) {
      this.checkipdid = 0;
      this.RegId = 0;
      this.rowClicked = -1;
      this.ipdDahboardobjdata = {};
      this.drugalerystring = "";
      // this.drupaleergyArray = [];
    } else {
      this.checkipdid = element.pK_IPDId;
      this.RegId = element.fK_RegId;
      this.rowClicked = idx;
      this.ipdDahboardobjdata = element;
      if (element.isDrugAllergy == true) {
        this.ipdService
          .get_allergies(this.RegId)
          .pipe(takeUntil(this.destroyipd$))
          .subscribe(
            (x: any) => {
              //   this.drupaleergyArray = [];
              if (x.length > 0) {
                this.drugalerystring = x.map((x1) => x1.saltName).join(",");
                //    this.drupaleergyArray = x;
              } else {
                this.drugalerystring = "";
              }
            },
            (err) => {
              if (err.status == 403) {
                this.dashboardService.openSnackBar(
                  "You Don't have Permission",
                  "OK"
                );
              } else {
                this.dashboardService.openSnackBar("API Failed", "OK");
              }
            }
          );
      } else {
        this.drugalerystring = "";
      }
      this.ipdService
        .get_otherinfo(this.RegId)
        .pipe(takeUntil(this.destroyipd$))
        .subscribe(
          (x: any) => {
            if (x) {
              this.ipdDahboardobjdata.pasthistroydata = x.pastEyeHistory;
            } else {
              this.ipdDahboardobjdata.pasthistroydata = "";
            }
          },
          (err) => {
            if (err.status == 403) {
              this.dashboardService.openSnackBar(
                "You Don't have Permission",
                "OK"
              );
            } else {
              this.dashboardService.openSnackBar("API Failed", "OK");
            }
          }
        );
    }
  }
  TableRowColor(idx: any) {
    if (this.rowClickedipdDoctor === idx) {
      this.rowClickedipdDoctor = -1;
    } else {
      this.rowClickedipdDoctor = idx;
    }
  }
  MoveOtherLocation(locid) {
    if (this.checkipdid > 0) {
      this.checklocid = locid;
      document.getElementById("moveotherLocation").style.display = "block";
    } else {
      this.checklocid = 0;
      this.dashboardService.openSnackBar("Please select Patient", "OK");
    }
  }
  MovePatient() {
    if (this.checkipdid > 0 && this.checklocid > 0) {
      this.PatientMoveOtherLocation(this.checkipdid, this.checklocid);
    }
  }
  cancelMove() {
    this.checklocid = 0;
    this.checkipdid = 0;
    document.getElementById("moveotherLocation").style.display = "none";
  }
  openDoc() {
    if (this.RegId > 0) {
      this.opendocdialog()
    }
    else {
      this.dashboardService.openSnackBar("Please Select Patient", "OK");
    }
  }
  opendocdialog(): void {
    const dialogRef = this.dialog.open(PatientDocumentComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "80vw",
      // height: "90%",
      width: "60%",
      data: { PatinetId: this.RegId, Ipdid: this.selectIpdId, checkboth: 1 },
    });

    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroyipd$))
      .subscribe((result) => {
        console.log("The dialog was closed");
        // this.animal = result;
      });

    // }

    // else {
    //   this.dashboardService.openSnackBar("Please Select Patient", "OK");
    // }
  }
  getsummary_url(type) {
    if (this.RegId > 0) {
      this.dashboardService
        .getsummary_url()
        .pipe(takeUntil(this.destroyipd$))
        .subscribe(
          (data) => this.succesurl(data, this.RegId, type),
          (err) => this.failedurl(err)
        );
    } else {
      this.dashboardService.openSnackBar("Please Select Patient", "OK");
    }
  }

  toggleDrawer() {
    // fun for patient transfer
    if (this.selectIpdId > 0) {
      this.drawer.toggle();
      this.GetIPDDashboardHeadName();
      this.GetIPDTrackingDetailByIPDId();
    } else {
      this.dashboardService.openSnackBar("Please Select Patient", "OK");
    }
  }

  GetIPDDashboardHeadName() {
    // api for getting the name of the headers of ipd dashboard
    this.ipdService.GetIPDDashboardHeadName().subscribe(
      (response: any) => {
        this.headNames = response;
      },
      (err) => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      }
    );
  }

  GetIPDTrackingDetailByIPDId() {
    //api for GetIPDTrackingDetailByIPDId
    this.ipdService.GetIPDTrackingDetailByIPDId(this.selectIpdId).subscribe(
      (response: any) => {
        this.trackingDetail = response;
        console.log(this.trackingDetail, "Tracking Detail>>");
      },
      (err) => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      }
    );
  }
  headerdata(header: any, i: number) {
    const lastIndex = this.trackingDetail.length - 1;
    if (
      this.trackingDetail.length > 0 &&
      header?.headName === this.trackingDetail[lastIndex]?.headName
    ) {
      this.dashboardService.openSnackBar(
        "This patient is already transferred for this location.",
        "OK"
      );
    } else {
      this.indexClicked = i;
      this.inserttrackingdata.pK_TranId = 0;
      this.inserttrackingdata.fK_IPDId = this.selectIpdId;
      this.inserttrackingdata.fK_HeadId = header.pK_HeadID;
      this.inserttrackingdata.isActive = true;
      this.inserttrackingdata.comments = null;
      // this.inserttrackingdata.isEdit = false;
      this.inserttrackingdata.fK_CreatedById =
        this.authService.Loggeduser.userid;
    }
  }

  oncommentChange(detail: any, event: any) {
    this.inserttrackingdata.pK_TranId = detail.pK_TranId;
    this.inserttrackingdata.fK_IPDId = this.selectIpdId;
    this.inserttrackingdata.fK_HeadId = detail.fK_HeadId;
    this.inserttrackingdata.isActive = true;
    this.inserttrackingdata.comments = event.target.value;
    // this.inserttrackingdata.isEdit = false;
    this.inserttrackingdata.fK_CreatedById = this.authService.Loggeduser.userid;
  }

  InsertIPDTrackingDetail() {
    this.inserttrackingdata.entryDateTime = this.datePipe.transform(
      new Date(),
      "yyyy-MM-dd HH:mm:ss"
    );
    const message =
      this.inserttrackingdata.pK_TranId <= 0
        ? "Patient moved successfully."
        : "Record updated successfully.";
    this.ipdService.InsertIPDTrackingDetail(this.inserttrackingdata).subscribe(
      (data) => {
        this.openpateinttransferModal(message);
        this.inserttrackingdata = {};
        this.indexClicked = -1;
        this.GetIPDTrackingDetailByIPDId();
      },
      (err) => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        }
        else if (err.error.statusCode == 422) {
          this.dashboardService.openSnackBar(err.error.message, "OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      }
    );
  }

  openpateinttransferModal(message: any) {
    document.getElementById("patienttransferModal").style.display = "block";
    const messageElement = document.getElementById("modalMessage");
    if (messageElement) {
      messageElement.innerText = message;
    }
  }

  closepatienttransferModal() {
    document.getElementById("patienttransferModal").style.display = "none";
  }

  succesurl(data, patientid, type) {
    const urldate = data.filter((item) => item.propertyName == "WebURL");
    const url = urldate[0].propertyValue;
    if (type == 1) {
      let checkreporttype = this.authService.webreportConfig.filter(
        (item) =>
          item.printOption == "Medical Record" &&
          item.printType == "NetramReport"
      );
      if (checkreporttype.length > 0) {
        var newWindow = window.open(
          url +
          "PatientEMRSummary.aspx?RegID=" +
          patientid +
          "&BillCompanyName=" +
          this.authService.Loggeduser.billingcompanyname +
          "&VisitOrderType=DESC" +
          "&BranchId=" +
          this.authService.Loggeduser.branchid
        );
      } else {
        this.ipdService.printTimelineBill(patientid);
      }
    } else if (type == 2) {
      var newWindow = window.open(
        url +
        "ProcedureSummmaryLocal.aspx?RegID=" +
        patientid +
        "&BillCompanyName=" +
        this.authService.Loggeduser.billingcompanyname +
        "&BranchId=" +
        this.authService.Loggeduser.branchid
      );
    } else if (type == 3) {
      let checkreporttype = this.authService.webreportConfig.filter(
        (item) =>
          item.printOption == "DischargeSummary" &&
          item.printType == "NetramReport"
      );
      if (checkreporttype.length > 0) {
        window.open(
          url +
          "DischargeSummary.aspx?RegID=" +
          patientid +
          "&IPDID=" +
          this.selectIpdId +
          "&BillCompanyName=" +
          this.authService.Loggeduser.billingcompanyname +
          "&BranchId=" +
          this.authService.Loggeduser.branchid +
          "&PageHeadWebReport=" +
          this.pageheadType
        );
      } else {
        this.printTimelinePrecheclistreport("DischargeSummary");
      }
    }
  }
  showOptions(event: MatCheckboxChange): void {
    if (event.checked == true) {
      this.pageheadType = "Y";
    } else {
      this.pageheadType = "N";
    }
  }
  failedurl(err) { }
  PatientTracking() {
    const dialogRef = this.dialog.open(PatientTrackingComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "80vw",
      width: "75%",
      data: null,
    });

    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroyipd$))
      .subscribe((result) => {
        console.log("The dialog was closed");
      });
  }
  PatientpreWorkup() {
    const dialogRef = this.dialog.open(PreopWorkupComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "90vw",
      width: "90vw",
      height: "80%",
      data: null,
    });

    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroyipd$))
      .subscribe((result) => {
        console.log("The dialog was closed");
      });
  }
  PatientLab() {
    const dialogRef = this.dialog.open(PatientLabComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "80vw",
      width: "60%",
      height: "60%",
      data: null,
    });

    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroyipd$))
      .subscribe((result) => {
        console.log("The dialog was closed");
      });
  }
  PatientBedTranfer() {
    const dialogRef = this.dialog.open(PatientBedTransferComponent, {
      // panelClass: "full-width-dialog",
      maxWidth: "95vw",
      width: "100%",
      //height: "100%",
      data: null,
    });

    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroyipd$))
      .subscribe((result) => {
        console.log("The dialog was closed");
      });
  }

  preOperativeWorkup() {
    if (this.templateMaster.length > 0) {
      this.selectTemplateRow(this.templateMaster[0], 0);
    }
    document.getElementById("preOperativeWorkup").style.display = "block";
  }
  templateNameenter() {
    this.templateMasterDisable = false;
  }
  cancelpreOperativeWorkup() {
    this.templateMaster = [];
    this.getPreOpTemplateMaster(0);
    document.getElementById("preOperativeWorkup").style.display = "none";
  }
  getAnesthesiaMasterList() {
    this.ipdService
      .getAnesthesiaMaster()
      .pipe(takeUntil(this.destroyipd$))
      .subscribe((data) => {
        this.dataSource.data = data;
        this.masterData = data;
        if (this.prerecordlength == 0) {
          this.masterData = data;
          this.addPreList();
        }
      });
  }

  selectRow(row) {
    this.selectedrow = row;

    if (this.selectedrow.pK_TranId === 0) {
      this.selectedrow.isEdit = false;
      this.modifyList[row.Uid] = row;
    } else {
      this.selectedrow.isEdit = true;
      this.modifyList[this.selectedrow.pK_TranId] = this.selectedrow;
    }
  }

  saveRecord() {
    const arrayList = Object.keys(this.modifyList).map(key => this.modifyList[key]);
    const preQList: any[] = [];

    this.ipdService
      .getAnesthesiaMaster()
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(existingData => {
        const existingHeadNames = existingData?.map(d => d.headName) || [];
        const newHeadNames = arrayList.map(item => item.headName);

        if (newHeadNames.some(n => existingHeadNames.includes(n))) {
          this.dashboardService.openSnackBar("Duplicate Head Names are not allowed", "OK");
          return;
        }

        const missing = arrayList.filter(item => !item.headName?.trim());
        if (missing.length) {
          this.dashboardService.openSnackBar("Header name is required", "OK");
          return;
        }

        arrayList
          .filter(item => item.pK_TranId === 0)
          .forEach(element => {
            preQList.push({
              actualValue: element.defaultValues,
              fK_IPDID: this.selectIpdId,
              headName: element.headName,
              isEdit: element.isEdit,
              isHeader: element.isHeader,
              isHidden: element.isHidden,
              pK_SynchId: element.pK_SynchId,
              pK_TranId: 0,
            });
          });

        if (preQList.length) {
          this.ipdService
            .addAnesthesiaIpd({ AnesthesiaQuestionsDetailDto: preQList })
            .pipe(takeUntil(this.destroyipd$))
            .subscribe(
              () => {
                if (this.prerecordlength === 0) {
                  this.getAnesthesiaMasterList();
                } else {
                  this.getByIPdList(this.selectIpdId);
                }
              },
              err => {
                if (err.status === 403) {
                  this.dashboardService.openSnackBar("You Don't have Permission", "OK");
                } else {
                  this.dashboardService.openSnackBar("API Failed", "OK");
                }
              }
            );
        }

        this.payLoad = { AnesthesiaQuestionsDto: arrayList };
        this.ipdService
          .addAnesthesiaMaster(this.payLoad)
          .pipe(takeUntil(this.destroyipd$))
          .subscribe(
            resp => {
              if (resp.statusCode === 1) {
                const newItems = arrayList.filter(item => item.pK_TranId === 0);
                this.dataSource.data = [...this.dataSource.data, ...newItems];
                this.dashboardService.openSnackBar("Record Saved Successfully", "OK");
              }

              this.sidenav.toggle();
              this.modifyList = {};
            },
            err => {
              if (err.status === 403) {
                this.dashboardService.openSnackBar("You Don't have Permission", "OK");
              } else if (err.error?.statusCode === 422) {
                this.dashboardService.openSnackBar(err.error.message, "OK");
              } else {
                this.dashboardService.openSnackBar("API Failed", "OK");
              }
            }
          );
      });
  }

  openMaster() {
    // this.Prequesdisable = false;
    // this.getAnesthesiaMasterList();
    this.sidenav.toggle();
  }
  addRow() {
    const newRow: UserMaster = {
      pK_TranId: 0,
      headName: "",
      defaultValues: "",
      isHeader: false,
      isActive: true,
      pK_SynchId: null,
      isEdit: false,
      isHidden: false,
      Uid: this.dataSource.data.length + 1,
    };
    this.dataSource.data = [newRow, ...this.dataSource.data];
  }
  cancelbtn() {
    this.sidenav.toggle();
    this.modifyList = {};
    // this.getAnesthesiaMasterList();
  }
  preaneQuestion: boolean = false;
  getByIPdList(id) {
    this.prerecordlength = "";
    this.ipdService
      .getByIpdId(id, 0)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe((data) => {
        if (data.length > 0) {
          this.preaneQuestion = true;
          const checkYesvalue = data.filter(
            (item) => item.actualValue && item.actualValue.toLocaleLowerCase() == "yes"
          );
          const checkNovalue = data.filter(
            (item) => item.actualValue && item.actualValue.toLocaleLowerCase() == "no"
          );
          const checkNonevalue = data.filter(
            (item) => item.actualValue && item.actualValue.toLocaleLowerCase() == "none"
          );
          if (data.length == checkYesvalue.length) {
            this.AQcheckedyes = true;
            this.AQcheckedno = false;
            this.AQcheckednone = false;
          } else if (data.length == checkNovalue.length) {
            this.AQcheckedyes = false;
            this.AQcheckedno = true;
            this.AQcheckednone = false;
          } else if (data.length == checkNonevalue.length) {
            this.AQcheckedyes = false;
            this.AQcheckedno = false;
            this.AQcheckednone = true;
          } else {
            this.AQcheckedyes = false;
            this.AQcheckedno = false;
            this.AQcheckednone = false;
          }
          this.dataSourceWorkup.data = data;
        } else {
          this.preaneQuestion = false;
          this.prerecordlength = data.length;
          this.addPreList();
        }
      });
  }

  addPreList() {
    this.masterDataList = [];
    this.masterData.forEach((element) => {
      this.masterDataList.push({
        actualValue: element.defaultValues,
        fK_IPDID: this.selectIpdId,
        headName: element.headName,
        isEdit: false,
        isHeader: element.isHeader,
        isHidden: element.isHidden,
        pK_SynchId: element.pK_SynchId,
        pK_TranId: 0,
      });
    });
    this.dataSourceWorkup.data = this.masterDataList;
    this.patIpdlist = this.masterDataList;
  }

  selectedTabValue(event) {
    this.selectedTabIndex = event.index;
    this.labelName = event.tab.textLabel;
    // if(this.labelName == "Corporate Detail"){
    //   this.addCorporateDetail();
    // }
    // if (this.labelName == "Pre-Anae Question") {
    //   this.getByIPdList(this.selectIpdId);
    //   this.getAnesthesiaMasterList();
    // }
    // else if (this.labelName == "Pre-Op Checklist") {
    //   this.getPreOpListIpdId(this.selectIpdId);
    // }
    //this.getByIPdList(this.selectIpdId);
    // this.getPreOpListIpdId(this.selectIpdId);
    if (this.labelName == "GA Checklist") {
      //   this.getGACheckListIpdId(this.selectIpdId);
    } else if (this.labelName == "Pre-op Checklist") {
      this.getPreOpCheckListMaster();
    } else if (this.labelName == "Nursing Workup") {
      if (this.selectCouncelorId > 0) {
        this.GetCounselorPreOpMedicinedetail(this.selectCouncelorId);
      }
    } else if (this.labelName == "otconsumable") {

      if (this.viewconsmtiondata.length > 0) {
        this.perpopup()
      } else {
        if (this.getdeparment.length > 0 && this.authService.masterdata.fK_DeptID != null) {
          this.ShowDepName = this.getdeparment.filter((item) => item.pkDeptId == this.authService.masterdata.fK_DeptID)[0]?.deptName
          this.depselect(0)
        }
      }
      var rounfOff = this.opdvisitService.documentrul.filter(item => item?.propertyName == "RoundOff_Final");
      if (rounfOff[0].propertyValue != null && rounfOff[0].propertyValue != undefined) {
        this.roundoff = 1 + '.' + rounfOff[0]?.propertyValue + '-' + rounfOff[0]?.propertyValue
      }

      var roudOffLimit = this.opdvisitService.documentrul.filter(item => item?.propertyName == "RoudOffLimit");
      if (rounfOff[0].propertyValue != null && roudOffLimit[0].propertyValue != undefined) {
        this.roundoffLimit = 1 + '.' + roudOffLimit[0]?.propertyValue + '-' + roudOffLimit[0]?.propertyValue
      }

      var gstlabel = this.opdvisitService.documentrul.filter(item => item?.propertyName == "GST_OR_VAT");
      if (gstlabel[0].propertyValue != null && gstlabel[0].propertyValue != undefined) {
        this.con_dynamiclabel = gstlabel[0]?.propertyValue
      }

      var conSaleQty = this.opdvisitService.documentrul.filter(item => item?.propertyName == "DefaultQtyForSales");
      if (conSaleQty[0].propertyValue != null && conSaleQty[0].propertyValue != undefined) {
        this.saleQuantity = conSaleQty[0]?.propertyValue
      }

      // var conDeptBillNoGeneration = this.opdvisitService.documentrul.filter(item => item?.propertyName == "DeptBillNoGenerationType");
      // if(conDeptBillNoGeneration[0].propertyValue!=null && conDeptBillNoGeneration[0].propertyValue!= undefined){
      //    this.con_BillNoGeneration = conDeptBillNoGeneration[0]?.propertyValue
      //    console.log(this.con_BillNoGeneration,'called con_BillNoGeneration')
      // }
      //  var autoBatch = this.opdvisitService.documentrul.filter(item => item?.propertyName == "PharmacyAutoBatch");
      // if(autoBatch[0].propertyValue!=null && autoBatch[0].propertyValue!= undefined){
      //   this.con_autoBatch = autoBatch[0]?.propertyValue
      //    console.log(  this.con_autoBatch,'called con_BillNoGeneration')
      // }
    }



    // this.GetDischargeData(this.selectIpdId);

    // this.getOtConsent(this.selectIpdId);
    // this.getGACheckListMaster();
  }

  selectPreanae(row, i) {
    this.dataSourceWorkup.data[i] = row;
    if (this.dataSourceWorkup.data[i].pK_TranId === 0) {
      this.dataSourceWorkup.data[i].isEdit = false;
      this.patIpdlist = this.masterDataList;
    } else {
      this.dataSourceWorkup.data[i].isEdit = true;
      this.dataSourceWorkup.data[i].fK_IPDID = this.selectIpdId;
      this.patIpdlist = this.dataSourceWorkup.data;
    }
    this.dataSourceWorkup.data = this.dataSourceWorkup.data.map((item) => {
      if (item.pK_TranId === 0) {
        item.isEdit = false;
      } else {
        item.isEdit = true;
        item.fK_IPDID = this.selectIpdId;
      }
      return item;
    });
  }
  getvalue(value) {
    this.Prequesdisable = false;
    // masterDataList
    // this.selectpre.actualValue = value;
    this.dataSourceWorkup.data.map((item) => (item.actualValue = value));
    this.dataSourceWorkup.data = this.dataSourceWorkup.data.map((item) => {
      if (item.pK_TranId === 0) {
        item.isEdit = false;
      } else {
        item.isEdit = true;
        item.fK_IPDID = this.selectIpdId;
      }
      return item;
    });
    // this.dataSourceWorkup.data.map(item => item.isEdit = false);
    const checkYesvalue = this.dataSourceWorkup.data.filter(
      (item) => item.actualValue.toLocaleLowerCase() == "yes"
    );
    const checkNovalue = this.dataSourceWorkup.data.filter(
      (item) => item.actualValue.toLocaleLowerCase() == "no"
    );
    const checkNonevalue = this.dataSourceWorkup.data.filter(
      (item) => item.actualValue.toLocaleLowerCase() == "none"
    );
    if (this.dataSourceWorkup.data.length == checkYesvalue.length) {
      this.AQcheckedyes = true;
      this.AQcheckedno = false;
      this.AQcheckednone = false;
    } else if (this.dataSourceWorkup.data.length == checkNovalue.length) {
      this.AQcheckedyes = false;
      this.AQcheckedno = true;
      this.AQcheckednone = false;
    } else if (this.dataSourceWorkup.data.length == checkNonevalue.length) {
      this.AQcheckedyes = false;
      this.AQcheckedno = false;
      this.AQcheckednone = true;
    } else {
      this.AQcheckedyes = false;
      this.AQcheckedno = false;
      this.AQcheckednone = false;
    }
    this.patIpdlist = this.dataSourceWorkup.data;
  }
  getAQSelectvalue(event, i) {
    this.Prequesdisable = false;
    this.dataSourceWorkup.data[i].isEdit =
      this.dataSourceWorkup.data[i].pK_TranId > 0 ? true : false;
    this.dataSourceWorkup.data[i].actualValue = event.value;
    const checkYesvalue = this.dataSourceWorkup.data.filter(
      (item) => item.actualValue && item.actualValue.toLocaleLowerCase() == "yes"
    );
    const checkNovalue = this.dataSourceWorkup.data.filter(
      (item) => item.actualValue && item.actualValue.toLocaleLowerCase() == "no"
    );
    const checkNonevalue = this.dataSourceWorkup.data.filter(
      (item) => item.actualValue && item.actualValue.toLocaleLowerCase() == "none"
    );
    if (this.dataSourceWorkup.data.length == checkYesvalue.length) {
      this.AQcheckedyes = true;
      this.AQcheckedno = false;
      this.AQcheckednone = false;
    } else if (this.dataSourceWorkup.data.length == checkNovalue.length) {
      this.AQcheckedyes = false;
      this.AQcheckedno = true;
      this.AQcheckednone = false;
    } else if (this.dataSourceWorkup.data.length == checkNonevalue.length) {
      this.AQcheckedyes = false;
      this.AQcheckedno = false;
      this.AQcheckednone = true;
    } else {
      this.AQcheckedyes = false;
      this.AQcheckedno = false;
      this.AQcheckednone = false;
    }
  }
  PreAQcheckstatus(option, i) {
    if (this.dataSourceWorkup.data[i].actualValue != null) {
      return (
        this.dataSourceWorkup.data[i].actualValue.toLocaleLowerCase() ==
        option.toLocaleLowerCase()
      );
    } else {
      return false;
    }
  }
  savePatIpd(event) {
    const button =
      event.srcElement.disabled === undefined
        ? event.srcElement.parentElement
        : event.srcElement;
    button.setAttribute("disabled", true);
    // setTimeout(function () {
    //   button.removeAttribute('disabled');
    // }, 1000);
    let preList = Object.keys(this.patIpdlist).map(
      (key) => this.patIpdlist[key]
    );
    let payLoadList = {
      AnesthesiaQuestionsDetailDto: preList,
    };
    this.ipdService
      .addAnesthesiaIpd(payLoadList)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (data) => {
          if (data.statusCode == 1) {
            this.Prequesdisable = true;
            this.getByIPdList(this.selectIpdId);
            this.dashboardService.openSnackBar(
              "Record Updated Successfully",
              "OK"
            );
          }
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          } else if (err.error.statusCode == 422) {
            this.dashboardService.openSnackBar(err.error.message, "OK");
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }

  closeModal() {
    this.isDepartmentSelected = true;
    this.getstoretemData = [];
    this.addedItems = [];
    this.getbatchnoData = [];
    this.billNo = '';
    this.consumeid = null;
    this.temId = null;
    this.filterText = ''
    this.isVoiceEnabled = false;
    this.clarecalculation();
    document.getElementById("ipdWorkUpModal").style.display = "none";
  }

  openModal() {
    this.GAcheckedyes = false;
    this.GAcheckedno = false;
    this.GAcheckednone = false;
    this.Precheckedyes = false;
    this.Precheckedno = false;
    this.Precheckednone = false;
    this.PDcheckedyes = false;
    this.PDcheckedno = false;
    this.PDcheckednone = false;
    this.AQcheckedyes = false;
    this.AQcheckedno = false;
    this.AQcheckednone = false;
    this.SScheckedyes = false;
    this.SScheckedno = false;
    this.SScheckednone = false;
    this.sschecklistModel = [];
    this.PostOpchecklistModel = [];
    this.masterListDataByName = [];
    this.changeSaveInstructionmodel = [];
    this.OTRegisterIdArray = [];
    this.newdoctorenablebtn = false;
    this.showspinner1 = false;
    if (this.checkipdid > 0) {
      this.labelName = "OT Consent";
      this.selectedTabIndex = 0;
      if (this.corporateData.surgTime != null) {
        this.counselorForm = true;
        this.ipdService.content.next(this.corporateData);
        this.getCounselorPreOpDetail(this.selectCouncelorId);
      } else {
        this.counselorForm = false;
      }
      if (this.corporateData.shortName != "CASH") {
        this.corporateFrom = true;
        this.ipdService.content.next(this.corporateData);
      } else {
        this.corporateFrom = false;
      }
      this.getInstructiondata(0);
      this.getipdExamlistByIpdId(0, this.selectIpdId);
      document.getElementById("ipdWorkUpModal").style.display = "block";
      this.GetsurgeryStausIddata();
      this.doctorControll1();
      this.doctorControll2();
      this.InstrcutionControll();
      this.getPreOpCheckListMaster();
      this.getByIPdList(this.selectIpdId);
      this.getPreOpListIpdId(this.selectIpdId);
      this.getGACheckListIpdId(this.selectIpdId);
      this.GetDischargeData(this.selectIpdId);
      this.getPainSacle(this.selectIpdId);
      this.getOtConsent(this.selectIpdId);
      this.getInstructionMasterData(0);
      this.getDischargeSUmmery(this.selectIpdId);
      this.GetDosageMaster(0, 0, 0);
      this.getinstructionSummery(this.selectIpdId);
      this.getlaabinvestigation(this.selectIpdId);
      this.getDischargeExamination(this.selectIpdId);
      this.getDischaredMedicine(this.selectIpdId);
      this.GetSurgeryOtRegister(this.selectIpdId);
      this.GetPatientGeneralCheckupDetailByRegId(this.RegId, 0);
      this.getNametype();
      this.getAnaePopup();
      this.getDeptMaster();

      this.checklistname = null;
      this.GetSsCheckListByIPDId(this.selectIpdId);
      this.PostOPchecklistname = null;
      this.GetPostOpCheckListByIPDId(
        this.selectIpdId
      );

      var selectData = this.ipdDahboarddata.filter(
        (item) => item.pK_IPDId == this.checkipdid
      );

      this.selectipdData = selectData[0];

      const personmaster_obj = this.opdvisitService.personmaster.find(
        (item) => item.pkPersonId == this.selectipdData.fkReferredbyId
      );
      if (personmaster_obj?.personName != null) {
        this.refferedby_name = personmaster_obj?.personName;
      } else {
        this.refferedby_name = null;
      }
      this.getexamType();
      this.GetNursingInstructiondata();
      this.GetNursingChartdata();
      this.GetNursingMedicineDetail();
      this.GetCounselorPreOpMedicinedetail(this.selectCouncelorId);
      this.ipdService.GetSsCheckListName();
      this.GetPostOpCheckListName();
      this.ShowCheckListName = null;
      this.opdvisitService.get_patient_docurl();
      // this.GetpackagebyIpdId(this.selectIpdId);
      this.getotcasesheetData(1);

      // this.RateTpyeName = "General";
      this.PreopAssesmentRecordindication = false;
      this.RateTypeId = this.ratetypeIPD;
      var rate = this.billingservice.ratetype.filter(
        (item) => item.rateTypeId == this.ratetypeIPD
      );
      this.RateTpyeName = rate[0].rateType;
      this.NURSINGCHARGETYPEMASTER();
      this.get_rate_list();
      this.GetNursingChargesByIPDId();
      this.getPreOpTemplateMaster(0);
      this.GetPreOpAssesmentRecord(this.RegId, this.selectIpdId);
      this.GetAnestheticRecordByIPDId(this.selectIpdId);
      this.GetPostAnesthesiaRecoverybyid(this.selectIpdId);
      this.getViewconsumtion();
    } else {
      this.checklocid = 0;
      this.dashboardService.openSnackBar("Please Select Patient", "OK");
    }
  }

  getPreOpCheckListMaster() {
    this.ipdService
      .getPreOpListMaster()
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (data) => {
          this.masterListData = [];
          // this.dataSource.data = data;
          this.masterListData = data;
          this.PreOpListControll();
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar(
              "You Don't have Permission",
              "OK"
            );
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }
  PreOpListControll() {
    this.myControl = new FormControl();
    this.PreOpListArray = this.myControl.valueChanges.pipe(
      startWith(""),
      map((option) =>
        option
          ? this.filterPreOpListfunction(option)
          : this.masterListData.slice()
      )
    );
  }
  filterPreOpListfunction(name: string) {
    const len = Object.keys(name).length;
    if (len > 9) {
      return this.masterListData.filter(
        (item) => item.checkListName?.toLowerCase().indexOf(name) === 0
      );
    } else {
      return this.masterListData.filter(
        (item) =>
          item.checkListName?.toLowerCase().indexOf(name?.toLowerCase()) === 0
      );
    }
  }
  getPreOpListobj(e: any) {
    var val = e.option.value;
    this.ShowCheckListName = val.checkListName;
    this.Checklistname = this.ShowCheckListName.replace(/\//g, "~");
    this.TransId = val.pK_TranId;
    this.getPreOpByIPdList(this.Checklistname);
  }

  CheckinputPreOpList(event: any) {
    var checkdata = event.target.value;
    if (checkdata == "") {
      this.PreOpListControll();
      this.TransId = 0;
      this.ShowCheckListName = null;
      this.getPreOpListIpdId(this.selectIpdId);
    }
  }
  preopchecklistchecked: boolean = false;
  getPreOpListIpdId(id) {
    this.ipdService
      .getPreOpListByIpdId(id)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (data) => {
          this.masterListDataByName = [];
          if (data.length > 0) {
            this.preopchecklistchecked = true;
            data.forEach((element) => {
              this.masterListDataByName.push({
                pK_TranId: element.pK_TranId,
                checkListName: element.checkListName,
                headName: element.headName,
                defaultValues: element.actualValue,
                isHeader: element.isHeader,
                isActive: true,
                fK_IPDID: element.fK_IPDID,
                isEdit: element.isEdit,
              });
            });
            const checkdefaultvalue = this.masterListDataByName.filter(
              (item) => item.defaultValues != null && item.defaultValues != ""
            );
            if (checkdefaultvalue.lenght > 0) {
              const checkYesvalue = checkdefaultvalue.filter(
                (item) => item.defaultValues.toString().toLowerCase() == "yes"
              );
              const checkNovalue = checkdefaultvalue.filter(
                (item) => item.defaultValues.toString().toLowerCase() == "no"
              );
              const checkNonevalue = checkdefaultvalue.filter(
                (item) => item.defaultValues.toString().toLowerCase() == "none"
              );
              if (this.masterListDataByName.length == checkYesvalue.length) {
                this.Precheckedyes = true;
                this.Precheckedno = false;
                this.Precheckednone = false;
              } else if (
                this.masterListDataByName.length == checkNovalue.length
              ) {
                this.Precheckedyes = false;
                this.Precheckedno = true;
                this.Precheckednone = false;
              } else if (
                this.masterListDataByName.length == checkNonevalue.length
              ) {
                this.Precheckedyes = false;
                this.Precheckedno = false;
                this.Precheckednone = true;
              } else {
                this.Precheckedyes = false;
                this.Precheckedno = false;
                this.Precheckednone = false;
              }
            }
            this.masterListDataByName;
          } else {
            this.preopchecklistchecked = false;
          }
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          } else if (err.error.statusCode == 422) {
            this.dashboardService.openSnackBar(err.error.message, "OK");
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }

  getPreOpByIPdList(checkname) {
    this.masterListDataByName = [];

    this.ipdService
      .getPreOplistByIpdname(checkname)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (data) => {
          if (data.length > 0) {
            const checkYesvalue = data.filter(
              (item) => String(item.defaultValues).toLowerCase() == "yes"
            );
            const checkNovalue = data.filter(
              (item) => String(item.defaultValues).toLowerCase() == "no"
            );
            const checkNonevalue = data.filter(
              (item) => String(item.defaultValues).toLowerCase() == "none"
            );
            if (data.length == checkYesvalue.length) {
              this.Precheckedyes = true;
              this.Precheckedno = false;
              this.Precheckednone = false;
            } else if (data.length == checkNovalue.length) {
              this.Precheckedyes = false;
              this.Precheckedno = true;
              this.Precheckednone = false;
            } else if (data.length == checkNonevalue.length) {
              this.Precheckedyes = false;
              this.Precheckedno = false;
              this.Precheckednone = true;
            } else {
              this.Precheckedyes = false;
              this.Precheckedno = false;
              this.Precheckednone = false;
            }
            this.masterListDataByName = data;
            this.masterListDataByName.map(item => item.pK_TranId = 0);


          }
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar(
              "You Don't have Permission",
              "OK"
            );
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }

  // selectPreOp(row) { 
  //   this.selectpreOpList = row;
  //   this.indexdata = this.selectpreOpList.pK_TranId;
  //   if (this.selectpreOpList.checkListName == undefined) {
  //     this.selectpreOpList.checkListName = this.ShowCheckListName;
  //   }
  //   if (this.selectpreOpList.fK_IPDID == undefined) {
  //     this.selectpreOpList.fK_IPDID = 0;
  //   }

  //   this.preIpdlist[this.indexdata] = this.selectpreOpList;
  // }
  getPreOpListvalue(value) {

    this.masterListDataByName.map((item) => (item.defaultValues = value));
    this.masterListDataByName.map((item) => (item.isEdit = 1, item.fK_IPDID = this.selectIpdId));
    const checkYesvalue = this.masterListDataByName.filter(
      (item) => String(item.defaultValues).toLowerCase() == "yes"
    );
    const checkNovalue = this.masterListDataByName.filter(
      (item) => String(item.defaultValues).toLowerCase() == "no"
    );
    const checkNonevalue = this.masterListDataByName.filter(
      (item) => String(item.defaultValues).toLowerCase() == "none"
    );
    if (this.masterListDataByName.length == checkYesvalue.length) {
      this.Precheckedyes = true;
      this.Precheckedno = false;
      this.Precheckednone = false;
    } else if (this.masterListDataByName.length == checkNovalue.length) {
      this.Precheckedyes = false;
      this.Precheckedno = true;
      this.Precheckednone = false;
    } else if (this.masterListDataByName.length == checkNonevalue.length) {
      this.Precheckedyes = false;
      this.Precheckedno = false;
      this.Precheckednone = true;
    } else {
      this.Precheckedyes = false;
      this.Precheckedno = false;
      this.Precheckednone = false;
    }

  }
  getPreOpSelectvalue(event, i) {

    this.masterListDataByName[i].isEdit =
      this.masterListDataByName[i].pK_TranId > 0 ? 1 : 0;
    this.masterListDataByName[i].defaultValues = event.value;
    const checkYesvalue = this.masterListDataByName.filter(
      (item) => String(item.defaultValues).toLowerCase() == "yes"
    );
    const checkNovalue = this.masterListDataByName.filter(
      (item) => String(item.defaultValues).toLowerCase() == "no"
    );
    const checkNonevalue = this.masterListDataByName.filter(
      (item) => String(item.defaultValues).toLowerCase() == "none"
    );
    if (this.masterListDataByName.length == checkYesvalue.length) {
      this.Precheckedyes = true;
      this.Precheckedno = false;
      this.Precheckednone = false;
    } else if (this.masterListDataByName.length == checkNovalue.length) {
      this.Precheckedyes = false;
      this.Precheckedno = true;
      this.Precheckednone = false;
    } else if (this.masterListDataByName.length == checkNonevalue.length) {
      this.Precheckedyes = false;
      this.Precheckedno = false;
      this.Precheckednone = true;
    } else {
      this.Precheckedyes = false;
      this.Precheckedno = false;
      this.Precheckednone = false;
    }
  }
  Precheckstatus(option, i) {
    if (this.masterListDataByName[i].defaultValues != null) {
      return (
        this.masterListDataByName[i].defaultValues.toLocaleLowerCase() ==
        option.toLocaleLowerCase()
      );
    } else {
      return false;
    }
  }

  SavePreOpListIpd(event) {
    const button = (event.srcElement.disabled === undefined) ? event.srcElement.parentElement : event.srcElement;
    button.setAttribute('disabled', true);
    this.ipdService.getPreOpListByIpdId(this.selectIpdId).pipe(takeUntil(this.destroyipd$)).subscribe((data) => {
      const checkdata = data;
      const checkduplicate = checkdata?.filter(item => String(item.checkListName).toLowerCase() == String(this.ShowCheckListName).toLowerCase());
      if (checkduplicate.length > 0) {
        button.removeAttribute('disabled');
        return this.dashboardService.openSnackBar(
          "Duplicate checklist is not Allowed",
          "OK"
        );
      }
      if (this.masterListDataByName.length > 0) {
        if (checkdata.length > 0) {
          const checkduplicate = checkdata.reduce((unique, o) => {
            if (unique.some(obj => obj.headName === o.headName && obj.checkListName === o.checkListName)) {
              unique.push(o);
            }
            return unique;
          }, []);
          if (checkduplicate.length > 1) {
            button.removeAttribute('disabled');
            return this.dashboardService.openSnackBar(
              "Duplicate Record is not Allowed",
              "OK"
            );
          }
        }
        var updatepayload = [];
        this.masterListDataByName.forEach((item) => {
          updatepayload.push({
            PK_TranId: item.pK_TranId > 0 ? item.pK_TranId : 0,
            CheckListName: item.checkListName ? item.checkListName : this.ShowCheckListName,
            HeadName: item.headName,
            ActualValue: item.defaultValues,
            IsHeader: item.isHeader,
            FK_IPDID: this.selectIpdId,
            IsEdit: item.pK_TranId > 0 ? 1 : 0,
          });
        });
        let payloaddat = {
          PreOpCheckList: updatepayload,
        };
        this.ipdService
          .updatePreOpListIpd(payloaddat)
          .pipe(takeUntil(this.destroyipd$))
          .subscribe(
            (data) => {
              button.removeAttribute('disabled');
              if (data.statusCode == 7 || data.statusCode == 1) {
                this.ShowCheckListName = null;
                const updatedata = this.masterListDataByName.filter((x: any) => x.pK_TranId == 0);
                if (updatedata.length > 0) {
                  this.dashboardService.openSnackBar(
                    "Record Saved Successfully",
                    "OK"
                  );

                } else {
                  this.dashboardService.openSnackBar(
                    "Record Updated Successfully",
                    "OK"
                  );
                }
                this.getPreOpListIpdId(this.selectIpdId);
              } else {
                this.dashboardService.openSnackBar(
                  data.statusCode,
                  "OK"
                );
              }


            },
            (err) => {
              button.removeAttribute('disabled');
              if (err.status == 403) {
                this.dashboardService.openSnackBar("You Don't have Permission", "OK");
              } else if (err.error.statusCode == 422) {
                this.dashboardService.openSnackBar(err.error.message, "OK");
              } else {
                this.dashboardService.openSnackBar("API Failed", "OK");
              }
            }
          );

      } else {
        button.removeAttribute('disabled');
        this.dashboardService.openSnackBar("No Record Found", "OK");
      }

    })
  }

  gachecklistdata: boolean = false;
  getGACheckListIpdId(id) {
    // this.masterdataGA = [];

    this.masterdataGA = [];
    this.ipdService
      .getGAListByIpdId(id)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe((data) => {
        this.GAmasterListData = [];
        if (data.length > 0) {
          this.gachecklistdata = true;
          this.masterdataGA = data;
          data.forEach((element) => {
            this.GAmasterListData.push({
              pK_TranId: element.pK_TranId,
              checkListName: element.checkListName,
              headName: element.headName,
              defaultValues: element.actualValue,
              isHeader: element.isHeader,
              isActive: element.isActive,
              fK_IPDID: element.fK_IPDID,
              isEdit: element.isEdit,
            });
          });
          if (this.GAmasterListData.length > 0) {
            const checkYesvalue = this.GAmasterListData.filter(
              (item) => item.defaultValues?.toString().toLowerCase() == "yes"
            );
            const checkNovalue = this.GAmasterListData.filter(
              (item) => item.defaultValues?.toString().toLowerCase() == "no"
            );
            const checkNonevalue = this.GAmasterListData.filter(
              (item) => item.defaultValues?.toString().toLowerCase() == "none"
            );
            if (this.GAmasterListData.length == checkYesvalue.length) {
              this.GAcheckedyes = true;
              this.GAcheckedno = false;
              this.GAcheckednone = false;
            } else if (this.GAmasterListData.length == checkNovalue.length) {
              this.GAcheckedyes = false;
              this.GAcheckedno = true;
              this.GAcheckednone = false;
            } else if (this.GAmasterListData.length == checkNonevalue.length) {
              this.GAcheckedyes = false;
              this.GAcheckedno = false;
              this.GAcheckednone = true;
            } else {
              this.GAcheckedyes = false;
              this.GAcheckedno = false;
              this.GAcheckednone = false;
            }
          } else {
            this.GAcheckedyes = false;
            this.GAcheckedno = false;
            this.GAcheckednone = false;
          }
          // this.masterdataGA= this.GAmasterListData;
        } else {
          this.gachecklistdata = false;
          this.getGACheckListMaster();
        }
      });
  }
  getGACheckListMaster() {
    this.GAmasterListData = [];
    this.ipdService
      .getGAListMaster()
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (data) => {
          if (data.length > 0) {
            this.GAmasterListData = data;
          }
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar(
              "You Don't have Permission",
              "OK"
            );
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }
  indexdata: number;
  selectGAList(row) {
    this.selectGA = row;
    this.indexdata = this.selectGA.pK_TranId;
    this.GAIpdlist[this.selectGA.pK_TranId] = this.selectGA;
  }
  // getGAListvalue(value) {

  //   var i = this.indexdata;

  //   if (this.GAmasterListData.find(o => o.pK_TranId === i)) {
  //     this.GAmasterListData.find(o => o.pK_TranId === i).defaultValues = value;
  //     this.GAIpdlist = this.GAmasterListData;
  //   }
  //   this.indexdata++;
  // }
  getGAListvalue(value) {
    this.GAmasterListData.map((item) => (item.defaultValues = value));
    this.GAmasterListData.map((item) => (item.isEdit = 1));

    const checkYesvalue = this.GAmasterListData.filter(
      (item) => item.defaultValues.toString().toLowerCase() == "yes"
    );
    const checkNovalue = this.GAmasterListData.filter(
      (item) => item.defaultValues.toString().toLowerCase() == "no"
    );
    const checkNonevalue = this.GAmasterListData.filter(
      (item) => item.defaultValues.toString().toLowerCase() == "none"
    );
    if (this.GAmasterListData.length == checkYesvalue.length) {
      this.GAcheckedyes = true;
      this.GAcheckedno = false;
      this.GAcheckednone = false;
    } else if (this.GAmasterListData.length == checkNovalue.length) {
      this.GAcheckedyes = false;
      this.GAcheckedno = true;
      this.GAcheckednone = false;
    } else if (this.GAmasterListData.length == checkNonevalue.length) {
      this.GAcheckedyes = false;
      this.GAcheckedno = false;
      this.GAcheckednone = true;
    } else {
      this.GAcheckedyes = false;
      this.GAcheckedno = false;
      this.GAcheckednone = false;
    }
    this.GAIpdlist = this.GAmasterListData;
  }
  getGASelectvalue(event, i) {
    this.GAmasterListData[i].isEdit =
      this.GAmasterListData[i].pK_TranId > 0 ? 1 : 0;
    this.GAmasterListData[i].defaultValues = event.value;
    const checkYesvalue = this.GAmasterListData.filter(
      (item) => item.defaultValues.toString().toLowerCase() == "yes"
    );
    const checkNovalue = this.GAmasterListData.filter(
      (item) => item.defaultValues.toString().toLowerCase() == "no"
    );
    const checkNonevalue = this.GAmasterListData.filter(
      (item) => item.defaultValues.toString().toLowerCase() == "none"
    );
    if (this.GAmasterListData.length == checkYesvalue.length) {
      this.GAcheckedyes = true;
      this.GAcheckedno = false;
      this.GAcheckednone = false;
    } else if (this.GAmasterListData.length == checkNovalue.length) {
      this.GAcheckedyes = false;
      this.GAcheckedno = true;
      this.GAcheckednone = false;
    } else if (this.GAmasterListData.length == checkNonevalue.length) {
      this.GAcheckedyes = false;
      this.GAcheckedno = false;
      this.GAcheckednone = true;
    } else {
      this.GAcheckedyes = false;
      this.GAcheckedno = false;
      this.GAcheckednone = false;
    }
  }
  GAcheckstatus(option, i) {
    if (this.GAmasterListData[i].defaultValues != null) {
      return (
        this.GAmasterListData[i].defaultValues.toLocaleLowerCase() ==
        option.toLocaleLowerCase()
      );
    } else {
      return false;
    }
  }
  GAIpdlistup: any = [];
  saveGAList() {
    let GALists = Object.keys(this.GAmasterListData).map(
      (key) => this.GAmasterListData[key]
    );
    let upGAList = Object.keys(this.GAIpdlist).map(
      (key) => this.GAIpdlist[key]
    );
    if (this.masterdataGA.length > 0) {
      //update case

      if (upGAList.length > 0) {
        this.GAIpdlistup = [];
        upGAList.forEach((item) => {
          this.GAIpdlistup.push({
            PK_TranId: item.pK_TranId,
            CheckListName: item.checkListName,
            HeadName: item.headName,
            ActualValue: item.defaultValues,
            IsHeader: item.isHeader,
            FK_IPDID: this.selectIpdId,
            IsEdit: 1,
          });
        });
      }
      let GAData = {
        GACheckList: this.GAIpdlistup,
      };
      this.ipdService
        .updateGACheckList(GAData)
        .pipe(takeUntil(this.destroyipd$))
        .subscribe((data) => {
          if (data.statusCode == 1) {
            this.getGACheckListIpdId(this.selectIpdId);
            // this.getGACheckListMaster();
          }
          this.GAIpdlistup = [];

          this.dashboardService.openSnackBar(
            " Record Updated Successfully",
            "OK"
          );
        });

      console.log("update Data ", GAData);
    } else {
      //insert case
      if (GALists.length > 0) {
        this.GAIpdlist = [];
        GALists.forEach((item) => {
          this.GAIpdlist.push({
            PK_TranId: 0,
            CheckListName: item.checkListName,
            HeadName: item.headName,
            ActualValue: item.defaultValues,
            IsHeader: item.isHeader,
            FK_IPDID: this.selectIpdId,
            IsEdit: 0,
          });
        });
      }
      let GAData = {
        GACheckList: this.GAIpdlist,
      };
      this.ipdService
        .saveGACheckList(GAData)
        .pipe(takeUntil(this.destroyipd$))
        .subscribe(
          (data) => {
            if (data.statusCode == 1) {
              this.getGACheckListIpdId(this.selectIpdId);
            }
            this.GAIpdlist = [];

            this.dashboardService.openSnackBar(
              "Record Saved Successfully",
              "OK"
            );
          },
          (err) => {
            if (err.status == 403) {
              this.dashboardService.openSnackBar("You Don't have Permission", "OK");
            }
            else if (err.error.statusCode == 422) {
              this.dashboardService.openSnackBar(err.error.message, "OK");
            }
            else {
              this.dashboardService.openSnackBar("API Failed", "OK");
            }
          }
        );

      console.log("Save Data ", GAData);
    }
  }

  //Not Yet Reported
  notYetReportedArray: any = [];
  notYetReported() {
    this.timeFormatArray = [];
    this._value = 0;
    this._hourvalue = 0;
    if (this.TotalNotyetReported > 0) {
      let sdate = this.datePipe.transform(
        this.authService.getServerDate,
        "yyyy-MM-dd"
      );
      this.ipdService
        .GetNotYetReported(this.authService.Loggeduser.branchid, sdate)
        .pipe(takeUntil(this.destroyipd$))
        .subscribe(
          (data) => {
            this.notYetReportedArray = [];
            this.notYetReportedArray = data;
            document.getElementById("notYetReportedModal").style.display =
              "block";
          },
          (err) => {
            if (err.status == 403) {
              this.dashboardService.openSnackBar(
                "You Don't have Permission",
                "OK"
              );
            } else {
              this.dashboardService.openSnackBar("API Failed", "OK");
            }
            document.getElementById("notYetReportedModal").style.display =
              "none";
          }
        );
    } else {
      this.dashboardService.openSnackBar("No Record Found", "OK");
    }
  }
  CancelnotYetReported() {
    document.getElementById("notYetReportedModal").style.display = "none";
  }

  //Discharge Time
  newindex: number = -1;
  checknursemedTranid: number = 0;
  admissionTime(type: any, index?: number, cehcid?: number) {
    this.ChangetimeName = type;
    this.timeFormatArray = [];
    this._value = 0;
    this._hourvalue = 0;
    this.newindex = index;
    this.checknursemedTranid = cehcid;
    document.getElementById("admissionTimeModal").style.display = "block";
  }
  CanceladmissionTime() {
    document.getElementById("admissionTimeModal").style.display = "none";
  }
  color: any;
  _value: number = 0;
  _hourvalue: number = 0;
  _step: number = 1;
  _min: number = 0;
  _max: number = 60;
  _hourmax: number = 12;
  _wrap: boolean = false;

  myFormGroup = new FormGroup({
    formField: new FormControl(),
  });

  set inputValue(_value: number) {
    this._value = this.parseNumber(_value);
  }

  set step(_step: number) {
    this._step = this.parseNumber(_step);
  }

  set min(_min: number) {
    this._min = this.parseNumber(_min);
  }

  set max(_max: number) {
    this._max = this.parseNumber(_max);
  }

  set hourmax(_hourmax: number) {
    this._hourmax = this.parseNumber(_hourmax);
  }

  set wrap(_wrap: boolean) {
    this._wrap = this.parseBoolean(_wrap);
  }

  private parseNumber(num: any): number {
    return +num;
  }

  private parseBoolean(bool: any): boolean {
    return !!bool;
  }

  setColor(color: string): void {
    this.color = color;
  }

  getColor(): string {
    return this.color;
  }

  incrementValue(step: number = 1): void {
    let inputValue = this._value + step;

    if (this._wrap) {
      inputValue = this.wrappedValue(inputValue);
    }
    this._value = inputValue;
  }

  hoursincrementValue(step: number = 1): void {
    let hourinputValue = this._hourvalue + step;

    if (this._wrap) {
      hourinputValue = this.hourwrappedValue(hourinputValue);
    }

    this._hourvalue = hourinputValue;
  }

  private wrappedValue(inputValue): number {
    if (inputValue > this._max) {
      return this._min + inputValue - this._max;
    }

    if (inputValue < this._min) {
      if (this._max === 12) {
        return 0;
      }

      return this._max + inputValue;
    }

    return inputValue;
  }

  private hourwrappedValue(hourinputValue): number {
    if (hourinputValue > this._hourmax) {
      return this._min + hourinputValue - this._hourmax;
    }

    if (hourinputValue < this._min) {
      if (this._hourmax === 60) {
        return 0;
      }

      return this._hourmax + hourinputValue;
    }

    return hourinputValue;
  }

  shouldDisableDecrement(inputValue: number): boolean {
    return !this._wrap && inputValue <= this._min;
  }

  shouldDisableIncrement(inputValue: number): boolean {
    return !this._wrap && inputValue >= this._max;
  }

  hourshouldDisableDecrement(hourinputValue: number): boolean {
    return !this._wrap && hourinputValue <= this._min;
  }

  hourshouldDisableIncrement(hourinputValue: number): boolean {
    return !this._wrap && hourinputValue >= this._hourmax;
  }

  changeFormat(event: any) {
    this.timeFormatcheck = event;
  }
  // add time
  timeFormatArray: any = [];
  addTime(hr, min) {
    if (hr > 12 || min > 59 || min == null || hr == null) {
      return this.dashboardService.openSnackBar("Select Valid Time", "OK");
    } else if (hr < 1 || min < 0) {
      return this.dashboardService.openSnackBar("Select Valid Time", "OK");
    }
    let bindtime = hr + ":" + min + " " + this.timeFormatcheck;
    // this.timeFormatArray.push({
    //   "dosageTime": bindtime
    // });
    if (this.ChangetimeName == 1) {
      this.getipddischargeData[0].ipdAdmTime = bindtime;
    } else if (this.ChangetimeName == 2) {
      this.getipddischargeData[0].surgeryTime = bindtime;
    } else if (this.ChangetimeName == 3) {
      this.getipddischargeData[0].tod = bindtime;
    } else if (this.ChangetimeName == 4) {
      this.dischargeDatamodel.firstFollowupTime = bindtime;
    } else if (this.ChangetimeName == 5) {
      this.dischargeDatamodel.secondFollowupTime = bindtime;
    } else if (this.ChangetimeName == 6) {
      this.GetNursingChartArray[this.newindex].mTime =
        this.datePipe.transform(new Date(), "yyyy-MM-dd") +
        " " +
        moment(bindtime, "hh:mm A").format("HH:mm");
      this.GetNursingChartArray[this.newindex].isEdit =
        this.checknursemedTranid > 0 ? true : false;
      this.GetNursingChartArray[this.newindex].isDelete = false;
    } else if (this.ChangetimeName == 7) {
      this.surgicalRecordobj.surgeryTime = bindtime;
    } else if (this.ChangetimeName == 8) {
      this.surgicalRecordobj.initiatedTime = bindtime;
    } else if (this.ChangetimeName == 9) {
      this.surgicalRecordobj.timedOut = bindtime;
    } else if (this.ChangetimeName == 10) {
      this.selectedRoutineExam.entryDatetime = bindtime;
      this.selecttime = moment(bindtime, "HH:mm A").format("HH:mm");
    } else if (this.ChangetimeName == 11) {
      this.AnestheticRecordModelobj.nilOrallyTime = bindtime;
    } else if (this.ChangetimeName == 12) {
      this.AnestheticVisitDetailModeldata[this.newindex].nTime =
        this.datePipe.transform(new Date(), "yyyy-MM-dd") +
        " " +
        moment(bindtime, "hh:mm A").format("HH:mm");
      this.AnestheticVisitDetailModeldata[this.newindex].isEdit =
        this.checknursemedTranid > 0 ? true : false;
    }
    this.CanceladmissionTime();
  }

  //Service Billing/Investigation Advised
  servicesBillingAdvised() {
    document.getElementById("servicesBillingAdvisedModal").style.display =
      "block";
  }
  CancelservicesBillingAdvised() {
    document.getElementById("servicesBillingAdvisedModal").style.display =
      "none";
  }

  //Doctor Visit Charges
  doctorVisitCharges() {
    document.getElementById("doctorVisitChargesModal").style.display = "block";
  }
  CanceladdoctorVisitCharges() {
    document.getElementById("doctorVisitChargesModal").style.display = "none";
  }

  clearFields() {
    // this.getipddischargeData[0].ipdAdmDate = null;
    this.getipddischargeData[0].surgerydate = this.datePipe.transform(
      this.getipddischargeData[0].surgerydate,
      "yyyy-MM-dd"
    );
    this.getipddischargeData[0].dod = this.datePipe.transform(
      this.authService.getServerDate,
      "yyyy-MM-dd"
    );
    // this.getipddischargeData[0].ipdAdmTime = null;
    if (this.getipddischargeData[0].surgeryTime != null) {
      this.getipddischargeData[0].surgeryTime = moment(
        this.getipddischargeData[0].surgeryTime,
        ["HH:mm"]
      ).format("h:mm A");
    }
    this.getipddischargeData[0].tod = moment(this.authService.serverTime, [
      "HH:mm",
    ]).format("h:mm A");
  }
  dischargecheck: boolean = false;
  GetDischargeData(id) {
    try {
      this.ipdService
        .getDischarge(this.selectIpdId)
        .pipe(takeUntil(this.destroyipd$))
        .subscribe((item) => {
          this.getipddischargeData = [];
          this.getipddischargeData = item;

          this.getipddischargeData[0].ipdAdmDate = this.datePipe.transform(
            new Date(this.getipddischargeData[0].ipdAdmDate),
            "yyyy-MM-dd"
          );
          this.getipddischargeData[0].surgerydate = this.datePipe.transform(
            this.getipddischargeData[0].surgerydate,
            "yyyy-MM-dd"
          );
          if (this.getipddischargeData[0].dod != null) {
            this.dischargecheck = true;
            this.getipddischargeData[0].dod = this.datePipe.transform(
              this.getipddischargeData[0].dod,
              "yyyy-MM-dd"
            );
          } else {
            this.dischargecheck = false;
            this.getipddischargeData[0].dod = this.datePipe.transform(
              this.authService.getServerDate,
              "yyyy-MM-dd"
            );
          }

          if (this.getipddischargeData[0].ipdAdmTime != null) {
            this.getipddischargeData[0].ipdAdmTime = moment(
              this.getipddischargeData[0].ipdAdmTime,
              ["HH:mm"]
            ).format("h:mm A");
          }
          this.maxDate = moment(this.authService.getServerDate).format(
            "YYYY-MM-DD"
          );

          this.minDate = this.getipddischargeData[0].ipdAdmDate;

          if (this.getipddischargeData[0].surgeryTime != null) {
            this.getipddischargeData[0].surgeryTime = moment(
              this.getipddischargeData[0].surgeryTime,
              ["HH:mm"]
            ).format("h:mm A");
          }
          if (this.getipddischargeData[0].tod != null) {
            this.getipddischargeData[0].tod = moment(
              this.getipddischargeData[0].tod,
              ["HH:mm"]
            ).format("h:mm A");
          } else {
            this.getipddischargeData[0].tod = moment(
              this.authService.serverTime,
              ["HH:mm"]
            ).format("h:mm A");
          }
        });
    } catch (e) { }
  }
  saveDischarge() {
    if (this.authService.masterdata?.isAllowtoCa && this.authService.masterdata?.isAllowtoFa) {
      if (this.getipddischargeData.length > 0) {
        if (this.getipddischargeData[0].dod > this.maxDate) {
          this.dashboardService.openSnackBar(
            "Select the Present or past date",
            "OK"
          );
        } else {
          this.dischargeData = [];

          this.getipddischargeData.forEach((item) => {
            this.dischargeData.push({
              PK_IPDId: this.selectIpdId,
              FK_BranchId: this.authService.Loggeduser.branchid,
              HeadName: "UPDATEDISCHARGE",
              FK_RegId: item.fK_RegId,
              Fk_UserID: 1,
              IPDAdmDate: this.datePipe.transform(item.ipdAdmDate, "dd/MMM/YYYY"),
              IPDAdmTime: moment(item.ipdAdmTime, ["h:mm A"]).format("HH:mm"),
              DOD: this.datePipe.transform(item.dod, "yyyy-MM-dd"),
              TOD: moment(item.tod, ["h:mm A"]).format("HH:mm"),
              surgerydate: this.datePipe.transform(
                item.surgerydate,
                "dd/MMM/YYYY"
              ),
              SurgeryTime:
                item.surgeryTime != null
                  ? moment(item.surgeryTime, ["h:mm A"]).format("HH:mm")
                  : item.surgeryTime,
            });
          });
          let DischargeData = {
            IpdRegMaster: this.dischargeData[0],
          };
          this.ipdService
            .updateDischarge(DischargeData)
            .pipe(takeUntil(this.destroyipd$))
            .subscribe(
              (x: any) => {
                if (x.statusCode == 1) {
                  this.GetDischargeData(this.selectIpdId);
                  this.dischargeData = [];
                  this.dashboardService.openSnackBar(
                    "Record Saved Successfully",
                    "OK"
                  );
                  // if (
                  //   this.opdvisitService.patientdetails.mobileNo != "" &&
                  //   this.opdvisitService.patientdetails.mobileNo != null &&
                  //   this.opdvisitService.patientdetails.mobileNo != undefined
                  // ) {
                  //   var result = this.opdvisitService.doctors.filter(
                  //     (x) => x.userId === this.corporateData.fK_ConsultantId
                  //   );
                  //   this.opdvisitService.datasendsms.PatientName =
                  //     this.opdvisitService.patientdetails.firstName +
                  //     " " +
                  //     this.opdvisitService.patientdetails.lastName;
                  //   this.opdvisitService.datasendsms.MobileNo =
                  //     this.opdvisitService.patientdetails.mobileNo;
                  //   this.opdvisitService.datasendsms.MrdNo = null;
                  //   this.opdvisitService.datasendsms.SeqNo = null;
                  //   this.opdvisitService.datasendsms.ApptDate = null;
                  //   this.opdvisitService.datasendsms.ApptTime = null;
                  //   this.opdvisitService.datasendsms.FIRSTFOLLOWUPDATE = this
                  //     .dischargeDatamodel.followupDate
                  //     ? this.dischargeDatamodel.followupDate
                  //     : null;
                  //   this.opdvisitService.datasendsms.ApptConsultant =
                  //     result[0].userName;
                  //   this.opdvisitService.datasendsms.SurgeryDate =
                  //     this.datePipe.transform(
                  //       this.getipddischargeData[0]?.surgerydate,
                  //       "dd/MMM/YYYY"
                  //     );
                  //   this.opdvisitService.datasendsms.SurgeryTime =
                  //     this.getipddischargeData[0]?.surgeryTime != null
                  //       ? moment(this.getipddischargeData[0]?.surgeryTime, [
                  //         "h:mm A",
                  //       ]).format("HH:mm")
                  //       : this.getipddischargeData[0]?.surgeryTime;
                  //   this.opdvisitService.datasendsms.BranchId =
                  //     this.authService.Loggeduser.branchid;
                  //   this.opdvisitService.datasendsms.SMSType = "IPDDISCHARGE";

                  //   this.opdvisitService.sendSMstoPatient(
                  //     this.opdvisitService.datasendsms
                  //   );
                  // }
                }
              },
              (err) => {
                if (err.status == 403) {
                  this.dashboardService.openSnackBar(
                    "You Don't have Permission",
                    "OK"
                  );
                } else {
                  this.dashboardService.openSnackBar("API Failed", "OK");
                }
              }
            );
        }
      }
    } else {
      this.dashboardService.openSnackBar(
        "You don't have permission",
        "OK"
      );
    }
  }
  isHover: number = -1;

  painscale(type) {
    this.isHover = type;
  }
  getPainSacle(ipdid) {
    this.isHover = -1;
    this.ipdService
      .getPainsacale(ipdid)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (x: any) => {
          this.painSacledata = {};
          this.painSacledata = x;
          if (
            this.painSacledata.painScore >= 0 &&
            this.painSacledata.painScore != null
          ) {
            this.painscale(this.painSacledata.painScore);
          }
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar(
              "You Don't have Permission",
              "OK"
            );
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }
  savePainScale() {
    if (this.isHover >= 0 && this.isHover != null) {
      let payload = {
        IpdPainScaleDetail: {
          PK_TranId:
            this.painSacledata.pK_TranId > 0 ? this.painSacledata.pK_TranId : 0,
          FK_IPDID: this.selectIpdId,
          PainScore: this.isHover,
          Remarks: this.painSacledata.remarks,
          IsEdit: this.painSacledata.pK_TranId > 0 ? true : false,
        },
      };
      this.ipdService
        .insertPainScale(payload)
        .pipe(takeUntil(this.destroyipd$))
        .subscribe(
          (x: any) => {
            this.getPainSacle(this.selectIpdId);
            this.dashboardService.openSnackBar(
              "Record Saved Successfully",
              "OK"
            );
          },
          (err) => {
            if (err.status == 403) {
              this.dashboardService.openSnackBar("You Don't have Permission", "OK");
            }
            else if (err.error.statusCode == 422) {
              this.dashboardService.openSnackBar(err.error.message, "OK");
            }
            else {
              this.dashboardService.openSnackBar("API Failed", "OK");
            }
          }
        );
    } else {
      this.dashboardService.openSnackBar("Select PainScale First", "OK");
    }
  }

  getOtConsent(id) {
    this.selectconsentdata = this.ipdDahboarddata.filter(
      (item) => item.pK_IPDId == id
    );
    if (this.selectconsentdata[0].fK_ConsId != null) {
      this.consId = this.selectconsentdata[0].fK_ConsId;
    } else {
      this.consId = 0;
    }
    this.doctype = "OTConcent";
    this.ipdService
      .getOTconstent(this.consId, this.doctype)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (x: any) => {
          this.Otconsentdata = [];
          if (x.length > 0) {
            this.Otconsentdata = x;
          }
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          }
          else if (err.error.statusCode == 422) {
            this.dashboardService.openSnackBar(err.error.message, "OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }
  getproductmasterconfig() {
    let BranchId = this.authService.Loggeduser.branchid;
    this.billingservice
      .getproductionConfrigration(BranchId)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe((data) => {
        console.log("master confrigartion", data);
        const urldate = data.filter((item) => item.propertyName == "WebURL");

        const pageheader = data.filter(
          (item) => item.propertyName == "PageHeadWebReport"
        );

        const checktrue = pageheader[0]?.propertyValue;
        this.PageHeader = checktrue;
        const url = urldate[0].propertyValue;
        this.reporturl = url;
        const pageqrcodeheader = data.filter(
          (item) => item.propertyName == "Patientsticker_barcode"
        );
        if (pageqrcodeheader.length > 0) {
          this.QrCode = pageqrcodeheader[0].propertyValue;
        } else {
          this.QrCode = "N";
        }
      });
  }
  otconsentUrl: any;
  getreport(element) {
    this.otconsentUrl = "";
    if (element.pK_DocumentId) {
      this.imageWorkupService.getAzureImagedata(
        element.pK_DocumentId,
        this.authService.Loggeduser.branchid,
        element.documentType
      )
        .pipe(takeUntil(this.destroyipd$))
        .subscribe(
          (data: any) => {
            if (data.length > 0) {

              if (this.authService.webstorageConfigobj.storageType.toLowerCase() == 'imageserver') {
                var mainimagepath = this.opdvisitService.documentrul.filter(item => item?.propertyName.toLowerCase() == "mainimagepath");
                if (mainimagepath.length > 0) {
                  const msg = { "message": "UPLOADFILE", "ACTIONTYPE": "VIEWFILE", "DOCUMENTNAME": data[0].documentName, "DOCUMENTTYPE": data[0].documentType.toUpperCase(), "BranchId": data[0].fk_BranchId.toString(), "PATIENTID": data[0].fk_RegId.toString(), "MAINIMAGEPATH": mainimagepath[0]?.propertyValue, }
                  this.webSocketService.sendMessage(msg);
                  this.webSocketService.getMessages().subscribe(
                    (message: any) => {

                      const filedat = message;
                      if (Array.isArray(filedat)) {
                        this.otconsentUrl = filedat[0].fbLong;
                        this.printOTconsent();
                      } else {
                        this.otconsentUrl = "";
                        this.printOTconsent();
                      }

                    }, err => {
                      this.dashboardService.openSnackBar("Please set server configuration", "OK");
                    });
                } else {
                  this.dashboardService.openSnackBar("Please set MainImagePath", "OK");
                }
              } else if (this.authService.webstorageConfigobj.storageType.toLowerCase() == 'server') {
                this.otconsentUrl = data[0].fbLong;
                this.printOTconsent();
              } else if (this.authService.webstorageConfigobj.storageType.toLowerCase() == 'azure') {
                this.otconsentUrl = data[0].fbLong;
                this.printOTconsent();
              } else {
                this.otconsentUrl = "";
                this.printOTconsent();
              }

            } else {
              this.otconsentUrl = "";
              this.printOTconsent();
            }

          },
          (err) => {
            if (err.status == 403) {
              this.dashboardService.openSnackBar("You Don't have Permission", "OK");
            }
            else if (err.error.statusCode == 422) {
              this.dashboardService.openSnackBar(err.error.message, "OK");
            }
            else {
              this.dashboardService.openSnackBar("API Failed", "OK");
            }
          }
        );
      //  window.open(this.reporturl + 'SurgicalConsentmaster.aspx?DocumentId=' + docid + '&DocumentName=' + docName + '&IpdID=' + this.selectIpdId + '&RegID=' + this.RegId + '&ConsID=' + this.consId + '&BranchId=' + this.authService.Loggeduser.branchid + '&PageHeadWebReport=' + this.PageHeader + '&OTType=' + doctype + '&BillingCompanyName=' + this.authService.Loggeduser.billingcompanyname);
    } else {
      this.dashboardService.openSnackBar("Please Select Bill ", "OK");
    }
  }
  ChangeHeader(event: any) {
    if (event == true) {
      this.PageHeader = "N";
      this.headerChecked = false;
    } else {
      this.PageHeader = "Y";
      this.headerChecked = true;
    }
  }
  invesrIpdTypePOpup(type: any, type1?: any, checkid?: any, headtype?: any) {
    const dialogRef = this.dialog.open(DynamicHelpListComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "33vw",
      disableClose: true,
      width: "33%",

      data: {
        parametertype: type,
      },
    });

    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroyipd$))
      .subscribe((result) => {
        if (result != 0) {
          if (headtype == 1) {
            this.getinvestigationlab[type1].headName = result;
            this.getinvestigationlab[type1].isEdit = checkid > 0 ? true : false;
            this.getinvestigationlab[type1].isDelete = false;
          } else if (headtype == 2) {
            this.getinvestigationlab[type1].referenceValue = result;
            this.getinvestigationlab[type1].isEdit = checkid > 0 ? true : false;
            this.getinvestigationlab[type1].isDelete = false;
          } else if (headtype == 3) {
            this.getinvestigationlab[type1].result = result;
            this.getinvestigationlab[type1].isEdit = checkid > 0 ? true : false;
            this.getinvestigationlab[type1].isDelete = false;
          }
        }
      });
  }
  refIpdTypePOpup(type, type1?: any, checkid?: number) {
    const dialogRef = this.dialog.open(DynamicHelpListComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "33vw",
      disableClose: true,
      width: "33%",

      data: {
        parametertype: type,
      },
    });

    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroyipd$))
      .subscribe((result) => {
        if (result != 0) {
          if (type == "Complaints") {
            if (
              this.dischargeDatamodel.complaints != null &&
              this.dischargeDatamodel.complaints != ""
            ) {
              this.dischargeDatamodel.complaints =
                this.dischargeDatamodel.complaints + "," + result;
            } else {
              this.dischargeDatamodel.complaints = result;
            }
          } else if (type == "Procedures") {
            if (
              this.dischargeDatamodel.procedureDone != null &&
              this.dischargeDatamodel.procedureDone != ""
            ) {
              this.dischargeDatamodel.procedureDone =
                this.dischargeDatamodel.procedureDone + "," + result;
            } else {
              this.dischargeDatamodel.procedureDone = result;
            }
          } else if (type == "OPDDiagnosis") {
            if (
              this.dischargeDatamodel.diagnosis != null &&
              this.dischargeDatamodel.diagnosis != ""
            ) {
              this.dischargeDatamodel.diagnosis =
                this.dischargeDatamodel.diagnosis + "," + result;
            } else {
              this.dischargeDatamodel.diagnosis = result;
            }
          } else if (type == "DischargeRemarks" && type1 == 1) {
            if (
              this.dischargeDatamodel.remarks != null &&
              this.dischargeDatamodel.remarks != ""
            ) {
              this.dischargeDatamodel.remarks =
                this.dischargeDatamodel.remarks + "," + result;
            } else {
              this.dischargeDatamodel.remarks = result;
            }
          } else if (type == "DischargeRemarks" && type1 == 2) {
            if (
              this.dischargeDatamodel.prognosis != null &&
              this.dischargeDatamodel.prognosis != ""
            ) {
              this.dischargeDatamodel.prognosis =
                this.dischargeDatamodel.prognosis + "," + result;
            } else {
              this.dischargeDatamodel.prognosis = result;
            }
          } else if (type == "Systemic-Disease") {
            if (
              this.dischargeDatamodel.systemicIllness != null &&
              this.dischargeDatamodel.systemicIllness != ""
            ) {
              this.dischargeDatamodel.systemicIllness =
                this.dischargeDatamodel.systemicIllness + "," + result;
            } else {
              this.dischargeDatamodel.systemicIllness = result;
            }
          } else if (type == "ConditionAtDischarge") {
            if (
              this.dischargeDatamodel.conditiononDischarge != null &&
              this.dischargeDatamodel.conditiononDischarge != ""
            ) {
              this.dischargeDatamodel.conditiononDischarge =
                this.dischargeDatamodel.conditiononDischarge + "," + result;
            } else {
              this.dischargeDatamodel.conditiononDischarge = result;
            }
          } else if (type == "AdviceonDischarge") {
            if (
              this.dischargeDatamodel.adviceonDischarge != null &&
              this.dischargeDatamodel.adviceonDischarge != ""
            ) {
              this.dischargeDatamodel.adviceonDischarge =
                this.dischargeDatamodel.adviceonDischarge + "," + result;
            } else {
              this.dischargeDatamodel.adviceonDischarge = result;
            }
          } else if (type == "DoctorInstruction") {
            this.GetNursingInstructionobj.doctorinstructions = result;
          } else if (type == "NursingRemarks") {
            this.GetNursingInstructionobj.nursinginstructions = result;
          } else if (type == "Temp") {
            if (result <= 110) {
              this.GetNursingChartArray[type1].nTemp = result;
              this.GetNursingChartArray[type1].isEdit =
                checkid > 0 ? true : false;
              this.GetNursingChartArray[type1].isDelete = false;
            } else {
              this.GetNursingChartArray[type1].nTemp = null;
              this.GetNursingChartArray[type1].isEdit =
                checkid > 0 ? true : false;
              this.GetNursingChartArray[type1].isDelete = false;
            }
          } else if (type == "Pulse") {
            if (result <= 200) {
              this.GetNursingChartArray[type1].pulse = result;
              this.GetNursingChartArray[type1].isEdit =
                checkid > 0 ? true : false;
              this.GetNursingChartArray[type1].isDelete = false;
            } else {
              this.GetNursingChartArray[type1].pulse = null;
              this.GetNursingChartArray[type1].isEdit =
                checkid > 0 ? true : false;
              this.GetNursingChartArray[type1].isDelete = false;
            }
          } else if (type == "Resp.") {
            if (result <= 100) {
              this.GetNursingChartArray[type1].rr = result;
              this.GetNursingChartArray[type1].isEdit =
                checkid > 0 ? true : false;
              this.GetNursingChartArray[type1].isDelete = false;
            } else {
              this.GetNursingChartArray[type1].rr = null;
              this.GetNursingChartArray[type1].isEdit =
                checkid > 0 ? true : false;
              this.GetNursingChartArray[type1].isDelete = false;
            }
          } else if (type == "BPS") {
            if (result <= 100) {
              this.GetNursingChartArray[type1].bps = result;
              this.GetNursingChartArray[type1].isEdit =
                checkid > 0 ? true : false;
              this.GetNursingChartArray[type1].isDelete = false;
            } else {
              this.GetNursingChartArray[type1].bps = null;
              this.GetNursingChartArray[type1].isEdit =
                checkid > 0 ? true : false;
              this.GetNursingChartArray[type1].isDelete = false;
            }
          } else if (type == "BPD") {
            if (result <= 200) {
              this.GetNursingChartArray[type1].bpd = result;
              this.GetNursingChartArray[type1].isEdit =
                checkid > 0 ? true : false;
              this.GetNursingChartArray[type1].isDelete = false;
            } else {
              this.GetNursingChartArray[type1].bpd = null;
              this.GetNursingChartArray[type1].isEdit =
                checkid > 0 ? true : false;
              this.GetNursingChartArray[type1].isDelete = false;
            }
          } else if (type == "SpO2") {
            if (result <= 100) {
              this.GetNursingChartArray[type1].spO2 = result;
              this.GetNursingChartArray[type1].isEdit =
                checkid > 0 ? true : false;
              this.GetNursingChartArray[type1].isDelete = false;
            } else {
              this.GetNursingChartArray[type1].spO2 = null;
              this.GetNursingChartArray[type1].isEdit =
                checkid > 0 ? true : false;
              this.GetNursingChartArray[type1].isDelete = false;
            }
          } else if (type == "Weight") {
            if (result <= 500) {
              this.GetNursingChartArray[type1].weight = result;
              this.GetNursingChartArray[type1].isEdit =
                checkid > 0 ? true : false;
              this.GetNursingChartArray[type1].isDelete = false;
            } else {
              this.GetNursingChartArray[type1].weight = null;
              this.GetNursingChartArray[type1].isEdit =
                checkid > 0 ? true : false;
              this.GetNursingChartArray[type1].isDelete = false;
            }
          } else if (type == "RBS") {
            if (result <= 1000) {
              this.GetNursingChartArray[type1].nInPut = result;
              this.GetNursingChartArray[type1].isEdit =
                checkid > 0 ? true : false;
              this.GetNursingChartArray[type1].isDelete = false;
            } else {
              this.GetNursingChartArray[type1].nInPut = null;
              this.GetNursingChartArray[type1].isEdit =
                checkid > 0 ? true : false;
              this.GetNursingChartArray[type1].isDelete = false;
            }
          } else if (type == "PatientType") {
            this.surgicalRecordobj.caseType = result;
          } else if (type == "OTComplication") {
            this.surgicalRecordobj.otComplication = result;
          } else if (type == "AssistSister" && type1 == 1) {
            this.surgicalRecordobj.assistenceSister = result;
          } else if (type == "AssistSister" && type1 == 2) {
            this.surgicalRecordobj.gaNurse = result;
          } else if (type == "AssistSister" && type1 == 3) {
            this.surgicalRecordobj.circulatingNurse = result;
          } else if (type == "OTEYE") {
            this.surgicalRecordobj.site = result;
          } else if (type == "ANADIAGNOSIS") {
            if (
              this.PreopAssesmentRecordModelobj.diagnosis != null &&
              this.PreopAssesmentRecordModelobj.diagnosis != ""
            ) {
              this.PreopAssesmentRecordModelobj.diagnosis =
                this.PreopAssesmentRecordModelobj.diagnosis + "," + result;
            } else {
              this.PreopAssesmentRecordModelobj.diagnosis = result;
            }
          } else if (type == "ANAPROCEDURE") {
            if (
              this.PreopAssesmentRecordModelobj.procedureName != null &&
              this.PreopAssesmentRecordModelobj.procedureName != ""
            ) {
              this.PreopAssesmentRecordModelobj.procedureName =
                this.PreopAssesmentRecordModelobj.procedureName + "," + result;
            } else {
              this.PreopAssesmentRecordModelobj.procedureName = result;
            }
          } else if (type == "ANASYMPTOMS") {
            if (
              this.PreopAssesmentRecordModelobj.symptoms != null &&
              this.PreopAssesmentRecordModelobj.symptoms != ""
            ) {
              this.PreopAssesmentRecordModelobj.symptoms =
                this.PreopAssesmentRecordModelobj.symptoms + "," + result;
            } else {
              this.PreopAssesmentRecordModelobj.symptoms = result;
            }
          } else if (type == "ANAMEDICATION" && type1 == 2) {
            if (
              this.PreopAssesmentRecordModelobj.currentMedication != null &&
              this.PreopAssesmentRecordModelobj.currentMedication != ""
            ) {
              this.PreopAssesmentRecordModelobj.currentMedication =
                this.PreopAssesmentRecordModelobj.currentMedication +
                "," +
                result;
            } else {
              this.PreopAssesmentRecordModelobj.currentMedication = result;
            }
          } else if (type == "ANAMEDICATION" && type1 == 1) {
            if (
              this.PreopAssesmentRecordModelobj.previousMedication != null &&
              this.PreopAssesmentRecordModelobj.previousMedication != ""
            ) {
              this.PreopAssesmentRecordModelobj.previousMedication =
                this.PreopAssesmentRecordModelobj.previousMedication +
                "," +
                result;
            } else {
              this.PreopAssesmentRecordModelobj.previousMedication = result;
            }
          } else if (type == "HISTORYSURGERY") {
            if (
              this.PreopAssesmentRecordModelobj.historyOfSurgery != null &&
              this.PreopAssesmentRecordModelobj.historyOfSurgery != ""
            ) {
              this.PreopAssesmentRecordModelobj.historyOfSurgery =
                this.PreopAssesmentRecordModelobj.historyOfSurgery +
                "," +
                result;
            } else {
              this.PreopAssesmentRecordModelobj.historyOfSurgery = result;
            }
          } else if (type == "MEDICALSTATUS") {
            if (
              this.PreopAssesmentRecordModelobj.medicalStatus != null &&
              this.PreopAssesmentRecordModelobj.medicalStatus != ""
            ) {
              this.PreopAssesmentRecordModelobj.medicalStatus =
                this.PreopAssesmentRecordModelobj.medicalStatus + "," + result;
            } else {
              this.PreopAssesmentRecordModelobj.medicalStatus = result;
            }
          } else if (type == "MEDICALTREATMENT") {
            if (
              this.PreopAssesmentRecordModelobj.medicalTreatment != null &&
              this.PreopAssesmentRecordModelobj.medicalTreatment != ""
            ) {
              this.PreopAssesmentRecordModelobj.medicalTreatment =
                this.PreopAssesmentRecordModelobj.medicalTreatment +
                "," +
                result;
            } else {
              this.PreopAssesmentRecordModelobj.medicalTreatment = result;
            }
          } else if (type == "DENTITATION") {
            this.AnestheticRecordModelobj.dentitation = result;
          } else if (type == "OBESITY") {
            this.AnestheticRecordModelobj.obesity = result;
          } else if (type == "ASA") {
            this.AnestheticRecordModelobj.asa = result;
          } else if (type == "ICTERUS") {
            this.AnestheticRecordModelobj.ictras = result;
          } else if (type == "MOUNTH") {
            this.AnestheticRecordModelobj.mouthOpening = result;
          } else if (type == "PREOPSPO2") {
            this.AnestheticRecordModelobj.preopSpo2 = result;
          } else if (type == "POLLAR") {
            this.AnestheticRecordModelobj.pollar = result;
          } else if (type == "CYNOSIS") {
            this.AnestheticRecordModelobj.cynosis = result;
          } else if (type == "NECT") {
            this.AnestheticRecordModelobj.neckMove = result;
          } else if (type == "LYMPHADENOPATHY") {
            this.AnestheticRecordModelobj.lymphadenopathy = result;
          } else if (type == "CLUBBING") {
            this.AnestheticRecordModelobj.clubbing = result;
          } else if (type == "JVP") {
            this.AnestheticRecordModelobj.jvp = result;
          } else if (type == "MPC") {
            this.AnestheticRecordModelobj.mpc = result;
          } else if (type == "ANASPLANED") {
            this.AnestheticRecordModelobj.anasPlaned = result;
          } else if (type == "EDEMA") {
            this.AnestheticRecordModelobj.edesma = result;
          } else if (type == "PRE-OPCHECKUP") {
            if (
              this.AnestheticRecordModelobj.preAnasChUp != null &&
              this.AnestheticRecordModelobj.preAnasChUp != ""
            ) {
              this.AnestheticRecordModelobj.preAnasChUp =
                this.AnestheticRecordModelobj.preAnasChUp + "," + result;
            } else {
              this.AnestheticRecordModelobj.preAnasChUp = result;
            }
          } else if (type == "PRE-OPMEDICATION") {
            if (
              this.AnestheticRecordModelobj.preMedication != null &&
              this.AnestheticRecordModelobj.preMedication != ""
            ) {
              this.AnestheticRecordModelobj.preMedication =
                this.AnestheticRecordModelobj.preMedication + "," + result;
            } else {
              this.AnestheticRecordModelobj.preMedication = result;
            }
          } else if (type == "PRE-OPREMARKS") {
            if (
              this.AnestheticRecordModelobj.preOpRemark != null &&
              this.AnestheticRecordModelobj.preOpRemark != ""
            ) {
              this.AnestheticRecordModelobj.preOpRemark =
                this.AnestheticRecordModelobj.preOpRemark + "," + result;
            } else {
              this.AnestheticRecordModelobj.preOpRemark = result;
            }
          } else if (type == "PRE-OPINDUCTION") {
            if (
              this.AnestheticRecordModelobj.induction != null &&
              this.AnestheticRecordModelobj.induction != ""
            ) {
              this.AnestheticRecordModelobj.induction =
                this.AnestheticRecordModelobj.induction + "," + result;
            } else {
              this.AnestheticRecordModelobj.induction = result;
            }
          } else if (type == "PRE-OPMAINTENANCE") {
            if (
              this.AnestheticRecordModelobj.maintenance != null &&
              this.AnestheticRecordModelobj.maintenance != ""
            ) {
              this.AnestheticRecordModelobj.maintenance =
                this.AnestheticRecordModelobj.maintenance + "," + result;
            } else {
              this.AnestheticRecordModelobj.maintenance = result;
            }
          } else if (type == "PRE-REVERSAL") {
            if (
              this.AnestheticRecordModelobj.reversal != null &&
              this.AnestheticRecordModelobj.reversal != ""
            ) {
              this.AnestheticRecordModelobj.reversal =
                this.AnestheticRecordModelobj.reversal + "," + result;
            } else {
              this.AnestheticRecordModelobj.reversal = result;
            }
          } else if (type == "MONITORING") {
            if (
              this.AnestheticRecordModelobj.monitoring != null &&
              this.AnestheticRecordModelobj.monitoring != ""
            ) {
              this.AnestheticRecordModelobj.monitoring =
                this.AnestheticRecordModelobj.monitoring + "," + result;
            } else {
              this.AnestheticRecordModelobj.monitoring = result;
            }
          } else if (type == "ANACOMPLICATIONS") {
            if (
              this.AnestheticRecordModelobj.complications != null &&
              this.AnestheticRecordModelobj.complications != ""
            ) {
              this.AnestheticRecordModelobj.complications =
                this.AnestheticRecordModelobj.complications + "," + result;
            } else {
              this.AnestheticRecordModelobj.complications = result;
            }
          } else if (type1 == "HistoryDisease" && checkid >= 0) {
            this.getpreopAssesmentHistory[checkid].resultValue = result;
          } else if (type1 == "PhysicalExaminations" && checkid >= 0) {
            this.getpreopAssesmentPhysical[checkid].resultValue = result;
          } else if (type1 == "LabInvestigation" && checkid >= 0) {
            this.getpreopAssesmentLab[checkid].resultValue = result;
          }
        }
      });
  }

  onnInPutTypechange(e, index, id) {
    if (e != null && e <= 1000) {
      this.GetNursingChartArray[index].nInPut = e;
      this.GetNursingChartArray[index].isEdit = id > 0 ? true : false;
      this.GetNursingChartArray[index].isDelete = false;
    } else {
      this.GetNursingChartArray[index].nInPut = null;
      this.GetNursingChartArray[index].isEdit = id > 0 ? true : false;
      this.GetNursingChartArray[index].isDelete = false;
    }
  }
  onweightTypechange(e, index, id) {
    if (e != null && e <= 500) {
      this.GetNursingChartArray[index].weight = e;
      this.GetNursingChartArray[index].isEdit = id > 0 ? true : false;
      this.GetNursingChartArray[index].isDelete = false;
    } else {
      this.GetNursingChartArray[index].weight = null;
      this.GetNursingChartArray[index].isEdit = id > 0 ? true : false;
      this.GetNursingChartArray[index].isDelete = false;
    }
  }
  onspO2Typechange(e, index, id) {
    if (e != null && e <= 100) {
      this.GetNursingChartArray[index].spO2 = e;
      this.GetNursingChartArray[index].isEdit = id > 0 ? true : false;
      this.GetNursingChartArray[index].isDelete = false;
    } else {
      this.GetNursingChartArray[index].spO2 = null;
      this.GetNursingChartArray[index].isEdit = id > 0 ? true : false;
      this.GetNursingChartArray[index].isDelete = false;
    }
  }
  onbpdTypechange(e, index, id) {
    if (e != null && e <= 200) {
      this.GetNursingChartArray[index].bpd = e;
      this.GetNursingChartArray[index].isEdit = id > 0 ? true : false;
      this.GetNursingChartArray[index].isDelete = false;
    } else {
      this.GetNursingChartArray[index].bpd = null;
      this.GetNursingChartArray[index].isEdit = id > 0 ? true : false;
      this.GetNursingChartArray[index].isDelete = false;
    }
  }
  onbpsTypechange(e, index, id) {
    if (e != null && e <= 200) {
      this.GetNursingChartArray[index].bps = e;
      this.GetNursingChartArray[index].isEdit = id > 0 ? true : false;
      this.GetNursingChartArray[index].isDelete = false;
    } else {
      this.GetNursingChartArray[index].bps = null;
      this.GetNursingChartArray[index].isEdit = id > 0 ? true : false;
      this.GetNursingChartArray[index].isDelete = false;
    }
  }
  onrrTypechange(e, index, id) {
    if (e != null && e <= 100) {
      this.GetNursingChartArray[index].rr = e;
      this.GetNursingChartArray[index].isEdit = id > 0 ? true : false;
      this.GetNursingChartArray[index].isDelete = false;
    } else {
      this.GetNursingChartArray[index].rr = null;
      this.GetNursingChartArray[index].isEdit = id > 0 ? true : false;
      this.GetNursingChartArray[index].isDelete = false;
    }
  }
  onTempTypechange(e, index, id) {
    if (e != null && e <= 110) {
      this.GetNursingChartArray[index].nTemp = e;
      this.GetNursingChartArray[index].isEdit = id > 0 ? true : false;
      this.GetNursingChartArray[index].isDelete = false;
    } else {
      this.GetNursingChartArray[index].nTemp = null;
      this.GetNursingChartArray[index].isEdit = id > 0 ? true : false;
      this.GetNursingChartArray[index].isDelete = false;
    }
  }
  onpulseTypechange(e, index, id) {
    if (e != null && e <= 200) {
      this.GetNursingChartArray[index].pulse = e;
      this.GetNursingChartArray[index].isEdit = id > 0 ? true : false;
      this.GetNursingChartArray[index].isDelete = false;
    } else {
      this.GetNursingChartArray[index].pulse = null;
      this.GetNursingChartArray[index].isEdit = id > 0 ? true : false;
      this.GetNursingChartArray[index].isDelete = false;
    }
  }
  instructionArray: any = [];
  getInstructiondata(type) {
    this.ipdService
      .getInstructiontype(type, "~")
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (x: any) => {
          this.instructionArray = [];
          this.InstrcutionName = null;
          this.instructionArray = x.filter((item) => item.type != null);
          this.InstrcutionControll();
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar(
              "You Don't have Permission",
              "OK"
            );
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }

  instructionMasterArray: any = [];
  getInstructionMasterData(type) {
    this.ipdService
      .getInstructiontype(type, "All")
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (x: any) => {
          this.instructionMasterArray = [];
          this.instructionMasterArray = x;
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar(
              "You Don't have Permission",
              "OK"
            );
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }
  //op type data
  InstrcutionControll() {
    this.InstructionsData = of(this.instructionArray);
    this.InstructionsCtrl = new FormControl();
    this.filteredInstructionsArray = this.InstructionsCtrl.valueChanges.pipe(
      startWith(""),
      switchMap((value) => this._filterinstruction(value))
    );
  }
  private _filterinstruction(value: string): Observable<string[]> {
    return this.InstructionsData.pipe(
      map((options) =>
        options.filter((option) =>
          option.type.toLowerCase().includes(value.toString().toLowerCase())
        )
      )
    );
  }
  InstrcutionName: any;
  getinstructionobj(e: any) {
    var val = e.option.value;
    if (val.type != null && val.type != "") {
      this.InstrcutionName = val.type;
      this.getInstructiondetail(val.type);
    }
  }
  instructiondetailArray: any = [];
  levelcheck: boolean = false;
  getInstructiondetail(type) {
    this.ipdService
      .getInstructiontype(0, type)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (x) => {
          this.instructiondetailArray = [];
          this.instructiondetailArray = x;
          if (this.getInstructionmodel.length > 0 && this.levelcheck == false) {
            this.changeSaveInstructionmodel = [];
            this.getInstructionmodel.forEach((data) => {
              let objdat = {
                pK_TranId: data.pK_TranId,
                fK_IPDId: data.fK_IPDId,
                instructions: data.instructions,
                isActive: false,
                isEdit: true,
                isDelete: true,
              };

              this.changeSaveInstructionmodel.push(objdat);
            });
            this.levelcheck = true;
          }

          if (this.instructiondetailArray.length > 0) {
            this.getInstructionmodel = [];
            this.instructiondetailArray.forEach((item) => {
              let objdata = {
                pK_TranId: 0,
                fK_IPDId: this.selectIpdId,
                instructions: item.instruction,
                isActive: true,
                isEdit: false,
                isDelete: false,
              };
              this.getInstructionmodel.push(objdata);
            });
          }
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar(
              "You Don't have Permission",
              "OK"
            );
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }

  selectrow(rowdata) {
    this.saveinstructionMaster.push(rowdata);
    this.saveinstructionMaster.map((item) => (item.isEdit = true));
    // if(this.saveinstructionMaster.length >1){
    //   this.saveinstructionMaster = this.saveinstructionMaster.reduce((unique, o) => {
    //     if (!unique.some(obj => obj.seqNo === o.seqNo)) {
    //       unique.push(o);
    //     }
    //     return unique;
    //   }, []);
    // }

    this.closeInstructionMasterlistModal();
    console.log(this.saveinstructionMaster);
  }
  AddNewInstruction() {
    if (
      this.instructionMasterobj.instruction != null ||
      this.instructionMasterobj.seqNo != null ||
      this.instructionMasterobj.type != null
    ) {
      let obj = {
        tranID: 0,
        instruction: this.instructionMasterobj.instruction,
        seqNo: this.instructionMasterobj.seqNo,
        type: this.instructionMasterobj.type,
        isEdit: false,
        isDelete: false,
      };
      this.saveinstructionMaster.push(obj);
      this.instructionMasterobj = {};
    }
  }
  savemasterArray: any = [];
  saveInstructionMaster() {
    if (this.saveinstructionMaster.length > 0) {
      this.savemasterArray = [];
      this.saveinstructionMaster.forEach((item) => {
        let objdata = {
          TranID: item.tranID,
          Type: item.type,
          Instruction: item.instruction,
          SeqNo: item.seqNo,
          IsEdit: item.tranID > 0 ? true : false,
          IsDelete: false,
        };
        this.savemasterArray.push(objdata);
      });
      let objnewdata = {
        DischargeInstructions: this.savemasterArray,
      };

      this.ipdService
        .insertDischargeInstructions(objnewdata)
        .pipe(takeUntil(this.destroyipd$))
        .subscribe(
          (item) => {
            this.savemasterArray = [];
            this.saveinstructionMaster = [];
            this.getInstructionMasterData(0);
            this.getInstructiondata(0);
            this.dashboardService.openSnackBar(
              "Record Saved Successfully",
              "OK"
            );
          },
          (err) => {
            if (err.status == 403) {
              this.dashboardService.openSnackBar("You Don't have Permission", "OK");
            }
            else if (err.error.statusCode == 422) {
              this.dashboardService.openSnackBar(err.error.message, "OK");
            }
            else {
              this.dashboardService.openSnackBar("API Failed", "OK");
            }
          }
        );
    }
    // insertDischargeInstructions
  }
  saveEdit(index: number) {
    this.saveinstructionMaster[index].isEdit = false;
  }
  Editdata(index: number) {
    this.saveinstructionMaster[index].isEdit = true;
  }
  oninstructionchange(value, index) {
    this.saveinstructionMaster[index].instruction = value;
  }
  onseqNochange(value, index) {
    this.saveinstructionMaster[index].seqNo = value;
  }
  ontypechange(value, index) {
    this.saveinstructionMaster[index].type = value;
  }
  removeData(row, index) {
    if (row.tranID == 0) {
      this.saveinstructionMaster.splice(index, 1);
      this.dashboardService.openSnackBar("Record Deleted Successfully", "OK");
    } else {
      this.saveinstructionMaster.splice(index, 1);
      let objdata = {
        TranID: row.tranID,
        Type: row.type,
        Instruction: row.instruction,
        SeqNo: row.seqNo,
        IsEdit: true,
        IsDelete: true,
      };
      this.savemasterArray.push(objdata);
      let objnewdata = {
        DischargeInstructions: this.savemasterArray,
      };
      this.ipdService
        .insertDischargeInstructions(objnewdata)
        .pipe(takeUntil(this.destroyipd$))
        .subscribe(
          (item) => {
            this.savemasterArray = [];
            this.getInstructionMasterData(0);
            this.getInstructiondata(0);
            this.dashboardService.openSnackBar(
              "Record Deleted Successfully",
              "OK"
            );
          },
          (err) => {
            if (err.status == 403) {
              this.dashboardService.openSnackBar("You Don't have Permission", "OK");
            }
            else if (err.error.statusCode == 422) {
              this.dashboardService.openSnackBar(err.error.message, "OK");
            }
            else {
              this.dashboardService.openSnackBar("API Failed", "OK");
            }
          }
        );
    }
  }

  surgerySite: string = "";
  transferdataEmr() {
    if (this.RegId > 0) {
      this.ipdService
        .get_pasthistory(this.RegId)
        .pipe(takeUntil(this.destroyipd$))
        .subscribe(
          (x: any) => {
            if (x.length > 0) {
              this.dischargeDatamodel.systemicIllness = x
                .map((x1) => x1.diseaseName)
                .join(",");
            }
          },
          (err) => {
            if (err.status == 403) {
              this.dashboardService.openSnackBar(
                "You Don't have Permission",
                "OK"
              );
            } else {
              this.dashboardService.openSnackBar("API Failed", "OK");
            }
          }
        );
      this.ipdService
        .getOtRecordSurgeryByIPDId(this.selectIpdId)
        .pipe(takeUntil(this.destroyipd$))
        .subscribe(
          (x: any) => {
            if (x.length > 0) {
              this.dischargeDatamodel.procedureDone = x
                .map((x1) => x1.surgeryName)
                .join(",");
              const checksurgoaid = x.filter((item) => item.fK_SurgeonId > 0);
              if (checksurgoaid.length > 0) {
                this.dischargeDatamodel.fK_DoctorId =
                  checksurgoaid[0].fK_SurgeonId;
                this.dischargeDatamodel.drName =
                  this.opdvisitService.doctors.filter(
                    (item) => item.userId == checksurgoaid[0].fK_SurgeonId
                  )[0]?.userName;
              }
              const sitecheck = x.filter((item) => item.fK_SurgeonId != null);
              this.surgerySite = sitecheck[0]?.site;

              const dublicatedata = x.reduce((unique, o) => {
                if (!unique.some((obj) => obj.diagnosis == o.diagnosis)) {
                  unique.push(o);
                }
                return unique;
              }, []);
              this.dischargeDatamodel.diagnosis = dublicatedata[0]?.diagnosis;

              this.ipdService
                .getipdExmaRegid(this.RegId)
                .pipe(takeUntil(this.destroyipd$))
                .subscribe((x: any) => {
                  if (x.length > 0) {
                    x.forEach((item) => {
                      this.getdischageExamintion.push({
                        pK_DisExamDetailId: 0,
                        fK_IPDId: this.selectIpdId,
                        fk_FindingId: item.fk_FindingId,
                        pK_SynchId: 0,
                        findingName: item.findingName,
                        examValues1: item.examValues1,
                        examValues2: item.examValues2,
                        specification: item.findingName,
                        isDelete: false,
                        isEdit: false,
                      });
                    });
                    this.getdischageExamintion =
                      this.getdischageExamintion.reduce((unique, o) => {
                        if (
                          !unique.some(
                            (obj) =>
                              obj.findingName === o.findingName &&
                              obj.fk_FindingId === o.fk_FindingId
                          )
                        ) {
                          unique.push(o);
                        }
                        return unique;
                      }, []);
                  }
                });
            }
          },
          (err) => { }
        );
      this.ipdService
        .getOtRecordComplaintRegid(this.RegId)
        .pipe(takeUntil(this.destroyipd$))
        .subscribe(
          (x: any) => {
            if (x.length > 0) {
              this.dischargeDatamodel.complaints = x
                .map((x1) => x1.complaint)
                .join(",");
            }
          },
          (err) => {
            if (err.status == 403) {
              this.dashboardService.openSnackBar(
                "You Don't have Permission",
                "OK"
              );
            } else {
              this.dashboardService.openSnackBar("API Failed", "OK");
            }
          }
        );
      this.dashboardService.openSnackBar("Transfer Complete", "OK");
    }
  }

  getDischargeSUmmery(ipdid) {
    this.ipdService
      .getDischagreSummery(ipdid)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (x: any) => {
          this.dischargeDatamodel = {};
          this.dischargeDatamodel = x;
          if (this.dischargeDatamodel.followupDate != null) {
            this.dischargeDatamodel.followupDate = this.datePipe.transform(
              this.dischargeDatamodel.followupDate,
              "yyyy-MM-dd"
            );
          } else {
            let sdate = new Date(this.authService.getServerDate);
            this.dischargeDatamodel.followupDate = this.datePipe.transform(
              sdate.setDate(sdate.getDate() + 1),
              "yyyy-MM-dd"
            );
          }
          if (this.dischargeDatamodel.restDateFrom != null) {
            this.dischargeDatamodel.restDateFrom = this.datePipe.transform(
              this.dischargeDatamodel.restDateFrom,
              "yyyy-MM-dd"
            );
          } else {
            this.dischargeDatamodel.restDateFrom = this.datePipe.transform(
              this.authService.getServerDate,
              "yyyy-MM-dd"
            );
          }
          if (this.dischargeDatamodel.restDateTo != null) {
            this.dischargeDatamodel.restDateTo = this.datePipe.transform(
              this.dischargeDatamodel.restDateTo,
              "yyyy-MM-dd"
            );
          } else {
            this.dischargeDatamodel.restDateTo = this.datePipe.transform(
              this.authService.getServerDate,
              "yyyy-MM-dd"
            );
          }
          if (this.dischargeDatamodel.secondFollowupDate != null) {
            this.dischargeDatamodel.secondFollowupDate =
              this.datePipe.transform(
                this.dischargeDatamodel.secondFollowupDate,
                "yyyy-MM-dd"
              );
          } else {
            let datee = new Date(this.authService.getServerDate);
            this.dischargeDatamodel.secondFollowupDate =
              this.datePipe.transform(
                datee.setDate(datee.getDate() + 14),
                "yyyy-MM-dd"
              );
          }
          if (this.dischargeDatamodel.firstFollowupTime != null) {
            this.dischargeDatamodel.firstFollowupTime = this.convertTime12Hour(
              this.dischargeDatamodel.firstFollowupTime
            );
          } else {
            this.dischargeDatamodel.firstFollowupTime = moment(
              this.authService.localDate
            ).format("h:mm A");
          }
          if (this.dischargeDatamodel.secondFollowupTime != null) {
            this.dischargeDatamodel.secondFollowupTime = this.convertTime12Hour(
              this.dischargeDatamodel.secondFollowupTime
            );
          } else {
            this.dischargeDatamodel.secondFollowupTime = moment(
              this.authService.localDate
            ).format("h:mm A");
          }
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar(
              "You Don't have Permission",
              "OK"
            );
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }
  getinstructionSummery(ipdid) {
    this.ipdService
      .instructionDetailByIPDID(ipdid)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (x: any) => {
          this.getInstructionmodel = [];
          this.getInstructionmodel = x;
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar(
              "You Don't have Permission",
              "OK"
            );
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }
  addnewlab() {
    if (this.getinvestigationlab.length > 0) {
      let checkdata = this.getinvestigationlab.filter(
        (item) => item.pK_TranId == 0
      );
      if (checkdata.length > 0) {
        this.dashboardService.openSnackBar("Row Already Added", "ok");
      } else {
        this.addnewRow();
      }
    } else {
      this.addnewRow();
    }
  }
  addnewRow() {
    this.getinvestigationlab.push({
      pK_TranId: 0,
      fK_IPDId: this.selectIpdId,
      headName: "",
      referenceValue: "",
      result: "",
      fk_CreatedByID: this.authService.Loggeduser.userid,
      createdDateTime: this.authService.localDate,
      fk_ModifiedByID: null,
      modifiedDateTime: null,
      isEdit: false,
      isDelete: false,
    });
  }
  getlaabinvestigation(ipdid) {
    this.ipdService
      .getDischargeLabInvestigation(ipdid)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (x: any) => {
          this.getinvestigationlab = [];
          this.getinvestigationlab = x;
          if (this.getinvestigationlab.length > 0) {
            this.getinvestigationlab.map(
              (item) => (item.isEdit = true, item.isDelete = false)
            );
          }
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar(
              "You Don't have Permission",
              "OK"
            );
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }

  timecheck: any;
  convertTime12Hour(time) {
    this.timecheck = null;
    this.timecheck = this.datePipe.transform(time, "HH:mm:ss");
    if (this.timecheck != null && this.timecheck != "") {
      let hour = this.timecheck.split(":")[0];
      let min = this.timecheck.split(":")[1];
      let part = hour > 12 ? "PM" : "AM";

      min = (min + "").length == 1 ? `0${min}` : min;
      hour = hour > 12 ? hour - 12 : hour;
      hour = (hour + "").length == 1 ? `0${hour}` : hour;

      return `${hour}:${min} ${part}`;
    } else {
      return null;
    }
  }
  saveDischagerSummery() {
    this.dischargeDatamodel.createdByName =
      this.authService.Loggeduser.username;
    this.dischargeDatamodel.fK_CreatedById = this.authService.Loggeduser.userid;
    if (
      this.dischargeDatamodel.fK_DoctorId == null ||
      this.dischargeDatamodel.fK_DoctorId == undefined
    ) {
      this.drValidation = true;
      setTimeout(() => {
        this.Doctorid.nativeElement.focus();
      }, 100);
      return this.dashboardService.openSnackBar(
        "Please Select Doctor Name",
        "OK"
      );
    }
    if (
      this.dischargeDatamodel.pK_TranId != null &&
      this.dischargeDatamodel.pK_TranId > 0
    ) {
      this.dischargeDatamodel.isEdit = true;
    } else {
      this.dischargeDatamodel.pK_TranId = 0;
      this.dischargeDatamodel.fK_IPDId = this.selectIpdId;
      this.dischargeDatamodel.isEdit = false;
    }
    if (this.dischargeDatamodel.blindnessDate != null) {
      this.dischargeDatamodel.blindnessDate = this.datePipe.transform(
        this.dischargeDatamodel.blindnessDate,
        "yyyy-MM-dd"
      );
    }
    if (this.dischargeDatamodel.campDate != null) {
      this.dischargeDatamodel.campDate = this.datePipe.transform(
        this.dischargeDatamodel.campDate,
        "yyyy-MM-dd"
      );
    }
    if (this.dischargeDatamodel.restDateFrom != null) {
      this.dischargeDatamodel.restDateFrom = this.datePipe.transform(
        this.dischargeDatamodel.restDateFrom,
        "yyyy-MM-dd"
      );
    }
    if (this.dischargeDatamodel.restDateTo != null) {
      this.dischargeDatamodel.restDateTo = this.datePipe.transform(
        this.dischargeDatamodel.restDateTo,
        "yyyy-MM-dd"
      );
    }
    if (this.dischargeDatamodel.firstFollowupTime != null) {
      this.dischargeDatamodel.firstFollowupTime = moment(
        this.dischargeDatamodel.firstFollowupTime,
        ["h:mm A"]
      ).format("HH:mm");
    }
    if (this.dischargeDatamodel.secondFollowupTime != null) {
      this.dischargeDatamodel.secondFollowupTime = moment(
        this.dischargeDatamodel.secondFollowupTime,
        ["h:mm A"]
      ).format("HH:mm");
    }
    this.dischargeDatamodel.isEdit = this.dischargeDatamodel.pK_TranId > 0 ? true : false;
    let dischageobj = {
      IpdDischargeRegister: this.dischargeDatamodel,
    };

    this.ipdService
      .insertIpdDischargeRegister(dischageobj)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (x) => {
          this.getDischargeSUmmery(this.selectIpdId);
          this.saveInstructionDetail();
          this.saveDischargeExamination();
          this.saveDischargePresception();
          this.saveLabinvestigation();
          this.dashboardService.openSnackBar("Record Saved Successfully", "OK");
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          }
          else if (err.error.statusCode == 422) {
            this.dashboardService.openSnackBar(err.error.message, "OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }

  saveInstructionDetail() {

    if (this.getInstructionmodel.length > 0) {
      var newpayload = [];
      if (this.getInstructionmodel.length > 0) {
        this.getInstructionmodel.forEach(item => {
          let payload = {
            "pK_TranId": item.pK_TranId > 0 ? item.pK_TranId : 0,
            "fK_IPDId": item.fK_IPDId,
            "instructions": item.instructions,
            "isActive": true,
            "isEdit": item.pK_TranId > 0 ? true : false,
            "isDelete": false,
          }
          newpayload.push(payload);
        })

      }
      let dischageobj = {
        DischargeInstructionDetail: newpayload.concat(this.changeSaveInstructionmodel)

      };

      this.ipdService
        .insertDischargeInstruction(dischageobj)
        .pipe(takeUntil(this.destroyipd$))
        .subscribe(
          (x) => {
            this.changeSaveInstructionmodel = [];
            this.levelcheck = false;
            this.getinstructionSummery(this.selectIpdId);
          },
          (err) => {
            this.changeSaveInstructionmodel = [];
            this.levelcheck = false;
            if (err.status == 403) {
              this.dashboardService.openSnackBar(
                "You Don't have Permission",
                "OK"
              );
            } else {
              this.dashboardService.openSnackBar("API Failed", "OK");
            }
          }
        );
    }
  }
  removeExam(row, index: number) {

    this.getdischageExamintion.splice(index, 1);
    if (row.pK_DisExamDetailId > 0) {
      this.getdeletedischageExamintion.push(row);
      this.getdeletedischageExamintion.map((item) => (item.isEdit = true));
      this.getdeletedischageExamintion.map((item) => (item.isDelete = true));
    }
  }
  removelab(row, index: number) {
    this.getinvestigationlab.splice(index, 1);
    if (row.pK_TranId > 0) {
      this.getinvestigationDellab.push(row);
      this.getinvestigationDellab.map((item) => (item.isEdit = true));
      this.getinvestigationDellab.map((item) => (item.isDelete = true));
    }
  }
  onheadName(e: any, index: number, idcheck) {
    if (e != null) {
      this.getinvestigationlab[index].headName = e;
      this.getinvestigationlab[index].isEdit = idcheck > 0 ? true : false;
      this.getinvestigationlab[index].isDelete = false;
    }
  }
  referenceValue(e: any, index: number, idcheck) {
    if (e != null) {
      this.getinvestigationlab[index].referenceValue = e;
      this.getinvestigationlab[index].isEdit = idcheck > 0 ? true : false;
      this.getinvestigationlab[index].isDelete = false;
    }
  }
  resultValue(e: any, index: number, idcheck) {
    if (e != null) {
      this.getinvestigationlab[index].result = e;
      this.getinvestigationlab[index].isEdit = idcheck > 0 ? true : false;
      this.getinvestigationlab[index].isDelete = false;
    }
  }
  saveDischargeExamination() {

    if (
      this.getdischageExamintion.length > 0 ||
      this.getdeletedischageExamintion.length > 0
    ) {

      let dischageexamobj = {
        DischargeExaminationDetail: [
          ...this.getdischageExamintion.map((item) => ({
            ...item,
            isEdit: item.pK_DisExamDetailId > 0 ? true : false,
            isDelete: false,
          })),
          ...this.getdeletedischageExamintion
        ],
      };

      this.ipdService
        .insertDIschargeExamination(dischageexamobj)
        .pipe(takeUntil(this.destroyipd$))
        .subscribe(
          (x) => {
            this.getdeletedischageExamintion = [];
            this.getDischargeExamination(this.selectIpdId);
          },
          (err) => {
            this.dashboardService.openSnackBar(
              "Save DischargeExamination API FAILED",
              "OK"
            );
          }
        );
    }

  }
  saveLabinvestigation() {
    if (
      this.getinvestigationlab.length > 0 ||
      this.getinvestigationDellab.length > 0
    ) {
      let labexamobj = {
        DischargeInstructionDetail: this.getinvestigationlab.concat(
          this.getinvestigationDellab
        ),
      };
      this.ipdService
        .insertlabData(labexamobj)
        .pipe(takeUntil(this.destroyipd$))
        .subscribe(
          (x) => {
            this.getinvestigationDellab = [];
            this.getlaabinvestigation(this.selectIpdId);
          },
          (err) => {
            this.dashboardService.openSnackBar(
              "Save LabInvestigation API FAILED",
              "OK"
            );
          }
        );
    }
  }
  //save prescription data
  saveDischargePresception() {
    if (
      this.getdischargeMedicine.length > 0 ||
      this.getdeletedischargeMedicine.length > 0
    ) {
      let dischargepreobj = {
        DischargePrescriptionDetail: [
          ...this.getdischargeMedicine.map((item) => ({
            ...item,
            isEdit: item.pK_DPrescriptionId > 0 ? true : false,
            isDelete: false,
          })),
          ...this.getdeletedischargeMedicine.map((item) => ({
            ...item,
            isDelete: true,
          })),
        ],
      };


      this.ipdService
        .insertDischargePrescription(dischargepreobj)
        .pipe(takeUntil(this.destroyipd$))
        .subscribe(
          (item) => {
            this.getdeletedischargeMedicine = [];
            this.getDischaredMedicine(this.selectIpdId);
          },
          (err) => {
            this.dashboardService.openSnackBar(
              "Discharge Prescription Api Failed",
              "OK"
            );
          }
        );
    }
  }
  //medinice template
  OpenMediniceTemplate(type) {
    const dialogRef = this.dialog.open(MedicineTemplateComponent, {
      // panelClass: "full-width-dialog",
      maxWidth: "100vw !important",
      // height: "90%",
      width: "90%",
    });
    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroyipd$))
      .subscribe((result) => {
        if (result.length > 0) {
          if (type == 1) {
            result?.forEach((item) => {
              let mdobj = {
                pK_DPrescriptionId: 0,
                fK_IPDId: this.selectIpdId,
                fK_MedicineId: item.pK_MedicineId,
                qty: item.qty,
                fK_DosageId: item.fK_DosageId,
                days: item.days,
                unit: item.daysUnit,
                isEdit: false,
                isDelete: false,
                eye: null,
                remarks: item.remarks,
                medicineName: item.medicineName,
                dosageDescription: item.dosageDescription,
                unitQty: 0,
              };
              this.getdischargeMedicine.push(mdobj);
            });
            this.getdischargeMedicine = this.getdischargeMedicine.reduce(
              (unique, o) => {
                if (
                  !unique.some(
                    (obj) =>
                      obj.medicineName == o.medicineName &&
                      obj.fK_MedicineId == o.fK_MedicineId
                  )
                ) {
                  unique.push(o);
                }
                return unique;
              },
              []
            );
          } else if (type == 2) {
            result?.forEach((item) => {
              this.getIPDPrescptionArray.push({
                pK_TranId: 0,
                fK_IPDVisitID: !this.getipdExamlistObj.pK_IPDVisitID
                  ? null
                  : this.getipdExamlistObj.pK_IPDVisitID,
                fK_MedicineId: item.pK_MedicineId,
                qty: item.qty,
                fK_DosageId: item.fK_DosageId,
                days: item.days,
                unit: item.daysUnit,
                isEdit: false,
                isDelete: false,
                eye: null,
                remarks: item.remarks,
                medicineName: item.medicineName,
                dosageDescription: item.dosageDescription,
                checkprescpedit: false,
              });
            });
            this.getIPDPrescptionArray = this.getIPDPrescptionArray.reduce(
              (unique, o) => {
                if (
                  !unique.some(
                    (obj) =>
                      obj.medicineName == o.medicineName &&
                      obj.fK_MedicineId == o.fK_MedicineId
                  )
                ) {
                  unique.push(o);
                }
                return unique;
              },
              []
            );
          } else if (type == 3) {
            result?.forEach((item) => {
              this.GetNursingMedicineArray.push({
                pK_TranID: 0,
                fK_IPDID: this.selectIpdId,
                entryDate: this.datePipe.transform(
                  new Date(),
                  "yyyy-MM-dd HH:mm:ss"
                ),
                fK_MedicineID: item.pK_MedicineId,
                site: null,
                fK_DosageID: item.fK_DosageId,
                dosageTime: null,
                givenTime: null,
                status: false,
                fK_AdvisedById: this.authService.Loggeduser.userid,
                fK_ActualGivenById: null,
                remarks: item.remarks,
                fk_Templateid: null,
                medicineName: item.medicineName,
                dosageCode: this.retundata(item.fK_DosageId),
                advisedBy: this.authService.Loggeduser.firstname,
                givenBy: null,
                dept: null,
                dosageDescription: item.dosageDescription,
                templateName: null,
                isEdit: false,
                isDelete: false,
              });
            });
            this.GetNursingMedicineArray = this.GetNursingMedicineArray.reduce(
              (unique, o) => {
                if (
                  !unique.some(
                    (obj) =>
                      obj.medicineName == o.medicineName &&
                      obj.fK_MedicineID == o.fK_MedicineID
                  )
                ) {
                  unique.push(o);
                }
                return unique;
              },
              []
            );
          } else if (type == 4) {
            if (result.length > 0) {
              this.templateMasterDisable = false;
              result?.forEach((item) => {
                this.MediciantemplateMaster.push({
                  pK_TranID: 0,
                  fK_TemplateId: this.masterTemplateId,
                  fK_MedicineId: item.pK_MedicineId,
                  qty: item.qty,
                  fK_DosageId: item.fK_DosageId,
                  days: item.days,
                  unit: item.daysUnit,
                  remakrs: item.remarks,
                  medicineName: item.medicineName,
                  dosageCode: item.dosageCode,
                  medicineType: item.type,
                  pK_SynchId: null,
                  isActive: true,
                  isEdit: false,
                  isDelete: false,
                });
              });

              if (this.MediciantemplateMaster.length > 1) {
                this.MediciantemplateMaster =
                  this.MediciantemplateMaster.reduce((unique, o) => {
                    if (
                      !unique.some((obj) => obj.medicineName === o.medicineName)
                    ) {
                      unique.push(o);
                    }
                    return unique;
                  }, []);
              }
            }
          } else if (type == 5) {
            if (result.length > 0) {
              this.CounspreopDisable = false;
              result?.forEach((item) => {
                this.CounselorMedicineDetail.push({
                  pK_TranId: 0,
                  fK_CounsID: this.selectCouncelorId,
                  fK_MedicineId: item.pK_MedicineId,
                  qty: item.qty,
                  fK_DosageId: item.fK_DosageId,
                  days: item.days,
                  unit: item.daysUnit,
                  remarks: item.remarks,
                  medicineName: item.medicineName,
                  dosageCode: item.dosageCode,
                  medicineType: item.type,
                  pK_SynchId: null,
                  isEdit: false,
                  isDelete: false,
                });
              });
              // this.MediciantemplateMaster = this.MediciantemplateMaster.concat(this.MediciantemplateMaster);
              if (this.CounselorMedicineDetail.length > 1) {
                this.CounselorMedicineDetail =
                  this.CounselorMedicineDetail.reduce((unique, o) => {
                    if (
                      !unique.some((obj) => obj.medicineName === o.medicineName)
                    ) {
                      unique.push(o);
                    }
                    return unique;
                  }, []);
              }
            }
          }
        }
      });
  }
  dublicateArray: any = [];
  transferDataOpd() {
    if (this.RegId > 0) {
      this.dublicateArray = [];

      this.emrservice
        .GetPrescriptionDetailByRegId(this.RegId, 0, 0)
        .pipe(takeUntil(this.destroyipd$))
        .subscribe(
          (item: any) => {
            if (item.length > 0) {
              this.dublicateArray = this.dublicateArray.concat(
                this.getdischargeMedicine
              );
              item?.forEach((item) => {
                let mdobj = {
                  pK_DPrescriptionId: 0,
                  fK_IPDId: this.selectIpdId,
                  fK_MedicineId: item.fK_MedicineId,
                  qty: item.qty,
                  fK_DosageId: item.fK_DosageId,
                  days: item.days,
                  unit: item.unit,
                  isEdit: false,
                  isDelete: false,
                  eye: item.eye,
                  remarks: item.remarks,
                  medicineName: item.medicineName,
                  dosageDescription: null,
                  unitQty: item.unitQty,
                };
                this.dublicateArray.push(mdobj);
              });
              var valueArr = this.dublicateArray.map(function (item) {
                return item.fK_MedicineId;
              });
              var isDuplicate = valueArr.some(function (item, idx) {
                return valueArr.indexOf(item) != idx;
              });

              if (isDuplicate == true) {
                document.getElementById("medicinetransferModel").style.display =
                  "block";
              } else {
                this.getdischargeMedicine = this.dublicateArray.reduce(
                  (unique, o) => {
                    if (
                      !unique.some(
                        (obj) => obj.fK_MedicineId === o.fK_MedicineId
                      )
                    ) {
                      unique.push(o);
                    }
                    return unique;
                  },
                  []
                );
                this.dashboardService.openSnackBar(
                  "Medicine transferred Successfully",
                  "OK"
                );
              }
            } else {
              this.dashboardService.openSnackBar(
                "Medicine not available",
                "OK"
              );
            }
          },
          (err) => {
            if (err.status == 403) {
              this.dashboardService.openSnackBar("You Don't have Permission", "OK");
            }
            else if (err.error.statusCode == 422) {
              this.dashboardService.openSnackBar(err.error.message, "OK");
            }
            else {
              this.dashboardService.openSnackBar("API Failed", "OK");
            }
          }
        );
    }
  }
  medicineAppened() {
    this.getdischargeMedicine = [];
    this.getdischargeMedicine = this.getdischargeMedicine.concat(
      this.dublicateArray
    );
    document.getElementById("medicinetransferModel").style.display = "none";
    this.dublicateArray = [];
    this.dashboardService.openSnackBar(
      "Medicine transferred Successfully",
      "OK"
    );
  }
  medicineNotAppened() {
    this.getdischargeMedicine = this.dublicateArray.reduce((unique, o) => {
      if (!unique.some((obj) => obj.fK_MedicineId === o.fK_MedicineId)) {
        unique.push(o);
      }
      return unique;
    }, []);
    document.getElementById("medicinetransferModel").style.display = "none";
    this.dublicateArray = [];
    this.dashboardService.openSnackBar(
      "Medicine transferred Successfully",
      "OK"
    );
  }
  transferDataIpd() {
    if (this.RegId > 0) {
      this.dublicateArray = [];
      this.ipdService
        .getmediciedataIpd(this.selectIpdId)
        .pipe(takeUntil(this.destroyipd$))
        .subscribe(
          (item: any) => {
            if (item.length > 0) {
              this.dublicateArray = this.dublicateArray.concat(
                this.getdischargeMedicine
              );
              item?.forEach((item) => {
                let mdobj = {
                  pK_DPrescriptionId: 0,
                  fK_IPDId: this.selectIpdId,
                  fK_MedicineId: item.fK_MedicineId,
                  qty: item.qty,
                  fK_DosageId: item.fK_DosageId,
                  days: item.days,
                  unit: item.unit,
                  isEdit: false,
                  isDelete: false,
                  eye: item.eye,
                  remarks: item.remarks,
                  medicineName: item.medicineName,
                  dosageDescription: item.dosageDescription,
                  unitQty: 0,
                };
                this.dublicateArray.push(mdobj);
              });
              var valueArr = this.dublicateArray.map(function (item) {
                return item.fK_MedicineId;
              });
              var isDuplicate = valueArr.some(function (item, idx) {
                return valueArr.indexOf(item) != idx;
              });

              if (isDuplicate == true) {
                document.getElementById(
                  "medicinetransferIPDModel"
                ).style.display = "block";
              } else {
                this.getdischargeMedicine = this.dublicateArray.reduce(
                  (unique, o) => {
                    if (
                      !unique.some(
                        (obj) => obj.fK_MedicineId === o.fK_MedicineId
                      )
                    ) {
                      unique.push(o);
                    }
                    return unique;
                  },
                  []
                );
                this.dashboardService.openSnackBar(
                  "Medicine transferred Successfully",
                  "OK"
                );
              }
            } else {
              this.dashboardService.openSnackBar(
                "Medicine not available",
                "OK"
              );
            }
          },
          (err) => {
            if (err.status == 403) {
              this.dashboardService.openSnackBar(
                "You Don't have Permission",
                "OK"
              );
            } else {
              this.dashboardService.openSnackBar("API Failed", "OK");
            }
          }
        );
    }
  }
  medicineAppenedIPD() {
    this.getdischargeMedicine = [];
    this.getdischargeMedicine = this.getdischargeMedicine.concat(
      this.dublicateArray
    );
    document.getElementById("medicinetransferIPDModel").style.display = "none";
    this.dublicateArray = [];
    this.dashboardService.openSnackBar(
      "Medicine transferred Successfully",
      "OK"
    );
  }
  medicineNotAppenedIPD() {
    this.getdischargeMedicine = this.dublicateArray.reduce((unique, o) => {
      if (!unique.some((obj) => obj.fK_MedicineId === o.fK_MedicineId)) {
        unique.push(o);
      }
      return unique;
    }, []);
    document.getElementById("medicinetransferIPDModel").style.display = "none";
    this.dublicateArray = [];
    this.dashboardService.openSnackBar(
      "Medicine transferred Successfully",
      "OK"
    );
  }
  //select from template
  opentemplate_help(type): void {
    const dialogRef = this.dialog.open(Template_helpComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "95vw",
      width: "95%",
      maxHeight: "95vh",
      disableClose: true,
      data: 0,
    });

    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroyipd$))
      .subscribe((result) => {
        if (type == 1) {
          if (result.examrow.length > 0) {
            result.examrow?.forEach((item) => {
              this.getdischageExamintion.push({
                pK_DisExamDetailId: 0,
                fK_IPDId: this.selectIpdId,
                fk_FindingId: item.fk_FindingId,
                pK_SynchId: item.pk_SynchId,
                findingName: item.findingName,
                examValues1: item.examValues1,
                examValues2: item.examValues2,
                specification: item.findingName,
                isDelete: false,
                isEdit: false,
              });
            });
            this.getdischageExamintion = this.getdischageExamintion.reduce(
              (unique, o) => {
                if (
                  !unique.some(
                    (obj) =>
                      obj.findingName === o.findingName &&
                      obj.fk_FindingId === o.fk_FindingId
                  )
                ) {
                  unique.push(o);
                }
                return unique;
              },
              []
            );
          }
          if (result.medicinerow.length > 0) {
            result.medicinerow?.forEach((item) => {
              let mdobj = {
                pK_DPrescriptionId: 0,
                fK_IPDId: this.selectIpdId,
                fK_MedicineId: item.fK_MedicineId,
                qty: item.qty,
                fK_DosageId: item.fK_DosageId,
                days: item.days,
                unit: item.unit,
                isEdit: false,
                isDelete: false,
                eye: null,
                remarks: item.remarks,
                medicineName: item.medicineName,
                dosageDescription: null,
                unitQty: 0,
              };
              this.getdischargeMedicine.push(mdobj);
            });
          }
        } else if (type == 2) {
          if (result.medicinerow.length > 0) {
            result.medicinerow?.forEach((item) => {
              this.getIPDPrescptionArray.push({
                pK_TranId: 0,
                fK_IPDVisitID: !this.getipdExamlistObj.pK_IPDVisitID
                  ? null
                  : this.getipdExamlistObj.pK_IPDVisitID,
                fK_MedicineId: item.fK_MedicineId,
                qty: item.qty,
                fK_DosageId: item.fK_DosageId,
                days: item.days,
                unit: item.unit,
                isEdit: false,
                isDelete: false,
                eye: null,
                remarks: item.remarks,
                medicineName: item.medicineName,
                dosageDescription: null,
                checkprescpedit: false,
              });
            });
          }
        }
      });
  }
  onMedicinechange(e: any, index: number) {
    if (e != null) {
      this.getdischargeMedicine[index].medicineName = e;
      this.getdischargeMedicine[index].isEdit = true;
      this.getdischargeMedicine[index].isDelete = false;
    }
  }
  onQtychange(e: any, index: number, idcheck) {
    if (e != null) {
      this.getdischargeMedicine[index].qty = e;
      this.getdischargeMedicine[index].isEdit = idcheck > 0 ? true : false;
      this.getdischargeMedicine[index].isDelete = false;
    }
  }
  onQtychange1(e: any, index: number, idcheck) {
    if (e != null) {
      this.getIPDPrescptionArray[index].qty = e;
      this.getIPDPrescptionArray[index].isEdit = idcheck > 0 ? true : false;
      this.getIPDPrescptionArray[index].isDelete = false;
    }
  }
  onDosechange(e: any, index: number, idcheck) {
  
    if (e != null) {
      this.getdischargeMedicine[index].fK_DosageId = e;
      this.getdischargeMedicine[index].isEdit = idcheck > 0 ? true : false;
      this.getdischargeMedicine[index].isDelete = false;
    }
  }
  onDosechange1(e: any, index: number, idcheck) {
    if (e != null) {
      this.getIPDPrescptionArray[index].fK_DosageId = e;
      this.getIPDPrescptionArray[index].isEdit = idcheck > 0 ? true : false;
      this.getIPDPrescptionArray[index].isDelete = false;
    }
  }
  onDosechangenurse(e: any, index: number, idcheck) {
    if (e != null) {
      this.GetNursingMedicineArray[index].dosageCode = e;
      this.GetNursingMedicineArray[index].fK_DosageID =
        this.dosedataArray.filter(
          (item) => item.dosageCode == e
        )[0].pK_DosageId;
      this.GetNursingMedicineArray[index].isEdit = idcheck > 0 ? true : false;
      this.GetNursingMedicineArray[index].isDelete = false;
    }
  }
  nurseStatuOptions(event: MatCheckboxChange, index: number, idcheck): void {
    this.GetNursingMedicineArray[index].status = event.checked;
    this.GetNursingMedicineArray[index].isEdit = idcheck > 0 ? true : false;
    this.GetNursingMedicineArray[index].isDelete = false;
  }
  onnurseRemarkchange(e: any, index: number, idcheck) {
    if (e != null) {
      this.GetNursingMedicineArray[index].remarks = e;
      this.GetNursingMedicineArray[index].isEdit = idcheck > 0 ? true : false;
      this.GetNursingMedicineArray[index].isDelete = false;
    }
  }
  ondaysChange(e: any, index: number, idcheck) {
    if (e != null) {
      this.getdischargeMedicine[index].days = e;
      this.getdischargeMedicine[index].isEdit = idcheck > 0 ? true : false;
      this.getdischargeMedicine[index].isDelete = false;
    }
  }
  ondaysChange1(e: any, index: number, idcheck) {
    if (e != null) {
      this.getIPDPrescptionArray[index].days = e;
      this.getIPDPrescptionArray[index].isEdit = idcheck > 0 ? true : false;
      this.getIPDPrescptionArray[index].isDelete = false;
    }
  }
  onUQtyChange(e: any, index: number, idcheck) {
    if (e != null) {
      this.getdischargeMedicine[index].unitQty = e;
      this.getdischargeMedicine[index].isEdit = idcheck > 0 ? true : false;
      this.getdischargeMedicine[index].isDelete = false;
    }
  }
  onUnitchange(e: any, index: number, idcheck) {
    if (e != null) {
      this.getdischargeMedicine[index].unit = e;
      this.getdischargeMedicine[index].isEdit = idcheck > 0 ? true : false;
      this.getdischargeMedicine[index].isDelete = false;
    }
  }
  onUnitchange1(e: any, index: number, idcheck) {
    if (e != null) {
      this.getIPDPrescptionArray[index].unit = e;
      this.getIPDPrescptionArray[index].isEdit = idcheck > 0 ? true : false;
      this.getIPDPrescptionArray[index].isDelete = false;
    }
  }
  onSitechange(e: any, index: number, idcheck) {
    if (e != null) {
      this.getdischargeMedicine[index].eye = e;
      this.getdischargeMedicine[index].isEdit = idcheck > 0 ? true : false;
      this.getdischargeMedicine[index].isDelete = false;
    }
  }
  onSitechange1(e: any, index: number, idcheck) {
    if (e != null) {
      this.getIPDPrescptionArray[index].eye = e;
      this.getIPDPrescptionArray[index].isEdit = idcheck > 0 ? true : false;
      this.getIPDPrescptionArray[index].isDelete = false;
    }
  }
  onInvSitechange(e: any, index: number, idcheck) {
    if (e != null) {
      this.getIPDInvestigationArray[index].eye = e;
      this.getIPDInvestigationArray[index].isEdit = idcheck > 0 ? true : false;
      this.getIPDInvestigationArray[index].isDelete = false;
    }
  }
  onremarkschange(e: any, index: number, idcheck) {
    if (e != null) {
      this.getdischargeMedicine[index].remarks = e;
      this.getdischargeMedicine[index].isEdit = idcheck > 0 ? true : false;
      this.getdischargeMedicine[index].isDelete = false;
    }
  }
  onremarkschange1(e: any, index: number, idcheck) {
    if (e != null) {
      this.getIPDPrescptionArray[index].remarks = e;
      this.getIPDPrescptionArray[index].isEdit = idcheck > 0 ? true : false;
      this.getIPDPrescptionArray[index].isDelete = false;
    }
  }
  oninvestRemarkchange(e: any, index: number, idcheck) {
    if (e != null) {
      this.getIPDInvestigationArray[index].result = e;
      this.getIPDInvestigationArray[index].isEdit = idcheck > 0 ? true : false;
      this.getIPDInvestigationArray[index].isDelete = false;
    }
  }
  onrightchange(e: any, index: number, idcheck) {
    if (e != null) {
      this.getdischageExamintion[index].examValues1 = e;
      this.getdischageExamintion[index].isEdit = idcheck > 0 ? true : false;
      this.getdischageExamintion[index].isDelete = false;
    }
  }
  onleftchange(e: any, index: number, idcheck) {
    if (e != null) {
      this.getdischageExamintion[index].examValues2 = e;
      this.getdischageExamintion[index].isEdit = idcheck > 0 ? true : false;
      this.getdischageExamintion[index].isDelete = false;
    }
  }
  onInstructionchanged(e: any, index: number, idcheck) {
    if (e != null) {
      this.getInstructionmodel[index].instructions = e;
      this.getInstructionmodel[index].isEdit = idcheck > 0 ? true : false;
      this.getInstructionmodel[index].isDelete = false;
    }
  }
  getexamTypeobjedit(e: any, index: number, idcheck) {
    let checkdr = this.getIPDExaminationArray.filter(item => item.fk_FindingId == e.option.id);
    if (checkdr.length > 0) {
      this.dashboardService.openSnackBar("Already exists in the list", "OK")
      this.getIPDExaminationArray[index].findingName = '';
      this.getIPDExaminationArray[index].fk_FindingId = null;
      return
    }
    if (e.option.value != null) {
      this.getIPDExaminationArray[index].findingName = e.option.value;
      this.getIPDExaminationArray[index].fk_FindingId = e.option.id;
      this.getIPDExaminationArray[index].isEdit = idcheck > 0 ? true : false;
      this.getIPDExaminationArray[index].isDelete = false;
    }
  }

  getrightTypeobjedit(e: any, index: number, idcheck) {
    if (e.option.value != null) {
      this.getIPDExaminationArray[index].examValues1 = e.option.value;
      this.getIPDExaminationArray[index].isEdit = idcheck > 0 ? true : false;
      this.getIPDExaminationArray[index].isDelete = false;
    }
  }
  checkinputvalue(e: any, index: number, idcheck) {
    if (e.target.value != null) {
      this.getIPDExaminationArray[index].examValues1 = e.target.value;
      this.getIPDExaminationArray[index].isEdit = idcheck > 0 ? true : false;
      this.getIPDExaminationArray[index].isDelete = false;
    } else {
      this.getIPDExaminationArray[index].examValues1 = null;
      this.getIPDExaminationArray[index].isEdit = idcheck > 0 ? true : false;
      this.getIPDExaminationArray[index].isDelete = false;
    }
  }
  getleftTypeobjedit(e: any, index: number, idcheck) {
    if (e.option.value != null) {
      this.getIPDExaminationArray[index].examValues2 = e.option.value;
      this.getIPDExaminationArray[index].isEdit = idcheck > 0 ? true : false;
      this.getIPDExaminationArray[index].isDelete = false;
    }
  }
  checkinputLvalue(e: any, index: number, idcheck) {
    if (e.target.value != null) {
      this.getIPDExaminationArray[index].examValues2 = e.target.value;
      this.getIPDExaminationArray[index].isEdit = idcheck > 0 ? true : false;
      this.getIPDExaminationArray[index].isDelete = false;
    } else {
      this.getIPDExaminationArray[index].examValues2 = null;
      this.getIPDExaminationArray[index].isEdit = idcheck > 0 ? true : false;
      this.getIPDExaminationArray[index].isDelete = false;
    }
  }
  ondiagnosisTypechange(e: any, index: number, idcheck) {
    this.getIPDDiagonosisArray[index].diagnosisType = e;
    this.getIPDDiagonosisArray[index].isEdit = idcheck > 0 ? true : false;
    this.getIPDDiagonosisArray[index].isDelete = false;
  }
  ondSitechange(e: any, index: number, idcheck) {
    this.getIPDDiagonosisArray[index].remarks = e;
    this.getIPDDiagonosisArray[index].isEdit = idcheck > 0 ? true : false;
    this.getIPDDiagonosisArray[index].isDelete = false;
  }
  onNursSitechange(e: any, index: number, idcheck) {
    this.GetNursingMedicineArray[index].site = e;
    this.GetNursingMedicineArray[index].isEdit = idcheck > 0 ? true : false;
    this.GetNursingMedicineArray[index].isDelete = false;
  }
  dosedataArray: any = [];
  GetDosageMaster(doseid, type, seachtype) {
    this.dosedataArray = [];
    this.emrservice
      .GetDosageMaster(doseid, type, seachtype)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe((item) => {
        this.dosedataArray = item;
      });
  }

  getSite() {
    this.emrservice
      .getMasterSite()
      .pipe(takeUntil(this.destroyipd$))
      .subscribe((data) => {
        this.sitelist = [];
        this.sitelist = data;
      });
  }
  newlistarrray: any = [];
  openexamination(type): void {
    const dialogRef = this.dialog.open(ExaminationHelpComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "90vw",
      width: "90%",
      disableClose: true,
    });

    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroyipd$))
      .subscribe((result) => {
        if (result.length > 0 && type == 1) {
          result?.forEach((item) => {
            this.getdischageExamintion.push({
              pK_DisExamDetailId: 0,
              fK_IPDId: this.selectIpdId,
              fk_FindingId: item.fk_FindingId,
              pK_SynchId: item.pk_SynchId,
              findingName: item.findingName,
              examValues1: item.examValues1,
              examValues2: item.examValues2,
              specification: item.findingName,
              isDelete: false,
              isEdit: false,
            });
          });
          this.getdischageExamintion = this.getdischageExamintion.reduce(
            (unique, o) => {
              if (
                !unique.some(
                  (obj) =>
                    obj.findingName === o.findingName &&
                    obj.fk_FindingId === o.fk_FindingId
                )
              ) {
                unique.push(o);
              }
              return unique;
            },
            []
          );
        } else if (result.length > 0 && type == 2) {
          result?.forEach((item) => {
            this.getIPDExaminationArray.push({
              pK_TranId: 0,
              fK_IPDVisitID: !this.getipdExamlistObj.pK_IPDVisitID
                ? null
                : this.getipdExamlistObj.pK_IPDVisitID,
              fk_FindingId: item.fk_FindingId,
              findingName: item.findingName,
              examValues1: item.examValues1,
              examValues2: item.examValues2,
              specification: item.findingName,
              isDelete: false,
              isEdit: false,
              checkUpdate: false,
            });
          });
          this.getIPDExaminationArray = this.getIPDExaminationArray.reduce(
            (unique, o) => {
              if (
                !unique.some(
                  (obj) =>
                    obj.findingName === o.findingName &&
                    obj.fk_FindingId === o.fk_FindingId
                )
              ) {
                unique.push(o);
              }
              return unique;
            },
            []
          );
        }
      });
  }
  getDischargeExamination(ipdid) {
    this.ipdService
      .getDischargeExamination(ipdid)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (x: any) => {
          this.getdischageExamintion = [];
          this.getdeletedischageExamintion = [];
          this.getdischageExamintion = x;
        },
        (err) => {
          this.getdeletedischageExamintion = [];
          this.dashboardService.openSnackBar(
            " Get Discharge Examination Api Failed",
            "OK"
          );
        }
      );
  }

  getDischaredMedicine(ipdid) {
    this.ipdService
      .getDischargeMedicine(ipdid)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (x: any) => {
          this.getdischargeMedicine = [];
          this.getdeletedischargeMedicine = [];
          this.getdischargeMedicine = x;
        },
        (err) => {
          this.getdeletedischargeMedicine = [];
          this.dashboardService.openSnackBar(
            " Get Discharge Medicine Api Failed",
            "OK"
          );
        }
      );
  }
  removeMedData(row, index: number) {
    this.getdischargeMedicine.splice(index, 1);
    if (row.pK_DPrescriptionId > 0) {
      this.getdeletedischargeMedicine.push(row);
      this.getdeletedischargeMedicine.map((item) => (item.isEdit = true));
      this.getdeletedischargeMedicine.map((item) => (item.isDelete = true));
    }
  }
  removeinstData(row, index: number) {
    this.getInstructionmodel.splice(index, 1);
    if (row.pK_TranId > 0) {
      let objdat = {
        pK_TranId: row.pK_TranId,
        fK_IPDId: row.fK_IPDId,
        instructions: row.instructions,
        isActive: false,
        isEdit: true,
        isDelete: true,
      };
      this.changeSaveInstructionmodel.push(objdat);

    }
  }
  removeFRow(row, index: number) {
    this.getIPDExaminationArray.splice(index, 1);
    if (row.pK_TranId > 0) {
      this.getIPDExaminationDeleteArray.push(row);
      this.getIPDExaminationDeleteArray.map((item) => (item.isEdit = true));
      this.getIPDExaminationDeleteArray.map((item) => (item.isDelete = true));
    }
  }
  removediagnosisRow(row, index: number) {
    this.getIPDDiagonosisArray.splice(index, 1);
    if (row.pK_TranId > 0) {
      this.getIPDDiagonosisDeleteArray.push(row);
      this.getIPDDiagonosisDeleteArray.map((item) => (item.isEdit = true));
      this.getIPDDiagonosisDeleteArray.map((item) => (item.isDelete = true));
    }
  }
  removeInvsRow(row, index: number) {
    this.getIPDInvestigationArray.splice(index, 1);
    if (row.pK_TranId > 0) {
      this.getIPDInvestigationDeleteArray.push(row);
      this.getIPDInvestigationDeleteArray.map((item) => (item.isEdit = true));
      this.getIPDInvestigationDeleteArray.map((item) => (item.isDelete = true));
    }
  }
  removeprescRow(row, index: number) {
    this.getIPDPrescptionArray.splice(index, 1);
    if (row.pK_TranId > 0) {
      this.getIPDPrescptionDeleteArray.push(row);
      this.getIPDPrescptionDeleteArray.map((item) => (item.isEdit = true));
      this.getIPDPrescptionDeleteArray.map((item) => (item.isDelete = true));
    }
  }
  //load normal finding
  getNormalFinding() {
    this.emrservice
      .GetNormalFindingTemplate(1)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (x: any) => {
          if (x.length > 0) {
            x?.forEach((item) => {
              this.getIPDExaminationArray.push({
                pK_TranId: 0,
                fK_IPDVisitID: !this.getipdExamlistObj.pK_IPDVisitID
                  ? null
                  : this.getipdExamlistObj.pK_IPDVisitID,
                fk_FindingId: item.fK_FindingId,
                findingName: item.findingName,
                examValues1: item.result1,
                examValues2: item.result2,
                specification: item.findingName,
                isDelete: false,
                isEdit: false,
                checkUpdate: false,
              });
            });
            this.getIPDExaminationArray = this.getIPDExaminationArray.reduce(
              (unique, o) => {
                if (
                  !unique.some(
                    (obj) =>
                      obj.findingName === o.findingName &&
                      obj.fk_FindingId === o.fk_FindingId
                  )
                ) {
                  unique.push(o);
                }
                return unique;
              },
              []
            );
          }
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar(
              "You Don't have Permission",
              "OK"
            );
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }
  opentemplates(): void {
    const dialogRef = this.dialog.open(TemplateFindingsComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "80vw",
      width: "70%",
      disableClose: true,
    });

    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroyipd$))
      .subscribe((result) => {
        if (result?.length > 0) {
          this.emrservice.enabledisablebtn = false;
          result?.forEach((element) => {
            this.newlistarrray.push({
              pK_TranId: 0,
              fK_VisitId: this.emrservice.visitid,
              fk_FindingId: element.fK_FindingId,
              pk_SynchId: 0,
              findingName: element.findingName,
              examValues1: element.result1,
              examValues2: element.result2,
              specification: element.findingName,
              findingSubGroup: element.findingSubGroup,
              isDelete: false,
              isEdit: false,
            });
          });
          this.newlistarrray = this.newlistarrray.reduce((unique, o) => {
            if (
              !unique.some(
                (obj) =>
                  obj.findingName === o.findingName &&
                  obj.fk_FindingId === o.fk_FindingId
              )
            ) {
              unique.push(o);
            }
            return unique;
          }, []);
          this.getIPDExaminationArray = this.newlistarrray;
        }
      });
  }
  //diagnosis model
  opendiagnosis(): void {
    const dialogRef = this.dialog.open(DiagnosisComponent, {
      // panelClass: "full-width-dialog",
      maxWidth: "90vw",
      width: "90%",
      disableClose: true,
    });

    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroyipd$))
      .subscribe((result) => {
        if (result.length > 0) {
          result?.forEach((item) => {
            this.getIPDDiagonosisArray.push({
              pK_TranId: 0,
              fK_IPDVisitID: !this.getipdExamlistObj.pK_IPDVisitID
                ? null
                : this.getipdExamlistObj.pK_IPDVisitID,
              fK_DiagnosisId: item.pk_DiagnosisId,
              icdCode: item.icdCode,
              diagnosisName: item.diagnosisName,
              diagnosisType: null,
              site: item.site,
              remarks: item.site,
              isEdit: false,
              diagnosisDate: this.datePipe.transform(new Date(), "yyyy-MM-dd"),
              isDelete: false,
              checkDiagnosis: false,
            });
          });

          this.getIPDDiagonosisArray = this.getIPDDiagonosisArray.reduce(
            (unique, o) => {
              if (
                !unique.some(
                  (obj) =>
                    obj.diagnosisName == o.diagnosisName &&
                    obj.fK_DiagnosisId == o.fK_DiagnosisId
                )
              ) {
                unique.push(o);
              }
              return unique;
            },
            []
          );
          //  this.diagnosis_ds = new MatTableDataSource(this.diagnosisMainArray.slice());
        }
      });
  }

  newservice(type) {
    const dialogRef = this.dialog.open(InvestigationServicesComponent, {
      // panelClass: "full-width-dialog",
      maxWidth: "90vw !important",
      maxHeight: "90%",
      width: "90%",
    });
    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroyipd$))
      .subscribe((result) => {
        if (type == 1) {
          if (this.emrservice.selectedInvestigationRow.length > 0) {
            this.emrservice.selectedInvestigationRow.forEach(
              (element, index) => {
                this.getIPDInvestigationArray.push({
                  pK_TranId: 0,
                  fK_IPDVisitID: !this.getipdExamlistObj.pK_IPDVisitID
                    ? null
                    : this.getipdExamlistObj.pK_IPDVisitID,
                  result: null,
                  serviceName: element.serviceName,
                  fK_ServiceId: element.serviceId,
                  eye: "",
                  isEdit: false,
                  academic: false,
                  isDelete: false,
                  checkInvetedit: false,
                });
                //
              }
            );
            this.getIPDInvestigationArray =
              this.getIPDInvestigationArray.reduce((unique, o) => {
                if (
                  !unique.some(
                    (obj) =>
                      obj.serviceName === o.serviceName &&
                      obj.fK_ServiceId === o.fK_ServiceId
                  )
                ) {
                  unique.push(o);
                }
                return unique;
              }, []);
          }
        } else if (type == 2) {
          this.templateMasterDisable = false;
          let newresult = this.emrservice.selectedInvestigationRow.reduce(
            (unique, o) => {
              if (
                !unique.some(
                  (obj) =>
                    obj.serviceName === o.serviceName &&
                    obj.FK_ServiceId === o.FK_ServiceId
                )
              ) {
                unique.push(o);
              }
              return unique;
            },
            []
          );
          newresult?.forEach((item) => {
            this.InvestigationtemplateMaster.push({
              pK_TranID: 0,
              fK_TemplateID: this.masterTemplateId,
              fK_ServiceId: item.serviceId,
              serviceName: item.serviceName,
              pK_SynchId: null,
              isActive: true,
              isEdit: false,
              isDelete: false,
            });
          });
          if (this.InvestigationtemplateMaster.length > 1) {
            this.InvestigationtemplateMaster =
              this.InvestigationtemplateMaster.reduce((unique, o) => {
                if (
                  !unique.some(
                    (obj) =>
                      obj.serviceName === o.serviceName &&
                      obj.fK_ServiceId === o.fK_ServiceId
                  )
                ) {
                  unique.push(o);
                }
                return unique;
              }, []);
          }
          // if (newresult.length > 0) {
          //
          //   this.InvestigationtemplateMaster = this.InvestigationtemplateMaster.concat(this.InvestigationtemplateMaster);

          // }
        } else if (type == 3) {
          this.CounspreopDisable = false;
          let newresult = this.emrservice.selectedInvestigationRow.reduce(
            (unique, o) => {
              if (
                !unique.some(
                  (obj) =>
                    obj.serviceName === o.serviceName &&
                    obj.FK_ServiceId === o.FK_ServiceId
                )
              ) {
                unique.push(o);
              }
              return unique;
            },
            []
          );
          newresult?.forEach((item) => {
            this.CounselorInvestigation.push({
              pK_TranId: 0,
              fK_CounsID: this.selectCouncelorId,
              fK_ServiceId: item.serviceId,
              serviceName: item.serviceName,
              pK_SynchId: null,
              result: item.result,
              eye: item.eye,
              isEdit: item.pk_TranId > 0 ? true : false,
              isDelete: false,
            });
          });
          if (this.CounselorInvestigation.length > 1) {
            this.CounselorInvestigation = this.CounselorInvestigation.reduce(
              (unique, o) => {
                if (
                  !unique.some(
                    (obj) =>
                      obj.serviceName === o.serviceName &&
                      obj.fK_ServiceId === o.fK_ServiceId
                  )
                ) {
                  unique.push(o);
                }
                return unique;
              },
              []
            );
          }
          // if (newresult.length > 0) {
          //
          //   this.InvestigationtemplateMaster = this.InvestigationtemplateMaster.concat(this.InvestigationtemplateMaster);

          // }
        }
      });
  }
  oldinvstindexvalue: number = -1;
  editinvest(index: number) {
    if (this.oldinvstindexvalue != -1) {
      this.getIPDInvestigationArray[this.oldinvstindexvalue].checkInvetedit =
        false;
      this.getIPDInvestigationArray[index].checkInvetedit = true;
      this.oldinvstindexvalue = index;
    } else {
      this.oldinvstindexvalue = index;
      this.getIPDInvestigationArray[index].checkInvetedit = true;
    }
  }
  canceleditinvest(index: number) {
    if (this.oldinvstindexvalue == index) {
      this.getIPDInvestigationArray[index].checkInvetedit = false;
    }
  }
  //add new dr. Examination
  NewDoctorAdmission(drid) {
    if (drid > 0) {
      this.newdoctorenablebtn = true;
      // let checkdr = this.getIPDExamListArray.filter(item => item.fK_DoctorID == drid);
      // if (checkdr.length > 0) {
      //   this.dashboardService.openSnackBar("This Doctor Already Exist", "OK")
      // } else {
      let newobj = {
        pK_IPDVisitID: 0,
        fK_IPDID: this.selectIpdId,
        visitDate: new Date(),
        fK_DoctorID: drid,
        doctorAdvise: null,
        examinationComments: null,
        examType: null,
        drName: this.newipdrName,
        isEdit: false,
        isDelete: false,
      };
      this.getIPDExamListArray.reverse();
      this.getIPDExamListArray.push(newobj);
      this.getIPDExamListArray.reverse();

      this.rowClickedipdDoctor = 0;
      this.getipdExamlistObj = newobj;
      this.getIPDPrescptionArray = [];
      this.getIPDPrescptionDeleteArray = [];
      this.getIPDInvestigationArray = [];
      this.getIPDInvestigationDeleteArray = [];
      this.getIPDExaminationDeleteArray = [];
      this.getIPDExaminationArray = [];
      this.getIPDDiagonosisArray = [];
      this.getIPDDiagonosisDeleteArray = [];
      //}
    } else {
      this.dashboardService.openSnackBar("Please Select Doctor", "OK");
    }
  }
  // get ipd examination list by doctor
  getIPDExamListArray: getIPDExamList[] = [];
  getipdExamlistObj: getIPDExamList = {};
  getipdExamlistByIpdId(examvisitid, ipdid) {
    this.ipdService
      .getExaminationList(examvisitid, ipdid)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (x: any) => {
          this.getipdExamlistObj = {};
          this.getIPDExamListArray = [];

          this.getIPDExamListArray = x.reverse();

          if (this.getIPDExamListArray.length > 0) {
            this.rowClickedipdDoctor = 0;
            this.getipdExamlistObj = this.getIPDExamListArray[0];

            this.newipdrName = this.getipdExamlistObj.drName;
            this.newipddoctorId = this.getipdExamlistObj.fK_DoctorID;
            this.DoctorCtrl2.patchValue(this.newipdrName);
            // this._filter2( this.newipdrName);

            this.getIPDPreceptionDetail(
              this.getipdExamlistObj.pK_IPDVisitID,
              this.selectIpdId
            );
            this.getIpdvisitInvestDetail(
              this.getipdExamlistObj.pK_IPDVisitID,
              this.selectIpdId
            );
            this.getIpdvisitDaigonsisDetail(
              this.getipdExamlistObj.pK_IPDVisitID,
              this.selectIpdId
            );
            this.getIpdvisitExaminationDetail(
              this.getipdExamlistObj.pK_IPDVisitID,
              this.selectIpdId
            );
          } else {
            this.rowClickedipdDoctor = -1;
            this.getIPDPrescptionArray = [];
            this.getIPDPrescptionDeleteArray = [];
            this.getIPDInvestigationArray = [];
            this.getIPDInvestigationDeleteArray = [];
            this.getIPDExaminationDeleteArray = [];
            this.getIPDExaminationArray = [];
            this.getIPDDiagonosisArray = [];
            this.getIPDDiagonosisDeleteArray = [];
            if (this.authService.Loggeduser.usertypeid == 6) {
              this.newipdrName = this.authService.Loggeduser.firstname;
              this.newipddoctorId = this.authService.Loggeduser.userid;
              this.DoctorCtrl2.patchValue(this.newipdrName);
              this.DoctorCtrl2.disable();
            } else {
              this.newipdrName = null;
              this.newipddoctorId = 0;
            }
          }
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar(
              "You Don't have Permission",
              "OK"
            );
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }
  doctorworkobj(obj) {
    this.getipdExamlistObj = {};
    this.getipdExamlistObj = obj;
    setTimeout(() => {
      this.newipdrName = this.getipdExamlistObj.drName;
      this.newipddoctorId = this.getipdExamlistObj.fK_DoctorID;
    }, 500);
    if (this.getipdExamlistObj.pK_IPDVisitID > 0) {
      this.getIPDPreceptionDetail(
        this.getipdExamlistObj.pK_IPDVisitID,
        this.selectIpdId
      );
      this.getIpdvisitInvestDetail(
        this.getipdExamlistObj.pK_IPDVisitID,
        this.selectIpdId
      );
      this.getIpdvisitDaigonsisDetail(
        this.getipdExamlistObj.pK_IPDVisitID,
        this.selectIpdId
      );
      this.getIpdvisitExaminationDetail(
        this.getipdExamlistObj.pK_IPDVisitID,
        this.selectIpdId
      );
    } else {
      this.rowClickedipdDoctor = -1;
      this.getIPDPrescptionArray = [];
      this.getIPDPrescptionDeleteArray = [];
      this.getIPDInvestigationArray = [];
      this.getIPDInvestigationDeleteArray = [];
      this.getIPDExaminationDeleteArray = [];
      this.getIPDExaminationArray = [];
      this.getIPDDiagonosisArray = [];
      this.getIPDDiagonosisDeleteArray = [];
      this.newipdrName = null;
      this.newipddoctorId = 0;
    }
  }
  // get IPD Medicine
  getIPDPrescptionArray: IpdvisitPrescModel[] = [];
  getIPDPrescptionDeleteArray: IpdvisitPrescModel[] = [];
  getIPDPreceptionDetail(examvisitid, ipdid) {
    this.getIPDPrescptionDeleteArray = [];
    this.ipdService
      .getIpdPresception(examvisitid, ipdid)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (x: any) => {
          this.getIPDPrescptionArray = [];
          this.getIPDPrescptionArray = x;
          this.getIPDPrescptionArray.map(
            (item) => (item.checkprescpedit = false, item.isEdit = true, item.isDelete = false)
          );
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar(
              "You Don't have Permission",
              "OK"
            );
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }
  // get IPD investigation
  getIPDInvestigationArray: IpdvisitInvestModel[] = [];
  getIPDInvestigationDeleteArray: IpdvisitInvestModel[] = [];
  getIpdvisitInvestDetail(examvisitid, ipdid) {
    this.getIPDInvestigationDeleteArray = [];
    this.ipdService
      .getIpdvisitInvest(examvisitid, ipdid)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (x: any) => {
          this.getIPDInvestigationArray = [];
          this.getIPDInvestigationArray = x;
          this.getIPDInvestigationArray.map(
            (item) => (item.checkInvetedit = false, item.isEdit = true, item.isDelete = false)
          );

        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar(
              "You Don't have Permission",
              "OK"
            );
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }
  // get IPD Diagonsis
  getIPDDiagonosisArray: IpdvisitDiagnosisModel[] = [];
  getIPDDiagonosisDeleteArray: IpdvisitDiagnosisModel[] = [];
  getIpdvisitDaigonsisDetail(examvisitid, ipdid) {
    this.getIPDDiagonosisDeleteArray = [];
    this.ipdService
      .getIpdvisitDaigonsis(examvisitid, ipdid)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (x: any) => {
          this.getIPDDiagonosisArray = [];
          this.getIPDDiagonosisArray = x;
          this.getIPDDiagonosisArray.map(
            (item) => (item.checkDiagnosis = false, item.isEdit = true, item.isDelete = false)
          );


        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar(
              "You Don't have Permission",
              "OK"
            );
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }

  // get IPD examination finding
  getIPDExaminationArray: IpdvisitExamModel[] = [];
  getIPDExaminationDeleteArray: IpdvisitExamModel[] = [];
  getIpdvisitExaminationDetail(examvisitid, ipdid) {
    this.getIPDExaminationDeleteArray = [];
    this.ipdService
      .getIpdvisitExamination(examvisitid, ipdid)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (x: any) => {
          this.getIPDExaminationArray = [];
          this.getIPDExaminationArray = x;
          this.getIPDExaminationArray.map(
            (item) => (item.checkUpdate = false, item.isEdit = true, item.isDelete = false)
          );

        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar(
              "You Don't have Permission",
              "OK"
            );
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }
  examTypeArray: any = [];
  getexamType() {
    this.ipdService
      .getExaminationtype()
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (x: any) => {
          this.examTypeArray = [];
          this.examTypeArray = x;
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar(
              "You Don't have Permission",
              "OK"
            );
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }

  // finging group
  GetFindingGroupdata(fk_subGroupId, type, serachtype) {
    this.emrservice
      .GetFindingGroupdata(fk_subGroupId, type, serachtype)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (data) => this.success_FindingSubdata(data),
        (err) => this.failed_FindingSubGroup(err)
      );
  }
  success_FindingSubdata(data) {
    this.findinggroupdata = [];
    this.findinggroupdata = data;
    this.ExamTypeControlledit();
  }
  failed_FindingSubGroup(err) { }
  ExamTypeControlledit() {
    this.examTypeCtrledit = new FormControl();
    this.filteredexamTypeArrayedit = this.examTypeCtrledit.valueChanges.pipe(
      startWith(""),
      map((cat) =>
        cat ? this.filterOpfunctions(cat) : this.findinggroupdata.slice()
      )
    );
  }
  filterOpfunctions(name: string) {
    const filterValue = name.toString().toLowerCase();
    return this.findinggroupdata.filter(
      (country) => country.findingName?.toLowerCase().indexOf(filterValue) === 0
    );
  }
  oldindexvalue: number = -1;
  editfinding(index: any) {
    if (this.oldindexvalue != -1) {
      this.getIPDExaminationArray[this.oldindexvalue].checkUpdate = false;
      this.getIPDExaminationArray[index].checkUpdate = true;
      this.oldindexvalue = index;
    } else {
      this.oldindexvalue = index;
      this.getIPDExaminationArray[index].checkUpdate = true;
    }
  }
  cancelEdit(index: any) {
    if (this.oldindexvalue == index) {
      this.getIPDExaminationArray[this.oldindexvalue].checkUpdate = false;
    }
  }
  GetFindingGroupResult(type, seachtype) {
    this.emrservice
      .GetFindingGResult(0, type, seachtype)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (data) => this.success_Findingreult(data),
        (err) => this.failed_FindingSubGroup(err)
      );
  }
  success_Findingreult(data) {
    this.result_dss = [];
    if (data.length > 0) {
      this.result_dss = data;

      this.rightTypeControlledit();
      this.leftTypeControlledit();
    }
  }
  rightTypeControlledit() {
    this.rightTypeCtrledit = new FormControl();
    this.filteredrightTypeArrayedit = this.rightTypeCtrledit.valueChanges.pipe(
      startWith(""),
      map((cat) =>
        cat ? this.filterrightfunction(cat) : this.result_dss.slice()
      )
    );
  }
  filterrightfunction(name: string) {
    const filterValue = name.toString().toLowerCase();
    return this.result_dss.filter(
      (country) => country.result?.toLowerCase().indexOf(filterValue) === 0
    );
  }

  leftTypeControlledit() {
    this.leftTypeCtrledit = new FormControl();
    this.filteredleftTypeArrayedit = this.leftTypeCtrledit.valueChanges.pipe(
      startWith(""),
      map((cat) =>
        cat ? this.filterleftfunction(cat) : this.result_dss.slice()
      )
    );
  }
  filterleftfunction(name: string) {
    const filterValue = name.toString().toLowerCase();
    return this.result_dss.filter(
      (country) => country.result?.toLowerCase().indexOf(filterValue) === 0
    );
  }
  oldindexdiagovalue: number = -1;
  editdiagonsis(index: any) {
    if (this.oldindexdiagovalue != -1) {
      this.getIPDDiagonosisArray[this.oldindexdiagovalue].checkDiagnosis =
        false;
      this.getIPDDiagonosisArray[index].checkDiagnosis = true;
      this.oldindexdiagovalue = index;
    } else {
      this.oldindexdiagovalue = index;
      this.getIPDDiagonosisArray[index].checkDiagnosis = true;
    }
  }
  canceldiagonsis(index: any) {
    if (this.oldindexdiagovalue == index) {
      this.getIPDDiagonosisArray[index].checkDiagnosis = false;
    }
  }
  oldindexPrescvalue: number = -1;
  editPresc(index: any) {
    if (this.oldindexPrescvalue != -1) {
      this.getIPDPrescptionArray[this.oldindexPrescvalue].checkprescpedit =
        false;
      this.getIPDPrescptionArray[index].checkprescpedit = true;
      this.oldindexPrescvalue = index;
    } else {
      this.oldindexPrescvalue = index;
      this.getIPDPrescptionArray[index].checkprescpedit = true;
    }
  }
  canceleditpresc(index: any) {
    if (this.oldindexPrescvalue == index) {
      this.getIPDPrescptionArray[index].checkprescpedit = false;
    }
  }
  retundata(doseid: number) {
    return this.dosedataArray.filter((s) => s.pK_DosageId == doseid)[0]
      ?.dosageCode;
  }

  checkChanges() {
    this.Prequesdisable = false;
  }
  examiValidation: boolean = false;
  DrValidation: boolean = false;
  @ViewChild("examtype", { static: false }) private Examtype: ElementRef;
  @ViewChild("drRef", { static: false }) private DrRef: ElementRef;
  @ViewChild("drawer") drawer!: MatDrawer;
  headNames: any[] = [];
  trackingDetail: any;
  inserttrackingdata: transferDataobjModel = {};
  InsertDrExamination() {
    if (
      this.getipdExamlistObj.fK_DoctorID == null ||
      this.getipdExamlistObj.fK_DoctorID == undefined
    ) {
      this.showspinner1 = false;
      this.DrValidation = true;
      setTimeout(() => {
        this.DrRef.nativeElement.focus();
      }, 100);
      return this.dashboardService.openSnackBar("Please Add Doctor First", "OK");
    }
    if (
      this.getipdExamlistObj.examType == null ||
      this.getipdExamlistObj.examType == undefined
    ) {
      this.showspinner1 = false;
      this.examiValidation = true;
      setTimeout(() => {
        this.Examtype.nativeElement.focus();
      }, 100);
      return this.dashboardService.openSnackBar("Please Select ExamType", "OK");
    }
    this.showspinner1 = true;
    let payload = {
      IpdExaminationMaster: {
        PK_IPDVisitID: this.getipdExamlistObj.pK_IPDVisitID
          ? this.getipdExamlistObj.pK_IPDVisitID
          : 0,
        FK_IPDID: this.selectIpdId,
        VisitDate:
          this.getipdExamlistObj.pK_IPDVisitID > 0
            ? this.getipdExamlistObj.visitDate
            : this.datePipe.transform(new Date(), "yyyy-MM-dd HH:mm:ss"),
        FK_DoctorID: this.getipdExamlistObj.fK_DoctorID,
        DoctorAdvise: this.getipdExamlistObj.doctorAdvise,
        ExaminationComments: this.getipdExamlistObj.examinationComments,
        ExamType: this.getipdExamlistObj.examType,
        IsEdit: this.getipdExamlistObj.pK_IPDVisitID > 0 ? true : false,
        IsDelete: false,
      },
      IpdVisitExaminationDetail: this.getIPDExaminationArray.concat(
        this.getIPDExaminationDeleteArray
      ),
      IpdVisitInvestigationDetail: this.getIPDInvestigationArray.concat(
        this.getIPDInvestigationDeleteArray
      ),
      IpdVisitDiagnosisDetail: this.getIPDDiagonosisArray.concat(
        this.getIPDDiagonosisDeleteArray
      ),
      IpdVisitPrescriptionDetail: this.getIPDPrescptionArray.concat(
        this.getIPDPrescptionDeleteArray
      ),
    };
    this.ipdService
      .insertIPDDrExamination(payload)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (x) => {
          this.getipdExamlistObj.pK_IPDVisitID = x["id"];
          this.newdoctorenablebtn = false;
          this.showspinner1 = false;

          this.getipdExamlistByIpdId(0, this.selectIpdId);
          this.dashboardService.openSnackBar("Record Saved Successfully", "OK");
        },
        (err) => {
          this.showspinner1 = false;
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          }
          else if (err.error.statusCode == 422) {
            this.dashboardService.openSnackBar(err.error.message, "OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }
  // Drug Advice and Nursing Chart
  GetNursingInstructionobj: NursingInstructionsModel = {};
  GetNursingInstructiondata() {
    this.ipdService
      .GetNursingInstruction(this.selectIpdId)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (x: any) => {
          this.GetNursingInstructionobj = {};
          if (x.length > 0) {
            this.GetNursingInstructionobj = x[0];
          }
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar(
              "You Don't have Permission",
              "OK"
            );
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }
  GetNursingChartArray: GetNursingChartModel[] = [];
  GetNursingChartdata() {
    this.ipdService
      .GetNursingChart(this.selectIpdId)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (x: any) => {
          this.GetNursingChartArray = [];
          if (x.length > 0) {
            this.GetNursingChartArray = x;
            console.log(
              this.GetNursingChartArray,
              "called GetNursingChartArray"
            );
          }
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar(
              "You Don't have Permission",
              "OK"
            );
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }
  // medicine sheet given by nurse
  GetNursingMedicineArray: GetNursingMedicineModel[] = [];
  GetNursingMedicineDetail() {
    this.ipdService
      .GetNursingMedicine(this.selectIpdId)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (x: any) => {
          this.GetNursingMedicineArray = [];
          if (x.length > 0) {
            this.GetNursingMedicineArray = x;
          }
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar(
              "You Don't have Permission",
              "OK"
            );
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }
  // pre operative medicine
  GetCounselorPreOpMedicineArray: GetCounselorPreOpMedicineModel[] = [];
  GetCounselorPreOpMedicinedetail(counlorid) {
    this.ipdService
      .GetCounselorPreOpMedicine(counlorid)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (x: any) => {
          this.GetCounselorPreOpMedicineArray = [];
          if (x.length > 0) {
            this.GetCounselorPreOpMedicineArray = x;
          }
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar(
              "You Don't have Permission",
              "OK"
            );
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }
  addMedicineNurse(row: any) {
    const isDuplicate = this.GetNursingMedicineArray.some(
      (item) => item.fK_MedicineID == row.fK_MedicineId
    );
    if (!isDuplicate) {
      var objdata = {
        pK_TranID: 0,
        fK_IPDID: this.selectIpdId,
        entryDate: this.datePipe.transform(new Date(), "yyyy-MM-dd HH:mm:ss"),
        fK_MedicineID: row.fK_MedicineId,
        site: row.eye,
        fK_DosageID: row.fK_DosageId,
        dosageTime: null,
        givenTime: null,
        status: false,
        fK_AdvisedById: row.fK_MainSurgeronId,
        fK_ActualGivenById: null,
        remarks: row.remarks,
        fk_Templateid: null,
        medicineName: row.medicineName,
        dosageCode: row.dosageCode,
        advisedBy: row.mainSurgeron,
        givenBy: null,
        dept: null,
        dosageDescription: null,
        templateName: null,
        isEdit: false,
        isDelete: false,
      };
      this.GetNursingMedicineArray.push(objdata);
      console.log(this.GetNursingMedicineArray)
    } else {
      this.dashboardService.openSnackBar("medicine already added in list", "OK");
    }
  }

  AddNewNurseChart() {
    let obj = {
      pK_NursingChartId: 0,
      fK_IPDId: this.selectIpdId,
      nDate: this.datePipe.transform(new Date(), "yyyy-MM-dd HH:mm:ss"),
      nTime: this.datePipe.transform(new Date(), "yyyy-MM-dd HH:mm:ss"),
      nTemp: null,
      pulse: null,
      rr: null,
      bps: null,
      bpd: null,
      spO2: null,
      weight: null,
      nInPut: null,
      nDatnInPutSpce: null,
      nOutPut: null,
      nOutPutSpc: null,
      fK_CreatedById: null,
      modifiedDatetime: null,
      mTime: null,
      createdBy: null,
      modifiedBy: null,
      fK_ModifiedById: null,
      isEdit: false,
      isDelete: false,
      dept: null,
    };
    this.GetNursingChartArray.push(obj);
  }
  saveNursingData() {
    this.showspinner1 = true;
    this.saveNursingChart();
    if (this.GetNursingChartArray.length > 0) {
      this.insertNursingChartDetail();
    }
    if (this.GetNursingMedicineArray.length > 0 || this.medicineSheetDeleteRowarray.length > 0) {
      this.InsertNursingMedicinedetail();
    }
  }
  saveNursingChart() {
    let Payload = {
      NursingInstructions: {
        pK_TranId: this.GetNursingInstructionobj.pK_TranId
          ? this.GetNursingInstructionobj.pK_TranId
          : 0,
        fK_IPDId: this.selectIpdId,
        doctorinstructions: this.GetNursingInstructionobj.doctorinstructions,
        nursinginstructions: this.GetNursingInstructionobj.nursinginstructions,
        nursingCarePlan: this.GetNursingInstructionobj.nursingCarePlan,
        nutritionalAdvise: this.GetNursingInstructionobj.nutritionalAdvise,
        IsEdit: this.GetNursingInstructionobj.pK_TranId > 0 ? true : false,
        IsDelete: false,
      },
    };
    this.ipdService
      .InsertNursingInstructions(Payload)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (x) => {
          this.GetNursingInstructiondata();
          this.showspinner1 = false;
          this.dashboardService.openSnackBar("Record Saved Successfully", "OK");
        },
        (err) => {
          this.showspinner1 = false;
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          }
          else if (err.error.statusCode == 422) {
            this.dashboardService.openSnackBar(err.error.message, "OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }
  // insert /update medicine
  InsertNursingMedicinedetail() {
    this.GetNursingMedicineArray.map((item, i) => {
      (item.isEdit = item.pK_TranID ? true : false),
        (item.isDelete = false)
    });
    let payload = {
      NursingMedicineDetail: this.GetNursingMedicineArray.concat(this.medicineSheetDeleteRowarray)
    };
    this.ipdService
      .InsertNursingMedicine(payload)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (x) => {
          this.GetNursingMedicineDetail();
          this.CloseNursegivenModalDialog();
          this.clearDelete_array();
          this.showspinner1 = false;
        },
        (err) => {
          this.showspinner1 = false;
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          } else if (err.error.statusCode == 422) {
            this.dashboardService.openSnackBar(err.error.message, "OK");
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }

  medicineSheetDeleteRowarray: GetNursingMedicineModel[] = [];
  MedicineSheetDeleteRow(row, index) {
    this.GetNursingMedicineArray.splice(index, 1);
    if (row.pK_TranID > 0) {
      this.medicineSheetDeleteRowarray.push(row);
      this.medicineSheetDeleteRowarray.map(
        (item) => (item.isEdit = true)
      );
      this.medicineSheetDeleteRowarray.map(
        (item) => (item.isDelete = true)
      );
    }
    // if (this.GetNursingMedicineArray.length == 0 && this.medicineSheetDeleteRowarray.length > 0) {
    //   this.InsertNursingMedicinedetail();
    // }
  }
  clearDelete_array() {
    this.medicineSheetDeleteRowarray = [];
  }
  insertNursingChartDetail() {
    this.GetNursingChartArray?.forEach((item, i) => {
      if (item.pK_NursingChartId == 0) {
        (item.fK_CreatedById = this.authService.Loggeduser.userid),
          (item.createdBy = this.authService.Loggeduser.firstname),
          (item.isEdit = item.pK_NursingChartId ? true : false),
          (item.isDelete = false)
      } else {
        item.isEdit = item.pK_NursingChartId ? true : false
        item.isDelete = false
      }
    });

    this.GetNursingChartArray.map(
      (item) => (item.createdBy = this.authService.Loggeduser.firstname)
    ).indexOf("0");
    let payload = {
      NursingChart: this.GetNursingChartArray,
    };
    this.ipdService
      .insertNursingChart(payload)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (x) => {
          this.GetNursingChartdata();
          this.showspinner1 = false;
        },
        (err) => {
          this.showspinner1 = false;
          if (err.status == 403) {
            this.dashboardService.openSnackBar(
              "You Don't have Permission",
              "OK"
            );
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }

  //Nurse Given time Modal
  giventimeindex: number = -1;
  NurseopenModalDialog(e: any, index: number, id: any) {
    if (id > 0 && e == null) {
      this.giventimeindex = index;
      document.getElementById("NurseGIventime").style.display = "block";
    } else if (id == 0) {
      this.giventimeindex = -1;
      document.getElementById("NurseNotGIventime").style.display = "block";
    }
  }

  CloseNursegivenModalDialog() {
    this.giventimeindex = -1;
    document.getElementById("NurseGIventime").style.display = "none";
  }
  NurseNotGIventime() {
    this.giventimeindex = -1;
    document.getElementById("NurseNotGIventime").style.display = "none";
  }
  saveGivenTime() {
    this.GetNursingMedicineArray[this.giventimeindex].givenTime =
      this.datePipe.transform(new Date(), "yyyy-MM-dd HH:mm:ss");
    this.GetNursingMedicineArray[this.giventimeindex].fK_ActualGivenById =
      this.authService.Loggeduser.userid;
    this.GetNursingMedicineArray[this.giventimeindex].givenBy =
      this.authService.Loggeduser.firstname;
    this.GetNursingMedicineArray[this.giventimeindex].isEdit = true;
    this.GetNursingMedicineArray[this.giventimeindex].isDelete = false;
    this.GetNursingMedicineArray[this.giventimeindex].status = true;
    this.InsertNursingMedicinedetail();
  }
  updateFunc(event: MatSlideToggleChange, currentstatus, billid, patientid) {
    event.source.checked = currentstatus == "Y" ? true : false;
    if (billid != null && billid > 0 && currentstatus == "Y") {
      this.printTimelineBill(billid, patientid);
    }
  }
  printTimelineBill(billid, patientid) {
    let checkreporttype = this.authService.webreportConfig.filter(
      (item) =>
        item.printOption == "Billing Invoice" &&
        item.printType == "NetramReport"
    );
    if (checkreporttype.length > 0) {
      this.getPrintInvoice(billid);
    } else {
      this.printTimelineBillreport(billid, patientid);
    }
  }

  partydetail: any;
  printTimelineBillreport(billid, patientid) {
    if (billid > 0) {
      let payload = {
        WebReportPrintMaster: {
          module: "Billing",
          printOption: "Billing Invoice",
          printType: "WebNetramReport",
          Pk_RegId: patientid,
          PRINTDATE: this.datePipe.transform(
            this.authService.localDate,
            "dd-MM-yyyy"
          ),
          PrintTime: this.convertTime12Hour(new Date()),
          AdvisedBy: this.authService.Loggeduser.firstname,
          BILLINGCOMPANYNAME: this.authService.Loggeduser.billingcompanyname,
          LINE1: this.branchmansterObj.line1,
          LINE2: this.branchmansterObj.line2,
          LINE3: this.branchmansterObj.line3,
          LINE4: this.branchmansterObj.line4,
          HOSPITALIMAGE:
            window.location.origin + "/" + this.authService.loginclientlogo,
          COMPANYIMAGE:
            window.location.origin + "/" + this.authService.leftbottomlogosm,
          CERTIFICATE1IMAGE:
            window.location.origin + "/" + +this.authService.nabhlogo,
          CERTIFICATE2COMPANYIMAGE: "",
          BillId: billid,
          Pk_BillId: billid,
          ReceiptArray: "Y",
          ServiceArray: "Y",
          BillMasterArray: "Y",
          PatientRegistrationArray: "Y",
          PrintHeaderArray: "Y",
        },
      };
      this.ipdService
        .GetWebReportPrint(payload)
        .pipe(takeUntil(this.destroyipd$))
        .subscribe((x: any) => {
          if (x.length > 0) {
            let printContents, popupWin;

            printContents = x[0].printTemplate;
            popupWin = window.open(
              "",
              "_blank",
              "top=0,left=0,height=100%,width=auto"
            );

            popupWin.document.open();

            popupWin.document.write(`
              <html>
             
            <body >${printContents}
            </body>
              </html>`);
            popupWin.document.close();
          } else {
            this.dashboardService.openSnackBar("Report Template Not Set", "OK");
          }
        });
    } else {
      this.dashboardService.openSnackBar("Please select bill first", "OK");
    }
  }

  getPrintInvoice(billid) {
    if (billid) {
      window.open(
        this.reporturl +
        "OPDBill.aspx?BillId=" +
        billid +
        "&BranchId=" +
        this.authService.Loggeduser.branchid +
        "&BillingCompanyName=" +
        this.authService.Loggeduser.billingcompanyname +
        "&PrintType=DETAIL&ALLSERVICE=Y&PageHeadWebReport=" +
        this.PageHeader +
        "&QRCode=" +
        this.QrCode
      );
    } else {
      this.dashboardService.openSnackBar("Please Select Bill ", "OK");
    }
  }

  //Clinical Discharge App Modal
  clinicalDischargeAppModalDialog(
    event: MatSlideToggleChange,
    type,
    currentstatus
  ) {
    event.source.checked = currentstatus;
    this.ipdService
      .GetPermissionbyUser(this.authService.Loggeduser.userid, type)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe((x: any) => {
        if (x != undefined) {
          if (x == true) {
            if (this.ipdDahboarddata.length > 0) {
              if (currentstatus != true) {
                document.getElementById(
                  "clinicalDischargeAppModal"
                ).style.display = "block";
              } else {
                this.dashboardService.openSnackBar(
                  "Clinical Approval is already given for this Patient.",
                  "ok"
                );
              }
            }
          } else {
            this.dashboardService.openSnackBar(
              "Action not allowed, Please check User Permission",
              "ok"
            );
          }
        } else {
          this.dashboardService.openSnackBar("Data not found", "ok");
        }
      });
  }

  closeClinicalDischargeAppModalDialog() {
    this.clinicalComment = "";
    document.getElementById("clinicalDischargeAppModal").style.display = "none";
  }
  //Financial Discharge App Modal
  financialDischargeAppModalDialog(
    event: MatSlideToggleChange,
    type,
    currentstatus
  ) {
    event.source.checked = currentstatus;
    this.ipdService
      .GetPermissionbyUser(this.authService.Loggeduser.userid, type)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe((x: any) => {
        if (x != undefined) {
          if (x == true) {
            if (this.ipdDahboarddata.length > 0) {
              if (currentstatus != true) {
                document.getElementById(
                  "financialDischargeAppModal"
                ).style.display = "block";
              } else {
                this.dashboardService.openSnackBar(
                  "Financial Approval is already given for this Patient.",
                  "ok"
                );
              }
            }
          } else {
            this.dashboardService.openSnackBar(
              "Action not allowed, Please check User Permission",
              "ok"
            );
          }
        } else {
          this.dashboardService.openSnackBar("Data not found", "ok");
        }
      });
  }
  closeFinancialDischargeAppModalDialog() {
    this.FinancialComment = "";
    document.getElementById("financialDischargeAppModal").style.display =
      "none";
  }

  // print time line
  printTimeline(type) {
    let payload = {
      WebReportPrintMaster: {
        module: "Discharge Summary",
        printOption: type == 1 ? "Time Slip" : "Medical Certificate",
        printType: "WebNetramReport",
        PATIENTNAME: this.selectipdData?.patientName,
        MRDNO: this.RegId,
        IPDID: this.selectIpdId,
        DISDATE: this.dischargeDatamodel.dod,
        PRINTDATE: this.datePipe.transform(
          this.authService.localDate,
          "dd-MM-yyyy"
        ),
        FROMDATE: this.datePipe.transform(
          this.dischargeDatamodel.restDateFrom,
          "dd-MM-yyyy"
        ),
        TODATE: this.datePipe.transform(
          this.dischargeDatamodel.restDateTo,
          "dd-MM-yyyy"
        ),
        FOLLOWUPDATE: this.datePipe.transform(
          this.dischargeDatamodel.restDateTo,
          "dd-MM-yyyy"
        ),
        BILLINGCOMPANYNAME: this.authService.Loggeduser.billingcompanyname,
        IdNo: this.dischargeDatamodel.idNo,
        LINE1: this.branchmansterObj.line1,
        LINE2: this.branchmansterObj.line2,
        LINE3: this.branchmansterObj.line3,
        HOSPITALIMAGE: "../../../" + this.authService.loginclientlogo,
        COMPANYIMAGE: "../../../" + this.authService.leftbottomlogosm,
        CERTIFICATE1IMAGE: "../../../" + this.authService.nabhlogo,
        CERTIFICATE2COMPANYIMAGE: "",
      },
    };
    this.ipdService
      .GetWebReportPrint(payload)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (x: any) => {
          if (x.length > 0) {
            let printContents, popupWin;

            printContents = x[0].printTemplate;
            popupWin = window.open(
              "",
              "_blank",
              "top=0,left=0,height=100%,width=auto"
            );

            popupWin.document.open();
            popupWin.document.write(`
      <html>
       
    <body onload="window.print()">${printContents}
    </body>
      </html>`);

            popupWin.document.close();
          } else {
            this.dashboardService.openSnackBar("Report Template Not Set", "OK");
          }
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar(
              "You Don't have Permission",
              "OK"
            );
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }
  branchmansterObj: any = {};
  getBranchDetail(id) {
    this.branchmansterObj = {};
    this.branchMatserService
      .getBrachMasterItem(id)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe((x: any) => {
        this.branchmansterObj = x[0];
      });
  }
  getsphvalue(category: string, valuebox) {
    this.emrservice.eyechkcategory = category;
    const dialogRef = this.dialog.open(EyecheckComponent, {
      panelClass: "full-width-dialog",
      minHeight: "300px",
      maxWidth: "70vw",
      width: "100%",
      data: {
        //category: category,
        //userid: this.authService.Loggeduser.userid
      },
    });

    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroyipd$))
      .subscribe((result) => {
        this.emrservice.enabledisableVision = false;
        if (result != null && result != undefined) {
          if (valuebox == 1) {
            this.dischargeDatamodel.preOpVADISOD = result.popupDescription;
          } else if (valuebox == 2) {
            this.dischargeDatamodel.preOpVADISOS = result.popupDescription;
          } else if (valuebox == 3) {
            this.dischargeDatamodel.preOpVANEAROD = result.popupDescription;
          } else if (valuebox == 4) {
            this.dischargeDatamodel.preOpVANEAROS = result.popupDescription;
          } else if (valuebox == 5) {
            this.dischargeDatamodel.preOpPHDISOD = result.popupDescription;
          } else if (valuebox == 6) {
            this.dischargeDatamodel.preOpPHDISOS = result.popupDescription;
          } else if (valuebox == 7) {
            this.dischargeDatamodel.preOpPHNEAROD = result.popupDescription;
          } else if (valuebox == 8) {
            this.dischargeDatamodel.preOpPHNEAROS = result.popupDescription;
          } else if (valuebox == 9) {
            this.dischargeDatamodel.postOpVADISOD = result.popupDescription;
          } else if (valuebox == 10) {
            this.dischargeDatamodel.postOpVADISOS = result.popupDescription;
          } else if (valuebox == 11) {
            this.dischargeDatamodel.postOpVANEAROD = result.popupDescription;
          } else if (valuebox == 12) {
            this.dischargeDatamodel.postOpVANEAROS = result.popupDescription;
          } else if (valuebox == 13) {
            this.dischargeDatamodel.postOpPHDISOD = result.popupDescription;
          } else if (valuebox == 14) {
            this.dischargeDatamodel.postOpPHDISOS = result.popupDescription;
          } else if (valuebox == 15) {
            this.dischargeDatamodel.postOpPHNEAROD = result.popupDescription;
          } else if (valuebox == 16) {
            this.dischargeDatamodel.postOpPHNEAROS = result.popupDescription;
          } else if (valuebox == 17) {
            this.dischargeDatamodel.postOpVADISOD2 = result.popupDescription;
          } else if (valuebox == 18) {
            this.dischargeDatamodel.postOpVADISOS2 = result.popupDescription;
          } else if (valuebox == 19) {
            this.dischargeDatamodel.postOpVANEAROD2 = result.popupDescription;
          } else if (valuebox == 20) {
            this.dischargeDatamodel.postOpVANEAROS2 = result.popupDescription;
          } else if (valuebox == 21) {
            this.dischargeDatamodel.postOpPHDISOD2 = result.popupDescription;
          } else if (valuebox == 22) {
            this.dischargeDatamodel.postOpPHDISOS2 = result.popupDescription;
          } else if (valuebox == 23) {
            this.dischargeDatamodel.postOpPHNEAROD2 = result.popupDescription;
          } else if (valuebox == 24) {
            this.dischargeDatamodel.postOpPHNEAROS2 = result.popupDescription;
          } else if (valuebox == 25) {
            this.dischargeDatamodel.postOpVADISOD3 = result.popupDescription;
          } else if (valuebox == 26) {
            this.dischargeDatamodel.postOpVADISOS3 = result.popupDescription;
          } else if (valuebox == 27) {
            this.dischargeDatamodel.postOpVANEAROD3 = result.popupDescription;
          } else if (valuebox == 28) {
            this.dischargeDatamodel.postOpVANEAROS3 = result.popupDescription;
          } else if (valuebox == 29) {
            this.dischargeDatamodel.postOpPHDISOD3 = result.popupDescription;
          } else if (valuebox == 30) {
            this.dischargeDatamodel.postOpPHDISOS3 = result.popupDescription;
          } else if (valuebox == 31) {
            this.dischargeDatamodel.postOpPHNEAROD3 = result.popupDescription;
          } else if (valuebox == 32) {
            this.dischargeDatamodel.postOpPHNEAROS3 = result.popupDescription;
          } else if (valuebox == 33) {
            this.dischargeDatamodel.gPrsd = result.popupDescription;
          } else if (valuebox == 34) {
            this.dischargeDatamodel.gPrcd = result.popupDescription;
          } else if (valuebox == 35) {
            this.dischargeDatamodel.gPrpd = result.popupDescription;
          } else if (valuebox == 36) {
            this.dischargeDatamodel.gPrvd = result.popupDescription;
          } else if (valuebox == 37) {
            this.dischargeDatamodel.gpnvR1 = result.popupDescription;
          } else if (valuebox == 38) {
            this.dischargeDatamodel.gPrsn = result.popupDescription;
          } else if (valuebox == 39) {
            this.dischargeDatamodel.gPrcn = result.popupDescription;
          } else if (valuebox == 40) {
            this.dischargeDatamodel.gPrpn = result.popupDescription;
          } else if (valuebox == 41) {
            this.dischargeDatamodel.gPrvn = result.popupDescription;
          } else if (valuebox == 42) {
            this.dischargeDatamodel.gPrsI = result.popupDescription;
          } else if (valuebox == 43) {
            this.dischargeDatamodel.gPrcI = result.popupDescription;
          } else if (valuebox == 44) {
            this.dischargeDatamodel.gPrpI = result.popupDescription;
          } else if (valuebox == 45) {
            this.dischargeDatamodel.gPrvI = result.popupDescription;
          } else if (valuebox == 46) {
            this.dischargeDatamodel.gPlsd = result.popupDescription;
          } else if (valuebox == 47) {
            this.dischargeDatamodel.gPlcd = result.popupDescription;
          } else if (valuebox == 48) {
            this.dischargeDatamodel.gPlpd = result.popupDescription;
          } else if (valuebox == 49) {
            this.dischargeDatamodel.gPlvd = result.popupDescription;
          } else if (valuebox == 50) {
            this.dischargeDatamodel.gpnvL1 = result.popupDescription;
          } else if (valuebox == 51) {
            this.dischargeDatamodel.gPlsn = result.popupDescription;
          } else if (valuebox == 52) {
            this.dischargeDatamodel.gPlcn = result.popupDescription;
          } else if (valuebox == 53) {
            this.dischargeDatamodel.gPlpn = result.popupDescription;
          } else if (valuebox == 54) {
            this.dischargeDatamodel.gPlvn = result.popupDescription;
          } else if (valuebox == 55) {
            this.dischargeDatamodel.gPlsI = result.popupDescription;
          } else if (valuebox == 56) {
            this.dischargeDatamodel.gPlcI = result.popupDescription;
          } else if (valuebox == 57) {
            this.dischargeDatamodel.gPlpI = result.popupDescription;
          } else if (valuebox == 58) {
            this.dischargeDatamodel.gPlvI = result.popupDescription;
          }
        }
      });
  }

  refhelplistPOpup(type, value) {
    const dialogRef = this.dialog.open(HelpListPopupComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "50vw",
      disableClose: true,
      width: "35%",
      data: {
        typeid: type,
      },
    });
    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroyipd$))
      .subscribe((result) => {
        if (result != null && result != undefined && result != 0) {
          if (value == 1) {
            this.dischargeDatamodel.gPrad = result;
          } else if (value == 2) {
            this.dischargeDatamodel.gPran = result;
          } else if (value == 3) {
            this.dischargeDatamodel.gPraI = result;
          } else if (value == 4) {
            this.dischargeDatamodel.gPlad = result;
          } else if (value == 5) {
            this.dischargeDatamodel.gPlan = result;
          } else if (value == 6) {
            this.dischargeDatamodel.gPlaI = result;
          } else if (value == 7) {
            this.surgicalRecordobj.duration = result;
          } else if (value == 8) {
            this.surgicalRecordobj.surgeryStatus = result;
            this.surgicalRecordobj.fK_OTStatusId =
              this.sugeryStatusArray.filter(
                (item) =>
                  item.popupDescription.toLocaleLowerCase() ==
                  result.toLocaleLowerCase()
              )[0].pkPopupId;
          }
        }
      });
  }

  SaveCAFA(type) {
    if (this.ipdDahboarddata.length > 0) {
      var selectDataCA = this.ipdDahboarddata.filter(
        (item) => item.pK_IPDId == Number(this.selectIpdId)
      );
      //  const indexvalue =this.ipdDahboarddata.findIndex(item => item.pK_IPDId == Number(this.selectIpdId));
      if (type == 1) {
        if (this.clinicalComment != null && this.clinicalComment != "") {
          if (this.invalidInput == false) {
            let payload = {
              IpdRegMaster: {
                PK_IPDId: this.selectIpdId,
                FK_BranchId: this.authService.Loggeduser.branchid,
                HeadName: "CLINICALAPPROVAL",
                FK_RegId: selectDataCA[0].fK_RegId,
                Fk_UserID: this.authService.Loggeduser.userid,
                ClinicalApprovalComments: this.clinicalComment,
                IsDischargeApproveByDr: true,
              },
            };

            this.ipdService
              .updateDischarge(payload)
              .pipe(takeUntil(this.destroyipd$))
              .subscribe(
                (x: any) => {
                  if (x.statusCode == 1) {
                    this.GetIpdData(
                      this.admssionById,
                      this.admissionFrom,
                      this.admissionTo,
                      this.dischargeFrom,
                      this.dischargeTo,
                      0,
                      this.consultantId,
                      0,
                      0,
                      this.opTypeId,
                      this.OTTheatreId,
                      0,
                      this.otgroupId,
                      this.fkroomcategoryid
                    );
                    this.dashboardService.openSnackBar(
                      "Approved Successfully",
                      "OK"
                    );
                    this.clinicalComment = "";
                    document.getElementById(
                      "clinicalDischargeAppModal"
                    ).style.display = "none";
                  }
                },
                (err) => {
                  if (err.status == 403) {
                    this.dashboardService.openSnackBar(
                      "You Don't have Permission",
                      "OK"
                    );
                  } else {
                    this.dashboardService.openSnackBar("API Failed", "OK");
                  }
                }
              );
          } else {
            this.clinicalComment = "";
            this.invalidInput = false;
            this.dashboardService.openSnackBar(
              "First character should not be a special character.",
              "OK"
            );
          }
        } else {
          this.dashboardService.openSnackBar("Please Enter Comment", "OK");
        }
      } else {
        if (this.FinancialComment != null && this.FinancialComment != "") {
          if (this.invalidInput == false) {
            let payload = {
              IpdRegMaster: {
                PK_IPDId: this.selectIpdId,
                FK_BranchId: this.authService.Loggeduser.branchid,
                HeadName: "FINANCIALAPPROVAL",
                FK_RegId: selectDataCA[0].fK_RegId,
                Fk_UserID: this.authService.Loggeduser.userid,
                FinancialApprovalComments: this.FinancialComment,
                IsDischargeApproveByAdmin: true,
              },
            };

            this.ipdService
              .updateDischarge(payload)
              .pipe(takeUntil(this.destroyipd$))
              .subscribe(
                (x: any) => {
                  if (x.statusCode == 1) {
                    this.GetIpdData(
                      this.admssionById,
                      this.admissionFrom,
                      this.admissionTo,
                      this.dischargeFrom,
                      this.dischargeTo,
                      0,
                      this.consultantId,
                      0,
                      0,
                      this.opTypeId,
                      this.OTTheatreId,
                      0,
                      this.otgroupId,
                      this.fkroomcategoryid
                    );

                    this.dashboardService.openSnackBar(
                      "Approved Successfully",
                      "OK"
                    );
                    this.FinancialComment = "";
                    document.getElementById(
                      "financialDischargeAppModal"
                    ).style.display = "none";
                  }
                },
                (err) => {
                  if (err.status == 403) {
                    this.dashboardService.openSnackBar(
                      "You Don't have Permission",
                      "OK"
                    );
                  } else {
                    this.dashboardService.openSnackBar("API Failed", "OK");
                  }
                }
              );
          } else {
            this.FinancialComment = "";
            this.invalidInput = false;
            this.dashboardService.openSnackBar(
              "First character should not be a special character.",
              "OK"
            );
          }
        } else {
          this.dashboardService.openSnackBar("Please Enter Comment", "OK");
        }
      }
    }
  }
  sugeryStatusArray: any = [];
  GetsurgeryStausIddata() {
    this.ipdService
      .GetsurgeryStausId()
      .pipe(takeUntil(this.destroyipd$))
      .subscribe((item: any) => {
        this.sugeryStatusArray = [];
        this.sugeryStatusArray = item;
      });
  }
  surgicalRecordArray: IPDsurgicalRecordModel[] = [];
  GetSurgeryOtRegister(ipdid) {
    if (ipdid > 0) {
      this.ipdService
        .GetSurgeryOtRegisterByIPDId(ipdid)
        .pipe(takeUntil(this.destroyipd$))
        .subscribe(
          (x: any) => {
            this.surgicalRecordArray = [];
            this.surgicalRecordobj = {};
            if (x.length > 0) {
              this.surgicalRecordArray = x.reverse();
              for (var i = 0; i < x.length; i++) {
                this.surgicalRecordArray[i].surgeryDate =
                  this.datePipe.transform(
                    this.surgicalRecordArray[i].surgeryDate,
                    "yyyy-MM-dd"
                  );
                this.surgicalRecordArray[i].surgeryTime = this
                  .surgicalRecordArray[i].surgeryTime
                  ? moment(this.surgicalRecordArray[i].surgeryTime).format(
                    "h:mm A"
                  )
                  : null;
                this.surgicalRecordArray[i].initiatedTime = this
                  .surgicalRecordArray[i].initiatedTime
                  ? moment(this.surgicalRecordArray[i].initiatedTime).format(
                    "h:mm A"
                  )
                  : null;
                this.surgicalRecordArray[i].timedOut = this.surgicalRecordArray[
                  i
                ].timedOut
                  ? moment(this.surgicalRecordArray[i].timedOut).format(
                    "h:mm A"
                  )
                  : null;
              }
              this.rowClickedipdsurgery = 0;
              this.surgicalRecordobj = this.surgicalRecordArray[0];

              if (this.surgicalRecordobj.pK_OTId > 0) {
                this.GetOtSurgeryByOTId(this.surgicalRecordobj.pK_OTId);
                this.GetOtRegisterMasterdata(this.surgicalRecordobj.pK_OTId);
              }
            } else {
              this.addNewOTSurgical();
            }
          },
          (err) => {
            if (err.status == 403) {
              this.dashboardService.openSnackBar(
                "You Don't have Permission",
                "OK"
              );
            } else {
              this.dashboardService.openSnackBar("API Failed", "OK");
            }
          }
        );
    }
  }
  addOtRegisterMaster() {
    if (this.OTRegisterIdArray.length > 0) {
      let checkalready = this.OTRegisterIdArray.filter(
        (item) => item.fK_RegisterId == 0
      );
      if (checkalready.length > 0) {
        this.dashboardService.openSnackBar("Record Already Added", "ok");
      } else {
        this.addnewotregister();
      }
    } else {
      this.addnewotregister();
    }
  }
  addnewotregister() {
    this.OTRegisterIdArray.push({
      pK_OTRegisterId: 0,
      fK_OTId: this.surgicalRecordobj.pK_OTId
        ? this.surgicalRecordobj.pK_OTId
        : 0,
      fK_RegisterId: 0,
      isHidden: false,
      isEdit: false,
      fk_CreatedByID: this.authService.Loggeduser.userid,
      createdDateTime: null,
      fk_ModifiedByID: null,
      modifiedDateTime: null,
      registerType: null,
      registerName: null,
    });
  }
  SelectRecord(obj) {
    this.surgicalRecordobj = {};
    this.surgicalRecordobj = obj;
    if (this.surgicalRecordobj.pK_OTId > 0) {
      this.GetOtSurgeryByOTId(this.surgicalRecordobj.pK_OTId);
      this.GetOtRegisterMasterdata(this.surgicalRecordobj.pK_OTId);
    }
  }
  // get OT surgery
  getotsurgeryArray: OtRecordSurgeryModel[] = [];
  GetOtSurgeryByOTId(pK_OTId) {
    this.ipdService
      .GetOtRecordSurgeryByOTId(pK_OTId)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (x: any) => {
          this.getotsurgeryArray = [];
          this.getotsurgeryArray = x;
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar(
              "You Don't have Permission",
              "OK"
            );
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }

  addNewOTSurgical() {
    this.getotsurgeryArray = [];
    this.surgicalRecordobj = {};
    this.rowClickedipdsurgery = -1;
    // this.surgicalRecordArray=[];
    if (this.selectCouncelorId > 0) {
      this.ipdService
        .getCounselordetailById(this.selectCouncelorId)
        .pipe(takeUntil(this.destroyipd$))
        .subscribe(
          (item: any) => {
            this.surgicalRecordobj.isPostponed = item.isPostponed;
            this.surgicalRecordobj.fK_CounselorId = item.pK_CounselorId;
            this.surgicalRecordobj.fK_BranchId = item.fK_ForBranchId;
            this.surgicalRecordobj.fK_IPDId = Number(this.selectIpdId);
            this.surgicalRecordobj.surgeryDate = this.datePipe.transform(
              item.surgeryDate,
              "yyyy-MM-dd"
            );
            this.surgicalRecordobj.surgeryTime = moment(
              item.surgeryTime
            ).format("h:mm A");
            this.surgicalRecordobj.bookingDate = this.datePipe.transform(
              item.bookingDate,
              "dd-MM-yyyy"
            );

            this.surgicalRecordobj.fK_SurgenId = item.fK_MainSurgeronId;
            this.surgicalRecordobj.fK_OperationTypeId = item.fK_OperationTypeId;
            this.surgicalRecordobj.fK_AnesthTypeId = item.fK_AnesthTypeId;
            this.surgicalRecordobj.fK_AnaesthetistId = item.fK_AneastheticId;
            this.surgicalRecordobj.site = item.eye;
            this.surgicalRecordobj.otComplication = "NIL";
            this.surgicalRecordobj.fK_TheatherId = item.fK_TheatreId;
            this.surgicalRecordobj.isPostponed =
              item.postponed_Reason != null ? true : false;
            this.surgicalRecordobj.postPonedReasons = item.postponed_Reason;
            this.surgicalRecordobj.caseType = item.patientType;
            this.surgicalRecordobj.procedureName = item.procedureName;
            this.surgicalRecordobj.startTime = moment(
              this.authService.localDate
            ).format("h:mm A");
            this.surgicalRecordobj.finishTime = moment(
              this.authService.localDate
            ).format("h:mm A");
            this.surgicalRecordobj.isActive = true;
            this.surgicalRecordobj.fK_CreatedById = item.fK_AdvicedById;
            this.surgicalRecordobj.fK_CoSurgeonId = item.fK_CoSurgeronId;
            this.surgicalRecordobj.cosurgeonName = item.coSurgeon;
            this.surgicalRecordobj.anesthTypeName = item.anesthTypeName;
            this.surgicalRecordobj.fK_InitiatedbyId =
              this.authService.Loggeduser.userid;
            this.surgicalRecordobj.fK_TimeoutById =
              this.authService.Loggeduser.userid;
            this.surgicalRecordobj.initiatedTime = moment(
              this.authService.localDate
            ).format("h:mm A");
            this.surgicalRecordobj.timedOut = moment(
              this.authService.localDate
            ).format("h:mm A");
            this.surgicalRecordobj.surgeonName = item.surgeonName;
            this.surgicalRecordobj.theatreName = item.theatreName;
            this.surgicalRecordobj.anaesthetistName = item.operationTypeName;
            this.surgicalRecordobj.surgeryStatus =
              item.surgeryStatus.toLowerCase() == "booked"
                ? "Done"
                : item.surgeryStatus;
            this.surgicalRecordobj.fK_OTStatusId =
              this.sugeryStatusArray.filter(
                (item) =>
                  item.popupDescription.toLocaleLowerCase() ==
                  this.surgicalRecordobj.surgeryStatus.toLocaleLowerCase()
              )[0].pkPopupId;
            this.surgicalRecordobj.initiatedBy =
              this.authService.Loggeduser.username;
            this.surgicalRecordobj.timedoutBy =
              this.authService.Loggeduser.username;
            this.surgicalRecordobj.postPonedReasons = !item.postponed_Reason
              ? null
              : item.postponed_Reason;
            this.surgicalRecordobj.anesthTypeName = this.anerTypeList.filter(
              (itemdata) => itemdata.pkPopupId == item.fK_AnesthTypeId
            )[0]?.popupDescription;
            this.surgicalRecordobj.operationTypeName =
              this.getOPTypeArray.filter(
                (itema) => itema.pK_OperationTypeId == item.fK_OperationTypeId
              )[0]?.operationTypeName;
            this.getDiagonisisdatabyID();
            if (this.surgicalRecordobj.operationTypeName == "CATARACT") {
              this.surgicalRecordobj.isIOL = true;
            } else {
              this.surgicalRecordobj.isIOL = false;
            }
          },
          (err) => {
            this.dashboardService.openSnackBar(
              "Counselor detail API FAILED",
              "OK"
            );
          }
        );
      this.ipdService
        .getSurgeryBycounselorId(this.selectCouncelorId)
        .pipe(takeUntil(this.destroyipd$))
        .subscribe(
          (x: any) => {
            if (x.length > 0) {
              x.forEach((item) => {
                this.getotsurgeryArray.push({
                  pK_OTSurgeryDetailId: 0,
                  fK_OTId: 0,
                  fK_SurgeryId: item.fK_SurgeryId,
                  fK_SurgeonId: item.fK_SurgeonId,
                  remarks: item.remarks,
                  fK_QualifierId: null,
                  oldotid: null,
                  isEdit: false,
                  isHidden: false,
                  surgeryName: item.surgeryName,
                  qualifierName: null,
                  surgeon: this.returnSurgoanName(item.fK_SurgeonId),
                  site: null,
                  rightEyeSurgerycount: null,
                  leftEyeSurgerycount: null,
                  diagnosis: null,
                });
              });
            }
          },
          (err) => {
            this.dashboardService.openSnackBar(
              "Counselor Surgery API FAILED",
              "OK"
            );
          }
        );
    } else {
      this.surgicalRecordobj.initiatedBy = this.authService.Loggeduser.username;
      this.surgicalRecordobj.timedoutBy = this.authService.Loggeduser.username;
      this.surgicalRecordobj.fK_CreatedById =
        this.authService.Loggeduser.userid;
      this.surgicalRecordobj.fK_InitiatedbyId =
        this.authService.Loggeduser.userid;
      this.surgicalRecordobj.fK_TimeoutById =
        this.authService.Loggeduser.userid;
      this.surgicalRecordobj.fK_CounselorId = 0;
      this.surgicalRecordobj.isActive = true;
      this.surgicalRecordobj.fK_BranchId = this.authService.Loggeduser.branchid;
      this.surgicalRecordobj.fK_IPDId = Number(this.selectIpdId);
      this.surgicalRecordobj.surgeryDate = this.datePipe.transform(
        this.authService.localDate,
        "yyyy-MM-dd"
      );
      this.surgicalRecordobj.surgeryTime = moment(
        this.authService.localDate
      ).format("h:mm A");
      this.surgicalRecordobj.initiatedTime = moment(
        this.authService.localDate
      ).format("h:mm A");
      this.surgicalRecordobj.timedOut = moment(
        this.authService.localDate
      ).format("h:mm A");
    }
  }

  returnSurgoanName(sid) {
    return this.opdvisitService.doctors.filter((item) => item.userId == sid)[0]
      ?.userName;
  }

  getOpTypeobj1(e: any) {
    var val = e.option.value;
    // this.opTypeName = val.operationTypeName;
    this.surgicalRecordobj.fK_OperationTypeId = val.pK_OperationTypeId;
    this.surgicalRecordobj.operationTypeName = val.operationTypeName;
  }

  CheckinputOpType1(event: any) {
    var checkdata = event.target.value;
    if (checkdata == "") {
      this.OpTypeControll();
      this.surgicalRecordobj.fK_OperationTypeId = null;
      this.surgicalRecordobj.operationTypeName = null;
    }
  }
  getOTTheatreobj1(e: any) {
    var val = e.option.value;
    this.surgicalRecordobj.theatreName = val.theatreName;
    this.surgicalRecordobj.fK_TheatherId = val.pK_OTTheatreId;
  }

  CheckinputOTTheatre1(event: any) {
    var checkdata = event.target.value;
    if (checkdata == "") {
      this.OTThreateControll();
      this.surgicalRecordobj.theatreName = null;
      this.surgicalRecordobj.fK_TheatherId = null;
    }
  }
  getSurgerydoctorobj(e: any, type) {
    var val = e.option.value;
    if (type == 1) {
      this.surgicalRecordobj.fellowsDoctor = val.userName;
      // this.consultantId = val.userId;
    } else if (type == 2) {
      this.surgicalRecordobj.anaesthetistName = val.userName;
      this.surgicalRecordobj.fK_AnaesthetistId = val.userId;
    } else if (type == 3) {
      this.surgicalRecordobj.surgeonName = val.userName;
      this.surgicalRecordobj.fK_SurgenId = val.userId;
    } else if (type == 4) {
      this.surgicalRecordobj.cosurgeonName = val.userName;
      this.surgicalRecordobj.fK_CoSurgeonId = val.userId;
    } else if (type == 5) {
      this.PreopAssesmentRecordModelobj.anesthetist = val.userName;
      this.PreopAssesmentRecordModelobj.fK_AnesthetistId = val.userId;
    } else if (type == 6) {
      this.AnestheticRecordModelobj.doctor = val.userName;
      this.AnestheticRecordModelobj.fK_DoctorID = val.userId;
    }
  }
  CheckinputSurgery(event: any, type) {
    var checkdata = event.target.value;
    if (checkdata == "" && type == 1) {
      this.doctorControll();
      this.surgicalRecordobj.fellowsDoctor = event.target.value
        ? event.target.value
        : null;
    } else if (checkdata == "" && type == 2) {
      this.doctorControll();
      this.surgicalRecordobj.anaesthetistName = null;
      this.surgicalRecordobj.fK_AnaesthetistId = null;
    } else if (checkdata == "" && type == 3) {
      this.doctorControll();
      this.surgicalRecordobj.surgeonName = null;
      this.surgicalRecordobj.fK_SurgenId = null;
    } else if (checkdata == "" && type == 4) {
      this.doctorControll();
      this.surgicalRecordobj.cosurgeonName = null;
      this.surgicalRecordobj.fK_CoSurgeonId = null;
    } else if (checkdata == "" && type == 5) {
      this.PreopAssesmentRecordModelobj.anesthetist = null;
      this.PreopAssesmentRecordModelobj.fK_AnesthetistId = null;
    } else if (checkdata == "" && type == 6) {
      this.AnestheticRecordModelobj.doctor = null;
      this.AnestheticRecordModelobj.fK_DoctorID = null;
    }
  }
  getdeletedischageSurgery: OtRecordSurgeryModel[] = [];
  removeSurgery(row, index: number) {
    this.getotsurgeryArray.splice(index, 1);
    if (row.pK_OTSurgeryDetailId > 0) {
      this.getdeletedischageSurgery.push(row);
      this.getdeletedischageSurgery.map((item) => (item.isEdit = true));
      this.getdeletedischageSurgery.map((item) => (item.isHidden = true));
    }
  }
  filterregName: any;
  stroreindex: number = -1;
  onRtypeChange(event, i) {
    this.OTRegisterIdArray[i].registerType = event;
  }
  onchnageRegisterList(data) {
    this.OTRegisterIdArray[this.stroreindex].fK_RegisterId = data.pK_RegisterId;
    this.OTRegisterIdArray[this.stroreindex].registerName = data.registerName;
    this.closeRegisterListDisplay();
  }
  OTRegisterdeleteArray: any = [];
  removeotRegister(row, index: number) {
    this.OTRegisterIdArray.splice(index, 1);
    if (row.pK_OTRegisterId > 0) {
      this.OTRegisterdeleteArray.push(row);
      this.OTRegisterdeleteArray.map((item) => (item.isEdit = true));
      this.OTRegisterdeleteArray.map((item) => (item.isHidden = true));
    }
  }
  closeRegisterListDisplay() {
    this.stroreindex = -1;
    document.getElementById("RegisterListDisplay").style.display = "none";
  }
  selectregName(regtype, i) {
    if (regtype) {
      this.stroreindex = i;
      this.getRegisterName(regtype);
      document.getElementById("RegisterListDisplay").style.display = "block";
    } else {
      this.dashboardService.openSnackBar("Please Select Type", "ok");
    }
  }
  getRegisterName(type) {
    this.ipdService
      .getRegisterNameData(type)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (x: any) => {
          if (x.length > 0) {
            this.registerNameArray = [];
            this.registerNameArray = x;
          }
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar(
              "You Don't have Permission",
              "OK"
            );
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }
  GetOtRegisterMasterdata(otid) {
    this.ipdService
      .GetOtRegisterMaster(otid)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (x: any) => {
          this.OTRegisterIdArray = [];
          if (x.length > 0) {
            this.OTRegisterIdArray = x;
            this.OTRegisterIdArray.map((item) => (item.isEdit = true));
            this.OTRegisterIdArray.map((item) => (item.isHidden = false));
          }
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar(
              "You Don't have Permission",
              "OK"
            );
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }
  getNametype() {
    this.ipdService
      .GetNameByType()
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (x: any) => {
          if (x.length > 0) {
            this.registerTypeArray = [];
            this.registerTypeArray = x;
          }
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar(
              "You Don't have Permission",
              "OK"
            );
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }
  @ViewChild("statusRef", { static: false }) private StatusRef: ElementRef;
  @ViewChild("caseTypeRef", { static: false }) private CaseTypeRef: ElementRef;
  @ViewChild("otComplicationRef", { static: false })
  private OtComplicationRef: ElementRef;
  @ViewChild("Refbyauto", { static: false }) private RefbyautoRef: ElementRef;
  @ViewChild("anaesthetisRef", { static: false })
  private AnaesthetisRef: ElementRef;
  @ViewChild("theatreRef", { static: false }) private TheatreRef: ElementRef;
  @ViewChild("surgeonNameRef", { static: false })
  private SurgeonNameRef: ElementRef;
  @ViewChild("siteRef", { static: false }) private SiteRef: ElementRef;

  private AnaetypeeRef: ElementRef;
  @ViewChild("anaetypeNameRef", { static: false }) private AnaetypeNameRef: ElementRef;

  @ViewChild("operationref", { static: false })
  private Operationref: ElementRef;
  @ViewChild("doctorid", { static: false }) private Doctorid: ElementRef;
  @ViewChild("surgerybtn", { static: false }) private Surgerybtn: ElementRef;

  // check Validation
  BranchValidation: boolean = false;
  docValidation: boolean = false;
  surgeryValidation: boolean = false;
  caseTypeValidation: boolean = false;
  otCompValidation: boolean = false;
  anaesthetisValidation: boolean = false;
  theatreValidation: boolean = false;
  surgeonValidation: boolean = false;
  getotsurValidation: boolean = false;
  siteValidation: boolean = false;
  drValidation: boolean = false;
  anaetypeValidation: boolean = false

  InsertOtRegisterdata() {
    if (!this.surgicalRecordobj.fK_BranchId) {
      this.showspinner1 = false;
      this.BranchValidation = true;
      setTimeout(() => {
        this.RefbyautoRef.nativeElement.focus();
      }, 100);
      return this.dashboardService.openSnackBar(
        "Please Select Branch Name",
        "OK"
      );
    } else if (!this.surgicalRecordobj.surgeryStatus) {
      this.showspinner1 = false;
      this.surgeryValidation = true;
      setTimeout(() => {
        this.StatusRef.nativeElement.focus();
      }, 100);
      return this.dashboardService.openSnackBar(
        "Please Select Surgery Status",
        "OK"
      );
    } else if (!this.surgicalRecordobj.caseType) {
      this.showspinner1 = false;
      this.caseTypeValidation = true;
      setTimeout(() => {
        this.CaseTypeRef.nativeElement.focus();
      }, 100);
      return this.dashboardService.openSnackBar(
        "Please Select Case Type",
        "OK"
      );
    } else if (!this.surgicalRecordobj.operationTypeName) {
      this.showspinner1 = false;
      this.docValidation = true;
      setTimeout(() => {
        this.Operationref.nativeElement.focus();
      }, 100);
      return this.dashboardService.openSnackBar(
        "Please Select Operation Type",
        "OK"
      );
    } else if (!this.surgicalRecordobj.otComplication) {
      this.showspinner1 = false;
      this.otCompValidation = true;
      setTimeout(() => {
        this.OtComplicationRef.nativeElement.focus();
      }, 100);
      return this.dashboardService.openSnackBar(
        "Please Select OT Complication, If NIL Also Put NIL",
        "OK"
      );
    } else if (!this.surgicalRecordobj.anesthTypeName) {
      this.showspinner1 = false;
      this.anaetypeValidation = true;
      setTimeout(() => {
        this.AnaetypeeRef.nativeElement.focus();
      }, 100);
      return this.dashboardService.openSnackBar(
        "Please Select Anae. Type",
        "OK"
      );
    }
    // else if (!this.surgicalRecordobj.anaesthetistName) {
    //   this.showspinner1 = false;
    //   this.anaesthetisValidation = true;
    //   setTimeout(() => {
    //     this.AnaesthetisRef.nativeElement.focus();
    //   }, 100);
    //   return this.dashboardService.openSnackBar(
    //     "Please Select Anaesthetist Type",
    //     "OK"
    //   );
    // } 
    else if (
      !this.surgicalRecordobj.theatreName ||
      this.surgicalRecordobj.fK_TheatherId == null
    ) {
      this.showspinner1 = false;
      this.theatreValidation = true;
      setTimeout(() => {
        this.TheatreRef.nativeElement.focus();
      }, 100);
      return this.dashboardService.openSnackBar(
        "Please Select Theatre Name",
        "OK"
      );
    } else if (!this.surgicalRecordobj.surgeonName) {
      this.showspinner1 = false;
      this.surgeonValidation = true;
      setTimeout(() => {
        this.SurgeonNameRef.nativeElement.focus();
      }, 100);
      return this.dashboardService.openSnackBar(
        "Please Select Surgeon Name",
        "OK"
      );
    } else if (!this.surgicalRecordobj.site) {
      this.showspinner1 = false;
      this.siteValidation = true;
      setTimeout(() => {
        this.SiteRef.nativeElement.focus();
      }, 100);
      return this.dashboardService.openSnackBar(
        "Please Select Surgery Eye",
        "OK"
      );
    } else if (this.getotsurgeryArray.length == 0) {
      this.showspinner1 = false;
      setTimeout(() => {
        this.Surgerybtn.nativeElement.focus();
      }, 100);
      return this.dashboardService.openSnackBar(
        "Please Select At Least one Surgery",
        "OK"
      );
    }
    if (this.surgicalRecordobj.pK_OTId > 0) {
      this.surgicalRecordobj.isEdit = true;
    } else {
      this.surgicalRecordobj.pK_OTId = 0;
      this.surgicalRecordobj.isEdit = false;
      if (this.surgicalRecordArray.length > 0) {
        const checkduplicate = this.surgicalRecordArray.filter(
          (item) =>
            item.site == this.surgicalRecordobj.site &&
            item.operationTypeName == this.surgicalRecordobj.operationTypeName
        );
        if (checkduplicate.length > 0) {
          this.showspinner1 = false;
          return this.dashboardService.openSnackBar(
            "You have already performed surgery with the same operation type and for the same eye, So you can not create another record.",
            "OK"
          );
        }
      }
    }

    this.surgicalRecordobj.fK_AnesthTypeId = !this.surgicalRecordobj
      .fK_AnesthTypeId
      ? null
      : this.surgicalRecordobj.fK_AnesthTypeId;
    this.surgicalRecordobj.anesthTypeName = !this.surgicalRecordobj
      .anesthTypeName
      ? null
      : this.surgicalRecordobj.anesthTypeName;
    this.surgicalRecordobj.anaeGivenNofofTime = !this.surgicalRecordobj
      .anaeGivenNofofTime
      ? null
      : this.surgicalRecordobj.anaeGivenNofofTime;
    this.surgicalRecordobj.xylocain = !this.surgicalRecordobj.xylocain
      ? false
      : this.surgicalRecordobj.xylocain;
    this.surgicalRecordobj.xylocainQty = !this.surgicalRecordobj.xylocainQty
      ? null
      : this.surgicalRecordobj.xylocainQty;
    this.surgicalRecordobj.gaNurse = !this.surgicalRecordobj.gaNurse
      ? null
      : this.surgicalRecordobj.gaNurse;
    this.surgicalRecordobj.circulatingNurse = !this.surgicalRecordobj
      .circulatingNurse
      ? null
      : this.surgicalRecordobj.circulatingNurse;
    this.surgicalRecordobj.procedureName = !this.surgicalRecordobj.procedureName
      ? null
      : this.surgicalRecordobj.procedureName;
    this.surgicalRecordobj.remark = !this.surgicalRecordobj.remark
      ? null
      : this.surgicalRecordobj.remark;
    this.surgicalRecordobj.isPostponed = !this.surgicalRecordobj.isPostponed
      ? false
      : this.surgicalRecordobj.isPostponed;
    this.surgicalRecordobj.postPonedReasons = !this.surgicalRecordobj
      .postPonedReasons
      ? null
      : this.surgicalRecordobj.postPonedReasons;
    this.surgicalRecordobj.manualOTNo = !this.surgicalRecordobj.manualOTNo
      ? null
      : this.surgicalRecordobj.manualOTNo;
    this.surgicalRecordobj.fK_CounselorId = !this.selectCouncelorId
      ? 0
      : this.selectCouncelorId;
    this.surgicalRecordobj.surgeryDate = this.datePipe.transform(
      this.surgicalRecordobj.surgeryDate,
      "yyyy-MM-dd"
    );
    this.surgicalRecordobj.surgeryTime = moment(
      this.surgicalRecordobj.surgeryTime,
      ["h:mm A"]
    ).format("HH:mm");
    if (this.surgicalRecordobj.initiatedTime) {
      this.surgicalRecordobj.initiatedTime = moment(
        this.surgicalRecordobj.initiatedTime,
        ["h:mm A"]
      ).format("HH:mm");
    }
    if (this.surgicalRecordobj.timedOut) {
      this.surgicalRecordobj.timedOut = moment(
        this.surgicalRecordobj.timedOut,
        ["h:mm A"]
      ).format("HH:mm");
    }

    if (this.surgicalRecordobj.startTime) {
      this.surgicalRecordobj.startTime = moment(
        this.surgicalRecordobj.startTime,
        ["h:mm A"]
      ).format("HH:mm");
    }
    if (this.surgicalRecordobj.finishTime) {
      this.surgicalRecordobj.finishTime = moment(
        this.surgicalRecordobj.finishTime,
        ["h:mm A"]
      ).format("HH:mm");
    }
    this.surgicalRecordobj.isIOL = this.surgicalRecordobj.isIOL ? this.surgicalRecordobj.isIOL : false;
    let payload = {
      OtRegister: this.surgicalRecordobj,
      OtRecordSurgery: this.getotsurgeryArray.concat(
        this.getdeletedischageSurgery
      ),
      OtIolPowerDetail: {},
      OtRegisterMaster: this.OTRegisterIdArray.concat(
        this.OTRegisterdeleteArray
      ),
      OtRegisterDetail: [],
    };
    this.ipdService
      .InsertOtRegister(payload)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (x: any) => {
          this.OTRegisterdeleteArray = [];
          this.showspinner1 = false;
          if (this.surgicalRecordobj.pK_OTId > 0) {
            this.dashboardService.openSnackBar(
              "Record Updated Successfully",
              "OK"
            );
          } else {
            this.dashboardService.openSnackBar(
              "Record Saved Successfully",
              "OK"
            );

            // if (
            //   this.opdvisitService.patientdetails.mobileNo != "" &&
            //   this.opdvisitService.patientdetails.mobileNo != null &&
            //   this.opdvisitService.patientdetails.mobileNo != undefined
            // ) {
            //   var result = this.opdvisitService.doctors.filter(
            //     (x) => x.userId === this.corporateData.fK_ConsultantId
            //   );
            //   this.opdvisitService.datasendsms.PatientName =
            //     this.opdvisitService.patientdetails.firstName +
            //     " " +
            //     this.opdvisitService.patientdetails.lastName;
            //   this.opdvisitService.datasendsms.MobileNo =
            //     this.opdvisitService.patientdetails.mobileNo;
            //   this.opdvisitService.datasendsms.MrdNo =
            //     this.opdvisitService.patientdetails.pkRegId;
            //   this.opdvisitService.datasendsms.SeqNo = null;
            //   this.opdvisitService.datasendsms.ApptDate = null;
            //   this.opdvisitService.datasendsms.ApptTime = null;
            //   this.opdvisitService.datasendsms.ApptConsultant =
            //     result[0].userName;
            //   this.opdvisitService.datasendsms.SurgeryDate =
            //     this.surgicalRecordobj.surgeryDate;
            //   this.opdvisitService.datasendsms.SurgeryTime =
            //     this.surgicalRecordobj.surgeryTime;
            //   this.opdvisitService.datasendsms.BranchId =
            //     this.authService.Loggeduser.branchid;
            //   this.opdvisitService.datasendsms.SMSType = "SURGERYBOOKING";
            //   this.opdvisitService.sendSMstoPatient(
            //     this.opdvisitService.datasendsms
            //   );
            // }
          }
          this.GetSurgeryOtRegister(this.selectIpdId);
        },
        (err) => {
          this.showspinner1 = false;
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          }
          else if (err.error.statusCode == 422) {
            this.dashboardService.openSnackBar(err.error.message, "OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }
  anerTypeList = [];
  getAnaePopup() {
    this.counselorService
      .getAnarType()
      .pipe(takeUntil(this.destroyipd$))
      .subscribe((data) => {
        this.anerTypeList = [];
        this.anerTypeList = data.filter((item) => item.isActive == true);
      });
  }
  anesthTpyePOpup(type) {
    this.getAnaePopup();
    const dialogRef = this.dialog.open(HelpListPopupComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "33vw",
      disableClose: true,
      width: "33%",
      data: {
        typeid: type,
      },
    });
    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroyipd$))
      .subscribe((result) => {
        if (result != 0) {
          if (type == 2) {
            this.surgicalRecordobj.anesthTypeName = result;
            let atypeId = this.anerTypeList.filter(
              (item) => item.popupDescription == result
            )[0];
            this.surgicalRecordobj.fK_AnesthTypeId = atypeId.pkPopupId;
          }
        }
      });
  }

  Addnewsurgery() {
    const dialogRef = this.dialog.open(CommanSurgeryPopupComponent, {
      width: "60%",
      data: {},
    });

    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroyipd$))
      .subscribe((result) => {
        if (result.length > 0) {
          result.forEach((item) => {
            this.getotsurgeryArray.push({
              pK_OTSurgeryDetailId: 0,
              fK_OTId: 0,
              fK_SurgeryId: item.pkSurgeryId,
              fK_SurgeonId: this.surgicalRecordobj.fK_SurgenId,
              remarks: item.eye,
              fK_QualifierId: null,
              oldotid: null,
              isEdit: false,
              isHidden: false,
              surgeryName: item.surgeryName,
              qualifierName: null,
              surgeon: this.surgicalRecordobj.surgeonName,
              site: item.eye,
              rightEyeSurgerycount: null,
              leftEyeSurgerycount: null,
              diagnosis: null,
            });
          });
        }
      });
  }

  opendiagnosisdata(): void {
    const dialogRef = this.dialog.open(DiagnosisComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "90vw",
      width: "70%",
      disableClose: true,
    });
    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroyipd$))
      .subscribe((result) => {
        if (result.length > 0) {
          var newdaigonsis = [];
          result?.forEach((item) => {
            newdaigonsis.push(item.diagnosisName);
          });
          if (
            this.surgicalRecordobj.diagnosis != null &&
            this.surgicalRecordobj.diagnosis != ""
          ) {
            this.surgicalRecordobj.diagnosis =
              this.surgicalRecordobj.diagnosis +
              "\r\n" +
              newdaigonsis.join("\r\n");
          } else {
            this.surgicalRecordobj.diagnosis = newdaigonsis.join("\r\n");
          }
        }
      });
  }
  // GetSsCheckListName() {
  //   this.ipdService.GetSsCheckListName().subscribe((x: any) => {
  //     this.checklistnameData = x;

  //   })
  // }
  getselectname(e) {
    if (e.option.value != null) {
      this.checklistname = e.option.value;
      this.GetSsCheckListBynameList(this.checklistname);
    }

    // this.GetSsCheckListByIPDId(this.selectIpdId, this.checklistname);

  }

  GetSsCheckListBynameList(name) {
    this.ipdService
      .GetSsCheckListBynameList(name)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe((x: any) => {
        this.sschecklistModel = [];
        this.sschecklistModel = x;
        const checkdefaultvalue = x.filter(
          (item) => item.defaultValues != null && item.defaultValues != ""
        );
        if (checkdefaultvalue.length > 0) {
          const checkYesvalue = checkdefaultvalue.filter(
            (item) => String(item.defaultValues).toLowerCase() == "yes"
          );
          const checkNovalue = checkdefaultvalue.filter(
            (item) => String(item.defaultValues).toLowerCase() == "no"
          );
          const checkNonevalue = checkdefaultvalue.filter(
            (item) => String(item.defaultValues).toLowerCase() == "none"
          );
          if (this.sschecklistModel.length == checkYesvalue.length) {
            this.SScheckedyes = true;
            this.SScheckedno = false;
            this.SScheckednone = false;
          } else if (this.sschecklistModel.length == checkNovalue.length) {
            this.SScheckedyes = false;
            this.SScheckedno = true;
            this.SScheckednone = false;
          } else if (this.sschecklistModel.length == checkNonevalue.length) {
            this.SScheckedyes = false;
            this.SScheckedno = false;
            this.SScheckednone = true;
          } else {
            this.SScheckedyes = false;
            this.SScheckedno = false;
            this.SScheckednone = false;
          }
        }
        this.sschecklistModel.map((item) => (item.pK_TranId = 0));
      });
  }
  SsCheckListcolor: boolean = false;
  GetSsCheckListByIPDId(id: any) {
    var checklistByName = [];
    this.ipdService
      .GetSsCheckListByIPDId(id)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe((x: any) => {
        this.sschecklistModel = [];
        if (x.length > 0) {
          this.SsCheckListcolor = true;
          if (x.length > 0) {
            x.forEach((element) => {
              checklistByName.push({
                pK_TranId: element.pK_TranId,
                checkListName: element.checkListName,
                headName: element.headName,
                defaultValues: element.actualValue,
                isHeader: element.isHeader,
                isActive: true,
                FK_IPDID: element.fK_IPDID,
                isEdit: element.isEdit,
              });
            });
            this.sschecklistModel = checklistByName;
            const checkYesvalue = this.sschecklistModel.filter(
              (item) => String(item.defaultValues).toLowerCase() == "yes"
            );
            const checkNovalue = this.sschecklistModel.filter(
              (item) => String(item.defaultValues).toLowerCase() == "no"
            );
            const checkNonevalue = this.sschecklistModel.filter(
              (item) => String(item.defaultValues).toLowerCase() == "none"
            );
            if (this.sschecklistModel.length == checkYesvalue.length) {
              this.SScheckedyes = true;
              this.SScheckedno = false;
              this.SScheckednone = false;
            } else if (this.sschecklistModel.length == checkNovalue.length) {
              this.SScheckedyes = false;
              this.SScheckedno = true;
              this.SScheckednone = false;
            } else if (this.sschecklistModel.length == checkNonevalue.length) {
              this.SScheckedyes = false;
              this.SScheckedno = false;
              this.SScheckednone = true;
            } else {
              this.SScheckedyes = false;
              this.SScheckedno = false;
              this.SScheckednone = false;
            }
          } else {

            this.SsCheckListcolor = false;
          }
        }
      });
  }
  getSelectvalue(event, i) {
    this.sschecklistModel[i].isEdit =
      this.sschecklistModel[i].pK_TranId > 0 ? 1 : 0;
    this.sschecklistModel[i].defaultValues = event.value;
    const checkYesvalue = this.sschecklistModel.filter(
      (item) => item.defaultValues && item.defaultValues.toString().toLowerCase() == "yes"
    );
    const checkNovalue = this.sschecklistModel.filter(
      (item) => item.defaultValues && item.defaultValues.toString().toLowerCase() == "no"
    );
    const checkNonevalue = this.sschecklistModel.filter(
      (item) => item.defaultValues && item.defaultValues.toString().toLowerCase() == "none"
    );
    if (this.sschecklistModel.length == checkYesvalue.length) {
      this.SScheckedyes = true;
      this.SScheckedno = false;
      this.SScheckednone = false;
    } else if (this.sschecklistModel.length == checkNovalue.length) {
      this.SScheckedyes = false;
      this.SScheckedno = true;
      this.SScheckednone = false;
    } else if (this.sschecklistModel.length == checkNonevalue.length) {
      this.SScheckedyes = false;
      this.SScheckedno = false;
      this.SScheckednone = true;
    } else {
      this.SScheckedyes = false;
      this.SScheckedno = false;
      this.SScheckednone = false;
    }
  }
  sscheckstatus(option, i) {
    if (this.sschecklistModel[i].defaultValues != null) {
      return (
        this.sschecklistModel[i].defaultValues.toLocaleLowerCase() ==
        option.toLocaleLowerCase()
      );
    } else {
      return false;
    }
  }

  selectallvalue(value) {
    this.sschecklistModel.map((item) => (item.defaultValues = value));
    this.sschecklistModel.map((item) => (item.isEdit = 1));
    const checkYesvalue = this.sschecklistModel.filter(
      (item) => item.defaultValues.toString().toLowerCase() == "yes"
    );
    const checkNovalue = this.sschecklistModel.filter(
      (item) => item.defaultValues.toString().toLowerCase() == "no"
    );
    const checkNonevalue = this.sschecklistModel.filter(
      (item) => item.defaultValues.toString().toLowerCase() == "none"
    );
    if (this.sschecklistModel.length == checkYesvalue.length) {
      this.SScheckedyes = true;
      this.SScheckedno = false;
      this.SScheckednone = false;
    } else if (this.sschecklistModel.length == checkNovalue.length) {
      this.SScheckedyes = false;
      this.SScheckedno = true;
      this.SScheckednone = false;
    } else if (this.sschecklistModel.length == checkNonevalue.length) {
      this.SScheckedyes = false;
      this.SScheckedno = false;
      this.SScheckednone = true;
    } else {
      this.SScheckedyes = false;
      this.SScheckedno = false;
      this.SScheckednone = false;
    }
  }
  addNewRow() {
    const sslist = {
      pK_TranId: 0,
      headName: "",
      defaultValues: "",
      isHeader: false,
      isActive: true,
      checkListName: this.checklistname,
      isEdit: 0,
      FK_IPDID: this.selectIpdId,
    };
    this.sschecklistModel.push(sslist);
    this.defaultautoRef.changes
      .pipe(take(1))
      .pipe(takeUntil(this.destroyipd$))
      .subscribe({
        next: (changes) => changes.last.nativeElement.focus(),
      });
  }

  checkdata(e) {
    if (e.target.value == "") {
      this.checklistname = null;
      this.GetSsCheckListByIPDId(this.selectIpdId);
    }
  }
  SaveSSchecklist(event) {
    if (this.sschecklistModel.length > 0) {
      const button = (event.srcElement.disabled === undefined) ? event.srcElement.parentElement : event.srcElement;
      button.setAttribute('disabled', true);
      var filterhead = this.sschecklistModel.filter(
        (item) => item.headName == "" || item.headName == null
      );
      if (filterhead.length > 0) {
        button.removeAttribute('disabled');
        return this.dashboardService.openSnackBar(
          "Please enter HeadName ",
          "OK"
        );
      }
      this.ipdService
        .GetSsCheckListByIPDId(this.selectIpdId)
        .pipe(takeUntil(this.destroyipd$))
        .subscribe((data: any) => {
          const checkdata = data;
          const checkduplicate = checkdata?.filter(item => String(item.checkListName).toLowerCase() == String(this.checklistname).toLowerCase());
          if (checkduplicate.length > 0) {
            button.removeAttribute('disabled');
            return this.dashboardService.openSnackBar(
              "Duplicate checklist is not Allowed",
              "OK"
            );
          }
          if (this.sschecklistModel.length > 0) {
            if (checkdata.length > 0) {
              const checkduplicate = checkdata.reduce((unique, o) => {
                if (unique.some(obj => obj.headName === o.headName && obj.checkListName === o.checkListName)) {
                  unique.push(o);
                }
                return unique;
              }, []);
              if (checkduplicate.length > 1) {
                button.removeAttribute('disabled');
                return this.dashboardService.openSnackBar(
                  "Duplicate Record are not Allowed",
                  "OK"
                );
              }
            }
          }
          var updatepayload = [];
          this.sschecklistModel.forEach((item) => {
            updatepayload.push({
              PK_TranId: item.pK_TranId > 0 ? item.pK_TranId : 0,
              CheckListName: item.checkListName ? item.checkListName : this.checklistname,
              HeadName: item.headName,
              ActualValue: item.defaultValues,
              IsHeader: item.isHeader,
              FK_IPDID: this.selectIpdId,
              IsEdit: item.pK_TranId > 0 ? 1 : 0,
            });
          });

          if (updatepayload.length > 0) {
            let payLoad = {
              SsCheckList: updatepayload,
            };
            this.ipdService
              .InsertSsCheckList(payLoad)
              .pipe(takeUntil(this.destroyipd$))
              .subscribe((data) => {
                button.removeAttribute('disabled');
                if (data.statusCode == 1) {
                  const updatedata = this.sschecklistModel.filter((x: any) => x.pK_TranId == 0);
                  if (updatedata.length > 0) {
                    this.dashboardService.openSnackBar(
                      "Record Saved Successfully",
                      "OK"
                    );

                  } else {
                    this.dashboardService.openSnackBar(
                      "Record Updated Successfully",
                      "OK"
                    );
                  }
                  this.checklistname = null;
                  this.GetSsCheckListByIPDId(this.selectIpdId);
                } else {
                  this.dashboardService.openSnackBar(
                    data.statusCode,
                    "OK"
                  );

                }
              }, err => {
                button.removeAttribute('disabled');
                if (err.status == 403) {
                  this.dashboardService.openSnackBar("You Don't have Permission", "OK");
                } else if (err.error.statusCode == 422) {
                  this.dashboardService.openSnackBar(err.error.message, "OK");
                } else {
                  this.dashboardService.openSnackBar("API Failed", "OK");
                }
              });
          }
        }, err => {
          button.removeAttribute('disabled');
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          } else if (err.error.statusCode == 422) {
            this.dashboardService.openSnackBar(err.error.message, "OK");
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        });

    }
  }
  rowClickedipdsurgery: number = -1;
  TablesurgeryColor(idx: any) {
    if (this.rowClickedipdsurgery === idx) {
      //  this.rowClickedipdsurgery = -1;
    } else {
      this.rowClickedipdsurgery = idx;
    }
  }
  // getDiagonisisdatabyID() {
  //   this.emrservice.getDaigonosisbyRegid(this.RegId, 0, 0).subscribe((x: any) => {
  //     if (x.length > 0) {
  //       x.forEach(item => {
  //         if (this.surgicalRecordobj.diagnosis != null && this.surgicalRecordobj.diagnosis != '') {
  //           this.surgicalRecordobj.diagnosis = this.surgicalRecordobj.diagnosis + '\r\n' + item.diagnosisName.join('\r\n');
  //         } else {
  //           this.surgicalRecordobj.diagnosis = item.diagnosisName.join('\r\n');
  //         }

  //       })

  //     }
  //   }, err => {

  //   })
  // }
  getDiagonisisdatabyID() {
    this.emrservice
      .getDaigonosisbyRegid(this.RegId, 0, 0)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (x: any) => {
          if (x.length > 0) {
            x.forEach((item) => {
              if (
                this.surgicalRecordobj.diagnosis != null &&
                this.surgicalRecordobj.diagnosis != ""
              ) {
                this.surgicalRecordobj.diagnosis =
                  this.surgicalRecordobj.diagnosis +
                  item.diagnosisName +
                  "\r\n";
              } else {
                this.surgicalRecordobj.diagnosis = item.diagnosisName + "\r\n";
              }
            });
          }
        },
        (err) => { }
      );
  }
  GetPostOpCheckListName() {
    this.ipdService
      .GetPostOpCheckListName()
      .pipe(takeUntil(this.destroyipd$))
      .subscribe((x: any) => {
        this.PostOPchecklistnameData = x;
      });
  }
  getPostOPselectname(e) {
    if (e.option.value != null) {
      this.PostOPchecklistname = e.option.value;
    }
    this.GetPostOpCheckListByCheckListName(this.PostOPchecklistname);
    // this.GetPostOpCheckListByIPDId(this.selectIpdId, this.PostOPchecklistname);
  }

  GetPostOpCheckListByCheckListName(name) {
    const modifiyName: string = name.replaceAll(/\//g, "_");
    this.ipdService
      .GetPostOpCheckListByCheckListName(modifiyName)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe((x: any) => {
        this.PostOpchecklistModel = [];
        const checkbalank = x.filter(
          (item) => item.defaultValues != null && item.defaultValues != ""
        );
        if (checkbalank.lenght > 0) {
          const checkYesvalue = checkbalank.filter(
            (item) => String(item.defaultValues).toLowerCase() == "yes"
          );
          const checkNovalue = checkbalank.filter(
            (item) => String(item.defaultValues).toLowerCase() == "no"
          );
          const checkNonevalue = checkbalank.filter(
            (item) => String(item.defaultValues).toLowerCase() == "none"
          );

          if (x.length == checkYesvalue.length) {
            this.checkedyes = true;
            this.checkedno = false;
            this.checkednone = false;
          } else if (x.length == checkNovalue.length) {
            this.checkedyes = false;
            this.checkedno = true;
            this.checkednone = false;
          } else if (x.length == checkNonevalue.length) {
            this.checkedyes = false;
            this.checkedno = false;
            this.checkednone = true;
          } else {
            this.checkedyes = false;
            this.checkedno = false;
            this.checkednone = false;
          }
        }
        this.PostOpchecklistModel = x;
        this.PostOpchecklistModel = this.PostOpchecklistModel.reduce(
          (unique, o) => {
            if (!unique.some((obj) => obj.headName === o.headName)) {
              unique.push(o);
            }
            return unique;
          },
          []
        );
        this.PostOpchecklistModel.map((item) => (item.pK_TranId = 0));
      });
  }
  checkedyes: boolean = false;
  checkedno: boolean = false;
  checkednone: boolean = false;
  GetPostOpCheckListByIPDId(id: any) {
    var PostOpchecklistByName = [];
    this.ipdService
      .GetPostOpCheckListByIPDId(id)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe((x: any) => {
        this.PostOpchecklistModel = [];
        if (x.length > 0) {
          x.forEach((element) => {
            PostOpchecklistByName.push({
              pK_TranId: element.pK_TranId,
              checkListName: element.checkListName,
              headName: element.headName,
              defaultValues: element.actualValue,
              isHeader: element.isHeader,
              isActive: true,
              FK_IPDID: element.fK_IPDID,
              isEdit: element.isEdit,
            });
          });
          this.PostOpchecklistModel = PostOpchecklistByName;
          const checkYesvalue = this.PostOpchecklistModel.filter(
            (item) => String(item.defaultValues).toLowerCase() == "yes"
          );
          const checkNovalue = this.PostOpchecklistModel.filter(
            (item) => String(item.defaultValues).toLowerCase() == "no"
          );
          const checkNonevalue = this.PostOpchecklistModel.filter(
            (item) => String(item.defaultValues).toLowerCase() == "none"
          );
          if (this.PostOpchecklistModel.length == checkYesvalue.length) {
            this.checkedyes = true;
            this.checkedno = false;
            this.checkednone = false;
          } else if (
            this.PostOpchecklistModel.length == checkNovalue.length
          ) {
            this.checkedyes = false;
            this.checkedno = true;
            this.checkednone = false;
          } else if (
            this.PostOpchecklistModel.length == checkNonevalue.length
          ) {
            this.checkedyes = false;
            this.checkedno = false;
            this.checkednone = true;
          } else {
            this.checkedyes = false;
            this.checkedno = false;
            this.checkednone = false;
          }
          this.PostOpchecklistModel = this.PostOpchecklistModel.reduce(
            (unique, o) => {
              if (!unique.some((obj) => obj.headName === o.headName)) {
                unique.push(o);
              }
              return unique;
            },
            []
          );
        }

      });
  }
  getpostOpSelectvalue(event, i) {
    this.PostOpchecklistModel[i].isEdit =
      this.PostOpchecklistModel[i].pK_TranId > 0 ? 1 : 0;
    this.PostOpchecklistModel[i].defaultValues = event.value;
    const checkYesvalue = this.PostOpchecklistModel.filter(
      (item) => item.defaultValues.toString().toLowerCase() == "yes"
    );
    const checkNovalue = this.PostOpchecklistModel.filter(
      (item) => item.defaultValues.toString().toLowerCase() == "no"
    );
    const checkNonevalue = this.PostOpchecklistModel.filter(
      (item) => item.defaultValues.toString().toLowerCase() == "none"
    );
    if (this.PostOpchecklistModel.length == checkYesvalue.length) {
      this.checkedyes = true;
      this.checkedno = false;
      this.checkednone = false;
    } else if (this.PostOpchecklistModel.length == checkNovalue.length) {
      this.checkedyes = false;
      this.checkedno = true;
      this.checkednone = false;
    } else if (this.PostOpchecklistModel.length == checkNonevalue.length) {
      this.checkedyes = false;
      this.checkedno = false;
      this.checkednone = true;
    } else {
      this.checkedyes = false;
      this.checkedno = false;
      this.checkednone = false;
    }
  }
  PostOpselectallvalue(value) {
    this.PostOpchecklistModel.map((item) => (item.defaultValues = value));
    this.PostOpchecklistModel.map((item) => (item.isEdit = 1));
    const checkYesvalue = this.PostOpchecklistModel.filter(
      (item) => item.defaultValues.toString().toLowerCase() == "yes"
    );
    const checkNovalue = this.PostOpchecklistModel.filter(
      (item) => item.defaultValues.toString().toLowerCase() == "no"
    );
    const checkNonevalue = this.PostOpchecklistModel.filter(
      (item) => item.defaultValues.toString().toLowerCase() == "none"
    );
    if (this.PostOpchecklistModel.length == checkYesvalue.length) {
      this.checkedyes = true;
      this.checkedno = false;
      this.checkednone = false;
    } else if (this.PostOpchecklistModel.length == checkNovalue.length) {
      this.checkedyes = false;
      this.checkedno = true;
      this.checkednone = false;
    } else if (this.PostOpchecklistModel.length == checkNonevalue.length) {
      this.checkedyes = false;
      this.checkedno = false;
      this.checkednone = true;
    } else {
      this.checkedyes = false;
      this.checkedno = false;
      this.checkednone = false;
    }
  }
  addNewRowPostOP() {
    const Postlist = {
      pK_TranId: 0,
      headName: "",
      defaultValues: "",
      isHeader: false,
      isActive: true,
      checkListName: this.PostOPchecklistname,
      isEdit: 0,
      FK_IPDID: this.selectIpdId,
    };
    this.PostOpchecklistModel.push(Postlist);
    this.defaultPostauto.changes
      .pipe(take(1))
      .pipe(takeUntil(this.destroyipd$))
      .subscribe({
        next: (changes) => changes.last.nativeElement.focus(),
      });
  }
  PostOpcheckdata(e) {
    if (e.target.value == "") {
      this.PostOPchecklistname = null;
      this.GetPostOpCheckListByIPDId(
        this.selectIpdId
      );
    }
  }
  SavePostOpchecklist(event) {
    if (this.PostOpchecklistModel.length > 0) {
      const button = (event.srcElement.disabled === undefined) ? event.srcElement.parentElement : event.srcElement;
      button.setAttribute('disabled', true);
      var filterhead = this.PostOpchecklistModel.filter(
        (item) => item.headName == "" || item.headName == null
      );
      if (filterhead.length > 0) {
        button.removeAttribute('disabled');
        return this.dashboardService.openSnackBar(
          "Please enter HeadName ",
          "OK"
        );
      }

      this.ipdService
        .GetPostOpCheckListByIPDId(this.selectIpdId)
        .pipe(takeUntil(this.destroyipd$))
        .subscribe((data: any) => {
          const checkdata = data;
          const checkduplicate = checkdata?.filter(item => String(item.checkListName).toLowerCase() == String(this.PostOPchecklistname).toLowerCase());
          if (checkduplicate.length > 0) {
            button.removeAttribute('disabled');
            return this.dashboardService.openSnackBar(
              "Duplicate checklist is not Allowed",
              "OK"
            );
          }
          if (this.PostOpchecklistModel.length > 0) {
            if (checkdata.length > 0) {
              const checkduplicate = checkdata.reduce((unique, o) => {
                if (unique.some(obj => obj.headName === o.headName && obj.checkListName === o.checkListName)) {
                  unique.push(o);
                }
                return unique;
              }, []);
              if (checkduplicate.length > 1) {
                button.removeAttribute('disabled');
                return this.dashboardService.openSnackBar(
                  "Duplicate Record is not Allowed",
                  "OK"
                );
              }
            }
            var updatepayload = [];
            this.PostOpchecklistModel.forEach((item) => {
              updatepayload.push({
                PK_TranId: item.pK_TranId > 0 ? item.pK_TranId : 0,
                CheckListName: item.checkListName ? item.checkListName : this.PostOPchecklistname,
                HeadName: item.headName,
                ActualValue: item.defaultValues,
                IsHeader: item.isHeader,
                FK_IPDID: this.selectIpdId,
                IsEdit: item.pK_TranId > 0 ? 1 : 0,
              });
            });
            let payLoad = {
              PostOpCheckList: updatepayload,
            };
            this.ipdService
              .InsertPostOpCheckList(payLoad)
              .pipe(takeUntil(this.destroyipd$))
              .subscribe((data) => {
                button.removeAttribute('disabled');
                if (data.statusCode == 1) {
                  const updatedata = this.PostOpchecklistModel.filter((x: any) => x.pK_TranId == 0);
                  if (updatedata.length > 0) {
                    this.dashboardService.openSnackBar(
                      "Record Saved Successfully",
                      "OK"
                    );

                  } else {
                    this.dashboardService.openSnackBar(
                      "Record Updated Successfully",
                      "OK"
                    );
                  }
                  this.PostOPchecklistname = null;
                  this.GetPostOpCheckListByIPDId(
                    this.selectIpdId
                  );


                }
              }, err => {
                button.removeAttribute('disabled');
                if (err.status == 403) {
                  this.dashboardService.openSnackBar("You Don't have Permission", "OK");
                } else if (err.error.statusCode == 422) {
                  this.dashboardService.openSnackBar(err.error.message, "OK");
                } else {
                  this.dashboardService.openSnackBar("API Failed", "OK");
                }
              });
          }
        }, err => {
          button.removeAttribute('disabled');
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          } else if (err.error.statusCode == 422) {
            this.dashboardService.openSnackBar(err.error.message, "OK");
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        })

    }
  }
  checkstatus(option, i) {
    if (this.PostOpchecklistModel[i].defaultValues != null) {
      return (
        this.PostOpchecklistModel[i].defaultValues.toLocaleLowerCase() ==
        option.toLocaleLowerCase()
      );
    } else {
      return false;
    }
  }

  validateInput(event: any) {
    const inputElement = event.target as HTMLInputElement;
    const inputValue = inputElement.value.trim();

    if (inputValue && /^[^a-zA-Z0-9]/.test(inputValue)) {
      this.invalidInput = true;
    } else {
      this.invalidInput = false;
    }
  }
  //Add Patient Routine Examination Modal
  addPatientRoutineModalDialog() {
    if (this.selectedRoutineExam.pK_TranId > 0) {
      this.selecttime = this.datePipe.transform(
        this.selectedRoutineExam.entryDatetime,
        "HH:mm"
      );
      this.selectedRoutineExam.isEdit = true;
      this.selectedRoutineExam.isDelete = false;
    } else {
      this.selectedRoutineExam.pK_TranId = 0;
      this.selectedRoutineExam.fK_RegId = this.RegId;
      this.selectedRoutineExam.fK_CreatedById =
        this.authService.Loggeduser.userid;
      this.selectedRoutineExam.entryDatetime = this.datePipe.transform(
        new Date(),
        "yyyy-MM-dd HH:mm:ss"
      );
      this.selecttime = this.datePipe.transform(new Date(), "HH:mm");
      this.selectedRoutineExam.isEdit = false;
      this.selectedRoutineExam.isDelete = false;
      this.selectedRoutineExam.createdBy = this.authService.Loggeduser.firstname;
    }

    this.enableroutine = false;
    document.getElementById("addPatientRoutineExamination").style.display =
      "block";
  }
  updatefunction(type) {
    this.ChangetimeName = type;
    // const selectedTime = event.target.value;
    //  const [hours, minutes] = selectedTime.split(':');
    //   const updatedDateTime = new Date(this.selectedRoutineExam.entryDatetime);
    //   updatedDateTime.setHours(Number(hours));
    //   updatedDateTime.setMinutes(Number(minutes));
    //   this.selecttime = this.datePipe.transform(updatedDateTime, "h:mm a");
    //   this.selectedRoutineExam.entryDatetime = this.datePipe.transform(updatedDateTime, "yyyy-MM-dd HH:mm:ss");
  }
  selectedRow(row, i) {
    if (this.rowcolor === i) {
      this.rowcolor = -1;
      this.clear();
    } else {
      this.rowcolor = i;
      this.selectedRoutineExam = row;
    }
  }
  clear() {
    this.rowcolor = -1;
    this.selectedRoutineExam = {};
    this.selectedRoutineExam.pK_TranId = 0;
    this.selectedRoutineExam.fK_RegId = this.RegId;
    this.selectedRoutineExam.fK_CreatedById =
      this.authService.Loggeduser.userid;
    this.selectedRoutineExam.entryDatetime = this.datePipe.transform(
      new Date(),
      "yyyy-MM-dd HH:mm:ss"
    );
    this.selectedRoutineExam.isEdit = false;
    this.selectedRoutineExam.isDelete = false;
    this.selectedRoutineExam.createdBy = this.authService.Loggeduser.firstname;
  }

  closeaddPatientRoutineModalDialog() {
    this.GetPatientGeneralCheckupDetailByRegId(
      this.selectedRoutineExam.fK_RegId,
      this.selectedRoutineExam.pK_TranId
    );
    this.clear();
    document.getElementById("addPatientRoutineExamination").style.display =
      "none";
  }
  GetPatientGeneralCheckupDetailByRegId(id, transId) {
    this.ipdService
      .GetPatientGeneralCheckupDetailByRegId(id)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (x: any) => {
          this.RoutinegetData = [];
          this.RoutineExamModel = [];
          this.selectedDateData = [];
          this.RoutineExamModel = x;
          // this.RoutineExamModel.createdBy = this.authService.Loggeduser.username
          const groupedData = x.reduce((groups, item) => {
            const date = item.entryDatetime.split("T")[0];
            if (!groups[date]) {
              groups[date] = [];
            }
            groups[date].push(item);
            return groups;
          }, {});
          this.RoutinegetData = groupedData;

          if (transId == 0 && this.selectedRoutineExam.isEdit == false) {
            if (Object.keys(this.RoutinegetData).length > 0) {
              const keysArray = Object.keys(this.RoutinegetData);
              if (keysArray.length > 0) {
                this.selectedDate = keysArray[keysArray.length - 1];
                this.selectedDateData = this.RoutinegetData[this.selectedDate];
              }
            }
          } else {
            const keysArray = Object.keys(this.RoutinegetData);
            const deleteDate = keysArray.filter(
              (item) => item == this.selectedDate
            );
            if (deleteDate.length > 0) {
              this.selectedDateData = this.RoutinegetData[this.selectedDate];
            } else {
              this.selectedDate = keysArray[keysArray.length - 1];
              this.selectedDateData = this.RoutinegetData[this.selectedDate];
            }
          }

          console.log(groupedData);
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar(
              "You Don't have Permission",
              "OK"
            );
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }

  selectedDateData: any = [];
  onDateClick(date: string): void {
    this.selectedDate = date;
    this.selectedDateData = this.RoutinegetData[date];
    this.rowcolor = -1;
  }
  calculateBMI() {
    if (
      this.selectedRoutineExam.height != null &&
      this.selectedRoutineExam.weight
    ) {
      if (
        (this.selectedRoutineExam.height >= 50 &&
          this.selectedRoutineExam.height <= 300) ||
        (this.selectedRoutineExam.weight >= 0 &&
          this.selectedRoutineExam.weight <= 500)
      ) {
        // const heightInMeters = this.selectedRoutineExam.height / 100;
        // this.selectedRoutineExam.bmi = (this.selectedRoutineExam.weight / (heightInMeters * heightInMeters)).toFixed(2);
        const calculateBMI =
          (this.selectedRoutineExam.weight /
            (this.selectedRoutineExam.height *
              this.selectedRoutineExam.height)) *
          10000;
        this.selectedRoutineExam.bmi = Math.round(calculateBMI * 100) / 100;
        // this.selectedRoutineExam.bmi = ((this.selectedRoutineExam.weight / (this.selectedRoutineExam.height * this.selectedRoutineExam.height)) * 10000).toFixed(2);
      } else {
        this.dashboardService.openSnackBar(
          "Height and weight are out of Valid range.",
          "OK"
        );
        this.selectedRoutineExam.bmi = null;
      }
    } else {
      this.selectedRoutineExam.bmi = null;
    }
  }
  deleteRow(item: any): void {
    const date = item.entryDatetime.split("T")[0];
    const indexToRemove = this.RoutinegetData[date].findIndex(
      (row) => row.entryDatetime === item.entryDatetime
    );
    console.log(this.RoutinegetData);
    this.selectedRoutineExam = this.RoutinegetData[date][indexToRemove];
    this.selectedRoutineExam.isDelete = true;
    this.selectedRoutineExam.isEdit = true;
    console.log(this.selectedRoutineExam);
    if (indexToRemove !== -1) {
      this.RoutinegetData[date].splice(indexToRemove, 1);
    }
    let PayLoad = {
      PatientGeneralCheckupDetail: [this.selectedRoutineExam],
    };
    this.ipdService
      .InsertPatientGeneralCheckupDetail(PayLoad)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (data) => {
          if (data.statusCode == 1) {
            this.GetPatientGeneralCheckupDetailByRegId(
              this.selectedRoutineExam.fK_RegId,
              this.selectedRoutineExam.pK_TranId
            );
            this.dashboardService.openSnackBar(
              " Record Deleted Successfully",
              "OK"
            );
            this.rowcolor = -1;
            this.selectedRoutineExam = {};
          }
        },
        (err) => {
          this.dashboardService.openSnackBar("API FAILED", "OK");
        }
      );
  }
  saveRoutineExam(event) {
    if (
      this.selectedRoutineExam.bpSys > 255 ||
      this.selectedRoutineExam.bpdy > 255 ||
      this.selectedRoutineExam.rbs > 255 ||
      this.selectedRoutineExam.temp > 255 ||
      this.selectedRoutineExam.respiration > 255 ||
      this.selectedRoutineExam.spO2 > 255
    ) {
      this.dashboardService.openSnackBar("Please Enter valid record.", "ok");
    } else {
      const button =
        event.srcElement.disabled === undefined
          ? event.srcElement.parentElement
          : event.srcElement;
      button.setAttribute("disabled", true);
      setTimeout(function () {
        button.removeAttribute("disabled");
      }, 1000);
      this.selectedRoutineExam.weight = Math.round(
        this.selectedRoutineExam.weight
      );
      this.selectedRoutineExam.height = Math.round(
        this.selectedRoutineExam.height
      );
      if (
        this.selectedRoutineExam.bmi == "" ||
        this.selectedRoutineExam.bmi == null ||
        this.selectedRoutineExam.bmi == undefined
      ) {
        let PayLoad = {
          PatientGeneralCheckupDetail: [this.selectedRoutineExam],
        };
        this.ipdService
          .InsertPatientGeneralCheckupDetail(PayLoad)
          .pipe(takeUntil(this.destroyipd$))
          .subscribe(
            (data) => {
              if (data.statusCode == 1) {
                this.enableroutine = true;
                this.GetPatientGeneralCheckupDetailByRegId(
                  this.selectedRoutineExam.fK_RegId,
                  this.selectedRoutineExam.pK_TranId
                );
                this.dashboardService.openSnackBar(
                  " Record Saved Successfully",
                  "OK"
                );
                this.closeaddPatientRoutineModalDialog();
              }
            },
            (err) => {
              if (err.status == 403) {
                this.dashboardService.openSnackBar("You Don't have Permission", "OK");
              }
              else if (err.error.statusCode == 422) {
                this.dashboardService.openSnackBar(err.error.message, "OK");
              }
              else {
                this.dashboardService.openSnackBar("API Failed", "OK");
              }
            }
          );
      } else {
        if (
          this.selectedRoutineExam.bmi >= 0 &&
          this.selectedRoutineExam.bmi <= 255
        ) {
          let PayLoad = {
            PatientGeneralCheckupDetail: [this.selectedRoutineExam],
          };
          this.ipdService
            .InsertPatientGeneralCheckupDetail(PayLoad)
            .pipe(takeUntil(this.destroyipd$))
            .subscribe(
              (data) => {
                if (data.statusCode == 1) {
                  this.enableroutine = true;
                  this.GetPatientGeneralCheckupDetailByRegId(
                    this.selectedRoutineExam.fK_RegId,
                    this.selectedRoutineExam.pK_TranId
                  );
                  this.dashboardService.openSnackBar(
                    " Record Saved Successfully",
                    "OK"
                  );
                  this.closeaddPatientRoutineModalDialog();
                }
              },
              (err) => {
                if (err.status == 403) {
                  this.dashboardService.openSnackBar(
                    "You Don't have Permission",
                    "OK"
                  );
                } else {
                  this.dashboardService.openSnackBar("API Failed", "OK");
                }
              }
            );
        } else {
          this.dashboardService.openSnackBar(
            "BMI are out of Valid range.",
            "OK"
          );
        }
      }
    }
  }

  formatDateTime(datetime: Date): string {
    return this.datePipe.transform(datetime, "shortTime");
    // Change the format here
  }
  routinebpSysColor(data) {
    if (data === "" || data === null) {
      var routinecolorcode = "#fffff"; //hypertension crises
      this.titlebpSys = "";
    } else {
      if (data < 120) {
        var routinecolorcode = "#2991e2"; //low
        this.titlebpSys = "Low";
      } else if (data == 120) {
        var routinecolorcode = "#62ab45"; //normal
        this.titlebpSys = "Normal";
      } else if (data > 120 && data <= 129) {
        var routinecolorcode = "#f4b400"; //hypertension Stage 1
        this.titlebpSys = "Hypertension Stage 1";
      } else if (data > 129 && data < 180) {
        var routinecolorcode = "#f27122"; //hypertension Stage 2
        this.titlebpSys = "Hypertension Stage 2";
      } else if (data >= 180) {
        var routinecolorcode = "#dc242c"; //hypertension crises
        this.titlebpSys = "Hypertension Crises";
      } else {
        var routinecolorcode = "#fffff"; //hypertension crises
        this.titlebpSys = "";
      }
      return routinecolorcode;
    }
  }
  routinebpdyColor(data) {
    if (data === "" || data === null) {
      var routinecolorcode = "#fffff";
      this.titlebpdy = "";
    } else {
      if (data < 80) {
        var routinecolorcode = "#2991e2";
        this.titlebpdy = "Low";
      } else if (data == 80) {
        var routinecolorcode = "#62ab45";
        this.titlebpdy = "Normal";
      } else if (data > 80 && data <= 89) {
        var routinecolorcode = "#f4b400";
        this.titlebpdy = "Hypertension Stage 1";
      } else if (data >= 90 && data <= 120) {
        var routinecolorcode = "#f27122";
        this.titlebpdy = "Hypertension Stage 2";
      } else if (data > 120) {
        var routinecolorcode = "#dc242c";
        this.titlebpdy = "Hypertension Crises";
      }
      return routinecolorcode;
    }
  }
  routineBMIColor(data) {
    if (data === "" || data === null) {
      var routinecolorcode = "#fffff";
      this.titlebmi = "";
    } else {
      if (data < 18.5) {
        var routinecolorcode = "#2991e2";
        this.titlebmi = "Underweight";
      } else if (data >= 18.5 && data < 25) {
        var routinecolorcode = "#62ab45";
        this.titlebmi = "Normal";
      } else if (data >= 25 && data < 30) {
        var routinecolorcode = "#f4b400";
        this.titlebmi = "Overweight";
      } else if (data >= 30 && data < 35) {
        var routinecolorcode = "#f27122";
        this.titlebmi = "Obese";
      } else if (data >= 35) {
        var routinecolorcode = "#dc242c";
        this.titlebmi = "extremely Obese";
      } else {
        var routinecolorcode = "#fffff";
        this.titlebmi = "";
      }
      return routinecolorcode;
    }
  }
  routineTempColor(data) {
    if (data === "" || data === null) {
      var routinecolorcode = "#fffff";
      this.titletemp = "";
    } else {
      if (data < 35.8) {
        var routinecolorcode = "#2991e2";
        this.titletemp = "Low";
      } else if (data >= 35.9 && data <= 37.0) {
        var routinecolorcode = "#62ab45";
        this.titletemp = "Normal";
      } else if (data > 37 && data <= 37.5) {
        var routinecolorcode = "#e1ae47";
        this.titletemp = "Increased";
      } else if (data >= 37.6 && data <= 38) {
        var routinecolorcode = "#f27122";
        this.titletemp = "Light Fever";
      } else if (data > 38 && data <= 38.5) {
        var routinecolorcode = "#fa9e73";
        this.titletemp = "Moderate Fever";
      } else if (data >= 38.6 && data <= 39.5) {
        var routinecolorcode = "#f32327";
        this.titletemp = "High Fever";
      } else if (data >= 39.6) {
        var routinecolorcode = "#a12525";
        this.titletemp = "Very High Fever";
      } else {
        var routinecolorcode = "#fffff";
        this.titletemp = "";
      }
      return routinecolorcode;
    }
  }
  routineRBSColor(data) {
    if (data === "" || data === null) {
      var routinecolorcode = "#fffff";
      this.titlerbs = "";
    } else {
      if (data <= 60) {
        var routinecolorcode = "#2991e2"; //low
        this.titlerbs = "Low";
      } else if (data > 60 && data <= 90) {
        var routinecolorcode = "#62ab45"; //normal
        this.titlerbs = "Normal";
      } else if (data > 90 && data <= 125) {
        var routinecolorcode = "#f27122"; //hypertension Stage 1
        this.titlerbs = "Pre-Daibetes";
      } else if (data >= 126) {
        var routinecolorcode = "#dc242c"; //hypertension crises
        this.titlerbs = "Daibetes";
      } else {
        var routinecolorcode = "#fffff";
        this.titlerbs = "";
      }
      return routinecolorcode;
    }
  }
  routineRespriationColor(data) {
    if (data === "" || data === null) {
      var routinecolorcode = "#fffff";
      this.titlerespiration = "";
    } else {
      if (data < 12) {
        var routinecolorcode = "#f4b400"; //low
        this.titlerespiration = "Slow";
      } else if (data >= 12 && data <= 20) {
        var routinecolorcode = "#62ab45"; //normal
        this.titlerespiration = "Normal";
      } else if (data > 20) {
        var routinecolorcode = "#dc242c"; //hypertension crises
        this.titlerespiration = "Fast";
      } else {
        var routinecolorcode = "#fffff";
        this.titlerespiration = "";
      }
      return routinecolorcode;
    }
  }
  routineRespo2Color(data) {
    if (data === "" || data === null) {
      var routinecolorcode = "#fffff";
      this.titlespO2 = "";
    } else {
      if (data > 90) {
        var routinecolorcode = "#f59319";
        this.titlespO2 = "Decreased";
      } else if (data >= 95 && data <= 97) {
        var routinecolorcode = "#4d94b8";
        this.titlespO2 = "Insufficient";
      } else if (data >= 98 && data <= 100) {
        var routinecolorcode = "#62ab45";
        this.titlespO2 = "Normal";
      } else if (data < 90 && data >= 80) {
        var routinecolorcode = "#fa9e73";
        this.titlespO2 = "Critical";
      } else if (data < 80 && data >= 70) {
        var routinecolorcode = "#f32327";
        this.titlespO2 = "Severe Hypoxia";
      } else if (data < 70) {
        var routinecolorcode = "#a12525";
        this.titlespO2 = "Acute Danger";
      } else {
        var routinecolorcode = "#fffff";
        this.titlespO2 = "";
      }
      return routinecolorcode;
    }
  }

  //Vital Record Modal
  // vitalRecordModal() {
  //   document.getElementById("vitalRecordModal").style.display = "block";
  // }
  closeVitalRecordModal() {
    document.getElementById("vitalRecordModal").style.display = "none";
  }
  GetIOLBookingListByConsID() {
    this.ipdService
      .GetIOLBookingListByConsID(this.consId)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (x: any) => {
          if (x.length > 0) {
            this.IOLBookingData = x;
          }
        },
        (err) => { }
      );
  }
  GetOtIolPowerDetailByIPDId() {
    this.ipdService
      .GetOtIolPowerDetailByIPDId(this.selectIpdId)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (x: any) => {
          if (x.length > 0) {
            this.IOLgetData = x[0];
          }
        },
        (err) => { }
      );
  }
  dateChanged(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    const newDate = inputElement.value;
    this.getotcasesheetData(0, newDate);
  }

  getotcasesheetData(type: number, datechange?: any) {
    this.opdvisitService.getpatientdetails(this.RegId);
    this.formatAmountfun();

    const applicationdata = this.opdvisitService.documentrul.filter(
      (item) => item.propertyName == "WithoutOTRegistraionOTSheetShow"
    );

    if (applicationdata[0]?.propertyValue == "Y") {
      this.ipdService
        .GetOtRegisterByRegId(this.RegId)
        .pipe(takeUntil(this.destroyipd$))
        .subscribe(
          (x: any) => {
            this.getotRegdata = x;
            if (this.getotRegdata.length > 0) {
              if (type == 0) {
                var surgerydate = datechange;
                // this.OtcaseSheetobj.pK_RegId = 0;
              } else {
                var surgerydate =
                  this.getotRegdata[this.currentIndex].surgeryDate;
                this.OtcaseSheetobj.startTime =
                  this.getotRegdata[this.currentIndex].startTime;
                this.OtcaseSheetobj.finishTime =
                  this.getotRegdata[this.currentIndex].finishTime;
                this.OtcaseSheetobj.site = this.getotRegdata[this.currentIndex].site;
              }
              this.ipdService
                .GetOtRecordBySurgeryDateByRegIdByIPDIdByBranchId(
                  surgerydate,
                  this.RegId,
                  this.selectIpdId,
                  this.authService.Loggeduser.branchid
                )
                .pipe(takeUntil(this.destroyipd$))
                .subscribe((x: any) => {
                  this.OtcaseSheetobj = {};
                  this.OtcaseSheetArray = [];
                  this.OtcaseSheetobj.surgeryDate = surgerydate;
                  if (x.length > 0) {
                    this.OtcaseSheetArray = x;
                    this.OtcaseSheetobj = x[this.currentIndex];
                    this.OtcaseSheetobj.surgeryDate = this.datePipe.transform(
                      x[this.currentIndex].surgeryDate,
                      "yyyy-MM-dd"
                    );
                    this.OtcaseSheetobj.site = x[this.currentIndex].site;
                    this.OtcaseSheetobj.startTime =
                      x[this.currentIndex].startTime;
                    this.OtcaseSheetobj.finishTime =
                      x[this.currentIndex].finishTime;
                  }
                  // this.OtcaseSheetobj.pK_RegId = this.RegId;
                  if (this.OtcaseSheetobj.netBillAmt == null) {
                    this.OtcaseSheetobj.netBillAmt = 0;
                  }
                  this.calldrugALlergeryData();
                });
            } else {
              if (type == 0) {
                var surgerydate = datechange;
                // this.OtcaseSheetobj.pK_RegId = 0;
              } else {
                var surgerydate = this.admissionTo;
              }
              this.getCallbyBranchid(surgerydate);
            }
          },
          (err) => { }
        );
    } else {
      if (type == 0) {
        var surgerydate = datechange;
        // this.OtcaseSheetobj.pK_RegId = 0;
      } else {
        var surgerydate = this.admissionTo;
      }
      this.getCallbyBranchid(surgerydate);
    }

    this.GetOtIolPowerDetailByIPDId();
    this.GetIOLBookingListByConsID();
  }
  calldrugALlergeryData() {
    this.ipdService
      .get_pasthistory(this.RegId)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (x: any) => {
          if (x.length > 0) {
            this.OtcaseSheetobj.sysDisease = x
              .map((x1) => x1.diseaseName)
              .join(",");
          }
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar(
              "You Don't have Permission",
              "OK"
            );
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
    this.ipdService
      .get_allergies(this.RegId)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (x: any) => {
          if (x.length > 0) {
            this.OtcaseSheetobj.DrugAllergy = x
              .map((x1) => x1.saltName)
              .join(",");
          }
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar(
              "You Don't have Permission",
              "OK"
            );
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }
  getCallbyBranchid(addmintiondate) {
    this.ipdService
      .GetOtRecordByIPDAdmDateByRegIdByIPDId(
        addmintiondate,
        this.RegId,
        this.selectIpdId
      )
      .pipe(takeUntil(this.destroyipd$))
      .subscribe((x: any) => {
        this.OtcaseSheetobj = {};
        this.OtcaseSheetArray = [];
        if (x.length > 0) {
          this.OtcaseSheetArray = x;
          this.OtcaseSheetobj = x[this.currentIndex];
          if (x[this.currentIndex].surgeryDate != null) {
            this.OtcaseSheetobj.surgeryDate = this.datePipe.transform(
              x[this.currentIndex].surgeryDate,
              "yyyy-MM-dd"
            );
          } else {
            this.OtcaseSheetobj.surgeryDate = addmintiondate;
          }
          this.OtcaseSheetobj.site = x[this.currentIndex].site;
          this.OtcaseSheetobj.startTime = x[this.currentIndex].startTime;
          this.OtcaseSheetobj.finishTime = x[this.currentIndex].finishTime;
        }
        // this.OtcaseSheetobj.pK_RegId = this.RegId;
        if (this.OtcaseSheetobj.netBillAmt == null) {
          this.OtcaseSheetobj.netBillAmt = 0;
        }
        this.calldrugALlergeryData();
      });
  }

  showPrevious() {
    if (this.currentIndex >= 0) {
      this.currentIndex--;
      // const checkarraydata =  this.OtcaseSheetArray[this.currentIndex];
      if (this.currentIndex < 0) {
        this.currentIndex = 0;
        this.dashboardService.openSnackBar("first record", "ok");
      } else {
        this.OtcaseSheetobj = this.OtcaseSheetArray[this.currentIndex];
        if (this.OtcaseSheetArray[this.currentIndex].surgeryDate != null) {
          this.OtcaseSheetobj.surgeryDate = this.datePipe.transform(
            this.OtcaseSheetArray[this.currentIndex].surgeryDate,
            "yyyy-MM-dd"
          );
        } else {
          this.OtcaseSheetobj.surgeryDate = this.datePipe.transform(
            this.authService.localDate,
            "yyyy-MM-dd"
          );
        }
        this.OtcaseSheetobj.site =
          this.OtcaseSheetArray[this.currentIndex].site;
        this.calldrugALlergeryData();
      }
    }
  }

  showNext() {
    if (this.currentIndex < this.OtcaseSheetArray.length - 1) {
      this.currentIndex++;
      this.OtcaseSheetobj = this.OtcaseSheetArray[this.currentIndex];
      if (this.OtcaseSheetArray[this.currentIndex].surgeryDate != null) {
        this.OtcaseSheetobj.surgeryDate = this.datePipe.transform(
          this.OtcaseSheetArray[this.currentIndex].surgeryDate,
          "yyyy-MM-dd"
        );
      } else {
        this.OtcaseSheetobj.surgeryDate = this.datePipe.transform(
          this.authService.localDate,
          "yyyy-MM-dd"
        );
      }
      this.OtcaseSheetobj.site = this.OtcaseSheetArray[this.currentIndex].site;
      this.calldrugALlergeryData();
    } else {
      this.dashboardService.openSnackBar("last record", "ok");
    }
  }
  start(type) {
    if (type == 1) {
      this.surgicalRecordobj.pK_OTId =
        this.getotRegdata[this.currentIndex].pK_OTId;
      (this.surgicalRecordobj.fK_IPDId =
        this.getotRegdata[this.currentIndex].fK_IPDId),
        (this.surgicalRecordobj.startTime = moment(
          this.authService.localDate
        ).format("hh:mm:ss"));
      this.surgicalRecordobj.isEdit = true;
      this.surgicalRecordobj.headName = "START";
      let payload = {
        OtRegister: this.surgicalRecordobj,

        OtRecordSurgery: [],
        OtIolPowerDetail: {},
      };
      this.ipdService
        .InsertOtRegister(payload)
        .pipe(takeUntil(this.destroyipd$))
        .subscribe(
          (x: any) => {
            this.showspinner1 = false;
            this.dashboardService.openSnackBar("Started", "OK");
            this.getotcasesheetData(1);
          },
          (err) => {
            this.showspinner1 = false;
            if (err.status == 403) {
              this.dashboardService.openSnackBar(
                "You Don't have Permission",
                "OK"
              );
            } else {
              this.dashboardService.openSnackBar("API Failed", "OK");
            }
          }
        );
    } else {
      this.surgicalRecordobj.pK_OTId =
        this.getotRegdata[this.currentIndex].pK_OTId;
      (this.surgicalRecordobj.fK_IPDId =
        this.getotRegdata[this.currentIndex].fK_IPDId),
        (this.surgicalRecordobj.finishTime = moment(
          this.authService.localDate
        ).format("hh:mm:ss"));
      this.surgicalRecordobj.isEdit = true;
      this.surgicalRecordobj.headName = "FINISH";
      let payload = {
        OtRegister: this.surgicalRecordobj,

        OtRecordSurgery: [],
        OtIolPowerDetail: {},
      };
      this.ipdService
        .InsertOtRegister(payload)
        .pipe(takeUntil(this.destroyipd$))
        .subscribe(
          (x: any) => {
            this.showspinner1 = false;
            this.dashboardService.openSnackBar("Finished", "OK");
            this.getotcasesheetData(1);
          },
          (err) => {
            this.showspinner1 = false;
            if (err.status == 403) {
              this.dashboardService.openSnackBar(
                "You Don't have Permission",
                "OK"
              );
            } else {
              this.dashboardService.openSnackBar("API Failed", "OK");
            }
          }
        );
    }
  }

  formatAmountfun() {
    this.ipdService
      .GetpackagebyIpdId(this.selectIpdId)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe((data) => {
        this.OTpackageName = data.map((obj) => obj.packageName).join(",");

        const totalAmount = data.reduce((sum, item) => sum + item.amount, 0);
        this.ipdAmount = totalAmount;
      });
  }

  //charge sheet
  NURSINGCHARGETYPEMASTER() {
    this.ipdService
      .NURSINGCHARGETYPEMASTER()
      .pipe(takeUntil(this.destroyipd$))
      .subscribe((x: any) => {
        if (x.length > 0) {
          this.getChargeType = x;
        }
      });
  }
  getChargeMasterName(event: any) {
    this.ChargeTypeMasterName = event.option.value;
    this.chargeTypeId = event.option.id;
  }
  GetRateType() {
    this.billingservice
      .get_rate_typelist()
      .pipe(takeUntil(this.destroyipd$))
      .subscribe((data: any[]) => {
        this.billingservice.ratetype = data;
      });
  }
  getRateChargeType(event: any) {
    this.RateTpyeName = event.option.value;
    this.RateTypeId = event.option.id;
  }
  get_rate_list() {
    this.billingservice
      .get_rate_list(
        this.authService.Loggeduser.branchid,
        this.selectipdData.fkPartyId
      )

      .pipe(takeUntil(this.destroyipd$))
      .subscribe((data: any[]) => {
        this.billingservice.ratelist = data[0];
      });
  }

  newservicecharge() {
    if (
      this.ChargeTypeMasterName != null &&
      this.ChargeTypeMasterName != undefined &&
      this.chargeTypeId > 0
    ) {
      if (this.RateTpyeName != "" && this.RateTypeId > 0) {
        const dialogRef = this.dialog.open(AddServiceComponent, {
          panelClass: "full-width-dialog",
          maxWidth: "100vw !important",
          height: "90%",
          width: "80%",
          data: {
            RateType: this.RateTypeId,
            Category_id: 1,
            headingHide: false,
          },
        });

        dialogRef
          .afterClosed()
          .pipe(takeUntil(this.destroyipd$))
          .subscribe((result) => {
            var result = this.billingservice.selectedServiceRow.reduce(
              (unique, o) => {
                if (
                  !unique.some(
                    (obj) =>
                      obj.serviceName === o.serviceName &&
                      obj.FK_ServiceId === o.FK_ServiceId
                  )
                ) {
                  unique.push(o);
                }
                return unique;
              },
              []
            );

            result.forEach((element, index) => {
              this.NursingChargesModel.push({
                pk_TranId: 0,
                fK_IPDID: this.selectIpdId,
                fK_ChargeTypeId: this.chargeTypeId,
                chargeDate: this.authService.localDate,
                fK_ServiceId: element.serviceId,
                serviceRate: element.rate,
                unit: 1,
                amount: element.rate,
                discount: this.returnSericeChage(
                  element.rate,
                  element.discount
                ),
                serviceCharges: this.returnSericeChage(
                  element.rate,
                  element.serviceCharge
                ),
                netAmt: this.netAmountcal(
                  element.rate,
                  this.returnSericeChage(element.rate, element.discount),
                  this.returnSericeChage(element.rate, element.serviceCharge)
                ),
                fK_PackageId: 0,
                isPerformed: false,
                remarks: "",
                pK_SynchId: 0,
                isDelete: 0,
                serviceName: element.serviceName,
                serviceChargesPer: element.serviceCharge
                  ? element.serviceCharge
                  : 0,
                discountPer: element.discount,
                FK_CreatedById: this.authService.Loggeduser.userid,
                FK_ModifiedById: null,
                TestPriority: null,
                IsEdit: false,
              });
              // this.NursingChargesModel = result;
            });
            this.NursingChargesModel =
              this.NursingChargesModel.reduce((unique, o) => {
                if (
                  !unique.some(
                    (obj) =>
                      obj.serviceName === o.serviceName &&
                      obj.fK_ServiceId === o.fK_ServiceId
                  )
                ) {
                  unique.push(o);
                }
                return unique;
              }, []);
          });
      } else {
        this.dashboardService.openSnackBar("Please Select Room Type", "OK");
      }
    } else {
      this.dashboardService.openSnackBar("Please Select Charge Type", "OK");
    }
  }
  // netAmountcal(rate, discount, sc) {
  //   let calchage = (rate - parseFloat(discount) + parseFloat(sc)).toFixed(2);
  //   return calchage;
  // }

  netAmountcal(rate, discount, sc) {
    let calchage = Math.round(rate - parseFloat(discount) + parseFloat(sc));
    return calchage;
  }

  GetNursingChargesByIPDId() {
    // this.NursingChargesobj = {};
    this.NursingChargesModel = [];
    this.ipdService
      .GetNursingChargesByIPDId(this.selectIpdId)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe((data: any[]) => {
        this.NursingChargesModel = data;
        // this.NursingChargesobj = data[0];
      });
  }
  returnSericeChage(amount, percetage) {
    if (amount > 0 && percetage > 0) {
      let calchage = (amount * percetage) / 100;
      return calchage.toFixed(2);
    } else {
      return 0;
    }
  }
  getNameById(id: number): string {
    if (id > 0) {
      const item = this.getChargeType.find((item) => item.pK_Id === id);

      return item ? item.name : "";
    }
  }

  SaveNursingCharges() {
    let filterData = this.NursingChargesModel.filter(
      (item) => item.pk_TranId == 0
    );
    if (filterData.length > 0) {
      let PayLoad = {
        NursingCharges: filterData,
      };
      this.ipdService
        .InsertNursingCharges(PayLoad)
        .pipe(takeUntil(this.destroyipd$))
        .subscribe(
          (data) => {
            if (data.statusCode == 1) {
              this.GetNursingChargesByIPDId();
              this.dashboardService.openSnackBar(
                " Record Saved Successfully",
                "OK"
              );
            }
          },
          (err) => {
            if (err.status == 403) {
              this.dashboardService.openSnackBar("You Don't have Permission", "OK");
            } else if (err.error.statusCode == 422) {
              this.dashboardService.openSnackBar(err.error.message, "OK");
            } else {
              this.dashboardService.openSnackBar("API Failed", "OK");
            }
          }
        );
    } else {
      this.dashboardService.openSnackBar("Please Add Charges", "OK");
    }
  }
  validateInputs(inputValue: number): boolean {
    return !isNaN(inputValue) && inputValue >= 0 && inputValue <= 255;
  }

  getPreOpTemplateMaster(transId: any) {
    this.templateMaster = [];
    this.ipdService
      .GetPreOpTemplateMaster(transId)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe((data: any[]) => {
        this.templateMaster = data;
      });
  }
  TemplateAddRow() {
    this.templateMasterDisable = false;
    this.MediciantemplateMaster = [];
    this.InvestigationtemplateMaster = [];
    this.InstructiontemplateMaster = [];
    const templist = {
      pK_TranID: 0,
      fK_SurgeryId: null,
      fK_DiagnosisId: null,
      templateName: "",
      isActive: true,
      pK_SynchId: null,
      isEdit: false,
      isDelete: false,
    };
    this.templateMaster.push(templist);
    this.defaulttemplate.changes
      .pipe(take(1))
      .pipe(takeUntil(this.destroyipd$))
      .subscribe({
        next: (changes) => changes.last.nativeElement.focus(),
      });
    this.selectTemplateRow(templist, this.templateMaster.length - 1);
  }

  TemplatedeleteRow(event, row, index: number) {
    if (this.authService.Loggeduser.usertypeid == 9) {
      this.templateMasterDisable = false;
      this.templateMaster.splice(index, 1);
      if (row.pK_TranID > 0) {
        this.templateMaster.push(row);
        this.templateMaster[index].isEdit = true;
        this.templateMaster[index].isDelete = true;
        this.MediciantemplateMaster.map((item) => (item.isEdit = true));
        this.MediciantemplateMaster.map((item) => (item.isDelete = true));
        this.InvestigationtemplateMaster.map((item) => (item.isEdit = true));
        this.InvestigationtemplateMaster.map((item) => (item.isDelete = true));
        this.InstructiontemplateMaster.map((item) => (item.isEdit = true));
        this.InstructiontemplateMaster.map((item) => (item.isDelete = true));
        this.SavePreOpTemplateMaster(1);
      }

      // this.templateMaster.splice(index, 1);
    } else {
      this.dashboardService.openSnackBar(
        "You Don't have Permission",
        "OK"
      );
    }
  }

  selectTemplateRow(row, i) {
    this.MediciantemplateMaster = [];
    this.InvestigationtemplateMaster = [];
    this.InstructiontemplateMaster = [];
    this.selectedTemprow = row;
    this.rowClickedTemplate = i;
    this.masterTemplateId = row.pK_TranID;
    if (this.masterTemplateId != 0) {
      this.GetPreOpTemplatePrescriptionDetailByIdByTemplateId();
      this.GetPreOpTemplateInvestigationDetailByIdByTemplateId();
      this.GetPreOpTemplateInstructionDetailByIdByTemplateId();
      this.clearTemplateDeletearray();
    }
  }
  MediciantemplateDeleteRow(row, index: number) {
    this.templateMasterDisable = false;
    this.MediciantemplateMaster.splice(index, 1);
    if (row.pK_TranID > 0) {
      this.MediciantemplateDeleteArray.push(row);
      this.MediciantemplateDeleteArray.map((item) => (item.isEdit = true));
      this.MediciantemplateDeleteArray.map((item) => (item.isDelete = true));
    }
  }
  InvestigationtemplateDeleteRow(row, index: number) {
    this.templateMasterDisable = false;
    this.InvestigationtemplateMaster.splice(index, 1);
    if (row.pK_TranID > 0) {
      this.InvestigationtemplateDeleteArray.push(row);
      this.InvestigationtemplateDeleteArray.map((item) => (item.isEdit = true));
      this.InvestigationtemplateDeleteArray.map(
        (item) => (item.isDelete = true)
      );
    }
  }

  InstructiontemplateDeleteRow(row, index: number) {
    this.templateMasterDisable = false;
    this.InstructiontemplateMaster.splice(index, 1);
    if (row.pK_TranID > 0) {
      this.InstructiontemplateDeleteArray.push(row);
      this.InstructiontemplateDeleteArray.map((item) => (item.isEdit = true));
      this.InstructiontemplateDeleteArray.map((item) => (item.isDelete = true));
    }
  }
  clearTemplateDeletearray() {
    this.MediciantemplateDeleteArray = [];
    this.InvestigationtemplateDeleteArray = [];
    this.InstructiontemplateDeleteArray = [];
  }
  GetPreOpTemplatePrescriptionDetailByIdByTemplateId() {
    this.MediciantemplateMaster = [];
    this.ipdService
      .GetPreOpTemplatePrescriptionDetailByIdByTemplateId(this.masterTemplateId)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe((data: any[]) => {
        this.MediciantemplateMaster = data.map((item) => ({
          daysUnit: item.unit,
          type: item.medicineType,
          ...item,
        }));
      });
  }
  GetPreOpTemplateInvestigationDetailByIdByTemplateId() {
    this.InvestigationtemplateMaster = [];
    this.ipdService
      .GetPreOpTemplateInvestigationDetailByIdByTemplateId(
        this.masterTemplateId
      )
      .pipe(takeUntil(this.destroyipd$))
      .subscribe((data: any[]) => {
        this.InvestigationtemplateMaster = data;
      });
  }

  GetPreOpTemplateInstructionDetailByIdByTemplateId() {
    this.InstructiontemplateMaster = [];
    this.ipdService
      .GetPreOpTemplateInstructionDetailByIdByTemplateId(this.masterTemplateId)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe((data: any[]) => {
        this.InstructiontemplateMaster = data;
      });
  }
  checkInstruction(event) {
    this.templateMasterDisable = false;
  }
  InstructionAddRow() {
    this.templateMasterDisable = false;
    const templist = {
      pK_TranID: 0,
      fK_TemplateId: this.masterTemplateId,
      instruction: "",
      isActive: true,
      isEdit: false,
      isDelete: false,
    };
    this.InstructiontemplateMaster.push(templist);
    this.defaultInstruction.changes
      .pipe(take(1))
      .pipe(takeUntil(this.destroyipd$))
      .subscribe({
        next: (changes) => changes.last.nativeElement.focus(),
      });
  }

  SavePreOpTemplateMaster(type, event?: any) {
    this.tempobj = {};
    if (type != 1) {
      const tempBlank = this.templateMaster.filter(
        (item) => item.templateName == "" || item.templateName == null
      );
      const InstructionBlank = this.InstructiontemplateMaster.filter(
        (item) => item.instruction == "" || item.instruction == null
      );
      if (tempBlank.length > 0) {
        this.dashboardService.openSnackBar("Please Add Template Name", "ok");
      } else {
        if (InstructionBlank.length > 0) {
          this.dashboardService.openSnackBar("Please Add Instruction", "ok");
        } else {
          const button =
            event.srcElement.disabled === undefined
              ? event.srcElement.parentElement
              : event.srcElement;
          button.setAttribute("disabled", true);

          var template = this.templateMaster.filter(
            (item) => item.pK_TranID == this.masterTemplateId
          );

          this.tempobj = template[0];
          if (this.tempobj.pK_TranID == 0) {
            this.tempobj.isEdit = false;
            this.tempobj.isDelete = false;
          } else {
            this.tempobj.isEdit = true;
            this.tempobj.isDelete = false;
          }
          for (var i = 0; i < this.InstructiontemplateMaster.length; i++) {
            if (this.InstructiontemplateMaster[i].pK_TranID !== 0) {
              this.InstructiontemplateMaster[i].isEdit = true;
              this.InstructiontemplateMaster[i].isDelete = false;
            } else {
              this.InstructiontemplateMaster[i].isEdit = false;
              this.InstructiontemplateMaster[i].isDelete = false;
            }
          }

          let PayLoad = {
            PreOpTemplateMaster: this.tempobj,

            PreOpTemplateInvestigationDetail:
              this.InvestigationtemplateMaster.concat(
                this.InvestigationtemplateDeleteArray
              ),

            PreOpTemplatePrescriptionDetail: this.MediciantemplateMaster.concat(
              this.MediciantemplateDeleteArray
            ),

            PreOpTemplateInstructionDetail:
              this.InstructiontemplateMaster.concat(
                this.InstructiontemplateDeleteArray
              ),
          };
          this.ipdService
            .InsertPreOpTemplateMaster(PayLoad)
            .pipe(takeUntil(this.destroyipd$))
            .subscribe(
              (data) => {
                button.removeAttribute("disabled");
                this.templateMasterDisable = true;
                if (data.statusCode == 1) {
                  this.getPreOpTemplateMaster(0);
                  this.clearTemplateDeletearray();
                  this.dashboardService.openSnackBar(
                    " Record Saved Successfully",
                    "OK"
                  );
                }
              },
              (err) => {
                if (err.status == 403) {
                  this.dashboardService.openSnackBar("You Don't have Permission", "OK");
                }
                else if (err.error.statusCode == 422) {
                  this.dashboardService.openSnackBar(err.error.message, "OK");
                }
                else {
                  this.dashboardService.openSnackBar("API Failed", "OK");
                }
              }
            );
        }
      }
    } else {
      var template = this.templateMaster.filter(
        (item) => item.isDelete == true
      );
      this.tempobj = template[0];
      let PayLoad = {
        PreOpTemplateMaster: this.tempobj,

        PreOpTemplateInvestigationDetail: this.InvestigationtemplateMaster,

        PreOpTemplatePrescriptionDetail: this.MediciantemplateMaster,

        PreOpTemplateInstructionDetail: this.InstructiontemplateMaster,
      };
      this.ipdService
        .InsertPreOpTemplateMaster(PayLoad)
        .pipe(takeUntil(this.destroyipd$))
        .subscribe(
          (data) => {
            if (data.statusCode == 1) {
              this.InvestigationtemplateMaster = [];
              this.MediciantemplateMaster = [];
              this.InstructiontemplateMaster = [];
              this.templateMasterDisable = true;
              this.getPreOpTemplateMaster(0);
              this.dashboardService.openSnackBar(
                " Record Deleted Successfully",
                "OK"
              );
            }
          },
          (err) => {
            if (err.status == 403) {
              this.dashboardService.openSnackBar("You Don't have Permission", "OK");
            }
            else if (err.error.statusCode == 422) {
              this.dashboardService.openSnackBar(err.error.message, "OK");
            }
            else {
              this.dashboardService.openSnackBar("API Failed", "OK");
            }
          }
        );
    }
  }
  updatePreOpTemplateMaster() {
    this.CounspreopDisable = false;
    this.InvestigationtemplateMaster?.forEach((item) => {
      this.CounselorInvestigation.push({
        pK_TranId: 0,
        fK_CounsID: this.selectCouncelorId,
        fK_ServiceId: item.fK_ServiceId,
        serviceName: item.serviceName,
        pK_SynchId: null,
        isEdit: false,
        isDelete: false,
      });
    });
    // this.CounselorMedicineDetail = this.CounselorMedicineDetail.concat(this.MediciantemplateMaster);
    this.MediciantemplateMaster?.forEach((item) => {
      this.CounselorMedicineDetail.push({
        pK_TranId: 0,
        fK_CounsID: this.selectCouncelorId,
        fK_MedicineId: item.fK_MedicineId,
        qty: item.qty,
        fK_DosageId: item.fK_DosageId,
        days: item.days,
        unit: item.unit,
        remarks: item.remakrs,
        medicineName: item.medicineName,
        dosageCode: item.dosageCode,
        medicineType: item.medicineType,
        pK_SynchId: null,
        isEdit: false,
        isDelete: false,
      });
    });
    // this.CounselorInstructionDetail = this.CounselorInstructionDetail.concat(this.InstructiontemplateMaster);
    this.InstructiontemplateMaster?.forEach((item) => {
      this.CounselorInstructionDetail.push({
        pK_TranId: 0,
        fK_CounsID: this.selectCouncelorId,
        instructions: item.instruction,
        isActive: item.isActive,
        isEdit: false,
        isDelete: false,
      });
    });
    this.cancelpreOperativeWorkup();
  }
  GetCounselorCheckListByCounselorId(id: any) {
    this.CounselorCheckList = [];
    this.ipdService
      .GetCounselorCheckListByCounselorId(id)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe((data: any[]) => {
        const checkYesvalue = data.filter(
          (item) => item.actualValue.toString().toLowerCase() == "yes"
        );
        const checkNovalue = data.filter(
          (item) => item.actualValue.toString().toLowerCase() == "no"
        );
        const checkNonevalue = data.filter(
          (item) => item.actualValue.toString().toLowerCase() == "none"
        );
        // const checkYesvalue = data.filter(item => String(item.actualValue).toLowerCase() === "yes");
        // const checkNovalue = data.filter(item => String(item.actualValue).toLowerCase() === "no");
        // const checkNonevalue = data.filter(item => String(item.actualValue).toLowerCase() === "none");
        if (data.length == checkYesvalue.length) {
          this.PDcheckedyes = true;
          this.PDcheckedno = false;
          this.PDcheckednone = false;
        } else if (data.length == checkNovalue.length) {
          this.PDcheckedyes = false;
          this.PDcheckedno = true;
          this.PDcheckednone = false;
        } else if (data.length == checkNonevalue.length) {
          this.PDcheckedyes = false;
          this.PDcheckedno = false;
          this.PDcheckednone = true;
        } else {
          this.PDcheckedyes = false;
          this.PDcheckedno = false;
          this.PDcheckednone = false;
        }
        this.CounselorCheckList = data;
      });
  }
  GetCounselorPreOpInvestigationByCounselorId(id: any) {
    this.CounselorInvestigation = [];
    this.ipdService
      .GetCounselorPreOpInvestigationByCounselorId(id)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe((data: any[]) => {
        this.CounselorInvestigation = data;
      });
  }
  GetCounselorPreOpMedicineDetailByCounselorId(id: any) {
    this.CounselorMedicineDetail = [];
    this.ipdService
      .GetCounselorPreOpMedicineDetailByCounselorId(id)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe((data: any[]) => {
        this.CounselorMedicineDetail = data;
      });
  }
  GetCounselorPreOpInstructionDetailByCounselorId(id: any) {
    this.CounselorInstructionDetail = [];
    this.ipdService
      .GetCounselorPreOpInstructionDetailByCounselorId(id)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe((data: any[]) => {
        this.CounselorInstructionDetail = data;
      });
  }
  CounselorInstructionAddRow() {
    this.CounspreopDisable = false;
    const templist = {
      pK_TranId: 0,
      fK_CounsID: this.selectCouncelorId,
      instructions: "",
      isActive: true,
      isEdit: false,
      isDelete: false,
    };
    this.CounselorInstructionDetail.push(templist);
    this.defaultConsInstruction.changes
      .pipe(take(1))
      .pipe(takeUntil(this.destroyipd$))
      .subscribe({
        next: (changes) => changes.last.nativeElement.focus(),
      });
  }
  getCounselorPreOpDetail(id) {
    this.GetCounselorCheckListByCounselorId(id);
    this.GetCounselorPreOpInvestigationByCounselorId(id);
    this.GetCounselorPreOpMedicineDetailByCounselorId(id);
    this.GetCounselorPreOpInstructionDetailByCounselorId(id);
    this.clearDeletearray();
  }
  SaveCounselorPreOpDetail(event) {
    const button =
      event.srcElement.disabled === undefined
        ? event.srcElement.parentElement
        : event.srcElement;
    button.setAttribute("disabled", true);
    this.CounselorCheckList?.forEach((item) => {
      if (item.pK_TranId > 0) {
        this.CounselorCheckList.map((item) => (item.isEdit = true));
        this.CounselorCheckList.map((item) => (item.isDelete = false));
      }
    });
    this.CounselorInvestigation?.forEach((item) => {
      if (item.pK_TranId > 0) {
        this.CounselorInvestigation.map((item) =>
          item.pK_TranId > 0 ? (item.isEdit = true) : (item.isEdit = false)
        );
        this.CounselorInvestigation.map((item) => (item.isDelete = false));
      }
    });

    this.CounselorMedicineDetail?.forEach((item) => {
      if (item.pK_TranId > 0) {
        this.CounselorMedicineDetail.map((item) =>
          item.pK_TranId > 0 ? (item.isEdit = true) : (item.isEdit = false)
        );
        this.CounselorMedicineDetail.map((item) => (item.isDelete = false));
      }
    });

    const invalidItems = this.CounselorInstructionDetail.some(item => !item.instructions || item.instructions.trim() === '');
    if (invalidItems) {
      this.dashboardService.openSnackBar("Please add instruction", "Ok");
      this.CounspreopDisable = true;
      button.removeAttribute('disabled');
      return;
    }
    this.CounselorInstructionDetail?.forEach((item) => {
      this.CounselorInstructionDetail.map((item) =>
        item.pK_TranId > 0 ? (item.isEdit = true) : (item.isEdit = false)
      );
      this.CounselorInstructionDetail.map((item) => (item.isDelete = false));
    });
    let PayLoad = {
      CounselorCheckList: this.CounselorCheckList,

      CounselorPreOpInvestigation: this.CounselorInvestigation.concat(
        this.CounselorInvestigationDeleteArray
      ),

      CounselorPreOpMedicineDetail: this.CounselorMedicineDetail.concat(
        this.CounselorMedicineDetailDeleteArray
      ),

      CounselorPreOpInstructionDetail: this.CounselorInstructionDetail.concat(
        this.CounselorInstructionDetailDeleteArray
      ),
    };

    this.ipdService
      .InsertCounselorPreOpDetail(PayLoad)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (data) => {
          button.removeAttribute('disabled');
          this.CounspreopDisable = true;
          if (data.statusCode == 1) {
            console.log(this.selectCouncelorId)
            this.getCounselorPreOpDetail(this.selectCouncelorId);
            this.clearDeletearray();
            this.dashboardService.openSnackBar(
              "Record Saved Successfully",
              "OK"
            );
          }
        },
        (err) => {
          button.removeAttribute('disabled');
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          }
          else if (err.error.statusCode == 422) {
            this.dashboardService.openSnackBar(err.error.message, "OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }
  clearAllcounselorPreOpdetail() {
    this.CounselorInvestigationDeleteArray = this.CounselorInvestigation.filter(item => item.pK_TranId > 0).map(item => { item.isDelete = true; item.isEdit = true; return item; });
    this.CounselorMedicineDetailDeleteArray = this.CounselorMedicineDetail.filter(item => item.pK_TranId > 0).map(item => { item.isDelete = true; item.isEdit = true; return item; });;
    this.CounselorInstructionDetailDeleteArray = this.CounselorInstructionDetail.filter(item => item.pK_TranId > 0).map(item => { item.isDelete = true; item.isEdit = true; return item; });;
    this.CounspreopDisable = true;
    this.CounselorCheckList = [];
    this.CounselorInvestigation = [];
    this.CounselorMedicineDetail = [];
    // this.selectCouncelorId = null;
    this.CounselorInstructionDetail = [];

  }
  clearDeletearray() {
    this.CounselorInvestigationDeleteArray = [];
    this.CounselorMedicineDetailDeleteArray = [];
    this.CounselorInstructionDetailDeleteArray = [];
  }
  checkCounselorInstruction() {
    this.CounspreopDisable = false;
  }
  CounselerCheckdeleteRow(row, index: number) {
    this.CounspreopDisable = false;
    this.CounselorCheckList.splice(index, 1);
    if (row.pK_TranId > 0) {
      this.CounselorCheckDeleteArray.push(row);
      this.CounselorCheckDeleteArray.map((item) => (item.isEdit = true));
      this.CounselorCheckDeleteArray.map((item) => (item.isDelete = true));
    }
  }
  CounselorInvestDeleteRow(row, index: number) {
    this.CounspreopDisable = false;

    this.CounselorInvestigation.splice(index, 1);
    if (row.pK_TranId > 0) {
      this.CounselorInvestigationDeleteArray.push(row);
      this.CounselorInvestigationDeleteArray.map(
        (item) => (item.isEdit = true)
      );
      this.CounselorInvestigationDeleteArray.map(
        (item) => (item.isDelete = true)
      );
    }
  }
  CounselorMedicineDeleteRow(row, index: number) {
    this.CounspreopDisable = false;

    this.CounselorMedicineDetail.splice(index, 1);
    if (row.pK_TranId > 0) {
      this.CounselorMedicineDetailDeleteArray.push(row);
      this.CounselorMedicineDetailDeleteArray.map(
        (item) => (item.isEdit = true)
      );
      this.CounselorMedicineDetailDeleteArray.map(
        (item) => (item.isDelete = true)
      );
    }
  }
  CounselorInstructionDeleteRow(row, index: number) {
    this.CounspreopDisable = false;

    this.CounselorInstructionDetail.splice(index, 1);
    if (row.pK_TranId > 0) {
      this.CounselorInstructionDetailDeleteArray.push(row);
      this.CounselorInstructionDetailDeleteArray.map(
        (item) => (item.isEdit = true)
      );
      this.CounselorInstructionDetailDeleteArray.map(
        (item) => (item.isDelete = true)
      );
    }
  }

  onSitechangeIns(e: any, index: number, idcheck) {
    this.CounspreopDisable = false;
    if (e != null) {
      this.CounselorInvestigation[index].eye = e;
      this.CounselorInvestigation[index].isEdit = idcheck > 0 ? true : false;
      this.CounselorInvestigation[index].isDelete = false;
    }
  }
  commentChange(e: any, index: number, idcheck) {
    this.CounspreopDisable = false;

    if (e != null) {
      this.CounselorInvestigation[index].result = e;
      this.CounselorInvestigation[index].isEdit = idcheck > 0 ? true : false;
      this.CounselorInvestigation[index].isDelete = false;
    }
  }
  onQtychangeCOuns(e: any, index: number, idcheck) {
    this.CounspreopDisable = false;
    if (e != null) {
      this.CounselorMedicineDetail[index].qty = e;
      this.CounselorMedicineDetail[index].isEdit = idcheck > 0 ? true : false;
      this.CounselorMedicineDetail[index].isDelete = false;
    }
  }
  onDosechangeCOuns(e: any, index: number, idcheck) {
    this.CounspreopDisable = false;
    if (e != null) {
      let doseid = this.dosedataArray.filter((item) => item.dosageCode == e);
      this.CounselorMedicineDetail[index].fK_DosageId = doseid[0].pK_DosageId;
      this.CounselorMedicineDetail[index].dosageCode = e;
      this.CounselorMedicineDetail[index].isEdit = idcheck > 0 ? true : false;
      this.CounselorMedicineDetail[index].isDelete = false;
    }
  }
  ondaysChangeCOuns(e: any, index: number, idcheck) {
    this.CounspreopDisable = false;
    if (e != null) {
      this.CounselorMedicineDetail[index].days = e;
      this.CounselorMedicineDetail[index].isEdit = idcheck > 0 ? true : false;
      this.CounselorMedicineDetail[index].isDelete = false;
    }
  }
  onUnitchangeCOuns(e: any, index: number, idcheck) {
    this.CounspreopDisable = false;
    if (e != null) {
      this.CounselorMedicineDetail[index].unit = e;
      this.CounselorMedicineDetail[index].isEdit = idcheck > 0 ? true : false;
      this.CounselorMedicineDetail[index].isDelete = false;
    }
  }
  onremarkschangeCOuns(e: any, index: number, idcheck) {
    this.CounspreopDisable = false;
    if (e != null) {
      this.CounselorMedicineDetail[index].remarks = e;
      this.CounselorMedicineDetail[index].isEdit = idcheck > 0 ? true : false;
      this.CounselorMedicineDetail[index].isDelete = false;
    }
  }
  onSitechangeCOuns(e: any, index: number, idcheck) {
    this.CounspreopDisable = false;
    if (e != null) {
      this.CounselorMedicineDetail[index].eye = e;
      this.CounselorMedicineDetail[index].isEdit = idcheck > 0 ? true : false;
      this.CounselorMedicineDetail[index].isDelete = false;
    }
  }
  onQtychangeTemp(e: any, index: number, idcheck) {
    this.templateMasterDisable = false;
    if (e != null) {
      this.MediciantemplateMaster[index].qty = e;
      this.MediciantemplateMaster[index].isEdit = idcheck > 0 ? true : false;
      this.MediciantemplateMaster[index].isDelete = false;
    }
  }
  onDosechangeTemp(e: any, index: number, idcheck) {
    this.templateMasterDisable = false;
    if (e != null) {
      let doseid = this.dosedataArray.filter((item) => item.dosageCode == e);
      this.MediciantemplateMaster[index].fK_DosageId = doseid[0].pK_DosageId;
      this.MediciantemplateMaster[index].dosageCode = e;
      this.MediciantemplateMaster[index].isEdit = idcheck > 0 ? true : false;
      this.MediciantemplateMaster[index].isDelete = false;
    }
  }
  ondaysChangeTemp(e: any, index: number, idcheck) {
    this.templateMasterDisable = false;
    if (e != null) {
      this.MediciantemplateMaster[index].days = e;
      this.MediciantemplateMaster[index].isEdit = idcheck > 0 ? true : false;
      this.MediciantemplateMaster[index].isDelete = false;
    }
  }
  onUnitchangeTemp(e: any, index: number, idcheck) {
    this.templateMasterDisable = false;
    if (e != null) {
      this.MediciantemplateMaster[index].unit = e;
      this.MediciantemplateMaster[index].isEdit = idcheck > 0 ? true : false;
      this.MediciantemplateMaster[index].isDelete = false;
    }
  }
  onremarkschangeTemp(e: any, index: number, idcheck) {
    this.templateMasterDisable = false;
    if (e != null) {
      this.MediciantemplateMaster[index].remakrs = e;
      this.MediciantemplateMaster[index].isEdit = idcheck > 0 ? true : false;
      this.MediciantemplateMaster[index].isDelete = false;
    }
  }
  medicineTypeTemp(e: any, index: number, idcheck) {
    this.templateMasterDisable = false;
    if (e != null) {
      this.MediciantemplateMaster[index].medicineType = e;
      this.MediciantemplateMaster[index].isEdit = idcheck > 0 ? true : false;
      this.MediciantemplateMaster[index].isDelete = false;
    }
  }
  selectPreOpDetail(row, i) {
    this.CounspreopDisable = false;

    this.SelectListRecord = row;
    this.indexdataCons = this.SelectListRecord.pK_TranId;

    this.CounselorCheckList[i] = this.SelectListRecord;
  }
  getPreOpDetailvalue(value) {
    this.CounspreopDisable = false;

    // var i = this.indexdataCons;

    // if (this.CounselorCheckList.find(o => o.pK_TranId === i)) {
    //   this.CounselorCheckList.find(o => o.pK_TranId === i).actualValue = value;

    // }
    // this.indexdataCons++;
    this.CounselorCheckList.map((item) => (item.actualValue = value));
    this.CounselorCheckList.map((item) => (item.isEdit = true));
    const checkYesvalue = this.CounselorCheckList.filter(
      (item) => item.actualValue.toLocaleLowerCase() == "yes"
    );
    const checkNovalue = this.CounselorCheckList.filter(
      (item) => item.actualValue.toLocaleLowerCase() == "no"
    );
    const checkNonevalue = this.CounselorCheckList.filter(
      (item) => item.actualValue.toLocaleLowerCase() == "none"
    );
    if (this.CounselorCheckList.length == checkYesvalue.length) {
      this.PDcheckedyes = true;
      this.PDcheckedno = false;
      this.PDcheckednone = false;
    } else if (this.CounselorCheckList.length == checkNovalue.length) {
      this.PDcheckedyes = false;
      this.PDcheckedno = true;
      this.PDcheckednone = false;
    } else if (this.CounselorCheckList.length == checkNonevalue.length) {
      this.PDcheckedyes = false;
      this.PDcheckedno = false;
      this.PDcheckednone = true;
    } else {
      this.PDcheckedyes = false;
      this.PDcheckedno = false;
      this.PDcheckednone = false;
    }
  }
  getPreDetailSelectvalue(event, i) {
    this.CounselorCheckList[i].isEdit =
      this.CounselorCheckList[i].pK_TranId > 0 ? true : false;
    this.CounselorCheckList[i].actualValue = event.value;
    const checkYesvalue = this.CounselorCheckList.filter(
      (item) => item.actualValue.toLocaleLowerCase() == "yes"
    );
    const checkNovalue = this.CounselorCheckList.filter(
      (item) => item.actualValue.toLocaleLowerCase() == "no"
    );
    const checkNonevalue = this.CounselorCheckList.filter(
      (item) => item.actualValue.toLocaleLowerCase() == "none"
    );
    if (this.CounselorCheckList.length == checkYesvalue.length) {
      this.PDcheckedyes = true;
      this.PDcheckedno = false;
      this.PDcheckednone = false;
    } else if (this.CounselorCheckList.length == checkNovalue.length) {
      this.PDcheckedyes = false;
      this.PDcheckedno = true;
      this.PDcheckednone = false;
    } else if (this.CounselorCheckList.length == checkNonevalue.length) {
      this.PDcheckedyes = false;
      this.PDcheckedno = false;
      this.PDcheckednone = true;
    } else {
      this.PDcheckedyes = false;
      this.PDcheckedno = false;
      this.PDcheckednone = false;
    }
  }
  PreDetailcheckstatus(option, i) {
    if (this.CounselorCheckList[i].actualValue != null) {
      return (
        this.CounselorCheckList[i].actualValue.toLocaleLowerCase() ==
        option.toLocaleLowerCase()
      );
    } else {
      return false;
    }
  }
  PreopAssesmentRecordModelobj: PreopAssesmentRecordModel = {};
  PreopAssesmentRecordindication: boolean = false;
  GetPreOpAssesmentRecord(regid, ipdid) {
    this.ipdService
      .GetPreOpAssesmentRecordByRegIdByIPDId(regid, ipdid)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (x: any) => {
          this.PreopAssesmentRecordModelobj = {};
          if (x.length > 0) {
            this.PreopAssesmentRecordindication = true;
            this.PreopAssesmentRecordModelobj = x[0];
            this.PreopAssesmentRecordModelobj.isEdit = true;

            this.GetPreOpAssesmentDetailByMaster(
              "HISTORY",
              this.RegId,
              this.selectIpdId
            );
            this.GetPreOpAssesmentDetailByPhysical(
              "PHYSICAL EXAMINATION",
              this.RegId,
              this.selectIpdId
            );
            this.GetPreOpAssesmentDetailByLab(
              "LAB",
              this.RegId,
              this.selectIpdId
            );
            this.GetPreOpAssesmentDetailByDIAGNOSTIC(
              "DIAGNOSTIC",
              this.RegId,
              this.selectIpdId
            );
          } else {
            this.PreopAssesmentRecordModelobj.pK_TranID = 0;
            this.PreopAssesmentRecordModelobj.fK_IPDID = this.selectIpdId;
            this.PreopAssesmentRecordModelobj.fK_REGID = this.RegId;
            this.PreopAssesmentRecordModelobj.isEdit = false;
            this.GetPreOpAssesmentDetailBytype("HISTORY");
            this.GetPreOpAssesmentPhysical("PHYSICAL EXAMINATION");
            this.GetPreOpAssesmentLab("LAB");
            this.GetPreOpAssesmentDiagnosis("DIAGNOSTIC");
          }
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar(
              "You Don't have Permission",
              "OK"
            );
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }
  getpreopAssesmentHistory: GetPreOpAssesmentDetailHistroy[] = [];
  GetPreOpAssesmentDetailByMaster(type, regid, ipdid) {
    this.ipdService
      .GetPreOpAssesmentDetailByMaster(type, regid, ipdid)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (x: any) => {
          this.getpreopAssesmentHistory = [];
          if (x.length > 0) {
            this.getpreopAssesmentHistory = x;
            this.getpreopAssesmentHistory.map((item) => (item.isEdit = true));
            this.getpreopAssesmentHistory.map((item) => (item.isHighLight = 0));
          } else {
            this.GetPreOpAssesmentDetailBytype(type);
          }
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar(
              "You Don't have Permission",
              "OK"
            );
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }
  GetPreOpAssesmentDetailBytype(type) {
    this.ipdService
      .GetPreOpAssesmentMasterByMasterType(type)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (x: any) => {
          this.getpreopAssesmentHistory = [];
          if (x.length > 0) {
            x.forEach((element) => {
              this.getpreopAssesmentHistory.push({
                pK_TranID: 0,
                fK_IPDID: this.selectIpdId,
                masterType: element.masterType,
                seqNo: element.seqNo,
                fieldName: element.fieldName,
                resultValue: element.defaultValue,
                fK_REGID: this.RegId,
                isHighLight: element.isHighLight,
                isEdit: false,
              });
            });
          }
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar(
              "You Don't have Permission",
              "OK"
            );
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }
  getpreopAssesmentPhysical: GetPreOpAssesmentDetailHistroy[] = [];
  GetPreOpAssesmentDetailByPhysical(type, regid, ipdid) {
    this.ipdService
      .GetPreOpAssesmentDetailByMaster(type, regid, ipdid)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (x: any) => {
          this.getpreopAssesmentPhysical = [];
          if (x.length > 0) {
            this.getpreopAssesmentPhysical = x;
            this.getpreopAssesmentPhysical.map((item) => (item.isEdit = true));
            this.getpreopAssesmentPhysical.map(
              (item) => (item.isHighLight = 0)
            );
          } else {
            this.GetPreOpAssesmentPhysical(type);
          }
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar(
              "You Don't have Permission",
              "OK"
            );
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }
  GetPreOpAssesmentPhysical(type) {
    this.ipdService
      .GetPreOpAssesmentMasterByMasterType(type)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (x: any) => {
          this.getpreopAssesmentPhysical = [];
          if (x.length > 0) {
            x.forEach((element) => {
              this.getpreopAssesmentPhysical.push({
                pK_TranID: 0,
                fK_IPDID: this.selectIpdId,
                masterType: element.masterType,
                seqNo: element.seqNo,
                fieldName: element.fieldName,
                resultValue: element.defaultValue,
                fK_REGID: this.RegId,
                isHighLight: element.isHighLight,
                isEdit: false,
              });
            });
          }
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar(
              "You Don't have Permission",
              "OK"
            );
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }

  getpreopAssesmentLab: GetPreOpAssesmentDetailHistroy[] = [];
  GetPreOpAssesmentDetailByLab(type, regid, ipdid) {
    this.ipdService
      .GetPreOpAssesmentDetailByMaster(type, regid, ipdid)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (x: any) => {
          this.getpreopAssesmentLab = [];
          if (x.length > 0) {
            this.getpreopAssesmentLab = x;
            this.getpreopAssesmentLab.map((item) => (item.isEdit = true));
            this.getpreopAssesmentLab.map((item) => (item.isHighLight = 0));
          } else {
            this.GetPreOpAssesmentLab(type);
          }
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar(
              "You Don't have Permission",
              "OK"
            );
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }
  GetPreOpAssesmentLab(type) {
    this.ipdService
      .GetPreOpAssesmentMasterByMasterType(type)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (x: any) => {
          this.getpreopAssesmentLab = [];
          if (x.length > 0) {
            x.forEach((element) => {
              this.getpreopAssesmentLab.push({
                pK_TranID: 0,
                fK_IPDID: this.selectIpdId,
                masterType: element.masterType,
                seqNo: element.seqNo,
                fieldName: element.fieldName,
                resultValue: element.defaultValue,
                fK_REGID: this.RegId,
                isHighLight: element.isHighLight,
                isEdit: false,
              });
            });
          }
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar(
              "You Don't have Permission",
              "OK"
            );
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }

  getpreopAssesmentDiagnosis: GetPreOpAssesmentDetailHistroy[] = [];
  GetPreOpAssesmentDetailByDIAGNOSTIC(type, regid, ipdid) {
    this.ipdService
      .GetPreOpAssesmentDetailByMaster(type, regid, ipdid)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (x: any) => {
          this.getpreopAssesmentDiagnosis = [];
          if (x.length > 0) {
            this.getpreopAssesmentDiagnosis = x;
            this.getpreopAssesmentDiagnosis.map((item) => (item.isEdit = true));
            this.getpreopAssesmentDiagnosis.map(
              (item) => (item.isHighLight = 0)
            );
          } else {
            this.GetPreOpAssesmentDiagnosis(type);
          }
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar(
              "You Don't have Permission",
              "OK"
            );
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }
  GetPreOpAssesmentDiagnosis(type) {
    this.ipdService
      .GetPreOpAssesmentMasterByMasterType(type)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (x: any) => {
          this.getpreopAssesmentDiagnosis = [];
          if (x.length > 0) {
            x.forEach((element) => {
              this.getpreopAssesmentDiagnosis.push({
                pK_TranID: 0,
                fK_IPDID: this.selectIpdId,
                masterType: element.masterType,
                seqNo: element.seqNo,
                fieldName: element.fieldName,
                resultValue: element.defaultValue,
                fK_REGID: this.RegId,
                isHighLight: element.isHighLight,
                isEdit: false,
              });
            });
          }
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar(
              "You Don't have Permission",
              "OK"
            );
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }

  //insert record
  InsertPreOpAssesmentRecord() {
    let payload = {
      PreOpAssesmentRecord: this.PreopAssesmentRecordModelobj,
      PreOpAssesmentRecordHistory: this.getpreopAssesmentHistory,
      PreOpAssesmentRecordPhysicalExamination: this.getpreopAssesmentPhysical,
      PreOpAssesmentRecordLAB: this.getpreopAssesmentLab,
      PreOpAssesmentRecordDiagnostic: this.getpreopAssesmentDiagnosis,
    };
    this.ipdService
      .InsertPreOpAssesmentRecord(payload)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (x: any) => {
          this.GetPreOpAssesmentRecord(this.RegId, this.selectIpdId);
          if (this.PreopAssesmentRecordModelobj.pK_TranID > 0) {
            this.dashboardService.openSnackBar(
              "Record Updated Successfully",
              "ok"
            );
          } else {
            this.dashboardService.openSnackBar(
              "Record Saved Successfully",
              "ok"
            );
          }
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          }
          else if (err.error.statusCode == 422) {
            this.dashboardService.openSnackBar(err.error.message, "OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }
  histroyDisease(event, index) {
    this.getpreopAssesmentHistory[index].resultValue = event.target.value
      ? event.target.value
      : null;
  }
  histroyPhysical(event, index) {
    this.getpreopAssesmentPhysical[index].resultValue = event.target.value
      ? event.target.value
      : null;
  }
  histroyLab(event, index) {
    this.getpreopAssesmentLab[index].resultValue = event.target.value
      ? event.target.value
      : null;
  }
  histroyDiagnosis(event, index) {
    this.getpreopAssesmentDiagnosis[index].resultValue = event.target.value
      ? event.target.value
      : null;
  }

  AnestheticRecordModelobj: AnestheticRecordModel = {};
  GetAnestheticRecordByIPDId(ipdid) {
    this.ipdService
      .GetAnestheticRecordByIPDId(ipdid)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (item: any) => {
          this.AnestheticRecordModelobj = {};
          if (item.length > 0) {
            this.AnestheticRecordModelobj = item[0];
            this.AnestheticRecordModelobj.isEdit = true;
            this.PreopAssesmentRecordindication = true;
            if (
              this.AnestheticRecordModelobj.nilOrallyTime != null &&
              this.AnestheticRecordModelobj.nilOrallyTime != "00:00:00"
            ) {
              this.AnestheticRecordModelobj.nilOrallyTime = moment(
                this.AnestheticRecordModelobj.nilOrallyTime,
                ["HH:mm"]
              ).format("h:mm A");
            } else {
              this.AnestheticRecordModelobj.nilOrallyTime = moment(
                this.authService.localDate
              ).format("h:mm A");
            }
            this.AnestheticRecordModelobj.nilOrallyDt = this.datePipe.transform(
              this.AnestheticRecordModelobj.nilOrallyDt,
              "yyyy-MM-dd"
            );
            this.GetAnestheticVitalDetailByIPDId(ipdid);
          } else {
            this.AnestheticVisitDetailModeldata = [];
            this.clearAnthersiarecord();
          }
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          }
          else if (err.error.statusCode == 422) {
            this.dashboardService.openSnackBar(err.error.message, "OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }
  clearAnthersiarecord() {
    this.AnestheticRecordModelobj = {
      pK_AnesthesiaId: 0,
      fK_IPDID: this.selectIpdId,
      preAnasChUp: null,
      preMedication: null,
      nilOrallyTime: moment(this.authService.localDate).format("h:mm A"),
      nilOrallyDt: this.datePipe.transform(
        this.authService.localDate,
        "yyyy-MM-dd"
      ),
      induction: null,
      maintenance: null,
      reversal: null,
      preOpRemark: null,
      pollar: null,
      ictras: null,
      clubbing: null,
      cynosis: null,
      lymphadenopathy: null,
      edesma: null,
      jvp: null,
      dentitation: null,
      mouthOpening: null,
      neckMove: null,
      mpc: null,
      obesity: null,
      asa: null,
      anasPlaned: null,
      nbm: 0,
      preopSpo2: null,
      resVerbal: "",
      responceToTechStimuls: null,
      patientShift: null,
      postOpMedication: null,
      pOstopRemarks: null,
      murmurs: null,
      addsounds: null,
      rs: null,
      breathsounds: null,
      s1: null,
      s2: null,
      s3: null,
      s4: null,
      adventitious: null,
      concious: null,
      cns: null,
      gis: null,
      colonpolyps: null,
      consistency: null,
      spleen: null,
      liver: null,
      bowelsound: null,
      others: null,
      adverseEvent: null,
      aldretteScore: null,
      postopSpo2: null,
      fK_DoctorID: null,
      monitoring: null,
      complications: null,
      isEdit: false,
    };
  }
  AnestheticVisitDetailModeldata: AnestheticVisitDetailModel[] = [];
  GetAnestheticVitalDetailByIPDId(ipdid) {
    this.ipdService
      .GetAnestheticVitalDetailByIPDId(ipdid)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (item: any) => {
          this.AnestheticVisitDetailModeldata = [];
          if (item.length > 0) {
            this.AnestheticVisitDetailModeldata = item;
            this.AnestheticVisitDetailModeldata.map(
              (e) => (e.fK_ModifiedById = this.authService.Loggeduser.userid)
            );
            this.AnestheticVisitDetailModeldata.map(
              (e) => (e.modifiedBy = this.authService.Loggeduser.username)
            );
            this.AnestheticVisitDetailModeldata.map(
              (e) =>
              (e.modifiedDatetime = this.datePipe.transform(
                new Date(),
                "yyyy-MM-dd HH:mm:ss"
              ))
            );
          }
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar(
              "You Don't have Permission",
              "OK"
            );
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }
  vitalRecordModal() {
    let obj = {
      pK_VitalDetailId: 0,
      fK_IPDId: this.selectIpdId,
      nDate: this.datePipe.transform(new Date(), "yyyy-MM-dd HH:mm:ss"),
      nTime: this.datePipe.transform(new Date(), "yyyy-MM-dd HH:mm:ss"),
      nTemp: null,
      pulse: null,
      rr: null,
      bps: null,
      bpd: null,
      spO2: null,
      weight: null,
      nInPut: null,
      nInPutSpc: null,
      nOutPut: null,
      nOutPutSpc: null,
      fK_CreatedById: this.authService.Loggeduser.userid,
      modifiedDatetime: null,
      mTime: null,
      createdBy: this.authService.Loggeduser.username,
      modifiedBy: null,
      fK_ModifiedById: null,
      isEdit: false,
    };
    this.AnestheticVisitDetailModeldata.push(obj);
  }
  onTempTypechange1(e, index, id) {
    if (e != null && e <= 110) {
      this.AnestheticVisitDetailModeldata[index].nTemp = e;
      this.AnestheticVisitDetailModeldata[index].isEdit = id > 0 ? true : false;
    } else {
      this.AnestheticVisitDetailModeldata[index].nTemp = null;
      this.AnestheticVisitDetailModeldata[index].isEdit = id > 0 ? true : false;
    }
  }
  onpulseTypechange1(e, index, id) {
    if (e != null && e <= 200) {
      this.AnestheticVisitDetailModeldata[index].pulse = e;
      this.AnestheticVisitDetailModeldata[index].isEdit = id > 0 ? true : false;
    } else {
      this.AnestheticVisitDetailModeldata[index].pulse = null;
      this.AnestheticVisitDetailModeldata[index].isEdit = id > 0 ? true : false;
    }
  }
  onrrTypechange1(e, index, id) {
    if (e != null && e <= 100) {
      this.AnestheticVisitDetailModeldata[index].rr = e;
      this.AnestheticVisitDetailModeldata[index].isEdit = id > 0 ? true : false;
    } else {
      this.AnestheticVisitDetailModeldata[index].rr = null;
      this.AnestheticVisitDetailModeldata[index].isEdit = id > 0 ? true : false;
    }
  }
  onbpsTypechange1(e, index, id) {
    if (e != null && e <= 200) {
      this.AnestheticVisitDetailModeldata[index].bps = e;
      this.AnestheticVisitDetailModeldata[index].isEdit = id > 0 ? true : false;
    } else {
      this.AnestheticVisitDetailModeldata[index].bps = null;
      this.AnestheticVisitDetailModeldata[index].isEdit = id > 0 ? true : false;
    }
  }
  onspO2Typechange1(e, index, id) {
    if (e != null && e <= 100) {
      this.AnestheticVisitDetailModeldata[index].spO2 = e;
      this.AnestheticVisitDetailModeldata[index].isEdit = id > 0 ? true : false;
    } else {
      this.AnestheticVisitDetailModeldata[index].spO2 = null;
      this.AnestheticVisitDetailModeldata[index].isEdit = id > 0 ? true : false;
    }
  }
  onbpdTypechange1(e, index, id) {
    if (e != null && e <= 200) {
      this.AnestheticVisitDetailModeldata[index].bpd = e;
      this.AnestheticVisitDetailModeldata[index].isEdit = id > 0 ? true : false;
    } else {
      this.AnestheticVisitDetailModeldata[index].bpd = null;
      this.AnestheticVisitDetailModeldata[index].isEdit = id > 0 ? true : false;
    }
  }
  onnInPutTypechange1(e, index, id) {
    if (e != null) {
      this.AnestheticVisitDetailModeldata[index].nInPut = e;
      this.AnestheticVisitDetailModeldata[index].isEdit = id > 0 ? true : false;
    } else {
      this.AnestheticVisitDetailModeldata[index].nInPut = null;
      this.AnestheticVisitDetailModeldata[index].isEdit = id > 0 ? true : false;
    }
  }
  onweightTypechange1(e, index, id) {
    if (e != null && e <= 500) {
      this.AnestheticVisitDetailModeldata[index].weight = e;
      this.AnestheticVisitDetailModeldata[index].isEdit = id > 0 ? true : false;
    } else {
      this.AnestheticVisitDetailModeldata[index].weight = null;
      this.AnestheticVisitDetailModeldata[index].isEdit = id > 0 ? true : false;
    }
  }
  onnInPutnInPutSpc(e, index, id) {
    if (e != null) {
      this.AnestheticVisitDetailModeldata[index].nInPutSpc = e;
      this.AnestheticVisitDetailModeldata[index].isEdit = id > 0 ? true : false;
    } else {
      this.AnestheticVisitDetailModeldata[index].nInPutSpc = null;
      this.AnestheticVisitDetailModeldata[index].isEdit = id > 0 ? true : false;
    }
  }
  onnInPutnOutPut(e, index, id) {
    if (e != null) {
      this.AnestheticVisitDetailModeldata[index].nOutPut = e;
      this.AnestheticVisitDetailModeldata[index].isEdit = id > 0 ? true : false;
    } else {
      this.AnestheticVisitDetailModeldata[index].nOutPut = null;
      this.AnestheticVisitDetailModeldata[index].isEdit = id > 0 ? true : false;
    }
  }
  onnInnOutPutSpc(e, index, id) {
    if (e != null) {
      this.AnestheticVisitDetailModeldata[index].nOutPutSpc = e;
      this.AnestheticVisitDetailModeldata[index].isEdit = id > 0 ? true : false;
    } else {
      this.AnestheticVisitDetailModeldata[index].nOutPutSpc = null;
      this.AnestheticVisitDetailModeldata[index].isEdit = id > 0 ? true : false;
    }
  }
  onnInPutscoreValue1(e, index, id, type) {
    if (e != "-") {
      if (type == true) {
        if (parseInt(e) <= 2) {
          this.RecoveryScoreMasterArray[index].scoreValue1 = e
            ? parseInt(e)
            : null;
          this.lastindexAdd(1);
        } else {
          this.RecoveryScoreMasterArray[index].scoreValue1 = 2;
          this.lastindexAdd(1);
          this.dashboardService.openSnackBar(
            "You can't make score more than 2",
            "ok"
          );
        }
      } else {
        this.RecoveryScoreMasterArray[index].scoreValue1 = e ? e : null;
      }
    }
  }

  onnInPutscoreValue2(e, index, id, type) {
    if (e != "-") {
      if (type == true) {
        if (parseInt(e) <= 2) {
          this.RecoveryScoreMasterArray[index].scoreValue2 = e
            ? parseInt(e)
            : null;
          this.lastindexAdd(2);
        } else {
          this.RecoveryScoreMasterArray[index].scoreValue2 = 2;
          this.lastindexAdd(2);
          this.dashboardService.openSnackBar(
            "You can't make score more than 2",
            "ok"
          );
        }
      } else {
        this.RecoveryScoreMasterArray[index].scoreValue2 = e ? e : null;
      }
    }
  }
  onnInPutscoreValue3(e, index, id, type) {
    if (e != "-") {
      if (type == true) {
        if (parseInt(e) <= 2) {
          this.RecoveryScoreMasterArray[index].scoreValue3 = e
            ? parseInt(e)
            : null;
          this.lastindexAdd(3);
        } else {
          this.RecoveryScoreMasterArray[index].scoreValue3 = 2;
          this.lastindexAdd(3);
          this.dashboardService.openSnackBar(
            "You can't make score more than 2",
            "ok"
          );
        }
      } else {
        this.RecoveryScoreMasterArray[index].scoreValue3 = e ? e : null;
      }
    }
  }
  onnInPutscoreValue4(e, index, id, type) {
    if (e != "-") {
      if (type == true) {
        if (parseInt(e) <= 2) {
          this.RecoveryScoreMasterArray[index].scoreValue4 = e
            ? parseInt(e)
            : null;
          this.lastindexAdd(4);
        } else {
          this.RecoveryScoreMasterArray[index].scoreValue4 = 2;
          this.lastindexAdd(4);
          this.dashboardService.openSnackBar(
            "You can't make score more than 2",
            "ok"
          );
        }
      } else {
        this.RecoveryScoreMasterArray[index].scoreValue4 = e ? e : null;
      }
    }
  }
  onnInPutscoreValue5(e, index, id, type) {
    if (e != "-") {
      if (type == true) {
        if (parseInt(e) <= 2) {
          this.RecoveryScoreMasterArray[index].scoreValue5 = e
            ? parseInt(e)
            : null;
          this.lastindexAdd(5);
        } else {
          this.RecoveryScoreMasterArray[index].scoreValue5 = 2;
          this.lastindexAdd(5);
          this.dashboardService.openSnackBar(
            "You can't make score more than 2",
            "ok"
          );
        }
      } else {
        this.RecoveryScoreMasterArray[index].scoreValue5 = e ? e : null;
      }
    }
  }
  onnInPutscoreValue6(e, index, id, type) {
    if (e != "-") {
      if (type == true) {
        if (parseInt(e) <= 2) {
          this.RecoveryScoreMasterArray[index].scoreValue6 = e
            ? parseInt(e)
            : null;
          this.lastindexAdd(6);
        } else {
          this.RecoveryScoreMasterArray[index].scoreValue6 = 2;
          this.lastindexAdd(6);
          this.dashboardService.openSnackBar(
            "You can't make score more than 2",
            "ok"
          );
        }
      } else {
        this.RecoveryScoreMasterArray[index].scoreValue6 = e ? e : null;
      }
    }
  }
  lastindexAdd(type) {
    var countvalue = 0;
    if (type == 1) {
      const Nedata = this.RecoveryScoreMasterArray;
      const newdata = Nedata.slice(0, -1);
      const newdata1 = newdata.filter(
        (item) => item.isScore == true && item.scoreValue1 != null
      );
      if (newdata1.length > 0) {
        newdata1.forEach((e) => {
          countvalue = countvalue + parseInt(e.scoreValue1);
        });
        this.RecoveryScoreMasterArray[
          this.RecoveryScoreMasterArray.length - 1
        ].scoreValue1 = countvalue;
      } else {
        this.RecoveryScoreMasterArray[
          this.RecoveryScoreMasterArray.length - 1
        ].scoreValue1 = 0;
      }
    } else if (type == 2) {
      const Nedata = this.RecoveryScoreMasterArray;
      const newdata = Nedata.slice(0, -1);
      const newdata1 = newdata.filter(
        (item) => item.isScore == true && item.scoreValue2 != null
      );
      if (newdata1.length > 0) {
        newdata1.forEach((e) => {
          countvalue = countvalue + parseInt(e.scoreValue2);
        });
        this.RecoveryScoreMasterArray[
          this.RecoveryScoreMasterArray.length - 1
        ].scoreValue2 = countvalue;
      } else {
        this.RecoveryScoreMasterArray[
          this.RecoveryScoreMasterArray.length - 1
        ].scoreValue2 = 0;
      }
    } else if (type == 3) {
      const Nedata = this.RecoveryScoreMasterArray;
      const newdata = Nedata.slice(0, -1);
      const newdata1 = newdata.filter(
        (item) => item.isScore == true && item.scoreValue3 != null
      );
      if (newdata1.length > 0) {
        newdata1.forEach((e) => {
          countvalue = countvalue + parseInt(e.scoreValue3);
        });
        this.RecoveryScoreMasterArray[
          this.RecoveryScoreMasterArray.length - 1
        ].scoreValue3 = countvalue;
      } else {
        this.RecoveryScoreMasterArray[
          this.RecoveryScoreMasterArray.length - 1
        ].scoreValue3 = 0;
      }
    } else if (type == 4) {
      const Nedata = this.RecoveryScoreMasterArray;
      const newdata = Nedata.slice(0, -1);
      const newdata1 = newdata.filter(
        (item) => item.isScore == true && item.scoreValue4 != null
      );
      if (newdata1.length > 0) {
        newdata1.forEach((e) => {
          countvalue = countvalue + parseInt(e.scoreValue4);
        });
        this.RecoveryScoreMasterArray[
          this.RecoveryScoreMasterArray.length - 1
        ].scoreValue4 = countvalue;
      } else {
        this.RecoveryScoreMasterArray[
          this.RecoveryScoreMasterArray.length - 1
        ].scoreValue4 = 0;
      }
    } else if (type == 5) {
      const Nedata = this.RecoveryScoreMasterArray;
      const newdata = Nedata.slice(0, -1);
      const newdata1 = newdata.filter(
        (item) => item.isScore == true && item.scoreValue5 != null
      );
      if (newdata1.length > 0) {
        newdata1.forEach((e) => {
          countvalue = countvalue + parseInt(e.scoreValue5);
        });
        this.RecoveryScoreMasterArray[
          this.RecoveryScoreMasterArray.length - 1
        ].scoreValue5 = countvalue;
      } else {
        this.RecoveryScoreMasterArray[
          this.RecoveryScoreMasterArray.length - 1
        ].scoreValue5 = 0;
      }
    } else if (type == 6) {
      const Nedata = this.RecoveryScoreMasterArray;
      const newdata = Nedata.slice(0, -1);
      const newdata1 = newdata.filter(
        (item) => item.isScore == true && item.scoreValue6 != null
      );
      if (newdata1.length > 0) {
        newdata1.forEach((e) => {
          countvalue = countvalue + parseInt(e.scoreValue6);
        });
        this.RecoveryScoreMasterArray[
          this.RecoveryScoreMasterArray.length - 1
        ].scoreValue6 = countvalue;
      } else {
        this.RecoveryScoreMasterArray[
          this.RecoveryScoreMasterArray.length - 1
        ].scoreValue6 = 0;
      }
    }
  }
  onnInPutscoreValue7(e, index, id, type) {
    this.RecoveryScoreMasterArray[index].scoreValue7 = e ? parseInt(e) : null;
  }
  SaveAnetesiaRecord() {
    if (this.AnestheticRecordModelobj.nilOrallyTime != null) {
      this.AnestheticRecordModelobj.nilOrallyTime = moment(
        this.AnestheticRecordModelobj.nilOrallyTime,
        ["h:mm A"]
      ).format("HH:mm");
    }
    if (this.AnestheticRecordModelobj.nbm == true) {
      this.AnestheticRecordModelobj.nbm = 1;
    } else if (this.AnestheticRecordModelobj.nbm == false) {
      this.AnestheticRecordModelobj.nbm = 0;
    }
    let payload = {
      AnestheticRecord: this.AnestheticRecordModelobj,
      AnestheticVitalDetail: this.AnestheticVisitDetailModeldata.map((item) => ({
        ...item,
        isEdit: item.pK_VitalDetailId > 0 ? true : false,
      })),
    };

    this.ipdService
      .InsertAnestheticRecord(payload)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (x: any) => {
          this.GetAnestheticRecordByIPDId(this.selectIpdId);
          if (this.AnestheticRecordModelobj.pK_AnesthesiaId > 0) {
            this.dashboardService.openSnackBar(
              "Record Updated Successfully",
              "ok"
            );
          } else {
            this.dashboardService.openSnackBar(
              "Record Saved Successfully",
              "ok"
            );
          }
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          }
          else if (err.error.statusCode == 422) {
            this.dashboardService.openSnackBar(err.error.message, "OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }
  RecoveryScoreMasterArray: RecoveryScoreMaster[] = [];
  GetPostAnesthesiaRecoverybyid(ipdid) {
    this.ipdService
      .AnesthesiaRecoveryScoreDetailByIPDId(ipdid)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (item: any) => {
          this.RecoveryScoreMasterArray = [];
          if (item.length > 0) {
            this.RecoveryScoreMasterArray = item;
            this.RecoveryScoreMasterArray.map((e) => (e.isEdit = true));
            this.PreopAssesmentRecordindication = true;
          } else {
            this.GetPostAnesthesiaRecovery();
          }
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar(
              "You Don't have Permission",
              "OK"
            );
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }
  GetPostAnesthesiaRecovery() {
    this.ipdService
      .GetPostAnesthesiaRecoveryScore()
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (item: any) => {
          this.RecoveryScoreMasterArray = item;
          this.RecoveryScoreMasterArray.map((e) => (e.isEdit = false));
          this.RecoveryScoreMasterArray.map(
            (e) => (e.fK_IPDID = this.selectIpdId)
          );
          this.RecoveryScoreMasterArray.map((e) => (e.pK_TranID = 0));
          this.RecoveryScoreMasterArray.map(
            (e) => (e.fK_CreatedById = this.authService.Loggeduser.userid)
          );
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar(
              "You Don't have Permission",
              "OK"
            );
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }
  InsertPostAnesthesiaData() {
    let payload = {
      PostAnesthesiaRecoveryScoreDetail: this.RecoveryScoreMasterArray,
    };
    this.ipdService
      .InsertPostAnesthesiaRecovery(payload)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (X: any) => {
          this.GetPostAnesthesiaRecoverybyid(this.selectIpdId);
          this.dashboardService.openSnackBar("Record Saved Successfully", "ok");
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          }
          else if (err.error.statusCode == 422) {
            this.dashboardService.openSnackBar(err.error.message, "OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }
  printOTconsent() {
    localStorage.setItem(
      "pateintdetail",
      JSON.stringify(this.opdvisitService.patientdetails)
    );
    localStorage.setItem(
      "branchMasterobj",
      JSON.stringify(this.branchmansterObj)
    );

    localStorage.setItem(
      "site",
      this.surgicalRecordobj.site ? this.surgicalRecordobj.site : ""
    );
    localStorage.setItem(
      "doctor",
      this.surgicalRecordobj.surgeonName
        ? this.surgicalRecordobj.surgeonName
        : ""
    );
    localStorage.setItem(
      "visitDate",
      this.surgicalRecordobj.bookingDate
        ? this.surgicalRecordobj.bookingDate
        : ""
    );
    localStorage.setItem(
      "ProcedureName",
      this.corporateData.surgeryName ? this.corporateData.surgeryName : ""
    );
    localStorage.setItem("pdfURL", this.otconsentUrl);
    window.open(
      window.location.origin + "/print-otconsent".toString(),
      "mypopup",
      "resizable=no, toolbar=no, scrollbars=no, menubar=no, status=no, directories=no, location=no, width=1000, height=600, left=10 top=100"
    );
  }
  apptexportexcel(type): void {
    this.exportdata.open_loader_Dialogtwo();
    if (type == 1) {
      let element = document.getElementById("contentapp");
      this.exportdata.Newexportxcel(element, "Service_List");
    }
  }
  opendesign_workup(): void {
    if (this.checkipdid > 0) {
      this.opdvisitService.patientdetails.pkRegId = this.RegId;
      const dialogRef = this.dialog.open(Image_workupComponent, {
        panelClass: "full-width-dialog",
        maxWidth: "90vw",
        width: "90%",
        maxHeight: "90%",
        disableClose: true,
        data: {
          Doctorid: this.selectCouncelorId,
          visitid: this.selectIpdId,
          folderName: "OTImages",
        },
      });

      dialogRef.afterClosed().subscribe((result) => {
        console.log("The dialog was closed");
      });
    } else {
      this.dashboardService.openSnackBar("Please select Patient", "ok");
    }
  }
  packagedetailArray: any = [];
  oprnPackageDetail(ipdid) {
    this.ipdService
      .GetpackagebyIpdId(ipdid)
      .pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (x: any) => {
          this.packagedetailArray = [];
          this.packagedetailArray = x;
          if (this.packagedetailArray.length > 0) {
            document.getElementById("packageRecordModal").style.display =
              "block";
          } else {
            this.dashboardService.openSnackBar("Package Not Available", "ok");
          }
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar(
              "You Don't have Permission",
              "OK"
            );
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }
  closepackageRecordModal() {
    document.getElementById("packageRecordModal").style.display = "none";
  }

  saletypeControll() {
    this.salesTypeControl = new FormControl();
    this.filteredSalesTypes = this.salesTypeControl.valueChanges.pipe(
      startWith(""),
      map((cat) =>
        cat
          ? this.filtersale(cat)
          : this.salesTypes.slice()
      )
    );

  }

  filtersale(value: any) {
    const len = Object.keys(value).length;
    if (len > 9) {
      return this.salesTypes.filter(
        (sale) => sale.name?.toLowerCase().indexOf(value) === 0
      );
    } else {
      return this.salesTypes.filter(
        (sale) =>
          sale.name?.toLowerCase().indexOf(value?.toLowerCase()) === 0
      );
    }
  }

  showAllSaletype() {
    this.salesTypeControl.setValue(this.salesTypeControl.value || 'Consumption');
    this.filteredSalesTypes = this.salesTypeControl.valueChanges.pipe(
      startWith(""),
      map((value) => this.filtersale(value))
    );
  }

  getsaleobj(e) {
    var val = e.option.value;
    this.storesConsumeMasterArray.salesType = val;
  }

  getdoctorrobj(e) {
    var val = e.option.value;
    this.storesConsumeMasterArray.doctorName = val;
  }

  getlocationobj(e) {
    const selectedloc = e.value;
    const locId = selectedloc.pK_ConsumptionLocationId;
    this.storesConsumeMasterArray.fK_ConsumeLocationID = locId;
  }

  getpayorobj(e) {
    const selectedPayor = e.value;
    const payorId = selectedPayor.pkPartyId;
    this.storesConsumeMasterArray.fK_PartyId = payorId;
  }

  filterStoreData() {
    const filterTextLower = this.filterText.toLowerCase();
    this.filteredStoreData = this.storeData.filter(template =>
      template.itemName.toLowerCase().includes(filterTextLower)
    );
  }
  temId: any = 0;
  item_id: any
  loadTemplateData(temid: any, index) {
    this.temId = temid;
    this.ipdService.getTemdatastore(this.temId).subscribe((res: any) => {
      this.getstoretemData = this.getstoretemData.concat(res);
    })
    document.getElementById("templateModal").style.display = "none";
    this.filterText = '';
  }

  locationdata: any;
  locationControll() {
    this.locationControl = new FormControl();
    this.filteredSLocation = this.locationControl.valueChanges.pipe(
      startWith(""),
      map((cat) =>
        cat
          ? this.filterlocation(cat)
          : this.locationgetData.slice()
      )
    );
  }

  filterlocation(value: any) {
    const len = Object.keys(value).length;
    if (len > 9) {
      return this.locationgetData.filter(
        (loca) => loca.consumptionLocationName?.toLowerCase().indexOf(value) === 0
      );
    } else {
      return this.locationgetData.filter(
        (loca) =>
          loca.consumptionLocationName?.toLowerCase().indexOf(value?.toLowerCase()) === 0
      );
    }
  }

  showAllLocations() {
    this.locationControl.setValue(this.locationControl.value);
    this.filteredSLocation = this.locationControl.valueChanges.pipe(
      startWith(""),
      map((value) => this.filterlocation(value))
    );
  }

  payordata: any
  payorControll() {
    this.payorControl = new FormControl();
    this.filterpayor = this.payorControl.valueChanges.pipe(
      startWith(""),
      map((cat) =>
        cat
          ? this.filterPayor(cat)
          : this.payorNames.slice()
      )
    );
  }

  filterPayor(value: any) {
    const len = Object.keys(value).length;
    if (len > 9) {
      return this.payorNames.filter(
        (pay) => pay.partyName?.toLowerCase().indexOf(value) === 0
      );
    } else {
      return this.payorNames.filter(
        (pay) =>
          pay.partyName?.toLowerCase().indexOf(value?.toLowerCase()) === 0
      );
    }
  }

  showAllpayor() {
    this.payorControl.setValue(this.payorControl.value);
    this.filterpayor = this.payorControl.valueChanges.pipe(
      startWith(""),
      map((value) => this.filterPayor(value))
    );
    this.isDepartmentSelected = false;
  }

  getDeptMaster() {
    this.ipdService.getDepartment(this.authService.Loggeduser.branchid).subscribe((res) => {
      this.getdeparment = res;
      this.depControll();
    })
  }


  depControll() {
    this.departmentControl = new FormControl();
    this.filterdeparment = this.departmentControl.valueChanges.pipe(
      startWith(""),
      map((cat) =>
        cat
          ? this.filterdep(cat)
          : this.getdeparment.slice()
      )
    );
  }


  showAlldep() {

    this.departmentControl.setValue(this.departmentControl.value);
    this.filterdeparment = this.departmentControl.valueChanges.pipe(
      startWith(""),
      map((value) => this.filterdep(value))
    );
  }

  filterdep(value: any) {
    const len = Object.keys(value).length;
    if (len > 9) {
      return this.getdeparment.filter(
        (dep) => dep.deptName?.toLowerCase().indexOf(value) === 0
      );
    } else {
      return this.getdeparment.filter(
        (dep) =>
          dep.deptName?.toLowerCase().indexOf(value?.toLowerCase()) === 0
      );
    }
  }


  filterItems() {
    if (!this.searchQuery) {
      this.filteredItemList = this.searchItemlist;
    } else {
      this.filteredItemList = this.searchItemlist.filter(item =>
        item.itemName.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    }
  }

  filterbarcode() {
    if (!this.searchbarcodeQuery) {
      this.filteredbarcodeList = this.searchbarcodelist;
    } else {
      this.filteredbarcodeList = this.searchbarcodelist.filter(item =>
        item.batchNo.toLowerCase().includes(this.searchbarcodeQuery.toLowerCase())
      );
    }
  }

  filterbatchno() {
    if (!this.searchbatchnoQuery) {
      this.filterbatchcodeList = this.getbatchnoData;
    } else {
      this.filterbatchcodeList = this.getbatchnoData.filter(item =>
        item.batchNo.toLowerCase().includes(this.searchbatchnoQuery.toLowerCase())
      );
    }
  }


  initializeFilteredItemList() {
    this.filteredItemList = this.searchItemlist;
  }
  initializeFilteredbatchnoList() {
    this.filterbatchcodeList = this.getbatchnoData;
  }


  barcodeSearch() {
    if (!this.barcodeQuery.trim()) {
      alert('Please enter a valid barcode!');
      return;
    }


    this.filteredbarcodeList = this.searchbarcodelist.filter(item =>
      item.batchNo.toLowerCase().includes(this.barcodeQuery.toLowerCase())
    );


    if (this.filteredbarcodeList.length > 0) {
      this.barcodeModel();
    } else {
      alert('No matching barcode found');
    }
  }

  deptId: any
  depselect(e) {
    if (e != 0) {
      const selectedDep = e.option.value;
      this.ShowDepName = selectedDep;
    }

    const selectedDepartment = this.getdeparment.find(dep => dep.deptName === this.ShowDepName);
    this.deptId = selectedDepartment?.pkDeptId;

    if (this.deptId) {
      this.isDepartmentSelected = false;
      forkJoin({
        locationMaster: this.ipdService.getComlocationMst(this.authService.Loggeduser.branchid, this.deptId),
        saleType: this.ipdService.get_saletype(),
        storeData: this.ipdService.getStoreData(this.authService.Loggeduser.branchid),
        templateData: this.ipdService.getTemdatastore(this.temId),
        partyData: this.ipdService.get_partytpa(),
        searchItem: this.ipdService.getSearchitem(this.deptId, 0),
        searchBarcode: this.ipdService.getSearchBarcode(this.deptId, 0),
        // storeConsume: this.ipdService.getStoresConsumeMaster(0, this.RegId, this.selectIpdId),

      }).subscribe(
        (results) => {

          this.salesTypes = results.saleType
          this.locationgetData = results.locationMaster
          this.storeData = results.storeData
          this.payorNames = results.partyData
          this.getstoretemData = results.templateData
          // this.getstoreConsume = results.storeConsume

          this.searchItemlist = results.searchItem.map(item => ({
            ...item,
            isSelected: false // Initialize the selection state
          }));
          const defaultOption = this.salesTypes.find(saleType => saleType.name === "Consumption");
          if (defaultOption) {
            this.storesConsumeMasterArray.salesType = defaultOption.name;
            this.salesTypeControl.setValue(defaultOption.name);
          }
          this.searchbarcodelist = results.searchBarcode

          this.initializeFilteredItemList();
          // this.initializeFilteredbarcodeList();
          this.initializeFilteredbatchnoList();
          this.saletypeControll();
          this.locationControll();
          this.payorControll();
          this.showAllSaletype()
        },

        (error) => {
          console.error('Error in API calls:', error);
        }
      );
    } else {
      this.dashboardService.openSnackBar("Please Select Department First", "OK");
    }
  }



  barcodeModel() {
    document.getElementById("BarcodeListDisplay").style.display = "block";
  }
  closebarcodeListDisplay() {
    document.getElementById("BarcodeListDisplay").style.display = "none";
  }
  searchitemModel() {
    if (this.deptId) {
      document.getElementById("searchItemListDisplay").style.display = "block";
    } else {
      this.dashboardService.openSnackBar("Please Select Department First", "OK");
    }
  }

  closeitemListDisplay() {
    document.getElementById("searchItemListDisplay").style.display = "none";
  }
  storind: number = -1
  batchModel(item, index) {
    this.storind = index
    const dynamicItemId = item.fK_ItemId || item.pK_ItemID

    this.ipdService.getCommanBatchno(this.deptId, dynamicItemId, 0).pipe(takeUntil(this.destroyipd$)).subscribe(
      (batchData) => {
        this.getbatchnoData = batchData;
        if (this.getbatchnoData.length > 0) {
          document.getElementById("BatchnoListDisplay").style.display = "block";
        } else {
          this.dashboardService.openSnackBar("No Btach no. Available for this item", "OK");
        }
      },
      (error) => console.error('Error fetching batchnoItem:', error)
    );
  }
  closebatchNoListDisplay() {
    document.getElementById("BatchnoListDisplay").style.display = "none";
  }

  addclosebatchNoListDisplay() {
    document.getElementById("addBatchnoListDisplay").style.display = "none"
  }

  inputbatchModel(item, index) {
    this.storind = index
    const pkitemId = item.pK_ItemID;
    if (pkitemId) {
      this.ipdService.getCommanBatchno(this.deptId, pkitemId, 0).pipe(takeUntil(this.destroyipd$)).subscribe((res) => {
        this.getbatchnoData = res;
        document.getElementById("addBatchnoListDisplay").style.display = "block";
      }, (error) => console.error('Error fetching batchnoItem:', error))
    }
    // if (pkitemId) {
    //   this.ipdService.getBatchitem(this.deptId, pkitemId).pipe(takeUntil(this.destroyipd$)).subscribe(
    //     (batchData) => {
    //       this.getbatchnoData = batchData;
    //       document.getElementById("addBatchnoListDisplay").style.display = "block";
    //       console.log(this.getbatchnoData, 'called batchno with dynamic pkitemId');
    //     },
    //     (error) => console.error('Error fetching batchnoItem:', error)
    //   );
    // }
  }

  selecteditemStockQty: any;
  clearitem: any
  onRowDblClick(item: any) {
    this.selecteditemStockQty = item.totalStockQty;
    item.saleQuantity = 1;
    // this.addedItems.push(item)
    this.addedItems.push({ ...item })
    const pkitemId = item.pK_ItemID;
    if (pkitemId) {
      this.ipdService.getBatchitem(this.deptId, pkitemId).pipe(takeUntil(this.destroyipd$)).subscribe(
        (batchData) => {
          this.getbatchnoData = batchData;
        },
        (error) => console.error('Error fetching batchnoItem:', error)
      );
    }
    document.getElementById("searchItemListDisplay").style.display = "none";
  }

  selectbarcode(item: any) {
    const selectedBatchId = item.pK_BatchID;
    this.selecteditemStockQty = item.totalStockQty;
    this.selectedStockQty = item.stockQty;
    this.ipdService.getCommanBatchno(this.deptId, 0, selectedBatchId).pipe(takeUntil(this.destroyipd$)).subscribe((res) => {
      if (res && res.length > 0) {
        const selectedItem = res.find((element) => element.pK_BatchID === selectedBatchId);
        this.addedItems.push(selectedItem)
        const soterate = (selectedItem.mrp / (100 + selectedItem.vatPercentage)) * 100;
        selectedItem.rate = soterate;
        selectedItem.brate = soterate;
      }
    })
    // this.ipdService.getbatchdetails(this.deptId, selectedBatchId).pipe(takeUntil(this.destroyipd$)).subscribe((res) => {
    //   if (res && res.length > 0) {
    //     const selectedItem = res.find((element) => element.pK_BatchID === selectedBatchId);
    //     this.addedItems.push(selectedItem)
    //   }
    // })
    document.getElementById("BarcodeListDisplay").style.display = "none";
  }

  baseAmount: any;
  selectBatchNoadd(item) {
    this.selectedStockQty = item.stockQty;
    const soterate = (item.mrp / (100 + this.addedItems[this.storind].vatPercentage)) * 100;
    this.addedItems[this.storind].batchNo = item.batchNo
    this.addedItems[this.storind].pK_BatchID = item.pK_BatchID
    this.addedItems[this.storind].expDate = item.expDate
    this.addedItems[this.storind].mrp = item.mrp
    this.addedItems[this.storind].rate = soterate;
    // this.addedItems[this.storind].rate = item.mrp - soterate
    this.addedItems[this.storind].brate = soterate
    //  this.addedItems[this.storind].netAmount = this.calculateNetAmount(this.addedItems[this.storind].discount,this.addedItems[this.storind].saleQuantity,item.mrp)   
    document.getElementById("addBatchnoListDisplay").style.display = "none";
    this.storind = -1
  }


  selectBatchNo(item: any) {
    const soterate = (item.mrp / (100 + this.getstoretemData[this.storind].vatPercentage)) * 100;
    // this.searchbatchnoQuery = item.batchNo; 
    if (this.storind == 0 || this.storind) {
      this.getstoretemData[this.storind].batchNo = item.batchNo
      this.getstoretemData[this.storind].expDate = item.expDate
      this.getstoretemData[this.storind].pK_ItemID = item.pK_ItemID
      this.getstoretemData[this.storind].pK_BatchID = item.pK_BatchID
      this.getstoretemData[this.storind].mrp = item.mrp
      this.getstoretemData[this.storind].rate = soterate
      this.getstoretemData[this.storind].baseRate = soterate
    }

    document.getElementById("BatchnoListDisplay").style.display = "none";
  }

  saleQuantitycal(index, item, type) {
    this.addedItems[index].netAmount = this.addedItems[index].mrp * item
    this.addedItems[index].amount = this.addedItems[index].rate * item
    if (type == '1') {
      this.addedItems[index].saleQuantity = item;
      this.addedItems[index].gstAmount = (this.addedItems[index].amount * this.addedItems[index].vatPercentage) / 100;
      // this.addedItems[index].amount = this.addedItems[index].amount - this.addedItems[index].gstAmount;

      if (this.addedItems[index].discountAmount) {
        this.addedItems[index].netAmount = (this.addedItems[index].mrp * item) - this.addedItems[index].discountAmount
      }

      if (this.addedItems[index].discountPercentage) {
        this.addedItems[index].discountAmount = (this.addedItems[index].discountPercentage / 100) * (this.addedItems[index].mrp * this.addedItems[index].saleQuantity)
        this.addedItems[index].netAmount = (this.addedItems[index].mrp * this.addedItems[index].saleQuantity) - this.addedItems[index].discountAmount;
        //  this.addedItems[index].amount = this.addedItems[index].amount - this.addedItems[index].discountAmount;
        this.addedItems[index].amount = (this.addedItems[index].rate * this.addedItems[index].saleQuantity) - (this.addedItems[index].discountPercentage / 100) * (this.addedItems[index].rate * this.addedItems[index].saleQuantity)
        this.addedItems[index].gstAmount = (this.addedItems[index].amount * this.addedItems[index].vatPercentage) / 100;

      }
    }
    if (type == '2') {
      this.addedItems[index].discountPercentage = item;
      this.addedItems[index].discountAmount = (this.addedItems[index].discountPercentage / 100) * (this.addedItems[index].mrp * this.addedItems[index].saleQuantity)
      this.addedItems[index].netAmount = (this.addedItems[index].mrp * this.addedItems[index].saleQuantity) - this.addedItems[index].discountAmount
      this.addedItems[index].amount = (this.addedItems[index].rate * this.addedItems[index].saleQuantity) - (this.addedItems[index].discountPercentage / 100) * (this.addedItems[index].rate * this.addedItems[index].saleQuantity)
      this.addedItems[index].gstAmount = (this.addedItems[index].amount * this.addedItems[index].vatPercentage) / 100;
      //  this.addedItems[index].gstAmount = (((this.addedItems[index].mrp *  this.addedItems[index].saleQuantity ) - this.addedItems[index].discountAmount)* this.addedItems[index].vatPercentage)/100;

    }

    if (type == '3') {
      this.addedItems[index].discountAmount = item;
      this.addedItems[index].discountPercentage = (this.addedItems[index].discountAmount / (this.addedItems[index].mrp * this.addedItems[index].saleQuantity)) * 100;
      this.addedItems[index].netAmount = (this.addedItems[index].mrp * this.addedItems[index].saleQuantity) - this.addedItems[index].discountAmount;
      this.addedItems[index].amount = (this.addedItems[index].rate * this.addedItems[index].saleQuantity) - (this.addedItems[index].discountPercentage / 100) * (this.addedItems[index].rate * this.addedItems[index].saleQuantity)
      this.addedItems[index].gstAmount = (this.addedItems[index].amount * this.addedItems[index].vatPercentage) / 100;
      // this.addedItems[index].amount = (this.addedItems[index].rate *  this.addedItems[index].saleQuantity) - this.addedItems[index].discountAmount
    }
    if (this.addedItems[index].saleQuantity == 0) {
      this.addedItems[index].netAmount = 0;
      this.addedItems[index].amount = 0;
    }
  }

  saleQuantityeditcal(index, item, type) {
    this.getstoretemData[index].netAmount = this.getstoretemData[index].mrp * item
    this.getstoretemData[index].amount = this.getstoretemData[index].rate * item
    if (type == '1') {
      this.getstoretemData[index].saleQuantity = item;
      this.getstoretemData[index].gstAmount = (this.getstoretemData[index].amount * this.getstoretemData[index].vatPercentage) / 100;
      // this.getstoretemData[index].amount = this.getstoretemData[index].amount - this.getstoretemData[index].gstAmount;
      if (this.getstoretemData[index].discountAmount) {
        this.getstoretemData[index].netAmount = (this.getstoretemData[index].mrp * item) - this.getstoretemData[index].discountAmount
      }
      if (this.getstoretemData[index].discountPercentage) {
        this.getstoretemData[index].discountAmount = (this.getstoretemData[index].discountPercentage / 100) * (this.getstoretemData[index].mrp * this.getstoretemData[index].saleQuantity)
        this.getstoretemData[index].netAmount = (this.getstoretemData[index].mrp * this.getstoretemData[index].saleQuantity) - this.getstoretemData[index].discountAmount
        this.getstoretemData[index].amount = (this.getstoretemData[index].rate * this.getstoretemData[index].saleQuantity) - (this.getstoretemData[index].discountPercentage / 100) * (this.getstoretemData[index].rate * this.getstoretemData[index].saleQuantity)
        this.getstoretemData[index].gstAmount = (this.getstoretemData[index].amount * this.getstoretemData[index].vatPercentage) / 100;
      }
    }
    if (type == '2') {
      this.getstoretemData[index].discountPercentage = item;
      this.getstoretemData[index].discountAmount = (this.getstoretemData[index].discountPercentage / 100) * (this.getstoretemData[index].mrp * this.getstoretemData[index].saleQuantity)
      this.getstoretemData[index].netAmount = (this.getstoretemData[index].mrp * this.getstoretemData[index].saleQuantity) - this.getstoretemData[index].discountAmount
      this.getstoretemData[index].amount = (this.getstoretemData[index].rate * this.getstoretemData[index].saleQuantity) - (this.getstoretemData[index].discountPercentage / 100) * (this.getstoretemData[index].rate * this.getstoretemData[index].saleQuantity)
      this.getstoretemData[index].gstAmount = (this.getstoretemData[index].amount * this.getstoretemData[index].vatPercentage) / 100;
      // this.getstoretemData[index].amount = (this.getstoretemData[index].rate * this.getstoretemData[index].saleQuantity) - this.getstoretemData[index].discountAmount
    }
    if (type == '3') {
      this.getstoretemData[index].discountAmount = item;
      this.getstoretemData[index].discountPercentage = (this.getstoretemData[index].discountAmount / (this.getstoretemData[index].mrp * this.getstoretemData[index].saleQuantity)) * 100;
      this.getstoretemData[index].netAmount = (this.getstoretemData[index].mrp * this.getstoretemData[index].saleQuantity) - this.getstoretemData[index].discountAmount;
      this.getstoretemData[index].amount = (this.getstoretemData[index].rate * this.getstoretemData[index].saleQuantity) - (this.getstoretemData[index].discountPercentage / 100) * (this.getstoretemData[index].rate * this.getstoretemData[index].saleQuantity)
      this.getstoretemData[index].gstAmount = (this.getstoretemData[index].amount * this.getstoretemData[index].vatPercentage) / 100;
    }

    if (this.getstoretemData[index].saleQuantity == 0) {
      this.getstoretemData[index].netAmount = 0;
      this.getstoretemData[index].amount = 0;
      this.getstoretemData[index].gstAmount = 0;
      this.getstoretemData[index].discountAmount = 0;
    }
  }

  uploadData() {
    let hasInvalidQuantity = this.addedItems.some(
      item => item.saleQuantity < 0 || item.saleQuantity === null || item.saleQuantity === undefined || item.saleQuantity === "" || item.saleQuantity == "0");
    if (hasInvalidQuantity) {
      this.dashboardService.openSnackBar("Consume quantity has to be greater than 0 for this item", "OK");
      return;
    }
    let hasInvalidBatchNumber = this.addedItems.some(
      item => !item.batchNo || item.batchNo === null || item.batchNo === undefined || item.batchNo.trim() === "");
    if (hasInvalidBatchNumber) {
      this.dashboardService.openSnackBar("Please select batch of  this item", "OK");
      return;
    }
    let checkSaleQuantity = this.addedItems.some(item => item.saleQuantity > this.selectedStockQty);
    if (checkSaleQuantity) {
      this.dashboardService.openSnackBar("Can't sale more than stock quantity in this batch", "OK");
      return;
    }
    let hasInvalidDiscount = this.addedItems.some(item => item.discountPercentage > 100);
    if (hasInvalidDiscount) {
      this.dashboardService.openSnackBar("Discount percentage cannot be greater than 100", "OK");
      return;
    }
    let invalidDiscount = this.addedItems.some(item => item.discountPercentage < 0);
    if (invalidDiscount) {
      this.dashboardService.openSnackBar("Discount percentage has to be greater than 0 for this item", "OK");
      return;
    }
    this.getstoretemData = this.getstoretemData.concat(this.addedItems)
    this.calculateTotalNetAmount();
    this.calculateTotalAmount();
    this.calculateTotalGstAmount()
    this.calculateTotaldiscountAmount()
    document.getElementById("AddConsumableItemsModal").style.display = "none";
    this.addedItems = [];
    this.getbatchnoData = [];
    // this.searchItemlist = [];
    this.selectedStockQty = 0;
    this.selecteditemStockQty = 0;
    this.barcodeQuery = "";
    this.isDepartmentSelected = false;
  }

  calculateTotalNetAmount() {
    if (this.getstoretemData && this.getstoretemData.length > 0) {
      // this.totalNetAmount = Math.floor(this.getstoretemData.reduce((acc, item) => acc + (item.netAmount || 0), 0));
      this.totalNetAmount = this.getstoretemData.reduce((acc, item) => acc + (item.netAmount || 0), 0);
    }
  }

  calculateTotalAmount() {
    if (this.getstoretemData && this.getstoretemData.length > 0) {
      this.totalAmount = this.getstoretemData.reduce((acc, item) => acc + (item.amount || 0), 0);
    }
  }

  // roundOffcalcualtion() {
  //   var queuetoken = this.opdvisitService.documentrul.filter(item => item?.propertyName == "RoundOff_Final");
  //   this.totalNetAmount = this.getstoretemData.reduce((acc, item) => acc + (item.netAmount || 0), 0);
  //   const integerPart =this.totalNetAmount;
  //   const decimalPart = this.totalNetAmount - integerPart;
  //   this.roundedOffAmount = decimalPart
  // }

  closeviewCon() {
    document.getElementById("viewConsumableListDisplay").style.display = "none";
    document.getElementById("ipdWorkUpModal").style.display = "none";
  }

  updateEditCache(): void {
    this.getstoretemData.forEach((item, index) => {
      this.editCache[index] = {
        edit: false,
        data: { ...item },
      };
    });
  }

  temEditcalcualtion(index, item) {
    this.getstoretemData[index].batchNo = item.batchNo
    this.getstoretemData[index].expDate = item.expDate
    this.getstoretemData[index].fK_BatchId = item.batchid
    this.getstoretemData[index].mrp = item.mrp
    this.getstoretemData[index].rate = item.rate
    this.getstoretemData[index].baseRate = item.baseRate

    // const saleQuantity = this.editCache[index].data.saleQuantity;
    const saleQuantity = item.saleQuantity
    this.getstoretemData[index].netAmount = this.getstoretemData[index].mrp * saleQuantity
    this.getstoretemData[index].amount = this.getstoretemData[index].rate * saleQuantity
    this.getstoretemData[index].discountPercentage = item.discountPercentage
    this.getstoretemData[index].discountAmount = item.discountAmount
    this.getstoretemData[index].gstAmount = (this.getstoretemData[index].amount * this.getstoretemData[index].vatPercentage) / 100;
    // this.getstoretemData[index].amount = this.getstoretemData[index].amount - this.getstoretemData[index].gstAmount;

    // if (this.getstoretemData[index].discountAmount) {
    //   this.getstoretemData[index].netAmount = (this.getstoretemData[index].mrp * saleQuantity) - this.getstoretemData[index].discountAmount
    // }

    if (this.getstoretemData[index].discountPercentage) {
      this.getstoretemData[index].discountAmount = (this.getstoretemData[index].discountPercentage / 100) * (this.getstoretemData[index].mrp * this.getstoretemData[index].saleQuantity)
      this.getstoretemData[index].netAmount = (this.getstoretemData[index].mrp * this.getstoretemData[index].saleQuantity) - this.getstoretemData[index].discountAmount;
      this.getstoretemData[index].amount = (this.getstoretemData[index].rate * this.getstoretemData[index].saleQuantity) - (this.getstoretemData[index].discountPercentage / 100) * (this.getstoretemData[index].rate * this.getstoretemData[index].saleQuantity)
      this.getstoretemData[index].gstAmount = (this.getstoretemData[index].amount * this.getstoretemData[index].vatPercentage) / 100;
      // this.getstoretemData[index].amount = (this.getstoretemData[index].rate * this.getstoretemData[index].saleQuantity) - this.getstoretemData[index].discountAmount;
    }

    if (this.getstoretemData[index].discountAmount) {
      this.getstoretemData[index].discountPercentage = (this.getstoretemData[index].discountAmount / (this.getstoretemData[index].mrp * this.getstoretemData[index].saleQuantity)) * 100;
      this.getstoretemData[index].netAmount = (this.getstoretemData[index].mrp * this.getstoretemData[index].saleQuantity) - this.getstoretemData[index].discountAmount;
      this.getstoretemData[index].amount = (this.getstoretemData[index].rate * this.getstoretemData[index].saleQuantity) - (this.getstoretemData[index].discountPercentage / 100) * (this.getstoretemData[index].rate * this.getstoretemData[index].saleQuantity)
      this.getstoretemData[index].gstAmount = (this.getstoretemData[index].amount * this.getstoretemData[index].vatPercentage) / 100;
    }

    if (this.getstoretemData[index].saleQuantity == 0) {
      this.getstoretemData[index].netAmount = 0;
      this.getstoretemData[index].amount = 0;
    }
    // ** Calculate Total Net Amount **
    // this.roundOffcalcualtion();
    this.calculateTotaltemNetAmount();
    this.calculatetemTotalAmount();
    this.updateTotalDiscount(index);
    this.updateTotalGstAmount(index);
    this.calculateTotaldiscountAmount();
    this.calculateTotalGstAmount()
  }
  isEditing: boolean = false;
  Edit(index, item) {
    // const dynamicItemId = item.fK_ItemId;
    this.updateEditCache();
    // this.editCache[index].edit = true;
    this.editCache[index] = { data: { ...item }, edit: true };
    this.isDepartmentSelected = false;
    this.isEditing = true;
  }

  canceledit(index: number, item): void {
    // this.editCache[index].data = { ...this.getstoretemData[index] };
    // this.editCache[index].edit = false;
    this.getstoretemData[index] = { ...this.editCache[index].data };
    this.editCache[index].edit = false;
  }

  // Save the changes and exit edit mode
  saveedit(index: number, item): void {
    if (item.discountPercentage > 100) {
      this.dashboardService.openSnackBar("Discount percentage cannot be greater than 100", "OK");
      return;
    }
    if (item.discountPercentage < 0) {
      this.dashboardService.openSnackBar("Discount percentage has to be greater than 0 for this item", "OK");
      return;
    }
    if (item.saleQuantity < 0 || item.saleQuantity == "0" || item.saleQuantity == "") {
      this.dashboardService.openSnackBar("Consume quantity has to be greater than 0 for this item", "OK");
      return;
    }
    // this.getstoretemData[index] = this.editCache[index].data;
    this.getstoretemData[index] = item;
    this.isDepartmentSelected = false;
    this.temEditcalcualtion(index, item);
    this.editCache[index].edit = false;
    this.isEditing = false;
  }



  calculateTotaltemNetAmount() {
    if (this.getstoretemData && this.getstoretemData.length > 0) {
      this.totalNetAmount = this.getstoretemData.reduce((acc, item) => acc + (item.netAmount || 0), 0);
    }
  }

  calculatetemTotalAmount() {
    if (this.getstoretemData && this.getstoretemData.length > 0) {
      this.totalAmount = this.getstoretemData.reduce((acc, item) => acc + (item.amount || 0), 0);
    }
  }

  updateTotalDiscount(index) {
    if (!this.discountAmount && this.getbatchnoData.length > 0) {
      this.discountAmount += this.getstoretemData.reduce((total, row) => {
        return total + row.discount; // Assuming each row has a 'discount' field
      }, 0);
    }
  }

  updateTotalGstAmount(index) {
    if (!this.totalGstAmount && this.getbatchnoData.length > 0) {
      this.totalGstAmount = this.getstoretemData.reduce((total, row) => {
        return total + row.vatAmount; // Assuming each row has a 'gstAmount' field
      }, 0);
    }
  }

  totalGstAmount: number;
  calculateTotalGstAmount(): void {
    this.totalGstAmount = this.getstoretemData.reduce((acc, item) => acc + (item.gstAmount || 0), 0);
  }

  calculateTotaldiscountAmount(): void {
    this.discountAmount = this.getstoretemData.reduce((acc, item) => acc + (item.discountAmount || 0), 0);
  }



  // cleardata() {
  //   this.addedItems = [];
  //   this.selectedItem = [];
  //   this.batchNo = '';
  //   this.saleQuantity = null;
  //   this.discountPercentage = null;
  //   this.expDate = null;
  //   this.selectedStockQty = null;

  // }
  clarecalculation() {
    this.totalAmount = 0;
    this.totalNetAmount = 0;
    this.gstAmount = 0;
    this.discountAmount = 0
    this.totalGstAmount = 0;
  }

  deleteminuscalculation(i) {
    if (this.getstoretemData[i]) {
      if (this.getstoretemData[i].netAmount) {
        this.totalNetAmount = this.totalNetAmount - this.getstoretemData[i].netAmount
      }
      if (this.getstoretemData[i].amount && this.getstoretemData[i]) {
        this.totalAmount = this.totalAmount - this.getstoretemData[i].amount
      }
      if (this.getstoretemData[i].gstAmount && this.getstoretemData[i]) {
        this.totalGstAmount = this.totalGstAmount - this.getstoretemData[i].gstAmount
      }
      if (this.getstoretemData[i].discountAmount) {
        this.discountAmount = this.discountAmount - this.getstoretemData[i].discountAmount
      }
    }
  }
  deleteItem(item: any, i): void {
    this.deleteminuscalculation(i)
    const index = this.getstoretemData.indexOf(item);
    if (index > -1) {
      this.getstoretemData.splice(index, 1);
    }
  }


  deleteItemrow(item: any) {
    const index = this.addedItems.indexOf(item);
    if (index > -1) {
      this.addedItems.splice(index, 1);
    }
  }

  deleterow(item) {
    const index = this.selectedItem.indexOf(item);
    if (index > -1) {
      this.selectedItem.splice(index, 1);
    }
  }

  consumeid: any;
  consumeQty: any
  idx: any
  billNo: any;
  saveConsumtion() {
    if (this.getstoretemData.some(item => item.saleQuantity === null || item.saleQuantity == 0)) {
      this.dashboardService.openSnackBar("Consume quantity has to be greater than 0 for this item", "Ok")
      return;
    }
    const checkBatchNo = this.getstoretemData.every(item => item.batchNo);
    const itemsWithoutBatchNo = this.getstoretemData.filter(item => !item.batchNo || item.batchNo.trim() === '').map(item => item.itemName);
    if (!checkBatchNo) {
      this.dashboardService.openSnackBar(`Please select batch of item ${itemsWithoutBatchNo}`, "OK");
      return;
    }
    if (!this.storesConsumeMasterArray.fK_PartyId) {
      this.dashboardService.openSnackBar("Please select payor name", "OK");
      return;
    }
    const partyInput = this.storesConsumeMasterArray.salesType?.trim();
    if (!partyInput) {
      this.dashboardService.openSnackBar("Please Select Sales Type", "OK");
      return;
    }
    if (this.storesConsumeMasterArray.salesType !== 'Consumption') {
      this.dashboardService.openSnackBar("Please Select Consumption Sales Type", "OK");
      return;
    }

    if (this.isEditing) {
      this.dashboardService.openSnackBar("Please save or cancel the ongoing edits before proceeding", "OK");
      return;
    }
    const currrentdate = JSON.parse(sessionStorage.getItem('SessiondateTime'));
    this.getstoretemData.forEach((item, index) => {
      this.idx = index
      if (item.fK_AltUnitId == item.fk_PrimaryUnitId) {
        this.consumeQty = item.saleQuantity
      } else {
        this.consumeQty = item.saleQuantity * item.conversionFactor
      }
      this.baseAmount = this.consumeQty * item.brate
      this.storesConsumeItemDetailsdata.push({
        "pK_ConsumeDetailId": item.pK_ConsumeDetailId ? item.pK_ConsumeDetailId : 0,
        "fK_ConsumeId": this.consumeid ? this.consumeid : 0,
        "fK_ItemId": item.pK_ItemID,
        "fK_GSTID": item.fK_VatSlabId,
        "fK_BatchId": item.pK_BatchID,
        "fK_PriceUnitId": item.fk_PrimaryUnitId,
        "indentQty": 0.0,
        "consumeQty": item.saleQuantity,
        "consumeQtyAlternateUnit": this.consumeQty,
        "mrp": item.mrp,
        "baseRate": item.brate,
        "rate": item.rate,
        "baseAmount": this.baseAmount,
        "discountPer": item.discountPercentage,
        "discountAmount": item.discountAmount,
        "amount": item.amount,
        "vatPer": item.vatPercentage,
        "vatAmount": item.gstAmount,
        "surchargePer": 0.0,
        "surchargeAmount": null,
        "totalTaxAmount": this.gstAmount,
        "netValue": item.netAmount,
        "remarks": this.storesConsumeMasterArray.remarks,
        "pK_DetailID": null,
        "pK_IndentDetailId": null,
        "purchasePrice": item.purchasePrice,
        "purchasePriceForTPA": 0,
        "isEdit": this.consumeid ? true : false,
        "isDelete": false
      })
    })
    const storesConsumeMaster = {
      "pK_ConsumeId": this.consumeid ? this.consumeid : 0,
      "fK_BranchId": this.authService.Loggeduser.branchid,
      "fK_FinYearId": this.authService.Loggeduser.finyear,
      "fK_DeptId": this.deptId,
      "transactionType": "Receipt",
      "consumeType": this.ShowDepName,
      "salesType": this.storesConsumeMasterArray.salesType,
      "billNo": this.billNo,
      "consumeDate": moment(currrentdate).format('YYYY-MM-DD'),
      "consumeTime": moment(currrentdate).format("HH:mm:ss"),
      "fK_IPDID": this.selectIpdId,
      "fK_RegID": this.RegId,
      "fK_PartyId": this.storesConsumeMasterArray.fK_PartyId,
      "fK_VisitID": null,
      "patientName": this.selectipdData?.patientName,
      "mobileNo": this.selectipdData?.mobileno,
      "doctorName": this.storesConsumeMasterArray.doctorName,
      "totalAmount": this.totalAmount,
      "discount": this.discountAmount,
      "gstAmount": this.totalGstAmount,
      "grossAmount": this.totalNetAmount,
      "roundOff": this.roundedOffAmount,
      "netAmount": this.totalNetAmount,
      "totalPaid": 0.0,
      "remarks": this.storesConsumeMasterArray.remarks,
      "deliveryDate": null,
      "isDelivered": null,
      "fK_CreatedbyId": this.authService.Loggeduser.userid,
      "createdDatetime": moment(currrentdate).format('YYYY-MM-DD') + 'T' + moment(currrentdate).format("HH:mm:ss"),
      "isActive": this.isActive,
      "fK_consumeId": null,
      "fK_BIllingCompanyId": this.authService.Loggeduser.billingcompanyid,
      "igN_Status": null,
      "fK_ConsumeLocationID": this.storesConsumeMasterArray.fK_ConsumeLocationID,
      "purchasePrice": this.getstoretemData[0]?.purchasePrice || 0,
      "fK_StateId": this.opdvisitService.stateid,
      "gstno": this.storesConsumeMasterArray.gstno,
      "shiftName": null,
      "isEdit": this.consumeid ? true : false
    };
    const ConsumeMasterTracking = {
      "PK_TranId,": this.consumeid ? this.consumeid : 0,
      "pK_ConsumeId": this.consumeid ? this.consumeid : 0,
      "fK_DeptId": this.deptId,
      "consumeType": this.ShowDepName,
      "salesType": this.storesConsumeMasterArray.salesType,
      "billNo": this.billNo,
      "consumeDate": moment(currrentdate).format('YYYY-MM-DD'),
      "consumeTime": moment(currrentdate).format("HH:mm:ss"),
      "fK_IPDID": this.selectIpdId,
      "fK_RegID": this.RegId,
      "fK_PartyID": this.storesConsumeMasterArray.fK_PartyId,
      "fK_VisitID": null,
      "patientName": this.selectipdData?.patientName,
      "mobileNo": this.selectipdData?.mobileno,
      "doctorName": this.storesConsumeMasterArray.doctorName,
      "totalAmount": this.totalAmount,
      "discount": this.discountAmount,
      "gstAmount": this.totalGstAmount,
      "grossAmount": this.totalNetAmount,
      "roundOff": this.roundedOffAmount,
      "netAmount": this.totalNetAmount,
      "totalPaid": 0,
      "remarks": this.storesConsumeMasterArray.remarks,
      "fK_CreatedbyId": this.authService.Loggeduser.userid,
      "createdDatetime": moment(currrentdate).format('YYYY-MM-DD') + 'T' + moment(currrentdate).format("HH:mm:ss"),
      "fK_consumeId": null,
      "fK_BIllingCompanyId": this.authService.Loggeduser.billingcompanyid,
      "fK_ConsumeLocationID": this.storesConsumeMasterArray.fK_ConsumeLocationID,
      "fK_StateId": this.opdvisitService.stateid,
      "gstno": this.storesConsumeMasterArray.gstno,
      "shiftName": null,
      "ComputerName": null,
      "transactionType": "Receipt",
      "isEdit": this.consumeid ? true : false
    }
    let payload = {
      StoresConsumeMaster: storesConsumeMaster,
      StoresConsumeItemDetail: this.storesConsumeItemDetailsdata,
      StoresConsumeMasterTracking: ConsumeMasterTracking,
    };
    this.showspinner = true;
    this.ipdService.saveInsertStoresConsumeMaster(payload).pipe(takeUntil(this.destroyipd$)).subscribe(
      data => {
        this.showspinner = false;
        if (data && data.statusCode === "1") {
          this.consumeid = data['id'];
          this.ipdService.getStoresConsumeMaster(this.consumeid, this.RegId, this.selectIpdId).pipe(takeUntil(this.destroyipd$)).subscribe((res) => {
            const billData = res.find((item) => item.billNo);
            if (billData) { this.billNo = billData.billNo; console.log(this.billNo) }
          })
          this.ipdService.getstoreConsumeDetails(this.consumeid).pipe(takeUntil(this.destroyipd$)).subscribe((res) => { console.log(res, 'called>>>>>2') })
          this.ipdService.getStoresConsumeMasterTracking(this.consumeid).pipe(takeUntil(this.destroyipd$)).subscribe((res) => { console.log(res, 'called>>>3') })
          this.dashboardService.openSnackBar("Record Saved Successfully", "OK");
          this.isDepartmentSelected = true;
          this.storesConsumeItemDetailsdata = [];
          this.getViewconsumtion();
        } else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
        //  this.cleardata();
      },
      err => {
        this.showspinner = false;
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        }
        else if (err.error.statusCode == 422) {
          this.dashboardService.openSnackBar(err.error.message, "OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      }
    );
  }

  getViewconsumtion() {
    this.ipdService.getviewConsumables(this.selectIpdId).pipe(takeUntil(this.destroyipd$)).subscribe((res) => {
      this.viewconsmtiondata = res;
      if (this.viewconsmtiondata.length > 0) {
        this.dischargecheck = true;
      }
    })
  }

  perpopup() {
    document.getElementById('viewConModal').style.display = "block"
  }

  noviewcon() {
    document.getElementById("viewConsumableListDisplay").style.display = "block";
    document.getElementById('viewConModal').style.display = "none"
  }

  viewCon_yes() {
    if (this.getdeparment.length > 0 && this.authService.masterdata.fK_DeptID != null) {
      this.ShowDepName = this.getdeparment.filter((item) => item.pkDeptId == this.authService.masterdata.fK_DeptID)[0]?.deptName
      this.depselect(0)
    }
    document.getElementById('viewConModal').style.display = "none"
  }

  closeserchot() {
    document.getElementById('otSearchRecordModal').style.display = "none"
  }

  serchOTrecord() {
    document.getElementById('otSearchRecordModal').style.display = "block"

  }

  bulkConscreen() {
    const dialogRefbulk = this.dialog.open(BulkConsumptionComponent, {
      panelClass: "full-width-dialog",
      width: "100%",
      height: "85%",
      disableClose: true,
      hasBackdrop: false,
    });
    dialogRefbulk.afterClosed().pipe(takeUntil(this.destroyipd$)).subscribe((result) => {
      this.getdeparment = [];
    });

  }

  printTimelinePrecheclistreport(ctype) {
    if (Number(this.selectIpdId) > 0 && this.RegId > 0) {
      let payload = {
        WebReportPrintMaster: {
          module: "IPDWorkUp",
          printOption: ctype,
          printType: "WebNetramReport",
          Pk_RegId: this.RegId,
          PRINTDATE: this.datePipe.transform(
            this.authService.localDate,
            "dd-MM-yyyy"
          ),
          PrintTime: this.convertTime12Hour(new Date()),
          AdvisedBy: this.authService.Loggeduser.firstname,
          BILLINGCOMPANYNAME: this.authService.Loggeduser.billingcompanyname,
          LINE1: this.branchmansterObj.line1,
          LINE2: this.branchmansterObj.line2,
          LINE3: this.branchmansterObj.line3,
          LINE4: this.branchmansterObj.line4,
          HOSPITALIMAGE:
            window.location.origin + "/" + this.authService.loginclientlogo,
          COMPANYIMAGE:
            window.location.origin + "/" + this.authService.leftbottomlogosm,
          CERTIFICATE1IMAGE:
            window.location.origin + "/" + this.authService.nabhlogo,
          CERTIFICATE2COMPANYIMAGE: "",
          Pk_IPDId: this.selectIpdId,
          PreOpCheckListArray: ctype == "PreOpCheckList" ? "Y" : "N",
          PostOpCheckListArray: ctype == "PostOpCheckList" ? "Y" : "N",
          SSCheckListArray: ctype == "SSCheckList" ? "Y" : "N",
          GACheckListArray: ctype == "GACheckList" ? "Y" : "N",
          PreAnestheticQuestionDetailArray:
            ctype == "PreAnestheticQuestionDetail" ? "Y" : "N",
          PatientRegistrationArray: "Y",
          PrintHeaderArray: "Y",
          DischargeSummaryArray: ctype == "DischargeSummary" ? "Y" : "N",
          DischargePrescriptionDetailArray:
            ctype == "DischargeSummary" ? "Y" : "N",
          DischargeExaminationDetailArray: "N",
          DischargeInstructionDetailArray:
            ctype == "DischargeSummary" ? "Y" : "N",
          DischargeLabInvestigationDetailArray:
            ctype == "DischargeSummary" ? "Y" : "N",
        },
      };
      this.ipdService
        .GetWebReportPrint(payload)
        .pipe(takeUntil(this.destroyipd$))
        .subscribe((x: any) => {
          if (x.length > 0) {
            let printContents, popupWin;

            printContents = x[0].printTemplate;
            popupWin = window.open(
              "",
              "_blank",
              "top=0,left=0,height=100%,width=auto"
            );

            popupWin.document.open();
            popupWin.document.write(`
<html>
 
<body onload="window.print()">${printContents}
</body>
</html>`);

            popupWin.document.close();
          } else {
            this.dashboardService.openSnackBar("Report Template Not Set", "OK");
          }
        });
    } else {
      this.dashboardService.openSnackBar("Please select bill first", "OK");
    }
  }
  registerNameDetail() { }

  //Advance Search Filter Modal
  advanceSearchFilterModal() {
    document.getElementById("advanceSearchFilterModal").style.display = "block";
  }
  closeAdvanceSearchFilterModal() {
    document.getElementById("advanceSearchFilterModal").style.display = "none";
  }

  //Patient Location Selection Modal
  patientLocationSelectionModal(ipdid:any) {
    this.checkipdid =ipdid;
    document.getElementById("patientLocationSelectionModal").style.display =
      "block";
  }
  closePatientLocationSelectionModal() {
    this.checkipdid =0;
    document.getElementById("patientLocationSelectionModal").style.display =
      "none";
  }
  showValidationMessage() {
    if (!this.counselorForm) {
      this.dashboardService.openSnackBar("Can't open Pre-Op details, Surgery time is not available.", "OK"
      );
    }
  }

  deleteRecord(element, index) {

    if (
      element.pK_TranId == 0
    ) {
      this.dataSource.data.splice(index, 1);
      this.dataSource.data = this.dataSource.data;
      return
    }
    let preQList = [{
      actualValue: element.defaultValues,
      fK_IPDID: this.selectIpdId,
      headName: element.headName,
      isEdit: true,
      isHeader: element.isHeader,
      isHidden: true,
      pK_SynchId: element.pK_SynchId,
      pK_TranId: element.pK_TranId,
      isActive: element.isActive,
    }];

    let prePayLoadList = {
      AnesthesiaQuestionsDto: preQList,
    };

    if (preQList.length > 0) {
      this.ipdService
        .addAnesthesiaMaster(prePayLoadList)
        .pipe(takeUntil(this.destroyipd$))
        .subscribe(
          (data) => {

            this.dashboardService.openSnackBar("Record Deleted Successfully", "OK");
            this.getAnesthesiaMasterList();
          },
          (err) => {
            if (err.status == 403) {
              this.dashboardService.openSnackBar("You Don't have Permission", "OK");
            }
            else if (err.error.statusCode == 422) {
              this.dashboardService.openSnackBar(err.error.message, "OK");
            }
            else {
              this.dashboardService.openSnackBar("API Failed", "OK");
            }
          }
        );
    }
  }
  onVoiceFocus(fieldName: string) {
    if (this.isVoiceEnabled) {
      this.currentFieldIndex = this.fieldSequence.indexOf(fieldName);
      this.voiceService.startDischarge(fieldName, (spokenText: string) => {
        if (spokenText.toLowerCase().trim() === 'next') {
          this.moveToNextField();
          return;
        }

        switch (fieldName) {
          case 'Complaints':
            this.dischargeDatamodel.complaints = this.mergeInput(this.dischargeDatamodel.complaints, spokenText);
            break;
          case 'Procedures':
            this.dischargeDatamodel.procedureDone = this.mergeInput(this.dischargeDatamodel.procedureDone, spokenText);
            break;
          case 'diagnosis':
            this.dischargeDatamodel.diagnosis = this.mergeInput(this.dischargeDatamodel.diagnosis, spokenText);
            break;
          case 'disease':
            this.dischargeDatamodel.systemicIllness = this.mergeInput(this.dischargeDatamodel.systemicIllness, spokenText);
            break;
          case 'Remarks':
            this.dischargeDatamodel.remarks = this.mergeInput(this.dischargeDatamodel.remarks, spokenText);
            break;
          case 'cDischarge':
            this.dischargeDatamodel.conditiononDischarge = this.mergeInput(this.dischargeDatamodel.conditiononDischarge, spokenText);
            break;
          case 'adviceonDischarge':
            this.dischargeDatamodel.adviceonDischarge = this.mergeInput(this.dischargeDatamodel.adviceonDischarge, spokenText);
            break;
          case 'prognosis':
            this.dischargeDatamodel.prognosis = this.mergeInput(this.dischargeDatamodel.prognosis, spokenText);
            break;
          case 'Prepared':
            this.dischargeDatamodel.createdByName = this.mergeInput(this.dischargeDatamodel.createdByName, spokenText);
            break;
          case 'finding':
            this.dischargeDatamodel.findings = this.mergeInput(this.dischargeDatamodel.findings, spokenText);
            break;
          case 'benificiaryName':
            this.dischargeDatamodel.benificiaryName = this.mergeInput(this.dischargeDatamodel.benificiaryName, spokenText);
            break;
          case 'benificiaryRemarks':
            this.dischargeDatamodel.benificiaryRemarks = this.mergeInput(this.dischargeDatamodel.benificiaryRemarks, spokenText);
            break;
        }
      });
    }
  }
  moveToNextField() {
    this.voiceService.stopDischarge(this.fieldSequence[this.currentFieldIndex]);

    if (this.currentFieldIndex < this.fieldSequence.length - 1) {
      const nextField = this.fieldSequence[++this.currentFieldIndex];

      setTimeout(() => {
        const inputElement = document.querySelector(`[name="${nextField}"]`) as HTMLElement;
        console.log(inputElement, "inputelelele::::")
        if (inputElement) {
          inputElement.focus();
        }
      }, 100);
    }
  }


  onVoiceBlur(fieldName: string) {
    if (this.isVoiceEnabled) {
      this.voiceService.stopDischarge(fieldName);
    }
  }
  mergeInput(original: string, voice: string): string {
    if (!voice) return original || '';
    if (!original) return voice;

    const words = original.split(' ');
    const last = words.slice(-6).join(' ');
    if (last.includes(voice)) return original;
    return `${original} ${voice}`.trim();
  }

}

